import { EmployeeWithReportedPayrollViewModel } from "@fora-monorepo/employer-my-pages-common/types";

export const mockEmploymentsLargeAmount: EmployeeWithReportedPayrollViewModel[] = [
  {
      "partnerNumberIndividual": "0030001636",
      "employeeId": "195410204282",
      "firstName": "Behårad",
      "lastName": "Spårdjup"
  },
  {
      "partnerNumberIndividual": "0030005159",
      "employeeId": "197008134228",
      "firstName": "Kopparröd",
      "lastName": "Intvålning"
  },
  {
      "partnerNumberIndividual": "0030012659",
      "employeeId": "197010284201",
      "firstName": "Märkesskyddad",
      "lastName": "Differentialtransformator"
  },
  {
      "partnerNumberIndividual": "0030015081",
      "employeeId": "195412044090",
      "firstName": "Geotermisk",
      "lastName": "Upprullningsmaskin"
  },
  {
      "partnerNumberIndividual": "0030020780",
      "employeeId": "199311296348",
      "firstName": "Ganskakort",
      "lastName": "Ömlåga"
  },
  {
      "partnerNumberIndividual": "0030023805",
      "employeeId": "195501260201",
      "firstName": "Brytbar",
      "lastName": "Pappersprodukt"
  },
  {
      "partnerNumberIndividual": "0030751055",
      "employeeId": "195912010245",
      "firstName": "Störtförälskad",
      "lastName": "Regleringssteg"
  },
  {
      "partnerNumberIndividual": "0030768215",
      "employeeId": "197902212807",
      "firstName": "Havregrynsgröt",
      "lastName": "Fusion"
  },
  {
      "partnerNumberIndividual": "0030813611",
      "employeeId": "198205086922",
      "firstName": "Ultimo",
      "lastName": "Enfrågepolitik"
  },
  {
      "partnerNumberIndividual": "0030813803",
      "employeeId": "198205087227",
      "firstName": "Blåklädd",
      "lastName": "Konjunkturteori"
  },
  {
      "partnerNumberIndividual": "0030818549",
      "employeeId": "198206102520",
      "firstName": "Statskontrollerad",
      "lastName": "Fartsladd"
  },
  {
      "partnerNumberIndividual": "0030818702",
      "employeeId": "198206103429",
      "firstName": "Risig",
      "lastName": "Årsöversikt"
  },
  {
      "partnerNumberIndividual": "0030818721",
      "employeeId": "198206103726",
      "firstName": "Torkkänslig",
      "lastName": "Upprorsförsök"
  },
  {
      "partnerNumberIndividual": "0030818917",
      "employeeId": "198206104328",
      "firstName": "Senare",
      "lastName": "Vattenstäkra"
  },
  {
      "partnerNumberIndividual": "0030822041",
      "employeeId": "198206118526",
      "firstName": "Förkatolsk",
      "lastName": "Magoperation"
  },
  {
      "partnerNumberIndividual": "0030822470",
      "employeeId": "198206110325",
      "firstName": "Evinnerligen",
      "lastName": "Förståndsutveckling"
  },
  {
      "partnerNumberIndividual": "0030826952",
      "employeeId": "198206139027",
      "firstName": "Stressig",
      "lastName": "Lerburk"
  },
  {
      "partnerNumberIndividual": "0030826997",
      "employeeId": "198206130521",
      "firstName": "Begreppsmässig",
      "lastName": "Marknadsfokuserad"
  },
  {
      "partnerNumberIndividual": "0030827866",
      "employeeId": "198206144720",
      "firstName": "Förvärkt",
      "lastName": "Ingetillamenat"
  },
  {
      "partnerNumberIndividual": "0030828911",
      "employeeId": "198206152525",
      "firstName": "Födoämnes",
      "lastName": "Skändning"
  },
  {
      "partnerNumberIndividual": "0030830892",
      "employeeId": "198206150289",
      "firstName": "Frapperande",
      "lastName": "Stenbädd"
  },
  {
      "partnerNumberIndividual": "0030831891",
      "employeeId": "198206165824",
      "firstName": "Senromantisk",
      "lastName": "Glansmedel"
  },
  {
      "partnerNumberIndividual": "0030832313",
      "employeeId": "198206166129",
      "firstName": "Bilmekanisk",
      "lastName": "Halvpence"
  },
  {
      "partnerNumberIndividual": "0030833311",
      "employeeId": "198206172424",
      "firstName": "Omusikalisk",
      "lastName": "Kortärm"
  },
  {
      "partnerNumberIndividual": "0030837185",
      "employeeId": "198206187224",
      "firstName": "Omusikalisk",
      "lastName": "Långhålsborrmaskin"
  },
  {
      "partnerNumberIndividual": "0030837778",
      "employeeId": "198206192323",
      "firstName": "Interparlamentarisk",
      "lastName": "Endogensubstans"
  },
  {
      "partnerNumberIndividual": "0030837878",
      "employeeId": "198206192620",
      "firstName": "Däst",
      "lastName": "Ränteparitetsteori"
  },
  {
      "partnerNumberIndividual": "0030841270",
      "employeeId": "198206208921",
      "firstName": "Pulverlackerad",
      "lastName": "Öringfiske"
  },
  {
      "partnerNumberIndividual": "0030842513",
      "employeeId": "198206215827",
      "firstName": "Stillasittande",
      "lastName": "Förkroppsling"
  },
  {
      "partnerNumberIndividual": "0030842933",
      "employeeId": "198206216122",
      "firstName": "Blåaktig",
      "lastName": "Utländskmoderbolag"
  },
  {
      "partnerNumberIndividual": "0030846520",
      "employeeId": "198206235122",
      "firstName": "Pratsjuk",
      "lastName": "Hårklädsel"
  },
  {
      "partnerNumberIndividual": "0030846898",
      "employeeId": "198206236328",
      "firstName": "Frankfurtbo",
      "lastName": "Parisiska"
  },
  {
      "partnerNumberIndividual": "0030848313",
      "employeeId": "198206242623",
      "firstName": "Anglobrasiliansk",
      "lastName": "Introduktionspris"
  },
  {
      "partnerNumberIndividual": "0030851431",
      "employeeId": "198206256227",
      "firstName": "Heteropolär",
      "lastName": "Jordgubbsland"
  },
  {
      "partnerNumberIndividual": "0030852975",
      "employeeId": "198206264023",
      "firstName": "Mintgrön",
      "lastName": "Mårdhår"
  },
  {
      "partnerNumberIndividual": "0030866416",
      "employeeId": "198206020821",
      "firstName": "Botswanisk",
      "lastName": "Inköpsagent"
  },
  {
      "partnerNumberIndividual": "0030866700",
      "employeeId": "198206020227",
      "firstName": "Plågande",
      "lastName": "Laboratoriearbetare"
  },
  {
      "partnerNumberIndividual": "0030867202",
      "employeeId": "198206033220",
      "firstName": "Brandfri",
      "lastName": "Läsesällskap"
  },
  {
      "partnerNumberIndividual": "0030870111",
      "employeeId": "198206041322",
      "firstName": "Julpimpande",
      "lastName": "Susande"
  },
  {
      "partnerNumberIndividual": "0030871167",
      "employeeId": "198206055223",
      "firstName": "Bombmattefällande",
      "lastName": "Vävnad"
  },
  {
      "partnerNumberIndividual": "0030880150",
      "employeeId": "198207092829",
      "firstName": "Odäckad",
      "lastName": "Socialbidrag"
  },
  {
      "partnerNumberIndividual": "0030883441",
      "employeeId": "198207108229",
      "firstName": "Jordig",
      "lastName": "Känsloskala"
  },
  {
      "partnerNumberIndividual": "0030883447",
      "employeeId": "198207109425",
      "firstName": "Årligen",
      "lastName": "Läkekonst"
  },
  {
      "partnerNumberIndividual": "0030884450",
      "employeeId": "198207114227",
      "firstName": "Besegrad",
      "lastName": "Blåsvarteufonia"
  },
  {
      "partnerNumberIndividual": "0030886845",
      "employeeId": "198207120521",
      "firstName": "Företagsbetald",
      "lastName": "Gjutugn"
  },
  {
      "partnerNumberIndividual": "0030888259",
      "employeeId": "198207136220",
      "firstName": "Plågande",
      "lastName": "Ärftlighetsgen"
  },
  {
      "partnerNumberIndividual": "0030890836",
      "employeeId": "198207149827",
      "firstName": "Endomorf",
      "lastName": "Legitimeradläkare"
  },
  {
      "partnerNumberIndividual": "0030892520",
      "employeeId": "198207156129",
      "firstName": "Bäst",
      "lastName": "Fregattfågel"
  },
  {
      "partnerNumberIndividual": "0030893002",
      "employeeId": "198207158224",
      "firstName": "Ejkonvertibel",
      "lastName": "Jamaicabäverråtta"
  },
  {
      "partnerNumberIndividual": "0030896493",
      "employeeId": "198207176325",
      "firstName": "Helfodrad",
      "lastName": "Fjädervilt"
  },
  {
      "partnerNumberIndividual": "0030896525",
      "employeeId": "198207176929",
      "firstName": "Proportionell",
      "lastName": "Morotsfrö"
  },
  {
      "partnerNumberIndividual": "0030896988",
      "employeeId": "198207177224",
      "firstName": "Rysk",
      "lastName": "Tavetavävare"
  },
  {
      "partnerNumberIndividual": "0030897902",
      "employeeId": "198207182620",
      "firstName": "Applikationsoberoende",
      "lastName": "Tidskorridor"
  },
  {
      "partnerNumberIndividual": "0030898052",
      "employeeId": "198207183222",
      "firstName": "Kiselhaltig",
      "lastName": "Penningutbud"
  },
  {
      "partnerNumberIndividual": "0030901501",
      "employeeId": "198207203723",
      "firstName": "Moltyst",
      "lastName": "Digitalsystem"
  },
  {
      "partnerNumberIndividual": "0030901989",
      "employeeId": "198207205223",
      "firstName": "Utseende",
      "lastName": "Lastnät"
  },
  {
      "partnerNumberIndividual": "0030906752",
      "employeeId": "198207227227",
      "firstName": "Halvsfärisk",
      "lastName": "Felkalkyl"
  },
  {
      "partnerNumberIndividual": "0030914351",
      "employeeId": "198207268528",
      "firstName": "Björnaktig",
      "lastName": "Betongvara"
  },
  {
      "partnerNumberIndividual": "0030915491",
      "employeeId": "198207274229",
      "firstName": "Urnupen",
      "lastName": "ERA"
  },
  {
      "partnerNumberIndividual": "0030926409",
      "employeeId": "198207010227",
      "firstName": "Ädel",
      "lastName": "Avbetalningslag"
  },
  {
      "partnerNumberIndividual": "0030929761",
      "employeeId": "198207038921",
      "firstName": "Åsyna",
      "lastName": "Växelkurssystem"
  },
  {
      "partnerNumberIndividual": "0030929821",
      "employeeId": "198207039523",
      "firstName": "Självstyrd",
      "lastName": "Arglist"
  },
  {
      "partnerNumberIndividual": "0030930791",
      "employeeId": "198207045520",
      "firstName": "Antikolonial",
      "lastName": "Mejeributik"
  },
  {
      "partnerNumberIndividual": "0030931271",
      "employeeId": "198207046122",
      "firstName": "Paradoxal",
      "lastName": "Stilkonst"
  },
  {
      "partnerNumberIndividual": "0030935149",
      "employeeId": "198207066328",
      "firstName": "Olycksfri",
      "lastName": "Kolombiadopping"
  },
  {
      "partnerNumberIndividual": "0030935182",
      "employeeId": "198207066625",
      "firstName": "Bekymmersfri",
      "lastName": "Hårklädsel"
  },
  {
      "partnerNumberIndividual": "0030935529",
      "employeeId": "198207067821",
      "firstName": "Helfodrad",
      "lastName": "Plättpanna"
  },
  {
      "partnerNumberIndividual": "0030936492",
      "employeeId": "198207072326",
      "firstName": "Didaktisk",
      "lastName": "Realläroverk"
  },
  {
      "partnerNumberIndividual": "0030942053",
      "employeeId": "198208098221",
      "firstName": "Adjektivisk",
      "lastName": "Enmiljon"
  },
  {
      "partnerNumberIndividual": "0030946698",
      "employeeId": "198208110224",
      "firstName": "Vissa",
      "lastName": "Vågmästare"
  },
  {
      "partnerNumberIndividual": "0030947189",
      "employeeId": "198208124720",
      "firstName": "Approximativ",
      "lastName": "Ättekulle"
  },
  {
      "partnerNumberIndividual": "0030949107",
      "employeeId": "198208132822",
      "firstName": "Lockförsedd",
      "lastName": "Bataljon"
  },
  {
      "partnerNumberIndividual": "0030950604",
      "employeeId": "198208139827",
      "firstName": "Glömsk",
      "lastName": "Självhypnos"
  },
  {
      "partnerNumberIndividual": "0030952564",
      "employeeId": "198208148224",
      "firstName": "Utbränd",
      "lastName": "Spjälsäng"
  },
  {
      "partnerNumberIndividual": "0030953388",
      "employeeId": "198208152721",
      "firstName": "Öppenheladagen",
      "lastName": "Åretruntboende"
  },
  {
      "partnerNumberIndividual": "0030956145",
      "employeeId": "198208172323",
      "firstName": "Etnisk",
      "lastName": "Köksinredning"
  },
  {
      "partnerNumberIndividual": "0030959526",
      "employeeId": "198208188923",
      "firstName": "Retlig",
      "lastName": "Avloppsslam"
  },
  {
      "partnerNumberIndividual": "0030960404",
      "employeeId": "198208193725",
      "firstName": "Kors",
      "lastName": "Sjukvårdsinrättning"
  },
  {
      "partnerNumberIndividual": "0030960484",
      "employeeId": "198208194020",
      "firstName": "Sölig",
      "lastName": "Natursiden"
  },
  {
      "partnerNumberIndividual": "0030960819",
      "employeeId": "198208195225",
      "firstName": "Prestationsorienterad",
      "lastName": "Natursiden"
  },
  {
      "partnerNumberIndividual": "0030963311",
      "employeeId": "198208209125",
      "firstName": "Väldifferentierad",
      "lastName": "Jamaicabäverråtta"
  },
  {
      "partnerNumberIndividual": "0030965659",
      "employeeId": "198208222326",
      "firstName": "Fröjdefull",
      "lastName": "Uppsökare"
  },
  {
      "partnerNumberIndividual": "0030966959",
      "employeeId": "198208220528",
      "firstName": "Khaki",
      "lastName": "Rutigtmönster"
  },
  {
      "partnerNumberIndividual": "0030968894",
      "employeeId": "198208242522",
      "firstName": "Spelad",
      "lastName": "Vattenstäkra"
  },
  {
      "partnerNumberIndividual": "0030969034",
      "employeeId": "198208243728",
      "firstName": "Tidvattens",
      "lastName": "Sommarväder"
  },
  {
      "partnerNumberIndividual": "0030970777",
      "employeeId": "198208241326",
      "firstName": "Insufficienskänsla",
      "lastName": "Konturspår"
  },
  {
      "partnerNumberIndividual": "0030971860",
      "employeeId": "198208256423",
      "firstName": "Bifalls",
      "lastName": "Klepsydra"
  },
  {
      "partnerNumberIndividual": "0030973262",
      "employeeId": "198208262421",
      "firstName": "Fyrfota",
      "lastName": "Gruppspråk"
  },
  {
      "partnerNumberIndividual": "0030973317",
      "employeeId": "198208262728",
      "firstName": "Skärbar",
      "lastName": "Jordenssalt"
  },
  {
      "partnerNumberIndividual": "0030976551",
      "employeeId": "198208277825",
      "firstName": "Jobbig",
      "lastName": "Akterom"
  },
  {
      "partnerNumberIndividual": "0030985110",
      "employeeId": "198208012925",
      "firstName": "Ljudlig",
      "lastName": "Cyanidlutning"
  },
  {
      "partnerNumberIndividual": "0030985507",
      "employeeId": "198208013220",
      "firstName": "Sim",
      "lastName": "Introduktionspris"
  },
  {
      "partnerNumberIndividual": "0030989124",
      "employeeId": "198208020720",
      "firstName": "Taklös",
      "lastName": "Åtskildhet"
  },
  {
      "partnerNumberIndividual": "0030990160",
      "employeeId": "198208035520",
      "firstName": "Renad",
      "lastName": "Macquarierall"
  },
  {
      "partnerNumberIndividual": "0030990638",
      "employeeId": "198208036122",
      "firstName": "Reformvänlig",
      "lastName": "Champagnetillverkare"
  },
  {
      "partnerNumberIndividual": "0030996298",
      "employeeId": "198208060825",
      "firstName": "Förkatolsk",
      "lastName": "Återbesättning"
  },
  {
      "partnerNumberIndividual": "0030996343",
      "employeeId": "198208061427",
      "firstName": "Deltidsanställd",
      "lastName": "Marschformation"
  },
  {
      "partnerNumberIndividual": "0030999025",
      "employeeId": "198208083728",
      "firstName": "Spacey",
      "lastName": "Resegaranti"
  },
  {
      "partnerNumberIndividual": "0030999391",
      "employeeId": "198208084320",
      "firstName": "Tillsist",
      "lastName": "Apa"
  },
  {
      "partnerNumberIndividual": "0031002283",
      "employeeId": "198209093320",
      "firstName": "Övertalningsbar",
      "lastName": "Alpsporre"
  },
  {
      "partnerNumberIndividual": "0031005767",
      "employeeId": "198209100828",
      "firstName": "Sommarvarm",
      "lastName": "Fläcktjockfot"
  },
  {
      "partnerNumberIndividual": "0031005815",
      "employeeId": "198209100224",
      "firstName": "Samskole",
      "lastName": "Smågnat"
  },
  {
      "partnerNumberIndividual": "0031010690",
      "employeeId": "198209135220",
      "firstName": "Dermatoplastisk",
      "lastName": "Aerosolsprutning"
  },
  {
      "partnerNumberIndividual": "0031010744",
      "employeeId": "198209136129",
      "firstName": "Partitrogen",
      "lastName": "Övningsgranat"
  },
  {
      "partnerNumberIndividual": "0031011585",
      "employeeId": "198209142424",
      "firstName": "Accentfri",
      "lastName": "Jetstråle"
  },
  {
      "partnerNumberIndividual": "0031014214",
      "employeeId": "198209156325",
      "firstName": "Brytbar",
      "lastName": "Kvartärgeologi"
  },
  {
      "partnerNumberIndividual": "0031014246",
      "employeeId": "198209156929",
      "firstName": "Ädel",
      "lastName": "Långpassning"
  },
  {
      "partnerNumberIndividual": "0031014673",
      "employeeId": "198209157224",
      "firstName": "Vaksam",
      "lastName": "Kinesisktaggsovare"
  },
  {
      "partnerNumberIndividual": "0031015311",
      "employeeId": "198209162323",
      "firstName": "Örnnäst",
      "lastName": "Morgonstjärna"
  },
  {
      "partnerNumberIndividual": "0031018960",
      "employeeId": "198209178626",
      "firstName": "Ytterligare",
      "lastName": "Äxing"
  },
  {
      "partnerNumberIndividual": "0031019516",
      "employeeId": "198209182826",
      "firstName": "Glasögonbärande",
      "lastName": "Investeringsfond"
  },
  {
      "partnerNumberIndividual": "0031022829",
      "employeeId": "198209198525",
      "firstName": "Obeivrad",
      "lastName": "Industriförorening"
  },
  {
      "partnerNumberIndividual": "0031023803",
      "employeeId": "198209204224",
      "firstName": "Tangentbordsstyrd",
      "lastName": "Årsmötesdeltagare"
  },
  {
      "partnerNumberIndividual": "0031026889",
      "employeeId": "198209210528",
      "firstName": "Nykomponerad",
      "lastName": "Driftsättning"
  },
  {
      "partnerNumberIndividual": "0031028738",
      "employeeId": "198209226227",
      "firstName": "Tölpig",
      "lastName": "Jordmån"
  },
  {
      "partnerNumberIndividual": "0031029771",
      "employeeId": "198209233728",
      "firstName": "Itmedveten",
      "lastName": "Avbärgning"
  },
  {
      "partnerNumberIndividual": "0031032606",
      "employeeId": "198209246423",
      "firstName": "Evasiv",
      "lastName": "Storskulden"
  },
  {
      "partnerNumberIndividual": "0031032680",
      "employeeId": "198209246126",
      "firstName": "Handlingsklar",
      "lastName": "Deklamator"
  },
  {
      "partnerNumberIndividual": "0031033142",
      "employeeId": "198209248221",
      "firstName": "Osystematisk",
      "lastName": "Levnadsregel"
  },
  {
      "partnerNumberIndividual": "0031033577",
      "employeeId": "198209252421",
      "firstName": "Motsägelsebar",
      "lastName": "Åretruntboende"
  },
  {
      "partnerNumberIndividual": "0031033932",
      "employeeId": "198209252728",
      "firstName": "Livegen",
      "lastName": "Överklassdygd"
  },
  {
      "partnerNumberIndividual": "0031034491",
      "employeeId": "198209254229",
      "firstName": "Bombmattefällande",
      "lastName": "Allvarsman"
  },
  {
      "partnerNumberIndividual": "0031036871",
      "employeeId": "198209267825",
      "firstName": "Färgframkallande",
      "lastName": "Kritikersuccé"
  },
  {
      "partnerNumberIndividual": "0031037854",
      "employeeId": "198209273229",
      "firstName": "Uppsökande",
      "lastName": "Överste"
  },
  {
      "partnerNumberIndividual": "0031048952",
      "employeeId": "198209024325",
      "firstName": "Malisk",
      "lastName": "Vävnad"
  },
  {
      "partnerNumberIndividual": "0031049396",
      "employeeId": "198209025223",
      "firstName": "Opersonlig",
      "lastName": "Cellofantejp"
  },
  {
      "partnerNumberIndividual": "0031050732",
      "employeeId": "198209032724",
      "firstName": "Accelererande",
      "lastName": "Beklädnadsförråd"
  },
  {
      "partnerNumberIndividual": "0031053113",
      "employeeId": "198209046328",
      "firstName": "Ledar",
      "lastName": "Energiproducerandemineral"
  },
  {
      "partnerNumberIndividual": "0031053251",
      "employeeId": "198209047821",
      "firstName": "Behandlande",
      "lastName": "Flythjälp"
  },
  {
      "partnerNumberIndividual": "0031053295",
      "employeeId": "198209047227",
      "firstName": "Guldgul",
      "lastName": "Cellofantejp"
  },
  {
      "partnerNumberIndividual": "0031054054",
      "employeeId": "198209052623",
      "firstName": "Algin",
      "lastName": "Startpedal"
  },
  {
      "partnerNumberIndividual": "0031054180",
      "employeeId": "198209053225",
      "firstName": "Allmäntbekant",
      "lastName": "Vävnad"
  },
  {
      "partnerNumberIndividual": "0031058390",
      "employeeId": "198209074023",
      "firstName": "Motsägelsebar",
      "lastName": "Urinstinkt"
  },
  {
      "partnerNumberIndividual": "0031061292",
      "employeeId": "198209088221",
      "firstName": "Vattenburen",
      "lastName": "Dagspress"
  },
  {
      "partnerNumberIndividual": "0031061698",
      "employeeId": "198209089120",
      "firstName": "Mörkhårig",
      "lastName": "Talsymbol"
  },
  {
      "partnerNumberIndividual": "0031065608",
      "employeeId": "198210104728",
      "firstName": "Guldfärgad",
      "lastName": "Teaterkostym"
  },
  {
      "partnerNumberIndividual": "0031066133",
      "employeeId": "198210106228",
      "firstName": "Omflyttbar",
      "lastName": "Läkemedelskontroll"
  },
  {
      "partnerNumberIndividual": "0031069244",
      "employeeId": "198210125228",
      "firstName": "Skimmelfärgad",
      "lastName": "Beardie"
  },
  {
      "partnerNumberIndividual": "0031069271",
      "employeeId": "198210126127",
      "firstName": "Sensualistisk",
      "lastName": "Bearbetaning"
  },
  {
      "partnerNumberIndividual": "0031069565",
      "employeeId": "198210127927",
      "firstName": "Deltid",
      "lastName": "Kaliumtiocyanat"
  },
  {
      "partnerNumberIndividual": "0031074640",
      "employeeId": "198210152321",
      "firstName": "Tunnklädd",
      "lastName": "Borrplats"
  },
  {
      "partnerNumberIndividual": "0031074724",
      "employeeId": "198210152628",
      "firstName": "Antiimperialist",
      "lastName": "Intvålning"
  },
  {
      "partnerNumberIndividual": "0031075202",
      "employeeId": "198210153220",
      "firstName": "Helförsäkrad",
      "lastName": "Marknadsfokuserad"
  },
  {
      "partnerNumberIndividual": "0031075217",
      "employeeId": "198210154426",
      "firstName": "Medhjälpande",
      "lastName": "Spolhjul"
  },
  {
      "partnerNumberIndividual": "0031078501",
      "employeeId": "198210168020",
      "firstName": "Reglementarisk",
      "lastName": "Svartkronadsiska"
  },
  {
      "partnerNumberIndividual": "0031078544",
      "employeeId": "198210169820",
      "firstName": "Babylonisk",
      "lastName": "Jättefylla"
  },
  {
      "partnerNumberIndividual": "0031081645",
      "employeeId": "198210189125",
      "firstName": "Flersidig",
      "lastName": "Getberget"
  },
  {
      "partnerNumberIndividual": "0031085590",
      "employeeId": "198210200823",
      "firstName": "Uppassad",
      "lastName": "Oljekastarbricka"
  },
  {
      "partnerNumberIndividual": "0031087019",
      "employeeId": "198210216225",
      "firstName": "Kopparröd",
      "lastName": "Vapenkammare"
  },
  {
      "partnerNumberIndividual": "0031088042",
      "employeeId": "198210222520",
      "firstName": "Lämplig",
      "lastName": "Silvervinge"
  },
  {
      "partnerNumberIndividual": "0031091436",
      "employeeId": "198210236421",
      "firstName": "Välskapad",
      "lastName": "Rödnäbbadfrankolin"
  },
  {
      "partnerNumberIndividual": "0031091938",
      "employeeId": "198210238229",
      "firstName": "Julpimpande",
      "lastName": "Handöverfräs"
  },
  {
      "partnerNumberIndividual": "0031092448",
      "employeeId": "198210242726",
      "firstName": "Enaxlad",
      "lastName": "Nollningsvecka"
  },
  {
      "partnerNumberIndividual": "0031094985",
      "employeeId": "198210250224",
      "firstName": "Torkkänslig",
      "lastName": "Huvudsajt"
  },
  {
      "partnerNumberIndividual": "0031098387",
      "employeeId": "198210278621",
      "firstName": "Känd",
      "lastName": "Fartsladd"
  },
  {
      "partnerNumberIndividual": "0031098433",
      "employeeId": "198210278928",
      "firstName": "Felinställd",
      "lastName": "Champagnetillverkare"
  },
  {
      "partnerNumberIndividual": "0031106593",
      "employeeId": "198210015221",
      "firstName": "Bukig",
      "lastName": "Myggblomster"
  },
  {
      "partnerNumberIndividual": "0031110529",
      "employeeId": "198210037225",
      "firstName": "Kopparröd",
      "lastName": "Jobbschema"
  },
  {
      "partnerNumberIndividual": "0031111042",
      "employeeId": "198210042324",
      "firstName": "Allmäntbekant",
      "lastName": "Guldnissöga"
  },
  {
      "partnerNumberIndividual": "0031112750",
      "employeeId": "198210040526",
      "firstName": "Morgonpigg",
      "lastName": "Tempocykel"
  },
  {
      "partnerNumberIndividual": "0031112766",
      "employeeId": "198210040823",
      "firstName": "Musikantisk",
      "lastName": "Blystearat"
  },
  {
      "partnerNumberIndividual": "0031114151",
      "employeeId": "198210056225",
      "firstName": "Oratorisk",
      "lastName": "Borrspån"
  },
  {
      "partnerNumberIndividual": "0031115565",
      "employeeId": "198210064021",
      "firstName": "Kors",
      "lastName": "Fartsladd"
  },
  {
      "partnerNumberIndividual": "0031117595",
      "employeeId": "198210078526",
      "firstName": "Invalid",
      "lastName": "Landet"
  },
  {
      "partnerNumberIndividual": "0031122388",
      "employeeId": "198211102523",
      "firstName": "Genomkokt",
      "lastName": "Offerpris"
  },
  {
      "partnerNumberIndividual": "0031123765",
      "employeeId": "198211109825",
      "firstName": "Kopparröd",
      "lastName": "Splittrad"
  },
  {
      "partnerNumberIndividual": "0031129774",
      "employeeId": "198211143220",
      "firstName": "Bionomisk",
      "lastName": "Maltesare"
  },
  {
      "partnerNumberIndividual": "0031132690",
      "employeeId": "198211165827",
      "firstName": "Bukstinn",
      "lastName": "Magoperation"
  },
  {
      "partnerNumberIndividual": "0031132743",
      "employeeId": "198211165223",
      "firstName": "Österrikiskpreussisk",
      "lastName": "Stapeldiagram"
  },
  {
      "partnerNumberIndividual": "0031135208",
      "employeeId": "198211178226",
      "firstName": "Zen",
      "lastName": "Alkoläsk"
  },
  {
      "partnerNumberIndividual": "0031135222",
      "employeeId": "198211179422",
      "firstName": "Rankig",
      "lastName": "Förhandlingspolitik"
  },
  {
      "partnerNumberIndividual": "0031136159",
      "employeeId": "198211184224",
      "firstName": "Läckande",
      "lastName": "Nedrekontrollgräns"
  },
  {
      "partnerNumberIndividual": "0031136517",
      "employeeId": "198211186328",
      "firstName": "Opåverkbar",
      "lastName": "Ljuvalivet"
  },
  {
      "partnerNumberIndividual": "0031143059",
      "employeeId": "198211228526",
      "firstName": "Deltid",
      "lastName": "Örn"
  },
  {
      "partnerNumberIndividual": "0031143475",
      "employeeId": "198211232429",
      "firstName": "Fisklik",
      "lastName": "Läkemedelskontroll"
  },
  {
      "partnerNumberIndividual": "0031143878",
      "employeeId": "198211232122",
      "firstName": "Dagvill",
      "lastName": "Paperback"
  },
  {
      "partnerNumberIndividual": "0031143905",
      "employeeId": "198211233922",
      "firstName": "Datorinriktad",
      "lastName": "Lärofrihet"
  },
  {
      "partnerNumberIndividual": "0031147533",
      "employeeId": "198211253227",
      "firstName": "Neuroberäknande",
      "lastName": "Jordmån"
  },
  {
      "partnerNumberIndividual": "0031150307",
      "employeeId": "198211268928",
      "firstName": "Sentblommande",
      "lastName": "Justeringavfinansiellöversikt"
  },
  {
      "partnerNumberIndividual": "0031151296",
      "employeeId": "198211274322",
      "firstName": "Numerär",
      "lastName": "Matbit"
  },
  {
      "partnerNumberIndividual": "0031151777",
      "employeeId": "198211276129",
      "firstName": "Reparerbar",
      "lastName": "Fläcktjockfot"
  },
  {
      "partnerNumberIndividual": "0031159516",
      "employeeId": "198211026326",
      "firstName": "Oljeriven",
      "lastName": "Toppmatch"
  },
  {
      "partnerNumberIndividual": "0031160001",
      "employeeId": "198211027225",
      "firstName": "Ihopvikbar",
      "lastName": "Nedmjölning"
  },
  {
      "partnerNumberIndividual": "0031166453",
      "employeeId": "198211068229",
      "firstName": "Postakut",
      "lastName": "Franchising"
  },
  {
      "partnerNumberIndividual": "0031167059",
      "employeeId": "198211073922",
      "firstName": "Såpoperalik",
      "lastName": "Tempocykel"
  },
  {
      "partnerNumberIndividual": "0031229802",
      "employeeId": "198301126135",
      "firstName": "Gravimetrisk",
      "lastName": "Andrahandsval"
  },
  {
      "partnerNumberIndividual": "0031234843",
      "employeeId": "198301152636",
      "firstName": "Moralistisk",
      "lastName": "Stridsvagnsduell"
  },
  {
      "partnerNumberIndividual": "0031235286",
      "employeeId": "198301153238",
      "firstName": "Somkanförnekas",
      "lastName": "Magnetmotstånd"
  },
  {
      "partnerNumberIndividual": "0031235303",
      "employeeId": "198301154731",
      "firstName": "Toskansk",
      "lastName": "Mätressregemente"
  },
  {
      "partnerNumberIndividual": "0031238242",
      "employeeId": "198301169838",
      "firstName": "Gulgrön",
      "lastName": "Grönaracari"
  },
  {
      "partnerNumberIndividual": "0031245603",
      "employeeId": "198301200237",
      "firstName": "Orientalisk",
      "lastName": "Teknikterm"
  },
  {
      "partnerNumberIndividual": "0031246878",
      "employeeId": "198301216233",
      "firstName": "Malisk",
      "lastName": "Överste"
  },
  {
      "partnerNumberIndividual": "0031246924",
      "employeeId": "198301217439",
      "firstName": "Genomandad",
      "lastName": "Kärandesidan"
  },
  {
      "partnerNumberIndividual": "0031250292",
      "employeeId": "198301236132",
      "firstName": "Skotträdd",
      "lastName": "Konturspår"
  },
  {
      "partnerNumberIndividual": "0031250636",
      "employeeId": "198301238831",
      "firstName": "Brabantsk",
      "lastName": "Härjare"
  },
  {
      "partnerNumberIndividual": "0031251092",
      "employeeId": "198301242437",
      "firstName": "Darrhänt",
      "lastName": "Läkarspalt"
  },
  {
      "partnerNumberIndividual": "0031251192",
      "employeeId": "198301242734",
      "firstName": "Uppvärmbar",
      "lastName": "Frostförsäkring"
  },
  {
      "partnerNumberIndividual": "0031254920",
      "employeeId": "198301263235",
      "firstName": "Utomrättslig",
      "lastName": "Amskrock"
  },
  {
      "partnerNumberIndividual": "0031257918",
      "employeeId": "198301278936",
      "firstName": "Kors",
      "lastName": "Kalkalg"
  },
  {
      "partnerNumberIndividual": "0031270183",
      "employeeId": "198301037837",
      "firstName": "Överprissatt",
      "lastName": "Applikationsfil"
  },
  {
      "partnerNumberIndividual": "0031270223",
      "employeeId": "198301037233",
      "firstName": "Reglementarisk",
      "lastName": "Gulbentflugskvätta"
  },
  {
      "partnerNumberIndividual": "0031270799",
      "employeeId": "198301042332",
      "firstName": "Anställd",
      "lastName": "Neurotiker"
  },
  {
      "partnerNumberIndividual": "0031271147",
      "employeeId": "198301042639",
      "firstName": "Fullriggad",
      "lastName": "Droppeihavet"
  },
  {
      "partnerNumberIndividual": "0031272656",
      "employeeId": "198301040831",
      "firstName": "Exkretorisk",
      "lastName": "Fläkthastighet"
  },
  {
      "partnerNumberIndividual": "0031274013",
      "employeeId": "198301058932",
      "firstName": "Skotträdd",
      "lastName": "Stormaktstid"
  },
  {
      "partnerNumberIndividual": "0031275305",
      "employeeId": "198301064039",
      "firstName": "Oför",
      "lastName": "Avloppsvatten"
  },
  {
      "partnerNumberIndividual": "0031278140",
      "employeeId": "198301084235",
      "firstName": "Interatomär",
      "lastName": "Omvikningsstål"
  },
  {
      "partnerNumberIndividual": "0031281122",
      "employeeId": "198302094738",
      "firstName": "Handlingsduglig",
      "lastName": "Ljuvalivet"
  },
  {
      "partnerNumberIndividual": "0031281584",
      "employeeId": "198302096238",
      "firstName": "Durativ",
      "lastName": "Småstiltatryck"
  },
  {
      "partnerNumberIndividual": "0031285359",
      "employeeId": "198302115236",
      "firstName": "Bombmattefällande",
      "lastName": "Akademikerbarn"
  },
  {
      "partnerNumberIndividual": "0031285448",
      "employeeId": "198302116135",
      "firstName": "Deriverbar",
      "lastName": "Elektroniskhandel"
  },
  {
      "partnerNumberIndividual": "0031289132",
      "employeeId": "198302136331",
      "firstName": "Skrafferad",
      "lastName": "Örlogsbesök"
  },
  {
      "partnerNumberIndividual": "0031293087",
      "employeeId": "198302158939",
      "firstName": "Omedelbart",
      "lastName": "Cylinderfläkt"
  },
  {
      "partnerNumberIndividual": "0031294744",
      "employeeId": "198302165231",
      "firstName": "Färgframkallande",
      "lastName": "Institutionelltsamarbete"
  },
  {
      "partnerNumberIndividual": "0031298151",
      "employeeId": "198302179430",
      "firstName": "Debattlysten",
      "lastName": "Förbränningsanläggning"
  },
  {
      "partnerNumberIndividual": "0031298695",
      "employeeId": "198302183937",
      "firstName": "Jobbig",
      "lastName": "Ljusbågeskydd"
  },
  {
      "partnerNumberIndividual": "0031299082",
      "employeeId": "198302184232",
      "firstName": "Dermatoplastisk",
      "lastName": "Terum"
  },
  {
      "partnerNumberIndividual": "0031299195",
      "employeeId": "198302186336",
      "firstName": "Julpimpande",
      "lastName": "Proteintyrosinkinas"
  },
  {
      "partnerNumberIndividual": "0031304201",
      "employeeId": "198302212538",
      "firstName": "Hanseatisk",
      "lastName": "Låneavtal"
  },
  {
      "partnerNumberIndividual": "0031304268",
      "employeeId": "198302212231",
      "firstName": "Prestationsorienterad",
      "lastName": "Månkalender"
  },
  {
      "partnerNumberIndividual": "0031306230",
      "employeeId": "198302225837",
      "firstName": "Evasiv",
      "lastName": "Äkthet"
  },
  {
      "partnerNumberIndividual": "0031306799",
      "employeeId": "198302227338",
      "firstName": "Bulldogslik",
      "lastName": "Tamgås"
  },
  {
      "partnerNumberIndividual": "0031307156",
      "employeeId": "198302227932",
      "firstName": "Tillyxad",
      "lastName": "Omao"
  },
  {
      "partnerNumberIndividual": "0031307199",
      "employeeId": "198302228237",
      "firstName": "Bombmattefällande",
      "lastName": "Etylortoformiat"
  },
  {
      "partnerNumberIndividual": "0031311862",
      "employeeId": "198302252633",
      "firstName": "Ledar",
      "lastName": "Brandriktning"
  },
  {
      "partnerNumberIndividual": "0031312117",
      "employeeId": "198302252930",
      "firstName": "Mellan",
      "lastName": "Cellurval"
  },
  {
      "partnerNumberIndividual": "0031315723",
      "employeeId": "198302269835",
      "firstName": "Sjöfarande",
      "lastName": "Kariol"
  },
  {
      "partnerNumberIndividual": "0031316223",
      "employeeId": "198302273738",
      "firstName": "Endoplasmatisk",
      "lastName": "Bearbetaning"
  },
  {
      "partnerNumberIndividual": "0031321678",
      "employeeId": "198302019438",
      "firstName": "Obillig",
      "lastName": "Hermelinsskinn"
  },
  {
      "partnerNumberIndividual": "0031328266",
      "employeeId": "198302053437",
      "firstName": "Bifokal",
      "lastName": "Oxfordrörelsemedlem"
  },
  {
      "partnerNumberIndividual": "0031339575",
      "employeeId": "198303105236",
      "firstName": "Genotypisk",
      "lastName": "Barnsligtillgivenhet"
  },
  {
      "partnerNumberIndividual": "0031343559",
      "employeeId": "198303126331",
      "firstName": "Bonapartistisk",
      "lastName": "Medicinutgift"
  },
  {
      "partnerNumberIndividual": "0031343607",
      "employeeId": "198303126935",
      "firstName": "Helförsäkrad",
      "lastName": "Spårdjup"
  },
  {
      "partnerNumberIndividual": "0031344002",
      "employeeId": "198303127230",
      "firstName": "Omusikalisk",
      "lastName": "Snigelcoua"
  },
  {
      "partnerNumberIndividual": "0031344525",
      "employeeId": "198303132339",
      "firstName": "Finstämd",
      "lastName": "Lustslott"
  },
  {
      "partnerNumberIndividual": "0031352362",
      "employeeId": "198303168838",
      "firstName": "Proportionell",
      "lastName": "Mönsterexemplar"
  },
  {
      "partnerNumberIndividual": "0031353875",
      "employeeId": "198303174232",
      "firstName": "Olycksfri",
      "lastName": "Valkalv"
  },
  {
      "partnerNumberIndividual": "0031354060",
      "employeeId": "198303176336",
      "firstName": "Staccato",
      "lastName": "Eftermiddagsskift"
  },
  {
      "partnerNumberIndividual": "0031355457",
      "employeeId": "198309115130",
      "firstName": "Konkretistisk",
      "lastName": "Arbetsmarknadspension"
  },
  {
      "partnerNumberIndividual": "0031356912",
      "employeeId": "198303180833",
      "firstName": "Behäftadmedfel",
      "lastName": "Hedersgubbe"
  },
  {
      "partnerNumberIndividual": "0031359355",
      "employeeId": "198303202835",
      "firstName": "Tangentbordsstyrd",
      "lastName": "Idealman"
  },
  {
      "partnerNumberIndividual": "0031362883",
      "employeeId": "198303222437",
      "firstName": "Utlämningsbar",
      "lastName": "Färgskiftning"
  },
  {
      "partnerNumberIndividual": "0031366515",
      "employeeId": "198303237831",
      "firstName": "Kostnadspolitisk",
      "lastName": "Förpostfäktning"
  },
  {
      "partnerNumberIndividual": "0031366558",
      "employeeId": "198303237237",
      "firstName": "Musikantisk",
      "lastName": "Vävnad"
  },
  {
      "partnerNumberIndividual": "0031367532",
      "employeeId": "198303242633",
      "firstName": "Penningorienterad",
      "lastName": "Yttervingturbin"
  },
  {
      "partnerNumberIndividual": "0031367615",
      "employeeId": "198303242930",
      "firstName": "Syndfri",
      "lastName": "Aktiebank"
  },
  {
      "partnerNumberIndividual": "0031368060",
      "employeeId": "198303243235",
      "firstName": "Dimhöljd",
      "lastName": "Förståndsutveckling"
  },
  {
      "partnerNumberIndividual": "0031386325",
      "employeeId": "198303016334",
      "firstName": "Välsittande",
      "lastName": "Ekorrbäver"
  },
  {
      "partnerNumberIndividual": "0031386713",
      "employeeId": "198303017837",
      "firstName": "Välkonserverad",
      "lastName": "Kontrollmanometer"
  },
  {
      "partnerNumberIndividual": "0031386740",
      "employeeId": "198303017233",
      "firstName": "Iglädjerus",
      "lastName": "Syre"
  },
  {
      "partnerNumberIndividual": "0031387734",
      "employeeId": "198303022332",
      "firstName": "Profan",
      "lastName": "Insektsmundel"
  },
  {
      "partnerNumberIndividual": "0031391682",
      "employeeId": "198303042538",
      "firstName": "Torkkänslig",
      "lastName": "Bariumprotoxide"
  },
  {
      "partnerNumberIndividual": "0031394909",
      "employeeId": "198303059433",
      "firstName": "Biofysisk",
      "lastName": "Resegaranti"
  },
  {
      "partnerNumberIndividual": "0031395838",
      "employeeId": "198303063930",
      "firstName": "Överprissatt",
      "lastName": "Restvärdesförsäkring"
  },
  {
      "partnerNumberIndividual": "0031395855",
      "employeeId": "198303063039",
      "firstName": "Fullskalig",
      "lastName": "Storgalangarot"
  },
  {
      "partnerNumberIndividual": "0031399215",
      "employeeId": "198303070232",
      "firstName": "Uteliggande",
      "lastName": "Köpmansgille"
  },
  {
      "partnerNumberIndividual": "0031400719",
      "employeeId": "198303086238",
      "firstName": "Somnambulistisk",
      "lastName": "Fariseism"
  },
  {
      "partnerNumberIndividual": "0031403530",
      "employeeId": "198304095832",
      "firstName": "Skattepliktig",
      "lastName": "Nerslagning"
  },
  {
      "partnerNumberIndividual": "0031404001",
      "employeeId": "198304096137",
      "firstName": "Västmanländsk",
      "lastName": "Heavyband"
  },
  {
      "partnerNumberIndividual": "0031407408",
      "employeeId": "198304116331",
      "firstName": "Elektrohydraulisk",
      "lastName": "Lyftsele"
  },
  {
      "partnerNumberIndividual": "0031408365",
      "employeeId": "198304122933",
      "firstName": "Handlingsklar",
      "lastName": "Fraktionsdestillation"
  },
  {
      "partnerNumberIndividual": "0031411260",
      "employeeId": "198304137139",
      "firstName": "Tillrufsad",
      "lastName": "Acetofenon"
  },
  {
      "partnerNumberIndividual": "0031412506",
      "employeeId": "198304142832",
      "firstName": "Bombmattefällande",
      "lastName": "Grundskolekompetens"
  },
  {
      "partnerNumberIndividual": "0031412550",
      "employeeId": "198304143731",
      "firstName": "Spetig",
      "lastName": "Nollningsvecka"
  },
  {
      "partnerNumberIndividual": "0031413060",
      "employeeId": "198304145538",
      "firstName": "Exkluderande",
      "lastName": "Skiktmoln"
  },
  {
      "partnerNumberIndividual": "0031416986",
      "employeeId": "198304159133",
      "firstName": "Expropierad",
      "lastName": "Hike"
  },
  {
      "partnerNumberIndividual": "0031426773",
      "employeeId": "198304206132",
      "firstName": "Akritisk",
      "lastName": "Låneavtal"
  },
  {
      "partnerNumberIndividual": "0031426959",
      "employeeId": "198304208534",
      "firstName": "Medinsjunketansikte",
      "lastName": "Språkdiskriminering"
  },
  {
      "partnerNumberIndividual": "0031431874",
      "employeeId": "198304227831",
      "firstName": "Standard",
      "lastName": "Snigelcoua"
  },
  {
      "partnerNumberIndividual": "0031436633",
      "employeeId": "198304249835",
      "firstName": "Endoplasmatisk",
      "lastName": "Brass"
  },
  {
      "partnerNumberIndividual": "0031437475",
      "employeeId": "198304253738",
      "firstName": "Georgisk",
      "lastName": "Betongblandning"
  },
  {
      "partnerNumberIndividual": "0031437995",
      "employeeId": "198304256137",
      "firstName": "Enaxlad",
      "lastName": "Referensmaterial"
  },
  {
      "partnerNumberIndividual": "0031440384",
      "employeeId": "198304269734",
      "firstName": "Nosgrann",
      "lastName": "Kunskapsspridning"
  },
  {
      "partnerNumberIndividual": "0031441807",
      "employeeId": "198304276937",
      "firstName": "Original",
      "lastName": "Flyttbestyr"
  },
  {
      "partnerNumberIndividual": "0031457273",
      "employeeId": "198304047338",
      "firstName": "Dermatoplastisk",
      "lastName": "Yrkesgrupp"
  },
  {
      "partnerNumberIndividual": "0031457729",
      "employeeId": "198304048534",
      "firstName": "Samhällsmedicinsk",
      "lastName": "Guldgrävning"
  },
  {
      "partnerNumberIndividual": "0031458546",
      "employeeId": "198304052734",
      "firstName": "Immun",
      "lastName": "Svetsanordning"
  },
  {
      "partnerNumberIndividual": "0031470289",
      "employeeId": "198305106331",
      "firstName": "Israelvänlig",
      "lastName": "Lågfjäll"
  },
  {
      "partnerNumberIndividual": "0031470722",
      "employeeId": "198305107230",
      "firstName": "Gråaktig",
      "lastName": "Dalöppning"
  },
  {
      "partnerNumberIndividual": "0031471228",
      "employeeId": "198305112339",
      "firstName": "Tidvattens",
      "lastName": "Laternamagica"
  },
  {
      "partnerNumberIndividual": "0031476564",
      "employeeId": "198305132535",
      "firstName": "Pulverlackerad",
      "lastName": "Allvarsman"
  },
  {
      "partnerNumberIndividual": "0031476644",
      "employeeId": "198305132832",
      "firstName": "Vållande",
      "lastName": "Samhörighet"
  },
  {
      "partnerNumberIndividual": "0031480634",
      "employeeId": "198305149430",
      "firstName": "Epicen",
      "lastName": "Dådlöshet"
  },
  {
      "partnerNumberIndividual": "0031491459",
      "employeeId": "198305203336",
      "firstName": "Folkmordsliknande",
      "lastName": "Oskaplighet"
  },
  {
      "partnerNumberIndividual": "0031491487",
      "employeeId": "198305203930",
      "firstName": "Ihopvikbar",
      "lastName": "Startpedal"
  },
  {
      "partnerNumberIndividual": "0031493953",
      "employeeId": "198305216932",
      "firstName": "Halvvåt",
      "lastName": "Avbrytarvals"
  },
  {
      "partnerNumberIndividual": "0031493983",
      "employeeId": "198305217831",
      "firstName": "Lockförsedd",
      "lastName": "Störresultanspett"
  },
  {
      "partnerNumberIndividual": "0031494352",
      "employeeId": "198305217237",
      "firstName": "Pölsig",
      "lastName": "Årstidsvind"
  },
  {
      "partnerNumberIndividual": "0031494793",
      "employeeId": "198305222336",
      "firstName": "Plandels",
      "lastName": "Batterilåda"
  },
  {
      "partnerNumberIndividual": "0031498802",
      "employeeId": "198305243738",
      "firstName": "Havsrättslig",
      "lastName": "Magnesiumstearat"
  },
  {
      "partnerNumberIndividual": "0031502519",
      "employeeId": "198305259130",
      "firstName": "Kapitalistisk",
      "lastName": "Stridstyrka"
  },
  {
      "partnerNumberIndividual": "0031503787",
      "employeeId": "198305266333",
      "firstName": "Applikationsoberoende",
      "lastName": "Kylslinga"
  },
  {
      "partnerNumberIndividual": "0031504776",
      "employeeId": "198305272331",
      "firstName": "Välhängd",
      "lastName": "Enfrågepolitik"
  },
  {
      "partnerNumberIndividual": "0031504814",
      "employeeId": "198305272638",
      "firstName": "Framröstad",
      "lastName": "Anropande"
  },
  {
      "partnerNumberIndividual": "0031506912",
      "employeeId": "198305270830",
      "firstName": "Pacifistisk",
      "lastName": "Glansmedel"
  },
  {
      "partnerNumberIndividual": "0031517002",
      "employeeId": "198305022231",
      "firstName": "Babyblå",
      "lastName": "Jordkällare"
  },
  {
      "partnerNumberIndividual": "0031521753",
      "employeeId": "198305042437",
      "firstName": "Artskild",
      "lastName": "Ulster"
  },
  {
      "partnerNumberIndividual": "0031521786",
      "employeeId": "198305042734",
      "firstName": "Förbenad",
      "lastName": "Jägaresamlare"
  },
  {
      "partnerNumberIndividual": "0031522177",
      "employeeId": "198305043930",
      "firstName": "Söder",
      "lastName": "Högmedeltiden"
  },
  {
      "partnerNumberIndividual": "0031522318",
      "employeeId": "198305044235",
      "firstName": "Sträckt",
      "lastName": "Berylliumjodid"
  },
  {
      "partnerNumberIndividual": "0031524847",
      "employeeId": "198305057831",
      "firstName": "Uppkopplad",
      "lastName": "Spraymunstycke"
  },
  {
      "partnerNumberIndividual": "0031529523",
      "employeeId": "198305079835",
      "firstName": "Hörsam",
      "lastName": "Avhorning"
  },
  {
      "partnerNumberIndividual": "0031534080",
      "employeeId": "198306096333",
      "firstName": "Vissa",
      "lastName": "Byggnadstimmer"
  },
  {
      "partnerNumberIndividual": "0031542367",
      "employeeId": "198306138531",
      "firstName": "Ful",
      "lastName": "Majolika"
  },
  {
      "partnerNumberIndividual": "0031542778",
      "employeeId": "198306139430",
      "firstName": "Cyklonartad",
      "lastName": "Konstruktionsstandard"
  },
  {
      "partnerNumberIndividual": "0031543333",
      "employeeId": "198306143937",
      "firstName": "Ask",
      "lastName": "Tetracyaneten"
  },
  {
      "partnerNumberIndividual": "0031546914",
      "employeeId": "198306150833",
      "firstName": "Förbikörande",
      "lastName": "Yrkesbrev"
  },
  {
      "partnerNumberIndividual": "0031547699",
      "employeeId": "198306164735",
      "firstName": "Bortkommenterad",
      "lastName": "Synkroniserare"
  },
  {
      "partnerNumberIndividual": "0031552669",
      "employeeId": "198306185839",
      "firstName": "Georgisk",
      "lastName": "Expojkvän"
  },
  {
      "partnerNumberIndividual": "0031553279",
      "employeeId": "198306188239",
      "firstName": "Intetillämpbar",
      "lastName": "Örn"
  },
  {
      "partnerNumberIndividual": "0031557183",
      "employeeId": "198306212336",
      "firstName": "Sammanhållande",
      "lastName": "Introduktionspris"
  },
  {
      "partnerNumberIndividual": "0031557238",
      "employeeId": "198306212633",
      "firstName": "Köpstark",
      "lastName": "Högmedeltiden"
  },
  {
      "partnerNumberIndividual": "0031557287",
      "employeeId": "198306212930",
      "firstName": "Keff",
      "lastName": "Kroppsspråk"
  },
  {
      "partnerNumberIndividual": "0031557726",
      "employeeId": "198306214738",
      "firstName": "Kortklippt",
      "lastName": "Brandriktning"
  },
  {
      "partnerNumberIndividual": "0031562218",
      "employeeId": "198306234033",
      "firstName": "Ödesbestämd",
      "lastName": "Nageltrång"
  },
  {
      "partnerNumberIndividual": "0031562253",
      "employeeId": "198306235832",
      "firstName": "Förväxlad",
      "lastName": "Dagspris"
  },
  {
      "partnerNumberIndividual": "0031569758",
      "employeeId": "198306260236",
      "firstName": "Didaktisk",
      "lastName": "Intvålning"
  },
  {
      "partnerNumberIndividual": "0031570776",
      "employeeId": "198306276232",
      "firstName": "Alkalilöslig",
      "lastName": "Totalomkostnad"
  },
  {
      "partnerNumberIndividual": "0031582704",
      "employeeId": "198306032437",
      "firstName": "Glädjerusande",
      "lastName": "Resform"
  },
  {
      "partnerNumberIndividual": "0031594938",
      "employeeId": "198307092638",
      "firstName": "Bonusberättigad",
      "lastName": "Sånghöna"
  },
  {
      "partnerNumberIndividual": "0031597946",
      "employeeId": "198307107139",
      "firstName": "Cyklonartad",
      "lastName": "Socialrätt"
  },
  {
      "partnerNumberIndividual": "0031602782",
      "employeeId": "198307136336",
      "firstName": "Vållande",
      "lastName": "Konstruktionsstandard"
  },
  {
      "partnerNumberIndividual": "0031605584",
      "employeeId": "198307140833",
      "firstName": "Allrakäraste",
      "lastName": "Malteserkors"
  },
  {
      "partnerNumberIndividual": "0031610920",
      "employeeId": "198307176134",
      "firstName": "Dålig",
      "lastName": "Läsesällskap"
  },
  {
      "partnerNumberIndividual": "0031611592",
      "employeeId": "198307182439",
      "firstName": "Bekymmersfri",
      "lastName": "Konceptbevis"
  },
  {
      "partnerNumberIndividual": "0031611978",
      "employeeId": "198307183338",
      "firstName": "Främst",
      "lastName": "Fotbollshysteri"
  },
  {
      "partnerNumberIndividual": "0031614214",
      "employeeId": "198307197833",
      "firstName": "Bekymmersfri",
      "lastName": "Arkivdepå"
  },
  {
      "partnerNumberIndividual": "0031614251",
      "employeeId": "198307197239",
      "firstName": "Avgudadyrkande",
      "lastName": "Frittinträde"
  },
  {
      "partnerNumberIndividual": "0031614710",
      "employeeId": "198307202336",
      "firstName": "Snarare",
      "lastName": "Självhypnos"
  },
  {
      "partnerNumberIndividual": "0031621717",
      "employeeId": "198307239437",
      "firstName": "Strukturerad",
      "lastName": "Vidareanvändning"
  },
  {
      "partnerNumberIndividual": "0031622107",
      "employeeId": "198307239734",
      "firstName": "Denaturerad",
      "lastName": "Förbränningsanläggning"
  },
  {
      "partnerNumberIndividual": "0031623153",
      "employeeId": "198307246333",
      "firstName": "Artskild",
      "lastName": "Scintillationsräknare"
  },
  {
      "partnerNumberIndividual": "0031624020",
      "employeeId": "198307252331",
      "firstName": "Atypisk",
      "lastName": "Faktureringsbok"
  },
  {
      "partnerNumberIndividual": "0031624112",
      "employeeId": "198307252935",
      "firstName": "Farlig",
      "lastName": "Kortärm"
  },
  {
      "partnerNumberIndividual": "0031642990",
      "employeeId": "198307045636",
      "firstName": "Felande",
      "lastName": "Skiktmoln"
  },
  {
      "partnerNumberIndividual": "0031646881",
      "employeeId": "198307065832",
      "firstName": "Speedig",
      "lastName": "Endogensubstans"
  },
  {
      "partnerNumberIndividual": "0031647258",
      "employeeId": "198307066434",
      "firstName": "Speedig",
      "lastName": "Kuhlsfladdermus"
  },
  {
      "partnerNumberIndividual": "0031648323",
      "employeeId": "198307072739",
      "firstName": "Gudfruktig",
      "lastName": "Parisiska"
  },
  {
      "partnerNumberIndividual": "0031650354",
      "employeeId": "198307086333",
      "firstName": "Dubbelbottnad",
      "lastName": "Potage"
  },
  {
      "partnerNumberIndividual": "0031654817",
      "employeeId": "198308104036",
      "firstName": "Spolad",
      "lastName": "Någonannanväg"
  },
  {
      "partnerNumberIndividual": "0031657386",
      "employeeId": "198308117939",
      "firstName": "Morfisk",
      "lastName": "Resonansenergi"
  },
  {
      "partnerNumberIndividual": "0031665934",
      "employeeId": "198308165235",
      "firstName": "Blästrad",
      "lastName": "Flyttbestyr"
  },
  {
      "partnerNumberIndividual": "0031667020",
      "employeeId": "198308172439",
      "firstName": "Knäckt",
      "lastName": "Mikrovektor"
  },
  {
      "partnerNumberIndividual": "0031671237",
      "employeeId": "198308192031",
      "firstName": "Tunnhårig",
      "lastName": "Boskapskötare"
  },
  {
      "partnerNumberIndividual": "0031674572",
      "employeeId": "198308209835",
      "firstName": "Närgången",
      "lastName": "Investeringsfond"
  },
  {
      "partnerNumberIndividual": "0031680295",
      "employeeId": "198308242935",
      "firstName": "Bas",
      "lastName": "Akterom"
  },
  {
      "partnerNumberIndividual": "0031684207",
      "employeeId": "198308262537",
      "firstName": "Israelockuperad",
      "lastName": "Skälmeri"
  },
  {
      "partnerNumberIndividual": "0031698362",
      "employeeId": "198308020232",
      "firstName": "Genotypisk",
      "lastName": "Testmoment"
  },
  {
      "partnerNumberIndividual": "0031701768",
      "employeeId": "198308041634",
      "firstName": "Musikantisk",
      "lastName": "Endag"
  },
  {
      "partnerNumberIndividual": "0031706378",
      "employeeId": "198308077836",
      "firstName": "Infällbar",
      "lastName": "Felmeddelande"
  },
  {
      "partnerNumberIndividual": "0031706436",
      "employeeId": "198308077232",
      "firstName": "Esoterisk",
      "lastName": "Ångstrykjärn"
  },
  {
      "partnerNumberIndividual": "0031706909",
      "employeeId": "198308082331",
      "firstName": "Myeloid",
      "lastName": "Ondtunga"
  },
  {
      "partnerNumberIndividual": "0031707384",
      "employeeId": "198308082935",
      "firstName": "Lykantropisk",
      "lastName": "Oxfordrörelsemedlem"
  },
  {
      "partnerNumberIndividual": "0031707491",
      "employeeId": "198308083230",
      "firstName": "Transitorisk",
      "lastName": "Utvecklingshistoria"
  },
  {
      "partnerNumberIndividual": "0031708811",
      "employeeId": "198308080830",
      "firstName": "Hialös",
      "lastName": "Vätgaselektrod"
  },
  {
      "partnerNumberIndividual": "0031709824",
      "employeeId": "198309092537",
      "firstName": "Denaturerad",
      "lastName": "Gulstrupigbulbyl"
  },
  {
      "partnerNumberIndividual": "0031713523",
      "employeeId": "198309108234",
      "firstName": "Partitrogen",
      "lastName": "Statsägande"
  },
  {
      "partnerNumberIndividual": "0031717328",
      "employeeId": "198309134735",
      "firstName": "Granulometrisk",
      "lastName": "Glykokoll"
  },
  {
      "partnerNumberIndividual": "0031718362",
      "employeeId": "198309142530",
      "firstName": "Levrad",
      "lastName": "Australiskhavssula"
  },
  {
      "partnerNumberIndividual": "0031720974",
      "employeeId": "198309155235",
      "firstName": "Halvvåt",
      "lastName": "Flugsnappare"
  },
  {
      "partnerNumberIndividual": "0031721039",
      "employeeId": "198309157934",
      "firstName": "Salutogen",
      "lastName": "Socialbidrag"
  },
  {
      "partnerNumberIndividual": "0031722021",
      "employeeId": "198309163932",
      "firstName": "Paltig",
      "lastName": "Spetsvinkel"
  },
  {
      "partnerNumberIndividual": "0031728331",
      "employeeId": "198309203738",
      "firstName": "Sydsvensk",
      "lastName": "Spårdjup"
  },
  {
      "partnerNumberIndividual": "0031728787",
      "employeeId": "198309205238",
      "firstName": "Säsongskorrigerad",
      "lastName": "Kroppsspråk"
  },
  {
      "partnerNumberIndividual": "0031729175",
      "employeeId": "198309206137",
      "firstName": "Ostämd",
      "lastName": "Reservationsdatum"
  },
  {
      "partnerNumberIndividual": "0031731458",
      "employeeId": "198309218538",
      "firstName": "Gråaktig",
      "lastName": "Laplacetransformation"
  },
  {
      "partnerNumberIndividual": "0031731471",
      "employeeId": "198309218835",
      "firstName": "Termostatreglerad",
      "lastName": "Bästaanfallstiden"
  },
  {
      "partnerNumberIndividual": "0031733016",
      "employeeId": "198309226333",
      "firstName": "Finstämd",
      "lastName": "Datorstab"
  },
  {
      "partnerNumberIndividual": "0031736115",
      "employeeId": "198309230830",
      "firstName": "Bifalls",
      "lastName": "Avbrytarvals"
  },
  {
      "partnerNumberIndividual": "0031736902",
      "employeeId": "198309245630",
      "firstName": "Mesaktig",
      "lastName": "Förstärkare"
  },
  {
      "partnerNumberIndividual": "0031741069",
      "employeeId": "198309272436",
      "firstName": "Homopolymerisk",
      "lastName": "Ladugårdsbacke"
  },
  {
      "partnerNumberIndividual": "0031741535",
      "employeeId": "198309273939",
      "firstName": "Avmätt",
      "lastName": "Gjutugn"
  },
  {
      "partnerNumberIndividual": "0031741860",
      "employeeId": "198309274234",
      "firstName": "Sirapsaktig",
      "lastName": "Antiklor"
  },
  {
      "partnerNumberIndividual": "0031751823",
      "employeeId": "198309023839",
      "firstName": "Virtuos",
      "lastName": "Lärofrihet"
  },
  {
      "partnerNumberIndividual": "0031758361",
      "employeeId": "198309059734",
      "firstName": "Folkmordsliknande",
      "lastName": "Teaterkostym"
  },
  {
      "partnerNumberIndividual": "0031760112",
      "employeeId": "198309067836",
      "firstName": "Tunnsliten",
      "lastName": "Kabeldistributör"
  },
  {
      "partnerNumberIndividual": "0031760143",
      "employeeId": "198309067232",
      "firstName": "Genteknologisk",
      "lastName": "Bolagsstämma"
  },
  {
      "partnerNumberIndividual": "0031766340",
      "employeeId": "198310098838",
      "firstName": "Övermöblerad",
      "lastName": "Vinylgummi"
  },
  {
      "partnerNumberIndividual": "0031770276",
      "employeeId": "198310110831",
      "firstName": "Brännskadad",
      "lastName": "Öglemutter"
  },
  {
      "partnerNumberIndividual": "0031770313",
      "employeeId": "198310110237",
      "firstName": "Född",
      "lastName": "Chancroid"
  },
  {
      "partnerNumberIndividual": "0031773643",
      "employeeId": "198310139830",
      "firstName": "Approximativ",
      "lastName": "Ljuspolarisation"
  },
  {
      "partnerNumberIndividual": "0031774979",
      "employeeId": "198310145837",
      "firstName": "Numinös",
      "lastName": "Månkalender"
  },
  {
      "partnerNumberIndividual": "0031776095",
      "employeeId": "198310152734",
      "firstName": "Rundnätt",
      "lastName": "Naturligläggning"
  },
  {
      "partnerNumberIndividual": "0031776169",
      "employeeId": "198310153336",
      "firstName": "Förvägen",
      "lastName": "Socioekonomi"
  },
  {
      "partnerNumberIndividual": "0031778610",
      "employeeId": "198310166932",
      "firstName": "Metalltäckt",
      "lastName": "Delbruk"
  },
  {
      "partnerNumberIndividual": "0031779631",
      "employeeId": "198310173235",
      "firstName": "Rankig",
      "lastName": "Maosko"
  },
  {
      "partnerNumberIndividual": "0031779651",
      "employeeId": "198310174738",
      "firstName": "Fridlysningsvärd",
      "lastName": "Niltilapia"
  },
  {
      "partnerNumberIndividual": "0031782100",
      "employeeId": "198310189835",
      "firstName": "Opåvisad",
      "lastName": "Mjölkchoklad"
  },
  {
      "partnerNumberIndividual": "0031785361",
      "employeeId": "198310209435",
      "firstName": "Omedelbart",
      "lastName": "Kolombiadopping"
  },
  {
      "partnerNumberIndividual": "0031785719",
      "employeeId": "198310209138",
      "firstName": "Brandfri",
      "lastName": "Barfrost"
  },
  {
      "partnerNumberIndividual": "0031792966",
      "employeeId": "198310257939",
      "firstName": "Pölsig",
      "lastName": "Osthyvelprincip"
  },
  {
      "partnerNumberIndividual": "0031796701",
      "employeeId": "198310270536",
      "firstName": "Neurotoxikologisk",
      "lastName": "Getberget"
  },
  {
      "partnerNumberIndividual": "0031803181",
      "employeeId": "198310014736",
      "firstName": "Odäckad",
      "lastName": "Domherre"
  },
  {
      "partnerNumberIndividual": "0031805945",
      "employeeId": "198310020436",
      "firstName": "Halvvåt",
      "lastName": "Torpedhantverkare"
  },
  {
      "partnerNumberIndividual": "0031807788",
      "employeeId": "198310042430",
      "firstName": "Transitorisk",
      "lastName": "Stålrör"
  },
  {
      "partnerNumberIndividual": "0031810182",
      "employeeId": "198310056331",
      "firstName": "Drömfri",
      "lastName": "Gratispassagerare"
  },
  {
      "partnerNumberIndividual": "0031811095",
      "employeeId": "198310062339",
      "firstName": "Utdömd",
      "lastName": "Mässkatalog"
  },
  {
      "partnerNumberIndividual": "0031824390",
      "employeeId": "198311135837",
      "firstName": "Behäftadmedfel",
      "lastName": "Extraläxa"
  },
  {
      "partnerNumberIndividual": "0031824735",
      "employeeId": "198311135233",
      "firstName": "Situationsanpassad",
      "lastName": "Alefnoll"
  },
  {
      "partnerNumberIndividual": "0031825428",
      "employeeId": "198311142437",
      "firstName": "Rovfågelsliknande",
      "lastName": "Arkitektkollega"
  },
  {
      "partnerNumberIndividual": "0031827818",
      "employeeId": "198311157831",
      "firstName": "Handlingsduglig",
      "lastName": "Hjärterot"
  },
  {
      "partnerNumberIndividual": "0031828449",
      "employeeId": "198311162633",
      "firstName": "Heterosexistisk",
      "lastName": "Glycerinvatten"
  },
  {
      "partnerNumberIndividual": "0031829057",
      "employeeId": "198311164738",
      "firstName": "Sopig",
      "lastName": "Punktbelastning"
  },
  {
      "partnerNumberIndividual": "0031832449",
      "employeeId": "198311185238",
      "firstName": "Störtförälskad",
      "lastName": "Soppa"
  },
  {
      "partnerNumberIndividual": "0031842463",
      "employeeId": "198311246139",
      "firstName": "Mångfunktionell",
      "lastName": "Lokalguide"
  },
  {
      "partnerNumberIndividual": "0031842914",
      "employeeId": "198311248531",
      "firstName": "Björnaktig",
      "lastName": "Katepsin"
  },
  {
      "partnerNumberIndividual": "0031842956",
      "employeeId": "198311248234",
      "firstName": "Dubbelbottnad",
      "lastName": "Vatikanbiblioteket"
  },
  {
      "partnerNumberIndividual": "0031843467",
      "employeeId": "198311252137",
      "firstName": "Härleddav",
      "lastName": "Arktisktklima"
  },
  {
      "partnerNumberIndividual": "0031843469",
      "employeeId": "198311253333",
      "firstName": "Malisk",
      "lastName": "Kringkastning"
  },
  {
      "partnerNumberIndividual": "0031846506",
      "employeeId": "198311267234",
      "firstName": "Umbärlig",
      "lastName": "Bukbandage"
  },
  {
      "partnerNumberIndividual": "0031847131",
      "employeeId": "198311273232",
      "firstName": "Orientalisk",
      "lastName": "Streamadvideo"
  },
  {
      "partnerNumberIndividual": "0031856303",
      "employeeId": "198311024031",
      "firstName": "Otillfredsställd",
      "lastName": "Stångjärnshammare"
  },
  {
      "partnerNumberIndividual": "0031857302",
      "employeeId": "198311032430",
      "firstName": "Underårig",
      "lastName": "Sjuplaning"
  },
  {
      "partnerNumberIndividual": "0031858757",
      "employeeId": "198001092306",
      "firstName": "Oratorisk",
      "lastName": "Kryckkäpp"
  },
  {
      "partnerNumberIndividual": "0031859177",
      "employeeId": "198001092900",
      "firstName": "Polygenisk",
      "lastName": "Vindsstege"
  },
  {
      "partnerNumberIndividual": "0031859446",
      "employeeId": "198311046331",
      "firstName": "Tillsist",
      "lastName": "Lamaull"
  },
  {
      "partnerNumberIndividual": "0031859677",
      "employeeId": "198001093502",
      "firstName": "Ejöverlämnad",
      "lastName": "Naturbruk"
  },
  {
      "partnerNumberIndividual": "0031859711",
      "employeeId": "198001093809",
      "firstName": "Beige",
      "lastName": "Cellteknologi"
  },
  {
      "partnerNumberIndividual": "0031864450",
      "employeeId": "198001112807",
      "firstName": "Handelspolitisk",
      "lastName": "Gulstrupigbulbyl"
  },
  {
      "partnerNumberIndividual": "0031864511",
      "employeeId": "198001113706",
      "firstName": "Våtvärmande",
      "lastName": "Realläroverk"
  },
  {
      "partnerNumberIndividual": "0031866367",
      "employeeId": "198311088234",
      "firstName": "Bokstavlig",
      "lastName": "Vidareanvändning"
  },
  {
      "partnerNumberIndividual": "0031866382",
      "employeeId": "198311089430",
      "firstName": "Tvåhändig",
      "lastName": "Ondtunga"
  },
  {
      "partnerNumberIndividual": "0031867978",
      "employeeId": "198001129108",
      "firstName": "Frånkopplad",
      "lastName": "Kommunstöd"
  },
  {
      "partnerNumberIndividual": "0031868837",
      "employeeId": "198001133902",
      "firstName": "Överens",
      "lastName": "Färgverk"
  },
  {
      "partnerNumberIndividual": "0031871748",
      "employeeId": "198001140501",
      "firstName": "Missbelåten",
      "lastName": "Tyrrhenuggla"
  },
  {
      "partnerNumberIndividual": "0031872773",
      "employeeId": "198001155608",
      "firstName": "Opåvisad",
      "lastName": "Färgseparation"
  },
  {
      "partnerNumberIndividual": "0031872784",
      "employeeId": "198001155905",
      "firstName": "Adderbar",
      "lastName": "Svågerpolitik"
  },
  {
      "partnerNumberIndividual": "0031872788",
      "employeeId": "198001155004",
      "firstName": "Oljeabsorberande",
      "lastName": "Matrisfilning"
  },
  {
      "partnerNumberIndividual": "0031874164",
      "employeeId": "198001162802",
      "firstName": "Cyklonartad",
      "lastName": "Lokalguide"
  },
  {
      "partnerNumberIndividual": "0031877151",
      "employeeId": "198001175804",
      "firstName": "Allrakäraste",
      "lastName": "Uppsökare"
  },
  {
      "partnerNumberIndividual": "0031882212",
      "employeeId": "198001197204",
      "firstName": "Lantbruksekonomisk",
      "lastName": "Fjärrbehandling"
  },
  {
      "partnerNumberIndividual": "0031882789",
      "employeeId": "198001202608",
      "firstName": "Profan",
      "lastName": "Hedersgubbe"
  },
  {
      "partnerNumberIndividual": "0031885989",
      "employeeId": "198001218901",
      "firstName": "Avresande",
      "lastName": "Åretruntboende"
  },
  {
      "partnerNumberIndividual": "0031886902",
      "employeeId": "198001223703",
      "firstName": "Kraft",
      "lastName": "Markränta"
  },
  {
      "partnerNumberIndividual": "0031886977",
      "employeeId": "198001224008",
      "firstName": "Kromosomskadad",
      "lastName": "Widescreenskärm"
  },
  {
      "partnerNumberIndividual": "0031887420",
      "employeeId": "198001226102",
      "firstName": "Ickeaktiv",
      "lastName": "Gitterkvadrat"
  },
  {
      "partnerNumberIndividual": "0031891850",
      "employeeId": "198001246902",
      "firstName": "Högsvansföring",
      "lastName": "Därvaro"
  },
  {
      "partnerNumberIndividual": "0031893310",
      "employeeId": "198001252603",
      "firstName": "Minus",
      "lastName": "Investeringsfond"
  },
  {
      "partnerNumberIndividual": "0031893367",
      "employeeId": "198001252009",
      "firstName": "Tyngdkrafts",
      "lastName": "Storgalangarot"
  },
  {
      "partnerNumberIndividual": "0031893793",
      "employeeId": "198001253205",
      "firstName": "Koncentrisk",
      "lastName": "Lastnät"
  },
  {
      "partnerNumberIndividual": "0031895264",
      "employeeId": "198001250805",
      "firstName": "Månadförmånad",
      "lastName": "Kantpress"
  },
  {
      "partnerNumberIndividual": "0031895294",
      "employeeId": "198001250201",
      "firstName": "Fingrad",
      "lastName": "Mordhistoria"
  },
  {
      "partnerNumberIndividual": "0031896223",
      "employeeId": "198001265605",
      "firstName": "Antikrigs",
      "lastName": "Maosko"
  },
  {
      "partnerNumberIndividual": "0031896331",
      "employeeId": "198001266207",
      "firstName": "Ädel",
      "lastName": "Brandsyn"
  },
  {
      "partnerNumberIndividual": "0031896777",
      "employeeId": "198001268609",
      "firstName": "Djungelaktig",
      "lastName": "Getberget"
  },
  {
      "partnerNumberIndividual": "0031897716",
      "employeeId": "198001272502",
      "firstName": "Sentblommande",
      "lastName": "Pressläktare"
  },
  {
      "partnerNumberIndividual": "0031909195",
      "employeeId": "198001022402",
      "firstName": "Ultimo",
      "lastName": "Mätarlarv"
  },
  {
      "partnerNumberIndividual": "0031909238",
      "employeeId": "198001022709",
      "firstName": "Oljerik",
      "lastName": "Storskulden"
  },
  {
      "partnerNumberIndividual": "0031913925",
      "employeeId": "198001046203",
      "firstName": "Gapskrattande",
      "lastName": "Djup"
  },
  {
      "partnerNumberIndividual": "0031916295",
      "employeeId": "198001059503",
      "firstName": "Benämnbar",
      "lastName": "Lochiarubra"
  },
  {
      "partnerNumberIndividual": "0031917426",
      "employeeId": "198001065807",
      "firstName": "Strukturerad",
      "lastName": "Opiumfält"
  },
  {
      "partnerNumberIndividual": "0031917892",
      "employeeId": "198001067001",
      "firstName": "Kortsvansad",
      "lastName": "Skifferbrytning"
  },
  {
      "partnerNumberIndividual": "0031918144",
      "employeeId": "198401098846",
      "firstName": "Påminnande",
      "lastName": "Ärtprotein"
  },
  {
      "partnerNumberIndividual": "0031918716",
      "employeeId": "198401102747",
      "firstName": "Hopkrupen",
      "lastName": "Genomsnittsvikt"
  },
  {
      "partnerNumberIndividual": "0031919361",
      "employeeId": "198001072100",
      "firstName": "Ickeofficiell",
      "lastName": "Tennjodid"
  },
  {
      "partnerNumberIndividual": "0031922127",
      "employeeId": "198401110245",
      "firstName": "Svåranträffbar",
      "lastName": "Syre"
  },
  {
      "partnerNumberIndividual": "0031922841",
      "employeeId": "198001087801",
      "firstName": "Förväxlad",
      "lastName": "Konceptbevis"
  },
  {
      "partnerNumberIndividual": "0031922975",
      "employeeId": "198401125649",
      "firstName": "Skärbar",
      "lastName": "Osfresiologisk"
  },
  {
      "partnerNumberIndividual": "0031924370",
      "employeeId": "198401132546",
      "firstName": "Xeromorfisk",
      "lastName": "Fraktionsdestillation"
  },
  {
      "partnerNumberIndividual": "0031926376",
      "employeeId": "198002097106",
      "firstName": "Monografisk",
      "lastName": "Engganoglasögonfågel"
  },
  {
      "partnerNumberIndividual": "0031926673",
      "employeeId": "198401145845",
      "firstName": "Stingande",
      "lastName": "Laktalalbumin"
  },
  {
      "partnerNumberIndividual": "0031926958",
      "employeeId": "198002099201",
      "firstName": "Psykokemisk",
      "lastName": "Kostall"
  },
  {
      "partnerNumberIndividual": "0031927423",
      "employeeId": "198002102203",
      "firstName": "Sträckt",
      "lastName": "Delbruk"
  },
  {
      "partnerNumberIndividual": "0031927586",
      "employeeId": "198401153344",
      "firstName": "Omflyttbar",
      "lastName": "Växelryttare"
  },
  {
      "partnerNumberIndividual": "0031930359",
      "employeeId": "198401172641",
      "firstName": "Morfisk",
      "lastName": "Ytfärg"
  },
  {
      "partnerNumberIndividual": "0031930383",
      "employeeId": "198401172948",
      "firstName": "Urtjatad",
      "lastName": "Storskulden"
  },
  {
      "partnerNumberIndividual": "0031930659",
      "employeeId": "198002117904",
      "firstName": "Bergs",
      "lastName": "Kalkaneus"
  },
  {
      "partnerNumberIndividual": "0031930730",
      "employeeId": "198002118209",
      "firstName": "Lättläst",
      "lastName": "Korsikanskhare"
  },
  {
      "partnerNumberIndividual": "0031930756",
      "employeeId": "198401173243",
      "firstName": "Ejgodkänd",
      "lastName": "Kostall"
  },
  {
      "partnerNumberIndividual": "0031931558",
      "employeeId": "198002123605",
      "firstName": "Lokomotorisk",
      "lastName": "Hukställning"
  },
  {
      "partnerNumberIndividual": "0031931578",
      "employeeId": "198002123902",
      "firstName": "Umbärlig",
      "lastName": "Nyårsgåva"
  },
  {
      "partnerNumberIndividual": "0031932600",
      "employeeId": "198002126301",
      "firstName": "Akter",
      "lastName": "Kricketlag"
  },
  {
      "partnerNumberIndividual": "0031935755",
      "employeeId": "198002139007",
      "firstName": "Färgframkallande",
      "lastName": "Resolharts"
  },
  {
      "partnerNumberIndividual": "0031936736",
      "employeeId": "198002144700",
      "firstName": "Synergisk",
      "lastName": "Fundamentalistgrupp"
  },
  {
      "partnerNumberIndividual": "0031936781",
      "employeeId": "198002145608",
      "firstName": "Elektronegativ",
      "lastName": "Extraläxa"
  },
  {
      "partnerNumberIndividual": "0031937285",
      "employeeId": "198002146200",
      "firstName": "Proportionell",
      "lastName": "Fundamentalistgrupp"
  },
  {
      "partnerNumberIndividual": "0031938031",
      "employeeId": "198401216943",
      "firstName": "Numinös",
      "lastName": "Krigsobligation"
  },
  {
      "partnerNumberIndividual": "0031939897",
      "employeeId": "198401220549",
      "firstName": "Riktningsstabil",
      "lastName": "Tilläggsbudget"
  },
  {
      "partnerNumberIndividual": "0031939931",
      "employeeId": "198401220846",
      "firstName": "Bågig",
      "lastName": "Naturbruk"
  },
  {
      "partnerNumberIndividual": "0031942140",
      "employeeId": "198002166109",
      "firstName": "Bergs",
      "lastName": "Storgalangarot"
  },
  {
      "partnerNumberIndividual": "0031942367",
      "employeeId": "198002168501",
      "firstName": "Utelämnad",
      "lastName": "Arbetsmarknadspension"
  },
  {
      "partnerNumberIndividual": "0031943424",
      "employeeId": "198002172404",
      "firstName": "Antistatisk",
      "lastName": "Plattjocklek"
  },
  {
      "partnerNumberIndividual": "0031943487",
      "employeeId": "198002172701",
      "firstName": "Farlig",
      "lastName": "Omao"
  },
  {
      "partnerNumberIndividual": "0031945768",
      "employeeId": "198401262749",
      "firstName": "Andragrads",
      "lastName": "Kunskapsspridning"
  },
  {
      "partnerNumberIndividual": "0031946003",
      "employeeId": "198002186909",
      "firstName": "Tobaksrökande",
      "lastName": "Längdskidlopp"
  },
  {
      "partnerNumberIndividual": "0031946299",
      "employeeId": "198401264240",
      "firstName": "Feber",
      "lastName": "Förekristus"
  },
  {
      "partnerNumberIndividual": "0031946409",
      "employeeId": "198002187204",
      "firstName": "Demonterad",
      "lastName": "Natursiden"
  },
  {
      "partnerNumberIndividual": "0031946948",
      "employeeId": "198002192600",
      "firstName": "Expanderande",
      "lastName": "Gulbentflugsnappare"
  },
  {
      "partnerNumberIndividual": "0031947433",
      "employeeId": "198002194408",
      "firstName": "Invalid",
      "lastName": "Bästaanfallstiden"
  },
  {
      "partnerNumberIndividual": "0031948668",
      "employeeId": "198401277846",
      "firstName": "Strup",
      "lastName": "Nummersexton"
  },
  {
      "partnerNumberIndividual": "0031952016",
      "employeeId": "198002213703",
      "firstName": "Skönast",
      "lastName": "Friochrättigheter"
  },
  {
      "partnerNumberIndividual": "0031952534",
      "employeeId": "198002215807",
      "firstName": "Kunskapsintensiv",
      "lastName": "Boförvaltare"
  },
  {
      "partnerNumberIndividual": "0031955569",
      "employeeId": "198002229402",
      "firstName": "Struntfin",
      "lastName": "Landet"
  },
  {
      "partnerNumberIndividual": "0031955883",
      "employeeId": "198002229105",
      "firstName": "Ädel",
      "lastName": "Nyårsgåva"
  },
  {
      "partnerNumberIndividual": "0031956884",
      "employeeId": "198002236308",
      "firstName": "Matrelaterad",
      "lastName": "Lekplatsutrustning"
  },
  {
      "partnerNumberIndividual": "0031958771",
      "employeeId": "198002243205",
      "firstName": "Naiv",
      "lastName": "Musikbibliotek"
  },
  {
      "partnerNumberIndividual": "0031959795",
      "employeeId": "198002240805",
      "firstName": "Bonapartistisk",
      "lastName": "Kritikersuccé"
  },
  {
      "partnerNumberIndividual": "0031960725",
      "employeeId": "198002255605",
      "firstName": "Söndersupen",
      "lastName": "Kritikersuccé"
  },
  {
      "partnerNumberIndividual": "0031960728",
      "employeeId": "198401042448",
      "firstName": "Obegränsad",
      "lastName": "Medljud"
  },
  {
      "partnerNumberIndividual": "0031962161",
      "employeeId": "198002262809",
      "firstName": "Informations",
      "lastName": "Reduceringsväxel"
  },
  {
      "partnerNumberIndividual": "0031962388",
      "employeeId": "198401049740",
      "firstName": "Ljudlig",
      "lastName": "Affischklistrare"
  },
  {
      "partnerNumberIndividual": "0031963291",
      "employeeId": "198401056943",
      "firstName": "Kostymerad",
      "lastName": "Bokklubbsutgåva"
  },
  {
      "partnerNumberIndividual": "0031964200",
      "employeeId": "198401063246",
      "firstName": "Rörformad",
      "lastName": "Vidareanvändning"
  },
  {
      "partnerNumberIndividual": "0031965431",
      "employeeId": "198002277906",
      "firstName": "Påsig",
      "lastName": "Årsöversikt"
  },
  {
      "partnerNumberIndividual": "0031965882",
      "employeeId": "198002279407",
      "firstName": "Bifalls",
      "lastName": "Tidskorridor"
  },
  {
      "partnerNumberIndividual": "0031967362",
      "employeeId": "198401083749",
      "firstName": "Härleddav",
      "lastName": "Kalkalg"
  },
  {
      "partnerNumberIndividual": "0031970950",
      "employeeId": "198002012709",
      "firstName": "Odäckad",
      "lastName": "Spårdjup"
  },
  {
      "partnerNumberIndividual": "0031971476",
      "employeeId": "198002014804",
      "firstName": "Tadelfri",
      "lastName": "Puaiohi"
  },
  {
      "partnerNumberIndividual": "0031974478",
      "employeeId": "198002020801",
      "firstName": "Eskatologisk",
      "lastName": "Faktureringsbok"
  },
  {
      "partnerNumberIndividual": "0031974484",
      "employeeId": "198002020207",
      "firstName": "Skimmelfärgad",
      "lastName": "Kalkaneus"
  },
  {
      "partnerNumberIndividual": "0031975024",
      "employeeId": "198002034703",
      "firstName": "Oljerik",
      "lastName": "Medicinutgift"
  },
  {
      "partnerNumberIndividual": "0031977104",
      "employeeId": "198402134947",
      "firstName": "Evasiv",
      "lastName": "Aerofon"
  },
  {
      "partnerNumberIndividual": "0031977398",
      "employeeId": "198402135845",
      "firstName": "Råkall",
      "lastName": "Allvarsman"
  },
  {
      "partnerNumberIndividual": "0031977557",
      "employeeId": "198402136140",
      "firstName": "Underkuvande",
      "lastName": "Straffverkställighet"
  },
  {
      "partnerNumberIndividual": "0031978312",
      "employeeId": "198402142742",
      "firstName": "Beige",
      "lastName": "Höghastighetsnät"
  },
  {
      "partnerNumberIndividual": "0031979806",
      "employeeId": "198002055203",
      "firstName": "Hemtrevlig",
      "lastName": "Västligtangara"
  },
  {
      "partnerNumberIndividual": "0031980141",
      "employeeId": "198002056706",
      "firstName": "Okollegial",
      "lastName": "Midsommarsol"
  },
  {
      "partnerNumberIndividual": "0031980915",
      "employeeId": "198402156346",
      "firstName": "Förbliven",
      "lastName": "Tonfrekvens"
  },
  {
      "partnerNumberIndividual": "0031981339",
      "employeeId": "198402157849",
      "firstName": "Elbesparande",
      "lastName": "Jordenssalt"
  },
  {
      "partnerNumberIndividual": "0031981413",
      "employeeId": "198402157245",
      "firstName": "Svängningsbar",
      "lastName": "Nonsinelaudeapprobatur"
  },
  {
      "partnerNumberIndividual": "0031982254",
      "employeeId": "198402162047",
      "firstName": "Ikonisk",
      "lastName": "Privatisering"
  },
  {
      "partnerNumberIndividual": "0031984916",
      "employeeId": "198002076308",
      "firstName": "Företagsbetald",
      "lastName": "Omvikningsstål"
  },
  {
      "partnerNumberIndividual": "0031985442",
      "employeeId": "198002077801",
      "firstName": "Mördad",
      "lastName": "Hjärtkontusion"
  },
  {
      "partnerNumberIndividual": "0031986376",
      "employeeId": "198402183746",
      "firstName": "Smidbar",
      "lastName": "Antiklor"
  },
  {
      "partnerNumberIndividual": "0031986736",
      "employeeId": "198402185840",
      "firstName": "Husdjursetisk",
      "lastName": "Fyrsken"
  },
  {
      "partnerNumberIndividual": "0031986793",
      "employeeId": "198402185246",
      "firstName": "Köpstark",
      "lastName": "Migrationsteori"
  },
  {
      "partnerNumberIndividual": "0031988653",
      "employeeId": "198402198843",
      "firstName": "Känd",
      "lastName": "Intvålning"
  },
  {
      "partnerNumberIndividual": "0031988909",
      "employeeId": "198402199148",
      "firstName": "Uppvispad",
      "lastName": "Akademikerbarn"
  },
  {
      "partnerNumberIndividual": "0031990188",
      "employeeId": "198003092205",
      "firstName": "Intetillämpbar",
      "lastName": "Nyhetsförmedling"
  },
  {
      "partnerNumberIndividual": "0031993703",
      "employeeId": "198402226248",
      "firstName": "Rörelsemässig",
      "lastName": "Örn"
  },
  {
      "partnerNumberIndividual": "0031993913",
      "employeeId": "198003109405",
      "firstName": "Genomandad",
      "lastName": "Kefalin"
  },
  {
      "partnerNumberIndividual": "0031995496",
      "employeeId": "198003116301",
      "firstName": "Tvungen",
      "lastName": "Ektypografi"
  },
  {
      "partnerNumberIndividual": "0031998123",
      "employeeId": "198402248549",
      "firstName": "Uppodlad",
      "lastName": "Stridsvagnsduell"
  },
  {
      "partnerNumberIndividual": "0031998169",
      "employeeId": "198402248242",
      "firstName": "Beställnings",
      "lastName": "Hanplanta"
  },
  {
      "partnerNumberIndividual": "0031998588",
      "employeeId": "198402249141",
      "firstName": "Huvudsaklig",
      "lastName": "Långhålsborrmaskin"
  },
  {
      "partnerNumberIndividual": "0031999052",
      "employeeId": "198402253648",
      "firstName": "Spjälad",
      "lastName": "Pariservitt"
  },
  {
      "partnerNumberIndividual": "0031999748",
      "employeeId": "198003120808",
      "firstName": "Illistig",
      "lastName": "Alkoläsk"
  },
  {
      "partnerNumberIndividual": "0032000404",
      "employeeId": "198003134700",
      "firstName": "Intevärdig",
      "lastName": "Frittinträde"
  },
  {
      "partnerNumberIndividual": "0032001326",
      "employeeId": "198003136200",
      "firstName": "Bukig",
      "lastName": "Brass"
  },
  {
      "partnerNumberIndividual": "0032005221",
      "employeeId": "198003141309",
      "firstName": "Skönast",
      "lastName": "Mycketväsenföringenting"
  },
  {
      "partnerNumberIndividual": "0032006669",
      "employeeId": "198003155804",
      "firstName": "Lantbruksekonomisk",
      "lastName": "Varumärkesrätt"
  },
  {
      "partnerNumberIndividual": "0032008406",
      "employeeId": "198003163907",
      "firstName": "Opatriotisk",
      "lastName": "Amerikanskpimpernöt"
  },
  {
      "partnerNumberIndividual": "0032010107",
      "employeeId": "198402019544",
      "firstName": "Vulvaliknande",
      "lastName": "Täckning"
  },
  {
      "partnerNumberIndividual": "0032011235",
      "employeeId": "198003177808",
      "firstName": "Regelbaserad",
      "lastName": "Susande"
  },
  {
      "partnerNumberIndividual": "0032011541",
      "employeeId": "198402025848",
      "firstName": "Missbelåten",
      "lastName": "Presbyter"
  },
  {
      "partnerNumberIndividual": "0032011567",
      "employeeId": "198402025244",
      "firstName": "Adderbar",
      "lastName": "Vidareanvändning"
  },
  {
      "partnerNumberIndividual": "0032012302",
      "employeeId": "198003182600",
      "firstName": "Avelsduglig",
      "lastName": "Droppeihavet"
  },
  {
      "partnerNumberIndividual": "0032012341",
      "employeeId": "198003182907",
      "firstName": "Sjöfarande",
      "lastName": "Hårspray"
  },
  {
      "partnerNumberIndividual": "0032012521",
      "employeeId": "198402032448",
      "firstName": "Direktörsaktig",
      "lastName": "Fartsladd"
  },
  {
      "partnerNumberIndividual": "0032012811",
      "employeeId": "198003183202",
      "firstName": "Eutrof",
      "lastName": "Standardegenskap"
  },
  {
      "partnerNumberIndividual": "0032012826",
      "employeeId": "198003184705",
      "firstName": "Figurutsmyckad",
      "lastName": "Allaktivist"
  },
  {
      "partnerNumberIndividual": "0032012886",
      "employeeId": "198003185306",
      "firstName": "Lycksalig",
      "lastName": "Stålverksarbetare"
  },
  {
      "partnerNumberIndividual": "0032016163",
      "employeeId": "198402052644",
      "firstName": "Darrhänt",
      "lastName": "Kuhlsfladdermus"
  },
  {
      "partnerNumberIndividual": "0032016465",
      "employeeId": "198402053246",
      "firstName": "Otillrådlig",
      "lastName": "Utländskmoderbolag"
  },
  {
      "partnerNumberIndividual": "0032016704",
      "employeeId": "198003198903",
      "firstName": "Djurvänlig",
      "lastName": "Blystearat"
  },
  {
      "partnerNumberIndividual": "0032017222",
      "employeeId": "198003199802",
      "firstName": "Sentblommande",
      "lastName": "Engelsklektion"
  },
  {
      "partnerNumberIndividual": "0032018359",
      "employeeId": "198003204008",
      "firstName": "Kortvågig",
      "lastName": "Direktsumma"
  },
  {
      "partnerNumberIndividual": "0032018431",
      "employeeId": "198003205807",
      "firstName": "Interkontinental",
      "lastName": "Utländskmoderbolag"
  },
  {
      "partnerNumberIndividual": "0032018439",
      "employeeId": "198003205203",
      "firstName": "Nordisk",
      "lastName": "Lokalguide"
  },
  {
      "partnerNumberIndividual": "0032019161",
      "employeeId": "198402072543",
      "firstName": "Somnambulistisk",
      "lastName": "Blankspik"
  },
  {
      "partnerNumberIndividual": "0032021933",
      "employeeId": "198003219402",
      "firstName": "Obeskrivlig",
      "lastName": "Malcylinder"
  },
  {
      "partnerNumberIndividual": "0032024802",
      "employeeId": "198003232306",
      "firstName": "Avgudadyrkande",
      "lastName": "Fariseism"
  },
  {
      "partnerNumberIndividual": "0032025082",
      "employeeId": "198403098141",
      "firstName": "Beroendeav",
      "lastName": "Kemtvättsinrättning"
  },
  {
      "partnerNumberIndividual": "0032025532",
      "employeeId": "198403090544",
      "firstName": "Självcentrerande",
      "lastName": "Moskovit"
  },
  {
      "partnerNumberIndividual": "0032026340",
      "employeeId": "198403104741",
      "firstName": "Jobbig",
      "lastName": "Himlenrunthörnet"
  },
  {
      "partnerNumberIndividual": "0032026440",
      "employeeId": "198403105946",
      "firstName": "Utelämnad",
      "lastName": "Silvervinge"
  },
  {
      "partnerNumberIndividual": "0032026959",
      "employeeId": "198003239905",
      "firstName": "Krympsäker",
      "lastName": "Förstorare"
  },
  {
      "partnerNumberIndividual": "0032027100",
      "employeeId": "198003231704",
      "firstName": "Ejöverlämnad",
      "lastName": "Vävnad"
  },
  {
      "partnerNumberIndividual": "0032028579",
      "employeeId": "198003246504",
      "firstName": "Påkopplad",
      "lastName": "Fläcktjockfot"
  },
  {
      "partnerNumberIndividual": "0032029885",
      "employeeId": "198403125241",
      "firstName": "Akritisk",
      "lastName": "Gjutstål"
  },
  {
      "partnerNumberIndividual": "0032033564",
      "employeeId": "198003267906",
      "firstName": "EUklassad",
      "lastName": "Plantavstånd"
  },
  {
      "partnerNumberIndividual": "0032033694",
      "employeeId": "198003268508",
      "firstName": "Rörformad",
      "lastName": "TimmenT"
  },
  {
      "partnerNumberIndividual": "0032035337",
      "employeeId": "198003274803",
      "firstName": "Didaktisk",
      "lastName": "Moskovit"
  },
  {
      "partnerNumberIndividual": "0032035886",
      "employeeId": "198403153243",
      "firstName": "Uppvispad",
      "lastName": "Observationsbrunn"
  },
  {
      "partnerNumberIndividual": "0032039969",
      "employeeId": "198403172847",
      "firstName": "Esoterisk",
      "lastName": "Automobilindustri"
  },
  {
      "partnerNumberIndividual": "0032042850",
      "employeeId": "198403189445",
      "firstName": "Peonisk",
      "lastName": "Stortungkg"
  },
  {
      "partnerNumberIndividual": "0032043775",
      "employeeId": "198403196341",
      "firstName": "Omedelbart",
      "lastName": "Brandklämtning"
  },
  {
      "partnerNumberIndividual": "0032044916",
      "employeeId": "198403202347",
      "firstName": "Behårad",
      "lastName": "Kontrollmanometer"
  },
  {
      "partnerNumberIndividual": "0032046844",
      "employeeId": "198403200846",
      "firstName": "Förgången",
      "lastName": "Observatörsvariation"
  },
  {
      "partnerNumberIndividual": "0032047954",
      "employeeId": "198003017806",
      "firstName": "Plakat",
      "lastName": "Gulkronadmajna"
  },
  {
      "partnerNumberIndividual": "0032048625",
      "employeeId": "198003010504",
      "firstName": "Paradoxal",
      "lastName": "Societetshus"
  },
  {
      "partnerNumberIndividual": "0032050177",
      "employeeId": "198003026203",
      "firstName": "Paraguayansk",
      "lastName": "Höghastighetsnät"
  },
  {
      "partnerNumberIndividual": "0032052968",
      "employeeId": "198003038901",
      "firstName": "Nyfunnen",
      "lastName": "Örlogsbesök"
  },
  {
      "partnerNumberIndividual": "0032053006",
      "employeeId": "198003039800",
      "firstName": "Sentimental",
      "lastName": "Trycklocksburk"
  },
  {
      "partnerNumberIndividual": "0032054225",
      "employeeId": "198403242442",
      "firstName": "Jobbig",
      "lastName": "Majshack"
  },
  {
      "partnerNumberIndividual": "0032054473",
      "employeeId": "198003044909",
      "firstName": "Omöjlig",
      "lastName": "Tempocykel"
  },
  {
      "partnerNumberIndividual": "0032054765",
      "employeeId": "198403244240",
      "firstName": "Själfull",
      "lastName": "Aneroxi"
  },
  {
      "partnerNumberIndividual": "0032055016",
      "employeeId": "198003047308",
      "firstName": "Expanderande",
      "lastName": "Årstidsvind"
  },
  {
      "partnerNumberIndividual": "0032057094",
      "employeeId": "198403257846",
      "firstName": "Vulvaliknande",
      "lastName": "Ledarställning"
  },
  {
      "partnerNumberIndividual": "0032059434",
      "employeeId": "198003066902",
      "firstName": "Kostymerad",
      "lastName": "Hjärtkontusion"
  },
  {
      "partnerNumberIndividual": "0032060772",
      "employeeId": "198003072009",
      "firstName": "Utledsen",
      "lastName": "Grönaracari"
  },
  {
      "partnerNumberIndividual": "0032060931",
      "employeeId": "198403278941",
      "firstName": "Ostämd",
      "lastName": "Attackdivision"
  },
  {
      "partnerNumberIndividual": "0032061011",
      "employeeId": "198403279246",
      "firstName": "Industrihistorisk",
      "lastName": "Oljekastarbricka"
  },
  {
      "partnerNumberIndividual": "0032064157",
      "employeeId": "198003088609",
      "firstName": "Eskatologisk",
      "lastName": "Riktverkan"
  },
  {
      "partnerNumberIndividual": "0032064197",
      "employeeId": "198003089508",
      "firstName": "Tillfälligtvis",
      "lastName": "Borgerskap"
  },
  {
      "partnerNumberIndividual": "0032067648",
      "employeeId": "198004097906",
      "firstName": "Poänglös",
      "lastName": "Lagbud"
  },
  {
      "partnerNumberIndividual": "0032068120",
      "employeeId": "198004098201",
      "firstName": "Fyradörrars",
      "lastName": "Politisksociologi"
  },
  {
      "partnerNumberIndividual": "0032068146",
      "employeeId": "198004099407",
      "firstName": "Peonisk",
      "lastName": "Höghastighetsnät"
  },
  {
      "partnerNumberIndividual": "0032069166",
      "employeeId": "198004103902",
      "firstName": "Applikationsoberoende",
      "lastName": "Återtaganderätt"
  },
  {
      "partnerNumberIndividual": "0032070476",
      "employeeId": "198403014346",
      "firstName": "Sentblommande",
      "lastName": "Gruppbildning"
  },
  {
      "partnerNumberIndividual": "0032072985",
      "employeeId": "198004110808",
      "firstName": "Fullskalig",
      "lastName": "Mårdhår"
  },
  {
      "partnerNumberIndividual": "0032073006",
      "employeeId": "198004110204",
      "firstName": "Reformvänlig",
      "lastName": "Öringfiske"
  },
  {
      "partnerNumberIndividual": "0032073158",
      "employeeId": "198403029443",
      "firstName": "Övermöblerad",
      "lastName": "Ärevördighet"
  },
  {
      "partnerNumberIndividual": "0032073193",
      "employeeId": "198403029740",
      "firstName": "Grovmalen",
      "lastName": "Svartbärpickare"
  },
  {
      "partnerNumberIndividual": "0032073828",
      "employeeId": "198004124700",
      "firstName": "Överstånden",
      "lastName": "Porslinsmålning"
  },
  {
      "partnerNumberIndividual": "0032074349",
      "employeeId": "198004127109",
      "firstName": "Grovmalen",
      "lastName": "Aerofon"
  },
  {
      "partnerNumberIndividual": "0032074561",
      "employeeId": "198403036349",
      "firstName": "Doxologisk",
      "lastName": "Inteckningshandling"
  },
  {
      "partnerNumberIndividual": "0032075062",
      "employeeId": "198403037842",
      "firstName": "Infällbar",
      "lastName": "Borgerskap"
  },
  {
      "partnerNumberIndividual": "0032075360",
      "employeeId": "198004132208",
      "firstName": "Spikrak",
      "lastName": "Gråvingadkotinga"
  },
  {
      "partnerNumberIndividual": "0032077301",
      "employeeId": "198004131606",
      "firstName": "Opåverkbar",
      "lastName": "Dahliesort"
  },
  {
      "partnerNumberIndividual": "0032078085",
      "employeeId": "198403040846",
      "firstName": "Basilar",
      "lastName": "Directmail"
  },
  {
      "partnerNumberIndividual": "0032078334",
      "employeeId": "198004146109",
      "firstName": "Livegen",
      "lastName": "Hagelkorn"
  },
  {
      "partnerNumberIndividual": "0032079415",
      "employeeId": "198403056248",
      "firstName": "Sjöfarande",
      "lastName": "Stortungkg"
  },
  {
      "partnerNumberIndividual": "0032079562",
      "employeeId": "198403058947",
      "firstName": "Grynings",
      "lastName": "Statsägande"
  },
  {
      "partnerNumberIndividual": "0032082430",
      "employeeId": "198004166909",
      "firstName": "Förbenad",
      "lastName": "Storgalangarot"
  },
  {
      "partnerNumberIndividual": "0032083900",
      "employeeId": "198004172600",
      "firstName": "Halvgenomskinlig",
      "lastName": "Åretruntboende"
  },
  {
      "partnerNumberIndividual": "0032084590",
      "employeeId": "198403082749",
      "firstName": "Tiohörnig",
      "lastName": "Ondtunga"
  },
  {
      "partnerNumberIndividual": "0032087141",
      "employeeId": "198404093844",
      "firstName": "Tobaksrökande",
      "lastName": "Ilandsättning"
  },
  {
      "partnerNumberIndividual": "0032088570",
      "employeeId": "198404102249",
      "firstName": "Bombmattefällande",
      "lastName": "Dubbelverkandeaxiallager"
  },
  {
      "partnerNumberIndividual": "0032089296",
      "employeeId": "198004188606",
      "firstName": "Lödd",
      "lastName": "Svets"
  },
  {
      "partnerNumberIndividual": "0032089586",
      "employeeId": "198004189802",
      "firstName": "Avgudadyrkande",
      "lastName": "Stilkonst"
  },
  {
      "partnerNumberIndividual": "0032090505",
      "employeeId": "198404109848",
      "firstName": "Linje",
      "lastName": "Strandgata"
  },
  {
      "partnerNumberIndividual": "0032091071",
      "employeeId": "198004194307",
      "firstName": "Döpt",
      "lastName": "Esofagusperforation"
  },
  {
      "partnerNumberIndividual": "0032091508",
      "employeeId": "198404115845",
      "firstName": "Senromantisk",
      "lastName": "Blodvätska"
  },
  {
      "partnerNumberIndividual": "0032091542",
      "employeeId": "198404115241",
      "firstName": "Zetetisk",
      "lastName": "Överklassdygd"
  },
  {
      "partnerNumberIndividual": "0032091603",
      "employeeId": "198004196104",
      "firstName": "Kostymerad",
      "lastName": "Matrisfilning"
  },
  {
      "partnerNumberIndividual": "0032092900",
      "employeeId": "198404122445",
      "firstName": "Yazidisk",
      "lastName": "Ilandsättning"
  },
  {
      "partnerNumberIndividual": "0032096044",
      "employeeId": "198404136940",
      "firstName": "Gulgrön",
      "lastName": "Köpmansgille"
  },
  {
      "partnerNumberIndividual": "0032096086",
      "employeeId": "198004217207",
      "firstName": "Agathaltig",
      "lastName": "Beklädnadsförråd"
  },
  {
      "partnerNumberIndividual": "0032096787",
      "employeeId": "198404142344",
      "firstName": "Hudvänlig",
      "lastName": "Investeringsavveckling"
  },
  {
      "partnerNumberIndividual": "0032096905",
      "employeeId": "198404142641",
      "firstName": "Ospenderad",
      "lastName": "Kvicksilverväxelriktare"
  },
  {
      "partnerNumberIndividual": "0032100040",
      "employeeId": "198404158944",
      "firstName": "Imperatorisk",
      "lastName": "Hoptryckning"
  },
  {
      "partnerNumberIndividual": "0032101041",
      "employeeId": "198404165246",
      "firstName": "Ickeaktiv",
      "lastName": "Cykelhandtag"
  },
  {
      "partnerNumberIndividual": "0032102149",
      "employeeId": "198004242502",
      "firstName": "Flockblommig",
      "lastName": "Blåringadängelfisk"
  },
  {
      "partnerNumberIndividual": "0032102621",
      "employeeId": "198004243708",
      "firstName": "Moralistisk",
      "lastName": "Årsöversikt"
  },
  {
      "partnerNumberIndividual": "0032103880",
      "employeeId": "198404178249",
      "firstName": "Förbenad",
      "lastName": "Arktisktklima"
  },
  {
      "partnerNumberIndividual": "0032104627",
      "employeeId": "198004241603",
      "firstName": "Påminnande",
      "lastName": "Hårrörskärl"
  },
  {
      "partnerNumberIndividual": "0032104850",
      "employeeId": "198404183942",
      "firstName": "Bianco",
      "lastName": "Rödöradbulbyl"
  },
  {
      "partnerNumberIndividual": "0032106077",
      "employeeId": "198004257302",
      "firstName": "Radiärsymmetrisk",
      "lastName": "Växelkurssystem"
  },
  {
      "partnerNumberIndividual": "0032107134",
      "employeeId": "198004262401",
      "firstName": "Underårig",
      "lastName": "Allvarsman"
  },
  {
      "partnerNumberIndividual": "0032107164",
      "employeeId": "198004262708",
      "firstName": "Finriven",
      "lastName": "Magnesiumbad"
  },
  {
      "partnerNumberIndividual": "0032107621",
      "employeeId": "198004263904",
      "firstName": "Sim",
      "lastName": "Förekristus"
  },
  {
      "partnerNumberIndividual": "0032108015",
      "employeeId": "198004264803",
      "firstName": "Inkontinent",
      "lastName": "Vågmästare"
  },
  {
      "partnerNumberIndividual": "0032108846",
      "employeeId": "198404190848",
      "firstName": "Fotostat",
      "lastName": "Offshoreverksamhet"
  },
  {
      "partnerNumberIndividual": "0032111455",
      "employeeId": "198004279900",
      "firstName": "Himmelsvid",
      "lastName": "Postsparbanksbok"
  },
  {
      "partnerNumberIndividual": "0032114478",
      "employeeId": "198404226147",
      "firstName": "Djuptrotad",
      "lastName": "Aneroxi"
  },
  {
      "partnerNumberIndividual": "0032114936",
      "employeeId": "198404228242",
      "firstName": "Trädbeskuggad",
      "lastName": "Jordkällare"
  },
  {
      "partnerNumberIndividual": "0032115376",
      "employeeId": "198404232442",
      "firstName": "Aerotropisk",
      "lastName": "Torpedhantverkare"
  },
  {
      "partnerNumberIndividual": "0032118008",
      "employeeId": "198404246947",
      "firstName": "Intetillämpbar",
      "lastName": "Elektrodynamometer"
  },
  {
      "partnerNumberIndividual": "0032119454",
      "employeeId": "198404252648",
      "firstName": "Minnes",
      "lastName": "Revision"
  },
  {
      "partnerNumberIndividual": "0032120008",
      "employeeId": "198404254743",
      "firstName": "Avskrapande",
      "lastName": "Jordbrukszon"
  },
  {
      "partnerNumberIndividual": "0032120189",
      "employeeId": "198004016203",
      "firstName": "Välsittande",
      "lastName": "Stapeldiagram"
  },
  {
      "partnerNumberIndividual": "0032120550",
      "employeeId": "198404255641",
      "firstName": "Tidvattens",
      "lastName": "Naturbruk"
  },
  {
      "partnerNumberIndividual": "0032123544",
      "employeeId": "198404268941",
      "firstName": "Urskiljbar",
      "lastName": "Enmiljon"
  },
  {
      "partnerNumberIndividual": "0032123614",
      "employeeId": "198404269840",
      "firstName": "Uppbyggande",
      "lastName": "Gjutugn"
  },
  {
      "partnerNumberIndividual": "0032124517",
      "employeeId": "198004034305",
      "firstName": "Överstånden",
      "lastName": "Kassasuccé"
  },
  {
      "partnerNumberIndividual": "0032124643",
      "employeeId": "198404274949",
      "firstName": "Äppelkindad",
      "lastName": "Omvikningsstål"
  },
  {
      "partnerNumberIndividual": "0032124929",
      "employeeId": "198004035807",
      "firstName": "Malisk",
      "lastName": "Miljöhinder"
  },
  {
      "partnerNumberIndividual": "0032125023",
      "employeeId": "198404274048",
      "firstName": "Zen",
      "lastName": "Arnaudbarbett"
  },
  {
      "partnerNumberIndividual": "0032125051",
      "employeeId": "198404275847",
      "firstName": "Stillasittande",
      "lastName": "Internetmonster"
  },
  {
      "partnerNumberIndividual": "0032126231",
      "employeeId": "198004042407",
      "firstName": "Skogsmässig",
      "lastName": "Övningsgranat"
  },
  {
      "partnerNumberIndividual": "0032126295",
      "employeeId": "198004042704",
      "firstName": "Bas",
      "lastName": "Boskapskötare"
  },
  {
      "partnerNumberIndividual": "0032128716",
      "employeeId": "198004056902",
      "firstName": "Senare",
      "lastName": "Kaliumtiocyanat"
  },
  {
      "partnerNumberIndividual": "0032130187",
      "employeeId": "198004062603",
      "firstName": "Födoämnes",
      "lastName": "Splittrad"
  },
  {
      "partnerNumberIndividual": "0032130228",
      "employeeId": "198004062009",
      "firstName": "Itmedveten",
      "lastName": "Porslinsmålning"
  },
  {
      "partnerNumberIndividual": "0032133699",
      "employeeId": "198404019740",
      "firstName": "Kabbalistisk",
      "lastName": "Obemärkthet"
  },
  {
      "partnerNumberIndividual": "0032135959",
      "employeeId": "198004084003",
      "firstName": "Utledsen",
      "lastName": "Ilandsättning"
  },
  {
      "partnerNumberIndividual": "0032136057",
      "employeeId": "198004085208",
      "firstName": "Postsilurisk",
      "lastName": "Udde"
  },
  {
      "partnerNumberIndividual": "0032138596",
      "employeeId": "198404030846",
      "firstName": "Tillsammantagen",
      "lastName": "Yrkesgrupp"
  },
  {
      "partnerNumberIndividual": "0032139885",
      "employeeId": "198404046545",
      "firstName": "Tätbebyggd",
      "lastName": "Hagelkorn"
  },
  {
      "partnerNumberIndividual": "0032140302",
      "employeeId": "198404046248",
      "firstName": "Approximativ",
      "lastName": "Inkassoperiod"
  },
  {
      "partnerNumberIndividual": "0032140361",
      "employeeId": "198404048947",
      "firstName": "Musikalisk",
      "lastName": "Kungsmagnolia"
  },
  {
      "partnerNumberIndividual": "0032141289",
      "employeeId": "198404052543",
      "firstName": "Självförhärligande",
      "lastName": "Offereld"
  },
  {
      "partnerNumberIndividual": "0032141756",
      "employeeId": "198404053145",
      "firstName": "Arm",
      "lastName": "Gratulationskort"
  },
  {
      "partnerNumberIndividual": "0032141779",
      "employeeId": "198404054341",
      "firstName": "Turbinelektrisk",
      "lastName": "Gurkhakniv"
  },
  {
      "partnerNumberIndividual": "0032143776",
      "employeeId": "198005100808",
      "firstName": "Situationsanpassad",
      "lastName": "Marmorflis"
  },
  {
      "partnerNumberIndividual": "0032144333",
      "employeeId": "198404068549",
      "firstName": "Datormanipulerad",
      "lastName": "Kunskapsspridning"
  },
  {
      "partnerNumberIndividual": "0032144612",
      "employeeId": "198404069745",
      "firstName": "Bronkitsnörd",
      "lastName": "Kolombiadopping"
  },
  {
      "partnerNumberIndividual": "0032144739",
      "employeeId": "198404069141",
      "firstName": "Reglementarisk",
      "lastName": "Midsommarsol"
  },
  {
      "partnerNumberIndividual": "0032144882",
      "employeeId": "198005116200",
      "firstName": "Skärbar",
      "lastName": "Längdskidlopp"
  },
  {
      "partnerNumberIndividual": "0032147947",
      "employeeId": "198005121606",
      "firstName": "Irreal",
      "lastName": "Golvplanka"
  },
  {
      "partnerNumberIndividual": "0032148878",
      "employeeId": "198005135507",
      "firstName": "Halvlång",
      "lastName": "Enterostomi"
  },
  {
      "partnerNumberIndividual": "0032149215",
      "employeeId": "198005135804",
      "firstName": "Kommunalistisk",
      "lastName": "Glasning"
  },
  {
      "partnerNumberIndividual": "0032149387",
      "employeeId": "198005136109",
      "firstName": "Underskön",
      "lastName": "Öljätte"
  },
  {
      "partnerNumberIndividual": "0032150880",
      "employeeId": "198005142404",
      "firstName": "Anstötlig",
      "lastName": "Teckenstorlek"
  },
  {
      "partnerNumberIndividual": "0032151735",
      "employeeId": "198405105241",
      "firstName": "Pirrig",
      "lastName": "Baalsdyrkan"
  },
  {
      "partnerNumberIndividual": "0032153211",
      "employeeId": "198405112742",
      "firstName": "Tölpig",
      "lastName": "Förhandlingspolitik"
  },
  {
      "partnerNumberIndividual": "0032155372",
      "employeeId": "198005156909",
      "firstName": "Glasögonbärande",
      "lastName": "Blomskaft"
  },
  {
      "partnerNumberIndividual": "0032155844",
      "employeeId": "198005157204",
      "firstName": "Heltmotsatt",
      "lastName": "Regissör"
  },
  {
      "partnerNumberIndividual": "0032156614",
      "employeeId": "198405126940",
      "firstName": "Snurrig",
      "lastName": "Skivproducent"
  },
  {
      "partnerNumberIndividual": "0032156730",
      "employeeId": "198405127849",
      "firstName": "Strukturerad",
      "lastName": "Hårrörskärl"
  },
  {
      "partnerNumberIndividual": "0032156837",
      "employeeId": "198005162303",
      "firstName": "Helfransk",
      "lastName": "Gitterkvadrat"
  },
  {
      "partnerNumberIndividual": "0032156888",
      "employeeId": "198005162600",
      "firstName": "Helförsäkrad",
      "lastName": "Investeringsfond"
  },
  {
      "partnerNumberIndividual": "0032157065",
      "employeeId": "198405127245",
      "firstName": "Marin",
      "lastName": "Teknikterm"
  },
  {
      "partnerNumberIndividual": "0032157355",
      "employeeId": "198005163806",
      "firstName": "Visuell",
      "lastName": "Resegaranti"
  },
  {
      "partnerNumberIndividual": "0032157441",
      "employeeId": "198005164705",
      "firstName": "Ljuslila",
      "lastName": "Pannstensbildning"
  },
  {
      "partnerNumberIndividual": "0032158189",
      "employeeId": "198405133243",
      "firstName": "Samlarlysten",
      "lastName": "Träldomsok"
  },
  {
      "partnerNumberIndividual": "0032160907",
      "employeeId": "198005178606",
      "firstName": "Fridlysningsvärd",
      "lastName": "Spikbleck"
  },
  {
      "partnerNumberIndividual": "0032161058",
      "employeeId": "198005179802",
      "firstName": "Toskansk",
      "lastName": "Cyanfettsyror"
  },
  {
      "partnerNumberIndividual": "0032161125",
      "employeeId": "198405152540",
      "firstName": "Utnött",
      "lastName": "Självhypnos"
  },
  {
      "partnerNumberIndividual": "0032161917",
      "employeeId": "198005183705",
      "firstName": "Oupptäckt",
      "lastName": "Släthammare"
  },
  {
      "partnerNumberIndividual": "0032162067",
      "employeeId": "198405154041",
      "firstName": "Esoterisk",
      "lastName": "Hagelkorn"
  },
  {
      "partnerNumberIndividual": "0032162190",
      "employeeId": "198405155246",
      "firstName": "Bakanför",
      "lastName": "Hårdförman"
  },
  {
      "partnerNumberIndividual": "0032162401",
      "employeeId": "198005184000",
      "firstName": "Alldaglig",
      "lastName": "Klagorop"
  },
  {
      "partnerNumberIndividual": "0032165142",
      "employeeId": "198405169742",
      "firstName": "Föräldra",
      "lastName": "Susande"
  },
  {
      "partnerNumberIndividual": "0032166082",
      "employeeId": "198405173942",
      "firstName": "Anställd",
      "lastName": "EIDE"
  },
  {
      "partnerNumberIndividual": "0032166260",
      "employeeId": "198405174247",
      "firstName": "Varmrökt",
      "lastName": "Ömlåga"
  },
  {
      "partnerNumberIndividual": "0032166851",
      "employeeId": "198005206902",
      "firstName": "Inbördeskrigliknande",
      "lastName": "Byggjobbare"
  },
  {
      "partnerNumberIndividual": "0032167966",
      "employeeId": "198405182042",
      "firstName": "Svensk",
      "lastName": "Porslinsmålning"
  },
  {
      "partnerNumberIndividual": "0032169394",
      "employeeId": "198405180244",
      "firstName": "Sank",
      "lastName": "Bergsklättrare"
  },
  {
      "partnerNumberIndividual": "0032170628",
      "employeeId": "198005219905",
      "firstName": "Berusande",
      "lastName": "Chokladpudding"
  },
  {
      "partnerNumberIndividual": "0032170663",
      "employeeId": "198005210508",
      "firstName": "Själfull",
      "lastName": "Splittrad"
  },
  {
      "partnerNumberIndividual": "0032171819",
      "employeeId": "198005225902",
      "firstName": "Vikariats",
      "lastName": "Kontantköp"
  },
  {
      "partnerNumberIndividual": "0032173337",
      "employeeId": "198005232502",
      "firstName": "Svängningsbar",
      "lastName": "Snöklocka"
  },
  {
      "partnerNumberIndividual": "0032173619",
      "employeeId": "198405215842",
      "firstName": "Obegränsad",
      "lastName": "Rymdteknik"
  },
  {
      "partnerNumberIndividual": "0032173725",
      "employeeId": "198405216147",
      "firstName": "Fridlysningsvärd",
      "lastName": "Stridstyrka"
  },
  {
      "partnerNumberIndividual": "0032173827",
      "employeeId": "198005233708",
      "firstName": "Blåklädd",
      "lastName": "Dådlöshet"
  },
  {
      "partnerNumberIndividual": "0032174147",
      "employeeId": "198405218549",
      "firstName": "Föräldra",
      "lastName": "Mindreskatfink"
  },
  {
      "partnerNumberIndividual": "0032174754",
      "employeeId": "198405222442",
      "firstName": "Fisklik",
      "lastName": "Vitfläckigpygmérall"
  },
  {
      "partnerNumberIndividual": "0032175100",
      "employeeId": "198405222749",
      "firstName": "Babylonisk",
      "lastName": "Vinnarserie"
  },
  {
      "partnerNumberIndividual": "0032176714",
      "employeeId": "198005249407",
      "firstName": "Begreppsmässig",
      "lastName": "Kreditförlustreserv"
  },
  {
      "partnerNumberIndividual": "0032177065",
      "employeeId": "198005252401",
      "firstName": "Pittoresk",
      "lastName": "Beklädnadsförråd"
  },
  {
      "partnerNumberIndividual": "0032178272",
      "employeeId": "198405236947",
      "firstName": "Närbesläktad",
      "lastName": "Fartsladd"
  },
  {
      "partnerNumberIndividual": "0032178456",
      "employeeId": "198405237846",
      "firstName": "Målfattig",
      "lastName": "Societetshus"
  },
  {
      "partnerNumberIndividual": "0032179823",
      "employeeId": "198005267805",
      "firstName": "Ickeskattefinansierad",
      "lastName": "Affischklistrare"
  },
  {
      "partnerNumberIndividual": "0032179870",
      "employeeId": "198405242945",
      "firstName": "Vördad",
      "lastName": "Ljudbild"
  },
  {
      "partnerNumberIndividual": "0032180305",
      "employeeId": "198005260503",
      "firstName": "Paltig",
      "lastName": "Avbetalningslag"
  },
  {
      "partnerNumberIndividual": "0032180335",
      "employeeId": "198405244743",
      "firstName": "Trendmedveten",
      "lastName": "Byggnadstimmer"
  },
  {
      "partnerNumberIndividual": "0032181226",
      "employeeId": "198005274702",
      "firstName": "Ormrik",
      "lastName": "Differentialrelä"
  },
  {
      "partnerNumberIndividual": "0032181381",
      "employeeId": "198005275006",
      "firstName": "Bonusberättigad",
      "lastName": "Systemvetenskap"
  },
  {
      "partnerNumberIndividual": "0032183476",
      "employeeId": "198405258347",
      "firstName": "Mittenavoktober",
      "lastName": "Höftstöd"
  },
  {
      "partnerNumberIndividual": "0032185073",
      "employeeId": "198405266142",
      "firstName": "Djäkla",
      "lastName": "Gerillakamp"
  },
  {
      "partnerNumberIndividual": "0032192809",
      "employeeId": "198005018901",
      "firstName": "Motsägelsebar",
      "lastName": "Totalomkostnad"
  },
  {
      "partnerNumberIndividual": "0032193174",
      "employeeId": "198005019800",
      "firstName": "Aerotropisk",
      "lastName": "Säkertläge"
  },
  {
      "partnerNumberIndividual": "0032194275",
      "employeeId": "198005025807",
      "firstName": "Tiodubbel",
      "lastName": "Jordbruksekonom"
  },
  {
      "partnerNumberIndividual": "0032196733",
      "employeeId": "198405016349",
      "firstName": "Sekret",
      "lastName": "Kontantköp"
  },
  {
      "partnerNumberIndividual": "0032196883",
      "employeeId": "198405017545",
      "firstName": "Medhjälpande",
      "lastName": "Asbestfiberplatta"
  },
  {
      "partnerNumberIndividual": "0032198143",
      "employeeId": "198005046308",
      "firstName": "Peonisk",
      "lastName": "Katepsin"
  },
  {
      "partnerNumberIndividual": "0032198345",
      "employeeId": "198405022941",
      "firstName": "Mural",
      "lastName": "Endag"
  },
  {
      "partnerNumberIndividual": "0032199579",
      "employeeId": "198005053205",
      "firstName": "Sydöster",
      "lastName": "Svartkronadsiska"
  },
  {
      "partnerNumberIndividual": "0032199857",
      "employeeId": "198405020549",
      "firstName": "Tillfredsställande",
      "lastName": "Jämkningsgrund"
  },
  {
      "partnerNumberIndividual": "0032200248",
      "employeeId": "198405020242",
      "firstName": "Ansvarsmedveten",
      "lastName": "Tilläggsbudget"
  },
  {
      "partnerNumberIndividual": "0032200708",
      "employeeId": "198005050805",
      "firstName": "Brabantsk",
      "lastName": "Bestrålningstid"
  },
  {
      "partnerNumberIndividual": "0032200828",
      "employeeId": "198405036248",
      "firstName": "Oantastlig",
      "lastName": "Alefnoll"
  },
  {
      "partnerNumberIndividual": "0032201080",
      "employeeId": "198005051704",
      "firstName": "Kardiografisk",
      "lastName": "Marknadsfokuserad"
  },
  {
      "partnerNumberIndividual": "0032204208",
      "employeeId": "198005074003",
      "firstName": "Accelererande",
      "lastName": "Silvervinge"
  },
  {
      "partnerNumberIndividual": "0032204769",
      "employeeId": "198405058242",
      "firstName": "Helfodrad",
      "lastName": "Rörligpensionsålder"
  },
  {
      "partnerNumberIndividual": "0032204796",
      "employeeId": "198405059448",
      "firstName": "Vadderad",
      "lastName": "Ladugårdsbacke"
  },
  {
      "partnerNumberIndividual": "0032204816",
      "employeeId": "198405059745",
      "firstName": "Tänkbar",
      "lastName": "Porslinsmålning"
  },
  {
      "partnerNumberIndividual": "0032205734",
      "employeeId": "198405063945",
      "firstName": "Guldbelagd",
      "lastName": "Isocrotonsyra"
  },
  {
      "partnerNumberIndividual": "0032207125",
      "employeeId": "198005088508",
      "firstName": "Posttraumatisk",
      "lastName": "Bomullslump"
  },
  {
      "partnerNumberIndividual": "0032210601",
      "employeeId": "198405086243",
      "firstName": "Underskön",
      "lastName": "Ulster"
  },
  {
      "partnerNumberIndividual": "0032211682",
      "employeeId": "198006104700",
      "firstName": "Spjälad",
      "lastName": "Blåringadängelfisk"
  },
  {
      "partnerNumberIndividual": "0032212982",
      "employeeId": "198406095847",
      "firstName": "Helfransk",
      "lastName": "Genomsnittsvikt"
  },
  {
      "partnerNumberIndividual": "0032213225",
      "employeeId": "198006112505",
      "firstName": "Rödbrokig",
      "lastName": "Konventdeltagare"
  },
  {
      "partnerNumberIndividual": "0032216235",
      "employeeId": "198006125804",
      "firstName": "Pikerad",
      "lastName": "Synkroniserare"
  },
  {
      "partnerNumberIndividual": "0032216626",
      "employeeId": "198006125200",
      "firstName": "Därförinnan",
      "lastName": "Stopptavla"
  },
  {
      "partnerNumberIndividual": "0032216669",
      "employeeId": "198006126406",
      "firstName": "Beroendeav",
      "lastName": "Envisman"
  },
  {
      "partnerNumberIndividual": "0032216713",
      "employeeId": "198406117849",
      "firstName": "Bilmekanisk",
      "lastName": "Hermelinsskinn"
  },
  {
      "partnerNumberIndividual": "0032216747",
      "employeeId": "198006127305",
      "firstName": "Sammanhållen",
      "lastName": "Svetsanordning"
  },
  {
      "partnerNumberIndividual": "0032217156",
      "employeeId": "198006127909",
      "firstName": "Konkretistisk",
      "lastName": "Brokigplaty"
  },
  {
      "partnerNumberIndividual": "0032217179",
      "employeeId": "198406122344",
      "firstName": "Copyrightfri",
      "lastName": "Långhålsborrmaskin"
  },
  {
      "partnerNumberIndividual": "0032217310",
      "employeeId": "198006128204",
      "firstName": "Benämnbar",
      "lastName": "Lochiarubra"
  },
  {
      "partnerNumberIndividual": "0032217878",
      "employeeId": "198006132404",
      "firstName": "Tvådelad",
      "lastName": "Oxfordrörelsemedlem"
  },
  {
      "partnerNumberIndividual": "0032221279",
      "employeeId": "198406142847",
      "firstName": "EUanställd",
      "lastName": "Institutionelltsamarbete"
  },
  {
      "partnerNumberIndividual": "0032221649",
      "employeeId": "198006152303",
      "firstName": "Begynnelse",
      "lastName": "Kvicksilverväxelriktare"
  },
  {
      "partnerNumberIndividual": "0032221658",
      "employeeId": "198406143746",
      "firstName": "Glömsk",
      "lastName": "Ångstrykjärn"
  },
  {
      "partnerNumberIndividual": "0032222122",
      "employeeId": "198006152600",
      "firstName": "Mittenavoktober",
      "lastName": "Susande"
  },
  {
      "partnerNumberIndividual": "0032224647",
      "employeeId": "198406159742",
      "firstName": "Dagvill",
      "lastName": "Förhandsavgift"
  },
  {
      "partnerNumberIndividual": "0032224675",
      "employeeId": "198406159148",
      "firstName": "Artskild",
      "lastName": "Hårdförman"
  },
  {
      "partnerNumberIndividual": "0032225038",
      "employeeId": "198006168903",
      "firstName": "Denotativ",
      "lastName": "Malteserkors"
  },
  {
      "partnerNumberIndividual": "0032225117",
      "employeeId": "198406163942",
      "firstName": "Urskiljbar",
      "lastName": "Karakullamm"
  },
  {
      "partnerNumberIndividual": "0032225855",
      "employeeId": "198006173705",
      "firstName": "Täthets",
      "lastName": "Kungsmagnolia"
  },
  {
      "partnerNumberIndividual": "0032225973",
      "employeeId": "198006174000",
      "firstName": "Deskriptiv",
      "lastName": "Stenkastare"
  },
  {
      "partnerNumberIndividual": "0032228025",
      "employeeId": "198406179948",
      "firstName": "Rörformad",
      "lastName": "Ordanvändning"
  },
  {
      "partnerNumberIndividual": "0032228808",
      "employeeId": "198406184740",
      "firstName": "Sammanhållande",
      "lastName": "Ekosofi"
  },
  {
      "partnerNumberIndividual": "0032228852",
      "employeeId": "198406185341",
      "firstName": "Inkräktande",
      "lastName": "Aluminiumborkarbid"
  },
  {
      "partnerNumberIndividual": "0032229881",
      "employeeId": "198006189404",
      "firstName": "Elektrohydraulisk",
      "lastName": "Fullnav"
  },
  {
      "partnerNumberIndividual": "0032230833",
      "employeeId": "198006194503",
      "firstName": "Malliknande",
      "lastName": "Utgiftutanförbudget"
  },
  {
      "partnerNumberIndividual": "0032232033",
      "employeeId": "198406205842",
      "firstName": "Finriven",
      "lastName": "Kantpress"
  },
  {
      "partnerNumberIndividual": "0032232299",
      "employeeId": "198406206444",
      "firstName": "Utsmyckad",
      "lastName": "Förkroppsling"
  },
  {
      "partnerNumberIndividual": "0032232378",
      "employeeId": "198406206147",
      "firstName": "Genotypisk",
      "lastName": "Baggbölare"
  },
  {
      "partnerNumberIndividual": "0032232451",
      "employeeId": "198406207343",
      "firstName": "Högsvansföring",
      "lastName": "Ömlåga"
  },
  {
      "partnerNumberIndividual": "0032234647",
      "employeeId": "198006200805",
      "firstName": "Anstötlig",
      "lastName": "Kandidat"
  },
  {
      "partnerNumberIndividual": "0032235569",
      "employeeId": "198006215605",
      "firstName": "Avgudadyrkande",
      "lastName": "Dragbult"
  },
  {
      "partnerNumberIndividual": "0032235985",
      "employeeId": "198006216207",
      "firstName": "Prelatensisk",
      "lastName": "Kvartärgeologi"
  },
  {
      "partnerNumberIndividual": "0032237100",
      "employeeId": "198006222809",
      "firstName": "Expropierad",
      "lastName": "Barnsligtillgivenhet"
  },
  {
      "partnerNumberIndividual": "0032238158",
      "employeeId": "198406233240",
      "firstName": "Bionomisk",
      "lastName": "Arktisktklima"
  },
  {
      "partnerNumberIndividual": "0032238264",
      "employeeId": "198406234743",
      "firstName": "Vållande",
      "lastName": "Restaurationskomedi"
  },
  {
      "partnerNumberIndividual": "0032240199",
      "employeeId": "198006239100",
      "firstName": "Algin",
      "lastName": "Fotbollshysteri"
  },
  {
      "partnerNumberIndividual": "0032240530",
      "employeeId": "198406249840",
      "firstName": "Tiggaraktig",
      "lastName": "Epitelcell"
  },
  {
      "partnerNumberIndividual": "0032240810",
      "employeeId": "198006243300",
      "firstName": "Pressad",
      "lastName": "Födelsekyrka"
  },
  {
      "partnerNumberIndividual": "0032240980",
      "employeeId": "198006243904",
      "firstName": "Albinistisk",
      "lastName": "Fjärrgodstransport"
  },
  {
      "partnerNumberIndividual": "0032241743",
      "employeeId": "198406256142",
      "firstName": "Pleuritisk",
      "lastName": "Konturspår"
  },
  {
      "partnerNumberIndividual": "0032244336",
      "employeeId": "198006257805",
      "firstName": "Högre",
      "lastName": "Tempocykel"
  },
  {
      "partnerNumberIndividual": "0032245762",
      "employeeId": "198406276942",
      "firstName": "Responsiv",
      "lastName": "Innehållsindikator"
  },
  {
      "partnerNumberIndividual": "0032245821",
      "employeeId": "198006263209",
      "firstName": "Blygrå",
      "lastName": "Utsago"
  },
  {
      "partnerNumberIndividual": "0032246259",
      "employeeId": "198006265907",
      "firstName": "Anemometrisk",
      "lastName": "Kantpress"
  },
  {
      "partnerNumberIndividual": "0032252793",
      "employeeId": "198406012644",
      "firstName": "Beroendeav",
      "lastName": "Dumpningavavfall"
  },
  {
      "partnerNumberIndividual": "0032252852",
      "employeeId": "198406013246",
      "firstName": "Halvlång",
      "lastName": "Medhjälpare"
  },
  {
      "partnerNumberIndividual": "0032253871",
      "employeeId": "198406010846",
      "firstName": "Överens",
      "lastName": "Skifferbrytning"
  },
  {
      "partnerNumberIndividual": "0032254864",
      "employeeId": "198406026248",
      "firstName": "Virtuos",
      "lastName": "Sandnarv"
  },
  {
      "partnerNumberIndividual": "0032255963",
      "employeeId": "198406033749",
      "firstName": "Video",
      "lastName": "Fraktionsdestillation"
  },
  {
      "partnerNumberIndividual": "0032256479",
      "employeeId": "198006015500",
      "firstName": "Visuell",
      "lastName": "Bravuraria"
  },
  {
      "partnerNumberIndividual": "0032256642",
      "employeeId": "198006016409",
      "firstName": "Tillyxad",
      "lastName": "Oframkomlighet"
  },
  {
      "partnerNumberIndividual": "0032259420",
      "employeeId": "198406049448",
      "firstName": "Tegellagd",
      "lastName": "Ytfinhet"
  },
  {
      "partnerNumberIndividual": "0032259802",
      "employeeId": "198006020906",
      "firstName": "Zoografisk",
      "lastName": "Kontantköp"
  },
  {
      "partnerNumberIndividual": "0032259847",
      "employeeId": "198406052442",
      "firstName": "Strup",
      "lastName": "Vågmästare"
  },
  {
      "partnerNumberIndividual": "0032259899",
      "employeeId": "198406052749",
      "firstName": "Ickeskattefinansierad",
      "lastName": "Pupalstadium"
  },
  {
      "partnerNumberIndividual": "0032261202",
      "employeeId": "198006037801",
      "firstName": "Bianco",
      "lastName": "Bildningsanstalt"
  },
  {
      "partnerNumberIndividual": "0032264251",
      "employeeId": "198406074743",
      "firstName": "Glasögonbärande",
      "lastName": "Mindreskatfink"
  },
  {
      "partnerNumberIndividual": "0032264272",
      "employeeId": "198406075641",
      "firstName": "Betydligt",
      "lastName": "Hukställning"
  },
  {
      "partnerNumberIndividual": "0032265625",
      "employeeId": "198006058609",
      "firstName": "Anstötlig",
      "lastName": "Landet"
  },
  {
      "partnerNumberIndividual": "0032266652",
      "employeeId": "198006064300",
      "firstName": "Reparerbar",
      "lastName": "Envisman"
  },
  {
      "partnerNumberIndividual": "0032266726",
      "employeeId": "198006064003",
      "firstName": "Paraguayansk",
      "lastName": "Vantrevnad"
  },
  {
      "partnerNumberIndividual": "0032266770",
      "employeeId": "198406089840",
      "firstName": "Övermöblerad",
      "lastName": "Segelhållare"
  },
  {
      "partnerNumberIndividual": "0032269262",
      "employeeId": "198006078508",
      "firstName": "Avgudadyrkande",
      "lastName": "Deklamator"
  },
  {
      "partnerNumberIndividual": "0032269613",
      "employeeId": "198006079100",
      "firstName": "Elokvent",
      "lastName": "Baljbotten"
  },
  {
      "partnerNumberIndividual": "0032270218",
      "employeeId": "198407106940",
      "firstName": "Riktningsstabil",
      "lastName": "Dubbelverkandeaxiallager"
  },
  {
      "partnerNumberIndividual": "0032270231",
      "employeeId": "198006083904",
      "firstName": "Ankyloserande",
      "lastName": "Ledningsmaterialavsilver"
  },
  {
      "partnerNumberIndividual": "0032270629",
      "employeeId": "198407107849",
      "firstName": "Kontraintuitiv",
      "lastName": "Höghastighetsnät"
  },
  {
      "partnerNumberIndividual": "0032270714",
      "employeeId": "198407107245",
      "firstName": "Jordig",
      "lastName": "Slum"
  },
  {
      "partnerNumberIndividual": "0032270717",
      "employeeId": "198407108441",
      "firstName": "Halvautonom",
      "lastName": "Arnaudbarbett"
  },
  {
      "partnerNumberIndividual": "0032271508",
      "employeeId": "198407112344",
      "firstName": "Prasslande",
      "lastName": "Medbringarpinne"
  },
  {
      "partnerNumberIndividual": "0032274064",
      "employeeId": "198007095303",
      "firstName": "Välarmerad",
      "lastName": "Överklassdygd"
  },
  {
      "partnerNumberIndividual": "0032274077",
      "employeeId": "198007095600",
      "firstName": "Olycksfri",
      "lastName": "Polarexpedition"
  },
  {
      "partnerNumberIndividual": "0032274096",
      "employeeId": "198007095907",
      "firstName": "Intetillgänglig",
      "lastName": "Tidsaspekt"
  },
  {
      "partnerNumberIndividual": "0032275973",
      "employeeId": "198407132847",
      "firstName": "Anställd",
      "lastName": "Arkiater"
  },
  {
      "partnerNumberIndividual": "0032276039",
      "employeeId": "198407133746",
      "firstName": "Interak",
      "lastName": "Engganoglasögonfågel"
  },
  {
      "partnerNumberIndividual": "0032278887",
      "employeeId": "198007118204",
      "firstName": "Elektrohydraulisk",
      "lastName": "Menlöshet"
  },
  {
      "partnerNumberIndividual": "0032278890",
      "employeeId": "198407147944",
      "firstName": "Artskild",
      "lastName": "Hästminne"
  },
  {
      "partnerNumberIndividual": "0032278940",
      "employeeId": "198407148546",
      "firstName": "Lättsmältande",
      "lastName": "Transformatorstation"
  },
  {
      "partnerNumberIndividual": "0032279300",
      "employeeId": "198407149742",
      "firstName": "Suppletiv",
      "lastName": "Udde"
  },
  {
      "partnerNumberIndividual": "0032279858",
      "employeeId": "198407153942",
      "firstName": "Torkkänslig",
      "lastName": "Ulster"
  },
  {
      "partnerNumberIndividual": "0032280333",
      "employeeId": "198407156341",
      "firstName": "Strupstor",
      "lastName": "Buffertfjäder"
  },
  {
      "partnerNumberIndividual": "0032282314",
      "employeeId": "198007136305",
      "firstName": "Sövande",
      "lastName": "Äkthet"
  },
  {
      "partnerNumberIndividual": "0032283698",
      "employeeId": "198007142600",
      "firstName": "Vedisk",
      "lastName": "Hexaklorcyklohexan"
  },
  {
      "partnerNumberIndividual": "0032284573",
      "employeeId": "198407182545",
      "firstName": "Lättsinnig",
      "lastName": "Pansarsköld"
  },
  {
      "partnerNumberIndividual": "0032287240",
      "employeeId": "198007158903",
      "firstName": "Glasögonbärande",
      "lastName": "Halvapa"
  },
  {
      "partnerNumberIndividual": "0032287663",
      "employeeId": "198407196149",
      "firstName": "Husdjursetisk",
      "lastName": "Opiumfält"
  },
  {
      "partnerNumberIndividual": "0032287745",
      "employeeId": "198407197949",
      "firstName": "Utsmyckad",
      "lastName": "Himlenrunthörnet"
  },
  {
      "partnerNumberIndividual": "0032288181",
      "employeeId": "198407198244",
      "firstName": "Bonusberättigad",
      "lastName": "Alefnoll"
  },
  {
      "partnerNumberIndividual": "0032288231",
      "employeeId": "198007164000",
      "firstName": "Kinesisktalande",
      "lastName": "Nötbröd"
  },
  {
      "partnerNumberIndividual": "0032288766",
      "employeeId": "198407202442",
      "firstName": "Strup",
      "lastName": "Slum"
  },
  {
      "partnerNumberIndividual": "0032291338",
      "employeeId": "198407216947",
      "firstName": "Tillsist",
      "lastName": "Träldomsok"
  },
  {
      "partnerNumberIndividual": "0032291694",
      "employeeId": "198007179404",
      "firstName": "Guldbelagd",
      "lastName": "Postsparbanksbok"
  },
  {
      "partnerNumberIndividual": "0032292234",
      "employeeId": "198407222648",
      "firstName": "Ejkonvertibel",
      "lastName": "Elektrodynamometer"
  },
  {
      "partnerNumberIndividual": "0032292545",
      "employeeId": "198407223240",
      "firstName": "Smidbar",
      "lastName": "Äkthet"
  },
  {
      "partnerNumberIndividual": "0032292806",
      "employeeId": "198007183901",
      "firstName": "Australiensisk",
      "lastName": "Torpedhantverkare"
  },
  {
      "partnerNumberIndividual": "0032293291",
      "employeeId": "198007186300",
      "firstName": "Vissnande",
      "lastName": "Bravuraria"
  },
  {
      "partnerNumberIndividual": "0032295910",
      "employeeId": "198407243743",
      "firstName": "Industrihistorisk",
      "lastName": "Bestämmare"
  },
  {
      "partnerNumberIndividual": "0032296070",
      "employeeId": "198007199907",
      "firstName": "Uppkörd",
      "lastName": "Cirkulärpartikelaccelerator"
  },
  {
      "partnerNumberIndividual": "0032296105",
      "employeeId": "198007190807",
      "firstName": "Hedersam",
      "lastName": "Rasfördom"
  },
  {
      "partnerNumberIndividual": "0032296431",
      "employeeId": "198407245847",
      "firstName": "Rättad",
      "lastName": "Broskvävnad"
  },
  {
      "partnerNumberIndividual": "0032296440",
      "employeeId": "198407245243",
      "firstName": "Intetillgänglig",
      "lastName": "Jordräknare"
  },
  {
      "partnerNumberIndividual": "0032297480",
      "employeeId": "198007206207",
      "firstName": "Motsägelsebar",
      "lastName": "Testikelinflammation"
  },
  {
      "partnerNumberIndividual": "0032298295",
      "employeeId": "198007212809",
      "firstName": "Kortklippt",
      "lastName": "Postsparbanksbok"
  },
  {
      "partnerNumberIndividual": "0032298805",
      "employeeId": "198407258840",
      "firstName": "Specialanpassad",
      "lastName": "Fritidsbåtbyggare"
  },
  {
      "partnerNumberIndividual": "0032298858",
      "employeeId": "198407259442",
      "firstName": "Virtuos",
      "lastName": "Kärandesidan"
  },
  {
      "partnerNumberIndividual": "0032299774",
      "employeeId": "198407266348",
      "firstName": "Återlagrad",
      "lastName": "Höftstöd"
  },
  {
      "partnerNumberIndividual": "0032299794",
      "employeeId": "198007211603",
      "firstName": "Adderbar",
      "lastName": "Praktsalvia"
  },
  {
      "partnerNumberIndividual": "0032301637",
      "employeeId": "198007229100",
      "firstName": "Otålmodig",
      "lastName": "Grågumpadträdseglare"
  },
  {
      "partnerNumberIndividual": "0032302248",
      "employeeId": "198007233003",
      "firstName": "Fördelaktig",
      "lastName": "Grenadjärgarde"
  },
  {
      "partnerNumberIndividual": "0032302267",
      "employeeId": "198407270548",
      "firstName": "Snart",
      "lastName": "Guldsnodd"
  },
  {
      "partnerNumberIndividual": "0032302287",
      "employeeId": "198407270845",
      "firstName": "Vattrad",
      "lastName": "Besittningtagande"
  },
  {
      "partnerNumberIndividual": "0032302590",
      "employeeId": "198407270241",
      "firstName": "Krabbätande",
      "lastName": "Mönsterexemplar"
  },
  {
      "partnerNumberIndividual": "0032302731",
      "employeeId": "198007234209",
      "firstName": "Kortpipig",
      "lastName": "Morgonstjärna"
  },
  {
      "partnerNumberIndividual": "0032306073",
      "employeeId": "198007240503",
      "firstName": "Orientalisk",
      "lastName": "Föreläsningssal"
  },
  {
      "partnerNumberIndividual": "0032306087",
      "employeeId": "198007240206",
      "firstName": "Grottlik",
      "lastName": "Stångstål"
  },
  {
      "partnerNumberIndividual": "0032306569",
      "employeeId": "198007253209",
      "firstName": "Övermöblerad",
      "lastName": "Sjukvårdsinrättning"
  },
  {
      "partnerNumberIndividual": "0032309838",
      "employeeId": "198007268603",
      "firstName": "Oförtruten",
      "lastName": "Hanjar"
  },
  {
      "partnerNumberIndividual": "0032309948",
      "employeeId": "198007269809",
      "firstName": "Urtjatad",
      "lastName": "Vätgaselektrod"
  },
  {
      "partnerNumberIndividual": "0032310190",
      "employeeId": "198407015646",
      "firstName": "Ejkonvertibel",
      "lastName": "Neuroskada"
  },
  {
      "partnerNumberIndividual": "0032310266",
      "employeeId": "198407016248",
      "firstName": "Rättsvetenskaplig",
      "lastName": "Testmoment"
  },
  {
      "partnerNumberIndividual": "0032311102",
      "employeeId": "198407022840",
      "firstName": "Frontad",
      "lastName": "Sidostöttning"
  },
  {
      "partnerNumberIndividual": "0032314487",
      "employeeId": "198407039448",
      "firstName": "Uzbekistansk",
      "lastName": "Arktisktklima"
  },
  {
      "partnerNumberIndividual": "0032317413",
      "employeeId": "198407050247",
      "firstName": "Ankyloserande",
      "lastName": "Alpmynta"
  },
  {
      "partnerNumberIndividual": "0032320070",
      "employeeId": "198007012407",
      "firstName": "Debattlysten",
      "lastName": "Arbetsmarknadspension"
  },
  {
      "partnerNumberIndividual": "0032321603",
      "employeeId": "198407084345",
      "firstName": "Helfransk",
      "lastName": "Partistyrelse"
  },
  {
      "partnerNumberIndividual": "0032321962",
      "employeeId": "198407085243",
      "firstName": "Högupplösnings",
      "lastName": "Skifferbrytning"
  },
  {
      "partnerNumberIndividual": "0032322063",
      "employeeId": "198407086142",
      "firstName": "Strup",
      "lastName": "Väggkarta"
  },
  {
      "partnerNumberIndividual": "0032322366",
      "employeeId": "198407087348",
      "firstName": "Sjöfarande",
      "lastName": "Förkroppsling"
  },
  {
      "partnerNumberIndividual": "0032323340",
      "employeeId": "198007026902",
      "firstName": "Otillämpbar",
      "lastName": "Scintillationsräknare"
  },
  {
      "partnerNumberIndividual": "0032323460",
      "employeeId": "198007027801",
      "firstName": "Inlösbar",
      "lastName": "Mossa"
  },
  {
      "partnerNumberIndividual": "0032324050",
      "employeeId": "198007032306",
      "firstName": "Fyradörrars",
      "lastName": "Referensmaterial"
  },
  {
      "partnerNumberIndividual": "0032324350",
      "employeeId": "198007032603",
      "firstName": "Spolad",
      "lastName": "Endag"
  },
  {
      "partnerNumberIndividual": "0032324398",
      "employeeId": "198007032900",
      "firstName": "Pacifistisk",
      "lastName": "Noronhavireo"
  },
  {
      "partnerNumberIndividual": "0032324468",
      "employeeId": "198007033205",
      "firstName": "Avgudifierad",
      "lastName": "Köksinredning"
  },
  {
      "partnerNumberIndividual": "0032325711",
      "employeeId": "198007030805",
      "firstName": "Interkontinental",
      "lastName": "Duplextalkanal"
  },
  {
      "partnerNumberIndividual": "0032325922",
      "employeeId": "198408102641",
      "firstName": "Andragrads",
      "lastName": "Chokladtyrann"
  },
  {
      "partnerNumberIndividual": "0032326317",
      "employeeId": "198408102047",
      "firstName": "Postsilurisk",
      "lastName": "Läckerriska"
  },
  {
      "partnerNumberIndividual": "0032326348",
      "employeeId": "198408103847",
      "firstName": "Debattlysten",
      "lastName": "Försnillande"
  },
  {
      "partnerNumberIndividual": "0032326368",
      "employeeId": "198408103243",
      "firstName": "Halvlång",
      "lastName": "Introduktionspris"
  },
  {
      "partnerNumberIndividual": "0032327331",
      "employeeId": "198007052502",
      "firstName": "Havs",
      "lastName": "Kornblixt"
  },
  {
      "partnerNumberIndividual": "0032329734",
      "employeeId": "198408122540",
      "firstName": "Kråmande",
      "lastName": "Beardie"
  },
  {
      "partnerNumberIndividual": "0032331159",
      "employeeId": "198007069407",
      "firstName": "Åtskild",
      "lastName": "Droppeihavet"
  },
  {
      "partnerNumberIndividual": "0032331607",
      "employeeId": "198007060000",
      "firstName": "Djurvänlig",
      "lastName": "Delbruk"
  },
  {
      "partnerNumberIndividual": "0032333122",
      "employeeId": "198408144247",
      "firstName": "Kinesisktalande",
      "lastName": "Kortärm"
  },
  {
      "partnerNumberIndividual": "0032333530",
      "employeeId": "198408146341",
      "firstName": "Tunnhårig",
      "lastName": "Häxkraft"
  },
  {
      "partnerNumberIndividual": "0032335874",
      "employeeId": "198007080800",
      "firstName": "Överens",
      "lastName": "Alpsporre"
  },
  {
      "partnerNumberIndividual": "0032336786",
      "employeeId": "198408165648",
      "firstName": "Åsyna",
      "lastName": "Längdskidlopp"
  },
  {
      "partnerNumberIndividual": "0032339279",
      "employeeId": "198008099809",
      "firstName": "Kostnadsfri",
      "lastName": "Delbruk"
  },
  {
      "partnerNumberIndividual": "0032339348",
      "employeeId": "198008091301",
      "firstName": "Opatriotisk",
      "lastName": "Alpmynta"
  },
  {
      "partnerNumberIndividual": "0032340330",
      "employeeId": "198008105804",
      "firstName": "Visuell",
      "lastName": "Trådekerhjul"
  },
  {
      "partnerNumberIndividual": "0032340666",
      "employeeId": "198408188244",
      "firstName": "Driftsklar",
      "lastName": "Musikbibliotek"
  },
  {
      "partnerNumberIndividual": "0032342885",
      "employeeId": "198008110903",
      "firstName": "Opåverkbar",
      "lastName": "Hedersgubbe"
  },
  {
      "partnerNumberIndividual": "0032343551",
      "employeeId": "198408206947",
      "firstName": "Tättsittande",
      "lastName": "Vänskapshandling"
  },
  {
      "partnerNumberIndividual": "0032343650",
      "employeeId": "198408207242",
      "firstName": "Djurvänlig",
      "lastName": "Transformatorstation"
  },
  {
      "partnerNumberIndividual": "0032343888",
      "employeeId": "198008126305",
      "firstName": "Störtskön",
      "lastName": "Cellurval"
  },
  {
      "partnerNumberIndividual": "0032343933",
      "employeeId": "198008126602",
      "firstName": "Etnifierad",
      "lastName": "Köksbänk"
  },
  {
      "partnerNumberIndividual": "0032347344",
      "employeeId": "198408228941",
      "firstName": "Konstruktiv",
      "lastName": "Kopparsvart"
  },
  {
      "partnerNumberIndividual": "0032348428",
      "employeeId": "198008148309",
      "firstName": "Varmrökt",
      "lastName": "Proteintyrosinkinas"
  },
  {
      "partnerNumberIndividual": "0032348753",
      "employeeId": "198408235243",
      "firstName": "Avelsduglig",
      "lastName": "Lärofrihet"
  },
  {
      "partnerNumberIndividual": "0032348802",
      "employeeId": "198008149505",
      "firstName": "Kartagisk",
      "lastName": "Gulstrupigbulbyl"
  },
  {
      "partnerNumberIndividual": "0032349710",
      "employeeId": "198008152806",
      "firstName": "Ensamma",
      "lastName": "Sommarväder"
  },
  {
      "partnerNumberIndividual": "0032349730",
      "employeeId": "198008153705",
      "firstName": "Biltog",
      "lastName": "Brass"
  },
  {
      "partnerNumberIndividual": "0032351559",
      "employeeId": "198408249442",
      "firstName": "Enaxlad",
      "lastName": "Ljusbågeskydd"
  },
  {
      "partnerNumberIndividual": "0032351567",
      "employeeId": "198408249749",
      "firstName": "Skenfager",
      "lastName": "Hagelkorn"
  },
  {
      "partnerNumberIndividual": "0032352730",
      "employeeId": "198008168505",
      "firstName": "Intetillämpbar",
      "lastName": "Giftdryck"
  },
  {
      "partnerNumberIndividual": "0032352940",
      "employeeId": "198408256645",
      "firstName": "Exakt",
      "lastName": "Blåringadängelfisk"
  },
  {
      "partnerNumberIndividual": "0032353293",
      "employeeId": "198008160908",
      "firstName": "Renad",
      "lastName": "Idealman"
  },
  {
      "partnerNumberIndividual": "0032355543",
      "employeeId": "198008182308",
      "firstName": "Färdigknuten",
      "lastName": "Kvartärgeologi"
  },
  {
      "partnerNumberIndividual": "0032356976",
      "employeeId": "198008189907",
      "firstName": "Trendmedveten",
      "lastName": "Konventdeltagare"
  },
  {
      "partnerNumberIndividual": "0032357982",
      "employeeId": "198008195607",
      "firstName": "Halvsfärisk",
      "lastName": "Kolpulvereldning"
  },
  {
      "partnerNumberIndividual": "0032359449",
      "employeeId": "198008202502",
      "firstName": "Pirrig",
      "lastName": "Ugnsgaller"
  },
  {
      "partnerNumberIndividual": "0032363358",
      "employeeId": "198008218201",
      "firstName": "Tyst",
      "lastName": "Golvplanka"
  },
  {
      "partnerNumberIndividual": "0032364091",
      "employeeId": "198408012840",
      "firstName": "Mystagogisk",
      "lastName": "Akademikerbarn"
  },
  {
      "partnerNumberIndividual": "0032364781",
      "employeeId": "198008224209",
      "firstName": "Debattlysten",
      "lastName": "Engelsklektion"
  },
  {
      "partnerNumberIndividual": "0032366690",
      "employeeId": "198408026741",
      "firstName": "Spelad",
      "lastName": "Magnesiumstearat"
  },
  {
      "partnerNumberIndividual": "0032367206",
      "employeeId": "198008237201",
      "firstName": "Piezomagnetisk",
      "lastName": "Chokladtyrann"
  },
  {
      "partnerNumberIndividual": "0032370568",
      "employeeId": "198408047846",
      "firstName": "Giftasvuxen",
      "lastName": "Empir"
  },
  {
      "partnerNumberIndividual": "0032370782",
      "employeeId": "198008258603",
      "firstName": "Ambivalent",
      "lastName": "Sändarkrets"
  },
  {
      "partnerNumberIndividual": "0032370787",
      "employeeId": "198008258900",
      "firstName": "Storbystad",
      "lastName": "Jamaicabäverråtta"
  },
  {
      "partnerNumberIndividual": "0032371528",
      "employeeId": "198408053240",
      "firstName": "Heldags",
      "lastName": "Halogenpuck"
  },
  {
      "partnerNumberIndividual": "0032371872",
      "employeeId": "198008264304",
      "firstName": "Grottlik",
      "lastName": "Djup"
  },
  {
      "partnerNumberIndividual": "0032372022",
      "employeeId": "198008265202",
      "firstName": "Rökblå",
      "lastName": "Vindsbjälklag"
  },
  {
      "partnerNumberIndividual": "0032372181",
      "employeeId": "198408056243",
      "firstName": "Öppenheladagen",
      "lastName": "Jamaicabäverråtta"
  },
  {
      "partnerNumberIndividual": "0032372359",
      "employeeId": "198008266408",
      "firstName": "Oförlåtande",
      "lastName": "Akterom"
  },
  {
      "partnerNumberIndividual": "0032372388",
      "employeeId": "198008266101",
      "firstName": "Okontant",
      "lastName": "Kryptografi"
  },
  {
      "partnerNumberIndividual": "0032373425",
      "employeeId": "198008272406",
      "firstName": "Hermitesk",
      "lastName": "Utländskmoderbolag"
  },
  {
      "partnerNumberIndividual": "0032374545",
      "employeeId": "198408068941",
      "firstName": "Statskontrollerad",
      "lastName": "Skiktmoln"
  },
  {
      "partnerNumberIndividual": "0032374973",
      "employeeId": "198008279708",
      "firstName": "Ostämd",
      "lastName": "Svets"
  },
  {
      "partnerNumberIndividual": "0032376113",
      "employeeId": "198408077348",
      "firstName": "Grovmalen",
      "lastName": "Fallskärmspacke"
  },
  {
      "partnerNumberIndividual": "0032376642",
      "employeeId": "198408082447",
      "firstName": "Preskriberad",
      "lastName": "Pansarsköld"
  },
  {
      "partnerNumberIndividual": "0032379865",
      "employeeId": "198409092049",
      "firstName": "Från",
      "lastName": "Innehållsindikator"
  },
  {
      "partnerNumberIndividual": "0032383106",
      "employeeId": "198409112847",
      "firstName": "Ljudlig",
      "lastName": "Silvervinge"
  },
  {
      "partnerNumberIndividual": "0032383164",
      "employeeId": "198409112243",
      "firstName": "Labyrintisk",
      "lastName": "Pannstensbildning"
  },
  {
      "partnerNumberIndividual": "0032385938",
      "employeeId": "198008022603",
      "firstName": "Färdigsydd",
      "lastName": "Stereoskopkamera"
  },
  {
      "partnerNumberIndividual": "0032386310",
      "employeeId": "198008023205",
      "firstName": "Vrickad",
      "lastName": "Eftermiddagsskift"
  },
  {
      "partnerNumberIndividual": "0032386457",
      "employeeId": "198409127944",
      "firstName": "Tjockflytande",
      "lastName": "Innehållsindikator"
  },
  {
      "partnerNumberIndividual": "0032386577",
      "employeeId": "198409129445",
      "firstName": "Opåverkbar",
      "lastName": "Hedersgubbe"
  },
  {
      "partnerNumberIndividual": "0032386832",
      "employeeId": "198409129742",
      "firstName": "Hudvänlig",
      "lastName": "Vattenstäkra"
  },
  {
      "partnerNumberIndividual": "0032386882",
      "employeeId": "198409129148",
      "firstName": "Kabbalistisk",
      "lastName": "Nordsjöstubb"
  },
  {
      "partnerNumberIndividual": "0032387926",
      "employeeId": "198008020805",
      "firstName": "Utnött",
      "lastName": "Strandväg"
  },
  {
      "partnerNumberIndividual": "0032389186",
      "employeeId": "198008036207",
      "firstName": "Tioårig",
      "lastName": "Föräldrar"
  },
  {
      "partnerNumberIndividual": "0032390267",
      "employeeId": "198008042502",
      "firstName": "Färdigutbildad",
      "lastName": "Ringbrynja"
  },
  {
      "partnerNumberIndividual": "0032390697",
      "employeeId": "198008043708",
      "firstName": "Oälskad",
      "lastName": "Köpmansgille"
  },
  {
      "partnerNumberIndividual": "0032390765",
      "employeeId": "198008044300",
      "firstName": "Överens",
      "lastName": "Kolpulvereldning"
  },
  {
      "partnerNumberIndividual": "0032391596",
      "employeeId": "198409154740",
      "firstName": "Halvvåt",
      "lastName": "Brandriktning"
  },
  {
      "partnerNumberIndividual": "0032394736",
      "employeeId": "198008063904",
      "firstName": "Grönbete",
      "lastName": "Gräsrotsrörelse"
  },
  {
      "partnerNumberIndividual": "0032395131",
      "employeeId": "198409176149",
      "firstName": "Tegellagd",
      "lastName": "Svartkronadsiska"
  },
  {
      "partnerNumberIndividual": "0032395615",
      "employeeId": "198409178244",
      "firstName": "Bifokal",
      "lastName": "Plausibilitet"
  },
  {
      "partnerNumberIndividual": "0032396215",
      "employeeId": "198409183947",
      "firstName": "Knäckt",
      "lastName": "Långhålsborrmaskin"
  },
  {
      "partnerNumberIndividual": "0032398595",
      "employeeId": "198008084702",
      "firstName": "Spjälad",
      "lastName": "Hermelinsskinn"
  },
  {
      "partnerNumberIndividual": "0032398918",
      "employeeId": "198409196345",
      "firstName": "Vaksam",
      "lastName": "Tursam"
  },
  {
      "partnerNumberIndividual": "0032399384",
      "employeeId": "198409197848",
      "firstName": "Hanseatisk",
      "lastName": "Restaurationskomedi"
  },
  {
      "partnerNumberIndividual": "0032399427",
      "employeeId": "198409197244",
      "firstName": "Labyrintisk",
      "lastName": "Kolpulvereldning"
  },
  {
      "partnerNumberIndividual": "0032402206",
      "employeeId": "198009097901",
      "firstName": "Motsägelsebar",
      "lastName": "Sändarkrets"
  },
  {
      "partnerNumberIndividual": "0032404603",
      "employeeId": "198409219246",
      "firstName": "Rosthindrande",
      "lastName": "Spiralfjäder"
  },
  {
      "partnerNumberIndividual": "0032405199",
      "employeeId": "198409223743",
      "firstName": "Förtretlig",
      "lastName": "Ciselerhammare"
  },
  {
      "partnerNumberIndividual": "0032405727",
      "employeeId": "198409225243",
      "firstName": "Blygrå",
      "lastName": "Klosterföreståndarinna"
  },
  {
      "partnerNumberIndividual": "0032405822",
      "employeeId": "198009116909",
      "firstName": "Toskansk",
      "lastName": "Skifferbrytning"
  },
  {
      "partnerNumberIndividual": "0032407102",
      "employeeId": "198009122907",
      "firstName": "Avmätt",
      "lastName": "Kritsnöre"
  },
  {
      "partnerNumberIndividual": "0032410689",
      "employeeId": "198009139802",
      "firstName": "Denaturerad",
      "lastName": "Fiskerikontroll"
  },
  {
      "partnerNumberIndividual": "0032413028",
      "employeeId": "198409265645",
      "firstName": "Orientalisk",
      "lastName": "Sportlov"
  },
  {
      "partnerNumberIndividual": "0032413055",
      "employeeId": "198409265942",
      "firstName": "Algin",
      "lastName": "Utsändning"
  },
  {
      "partnerNumberIndividual": "0032414260",
      "employeeId": "198009158505",
      "firstName": "Lockförsedd",
      "lastName": "Landet"
  },
  {
      "partnerNumberIndividual": "0032414663",
      "employeeId": "198009159404",
      "firstName": "Obillig",
      "lastName": "Läsesällskap"
  },
  {
      "partnerNumberIndividual": "0032414762",
      "employeeId": "198009159107",
      "firstName": "Högsvansföring",
      "lastName": "Kringkastning"
  },
  {
      "partnerNumberIndividual": "0032414801",
      "employeeId": "198409273144",
      "firstName": "Flockblommig",
      "lastName": "Jordmån"
  },
  {
      "partnerNumberIndividual": "0032415217",
      "employeeId": "198009163901",
      "firstName": "Hudvänlig",
      "lastName": "Nickel"
  },
  {
      "partnerNumberIndividual": "0032415319",
      "employeeId": "198009164206",
      "firstName": "Sociologiskt",
      "lastName": "Mussla"
  },
  {
      "partnerNumberIndividual": "0032415638",
      "employeeId": "198009166300",
      "firstName": "Partitrogen",
      "lastName": "Kvartärgeologi"
  },
  {
      "partnerNumberIndividual": "0032415712",
      "employeeId": "198009166003",
      "firstName": "Kokett",
      "lastName": "Ledarställning"
  },
  {
      "partnerNumberIndividual": "0032416889",
      "employeeId": "198009172308",
      "firstName": "Plandels",
      "lastName": "Systemvetenskap"
  },
  {
      "partnerNumberIndividual": "0032417274",
      "employeeId": "198009172001",
      "firstName": "Självförhärligande",
      "lastName": "Dubbelpropellerångare"
  },
  {
      "partnerNumberIndividual": "0032418912",
      "employeeId": "198009170500",
      "firstName": "Kunskapsintensiv",
      "lastName": "Prisberäkning"
  },
  {
      "partnerNumberIndividual": "0032418955",
      "employeeId": "198009170807",
      "firstName": "Vördad",
      "lastName": "Nymodighetsfobi"
  },
  {
      "partnerNumberIndividual": "0032419306",
      "employeeId": "198009170203",
      "firstName": "Kvadrofonisk",
      "lastName": "Strandgata"
  },
  {
      "partnerNumberIndividual": "0032420066",
      "employeeId": "198009185607",
      "firstName": "Uppspelad",
      "lastName": "Tangentialturbin"
  },
  {
      "partnerNumberIndividual": "0032423952",
      "employeeId": "198409024240",
      "firstName": "Pyroteknisk",
      "lastName": "Inloppsrör"
  },
  {
      "partnerNumberIndividual": "0032426159",
      "employeeId": "198009214209",
      "firstName": "Debattlysten",
      "lastName": "Regleringssteg"
  },
  {
      "partnerNumberIndividual": "0032426394",
      "employeeId": "198409037846",
      "firstName": "Konstruktiv",
      "lastName": "Empir"
  },
  {
      "partnerNumberIndividual": "0032428214",
      "employeeId": "198409046243",
      "firstName": "Flodhästliknande",
      "lastName": "Partistyrelse"
  },
  {
      "partnerNumberIndividual": "0032428355",
      "employeeId": "198009227805",
      "firstName": "Feber",
      "lastName": "Ektypografi"
  },
  {
      "partnerNumberIndividual": "0032428401",
      "employeeId": "198009227201",
      "firstName": "Bulldogslik",
      "lastName": "Betongblandning"
  },
  {
      "partnerNumberIndividual": "0032428908",
      "employeeId": "198009220206",
      "firstName": "Obeskrivlig",
      "lastName": "Färgverk"
  },
  {
      "partnerNumberIndividual": "0032431329",
      "employeeId": "198409065847",
      "firstName": "Asocial",
      "lastName": "Hästminne"
  },
  {
      "partnerNumberIndividual": "0032431366",
      "employeeId": "198409065243",
      "firstName": "Besegrad",
      "lastName": "Ilandsättning"
  },
  {
      "partnerNumberIndividual": "0032432550",
      "employeeId": "198409072744",
      "firstName": "Alkalilöslig",
      "lastName": "PCkort"
  },
  {
      "partnerNumberIndividual": "0032433345",
      "employeeId": "198009248900",
      "firstName": "Himmelsvid",
      "lastName": "Signor"
  },
  {
      "partnerNumberIndividual": "0032434234",
      "employeeId": "198009253702",
      "firstName": "Episkopal",
      "lastName": "Örn"
  },
  {
      "partnerNumberIndividual": "0032434292",
      "employeeId": "198009254304",
      "firstName": "Västtysk",
      "lastName": "Tyrrhenuggla"
  },
  {
      "partnerNumberIndividual": "0032434711",
      "employeeId": "198009255806",
      "firstName": "Skogaktig",
      "lastName": "Realtid"
  },
  {
      "partnerNumberIndividual": "0032437381",
      "employeeId": "198009269401",
      "firstName": "Piezomagnetisk",
      "lastName": "Försäkringskostnad"
  },
  {
      "partnerNumberIndividual": "0032439073",
      "employeeId": "198009276901",
      "firstName": "Förbuskad",
      "lastName": "Lamaull"
  },
  {
      "partnerNumberIndividual": "0032441314",
      "employeeId": "198410118247",
      "firstName": "Kostymerad",
      "lastName": "Tidvattenskraft"
  },
  {
      "partnerNumberIndividual": "0032445793",
      "employeeId": "198410144748",
      "firstName": "Avmätt",
      "lastName": "Hemläkare"
  },
  {
      "partnerNumberIndividual": "0032446074",
      "employeeId": "198009012009",
      "firstName": "Olöslig",
      "lastName": "Spraymunstycke"
  },
  {
      "partnerNumberIndividual": "0032446278",
      "employeeId": "198410146248",
      "firstName": "Svåranskaffad",
      "lastName": "Fariseism"
  },
  {
      "partnerNumberIndividual": "0032448912",
      "employeeId": "198410165842",
      "firstName": "Helfodrad",
      "lastName": "Älsklingen"
  },
  {
      "partnerNumberIndividual": "0032449455",
      "employeeId": "198009026207",
      "firstName": "Bombmattefällande",
      "lastName": "Återflöde"
  },
  {
      "partnerNumberIndividual": "0032450390",
      "employeeId": "198009032809",
      "firstName": "Fågel",
      "lastName": "Bröstlidande"
  },
  {
      "partnerNumberIndividual": "0032451257",
      "employeeId": "198410170941",
      "firstName": "Tillsist",
      "lastName": "Kalkalg"
  },
  {
      "partnerNumberIndividual": "0032452317",
      "employeeId": "198410186947",
      "firstName": "Naturstridig",
      "lastName": "Lärofrihet"
  },
  {
      "partnerNumberIndividual": "0032453256",
      "employeeId": "198410192341",
      "firstName": "Datormanipulerad",
      "lastName": "Gurkhakniv"
  },
  {
      "partnerNumberIndividual": "0032453672",
      "employeeId": "198410193240",
      "firstName": "Blåaktig",
      "lastName": "Celsiusgrad"
  },
  {
      "partnerNumberIndividual": "0032453719",
      "employeeId": "198410194743",
      "firstName": "Jordig",
      "lastName": "Vichyregering"
  },
  {
      "partnerNumberIndividual": "0032453983",
      "employeeId": "198009048508",
      "firstName": "Anstötlig",
      "lastName": "Stridsvagnsduell"
  },
  {
      "partnerNumberIndividual": "0032454010",
      "employeeId": "198009048201",
      "firstName": "Evasiv",
      "lastName": "Fakturarabatt"
  },
  {
      "partnerNumberIndividual": "0032454553",
      "employeeId": "198009052708",
      "firstName": "Rökblå",
      "lastName": "Jättefylla"
  },
  {
      "partnerNumberIndividual": "0032454946",
      "employeeId": "198009053003",
      "firstName": "Biltog",
      "lastName": "Neurotiker"
  },
  {
      "partnerNumberIndividual": "0032457380",
      "employeeId": "198009060503",
      "firstName": "Artskild",
      "lastName": "Miltklimat"
  },
  {
      "partnerNumberIndividual": "0032457384",
      "employeeId": "198009060800",
      "firstName": "Slumpmässig",
      "lastName": "Lyra"
  },
  {
      "partnerNumberIndividual": "0032458214",
      "employeeId": "198009074702",
      "firstName": "Vattenburen",
      "lastName": "Cellurval"
  },
  {
      "partnerNumberIndividual": "0032461391",
      "employeeId": "198009089809",
      "firstName": "Urskiljbar",
      "lastName": "Platå"
  },
  {
      "partnerNumberIndividual": "0032462481",
      "employeeId": "198410240843",
      "firstName": "Tillsist",
      "lastName": "Guldnissöga"
  },
  {
      "partnerNumberIndividual": "0032463082",
      "employeeId": "198410255643",
      "firstName": "Utankärlek",
      "lastName": "Yttervingturbin"
  },
  {
      "partnerNumberIndividual": "0032464480",
      "employeeId": "198410263746",
      "firstName": "Julpimpande",
      "lastName": "Kylslinga"
  },
  {
      "partnerNumberIndividual": "0032467243",
      "employeeId": "198010112301",
      "firstName": "Afanitisk",
      "lastName": "Äxing"
  },
  {
      "partnerNumberIndividual": "0032470526",
      "employeeId": "198010128307",
      "firstName": "Finans",
      "lastName": "Läkartjänst"
  },
  {
      "partnerNumberIndividual": "0032471133",
      "employeeId": "198010132804",
      "firstName": "Antikrigs",
      "lastName": "Arkivlag"
  },
  {
      "partnerNumberIndividual": "0032471143",
      "employeeId": "198010133703",
      "firstName": "Surrealistisk",
      "lastName": "Magnetmotstånd"
  },
  {
      "partnerNumberIndividual": "0032471574",
      "employeeId": "198010135203",
      "firstName": "Ametistliknande",
      "lastName": "Ektypografi"
  },
  {
      "partnerNumberIndividual": "0032473945",
      "employeeId": "198410012747",
      "firstName": "Durativ",
      "lastName": "Nedrekontrollgräns"
  },
  {
      "partnerNumberIndividual": "0032474700",
      "employeeId": "198010153909",
      "firstName": "Gravimetrisk",
      "lastName": "Fundamentalistgrupp"
  },
  {
      "partnerNumberIndividual": "0032477126",
      "employeeId": "198410033842",
      "firstName": "Bukstinn",
      "lastName": "Insektsmundel"
  },
  {
      "partnerNumberIndividual": "0032477181",
      "employeeId": "198410034741",
      "firstName": "Tillvitas",
      "lastName": "Smiley"
  },
  {
      "partnerNumberIndividual": "0032477978",
      "employeeId": "198010160805",
      "firstName": "Babyblå",
      "lastName": "Plättpanna"
  },
  {
      "partnerNumberIndividual": "0032478869",
      "employeeId": "198410048949",
      "firstName": "Störtförälskad",
      "lastName": "Djurläkare"
  },
  {
      "partnerNumberIndividual": "0032479781",
      "employeeId": "198410055845",
      "firstName": "Påhittig",
      "lastName": "Skiktmoln"
  },
  {
      "partnerNumberIndividual": "0032479790",
      "employeeId": "198410055241",
      "firstName": "Jordbruksmässig",
      "lastName": "Nummersexton"
  },
  {
      "partnerNumberIndividual": "0032480323",
      "employeeId": "198010183401",
      "firstName": "Född",
      "lastName": "Arnaudbarbett"
  },
  {
      "partnerNumberIndividual": "0032482435",
      "employeeId": "198010196403",
      "firstName": "Tegellagd",
      "lastName": "Chancroid"
  },
  {
      "partnerNumberIndividual": "0032482694",
      "employeeId": "198010196106",
      "firstName": "Evinnerligen",
      "lastName": "Gny"
  },
  {
      "partnerNumberIndividual": "0032483070",
      "employeeId": "198410077849",
      "firstName": "Artskild",
      "lastName": "Automobilindustri"
  },
  {
      "partnerNumberIndividual": "0032483259",
      "employeeId": "198010202409",
      "firstName": "Kostnadsfri",
      "lastName": "Humussyra"
  },
  {
      "partnerNumberIndividual": "0032483573",
      "employeeId": "198410082641",
      "firstName": "Jävelns",
      "lastName": "Hike"
  },
  {
      "partnerNumberIndividual": "0032486010",
      "employeeId": "198411094348",
      "firstName": "Kunskapsintensiv",
      "lastName": "Ekosofi"
  },
  {
      "partnerNumberIndividual": "0032486150",
      "employeeId": "198010217209",
      "firstName": "Omflyttbar",
      "lastName": "Älsklingen"
  },
  {
      "partnerNumberIndividual": "0032486314",
      "employeeId": "198411094041",
      "firstName": "Bionomisk",
      "lastName": "Svanhus"
  },
  {
      "partnerNumberIndividual": "0032486791",
      "employeeId": "198010210204",
      "firstName": "Abelsk",
      "lastName": "Hjärtskiljevägg"
  },
  {
      "partnerNumberIndividual": "0032487254",
      "employeeId": "198010222902",
      "firstName": "Välhängd",
      "lastName": "Förhörsledare"
  },
  {
      "partnerNumberIndividual": "0032487301",
      "employeeId": "198010223207",
      "firstName": "Bisynkron",
      "lastName": "Naturbruk"
  },
  {
      "partnerNumberIndividual": "0032487348",
      "employeeId": "198010224700",
      "firstName": "Profan",
      "lastName": "Köpmansgille"
  },
  {
      "partnerNumberIndividual": "0032489373",
      "employeeId": "198411113940",
      "firstName": "Synergisk",
      "lastName": "Widescreenskärm"
  },
  {
      "partnerNumberIndividual": "0032490377",
      "employeeId": "198010239807",
      "firstName": "Ickeaktiv",
      "lastName": "Slum"
  },
  {
      "partnerNumberIndividual": "0032491656",
      "employeeId": "198010245804",
      "firstName": "Bäst",
      "lastName": "Läkemedelskontroll"
  },
  {
      "partnerNumberIndividual": "0032491692",
      "employeeId": "198010246406",
      "firstName": "Postakut",
      "lastName": "Importintressen"
  },
  {
      "partnerNumberIndividual": "0032491721",
      "employeeId": "198010246109",
      "firstName": "Eutrof",
      "lastName": "Festtåg"
  },
  {
      "partnerNumberIndividual": "0032495024",
      "employeeId": "198411149845",
      "firstName": "Piskande",
      "lastName": "Laplacetransformation"
  },
  {
      "partnerNumberIndividual": "0032496065",
      "employeeId": "198411155842",
      "firstName": "Omöjlig",
      "lastName": "Gråvingadkotinga"
  },
  {
      "partnerNumberIndividual": "0032496112",
      "employeeId": "198411156147",
      "firstName": "Sköplig",
      "lastName": "Procentsiffra"
  },
  {
      "partnerNumberIndividual": "0032496501",
      "employeeId": "198411158242",
      "firstName": "Radhusliknande",
      "lastName": "Kriminalteknisktlaboratorium"
  },
  {
      "partnerNumberIndividual": "0032499206",
      "employeeId": "198411176947",
      "firstName": "Samlarlysten",
      "lastName": "Ringbrynja"
  },
  {
      "partnerNumberIndividual": "0032502918",
      "employeeId": "198411205845",
      "firstName": "Obrytlig",
      "lastName": "Tjocknäbbadmarkduva"
  },
  {
      "partnerNumberIndividual": "0032505382",
      "employeeId": "198411219747",
      "firstName": "Förbikörande",
      "lastName": "Blåsvarteufonia"
  },
  {
      "partnerNumberIndividual": "0032506375",
      "employeeId": "198411224242",
      "firstName": "Tumultartad",
      "lastName": "Ljuspolarisation"
  },
  {
      "partnerNumberIndividual": "0032506621",
      "employeeId": "198010018904",
      "firstName": "Dagvill",
      "lastName": "Ledarställning"
  },
  {
      "partnerNumberIndividual": "0032507090",
      "employeeId": "198010022500",
      "firstName": "Jävelns",
      "lastName": "Kantpress"
  },
  {
      "partnerNumberIndividual": "0032507398",
      "employeeId": "198411232641",
      "firstName": "Irreal",
      "lastName": "Anföringsverb"
  },
  {
      "partnerNumberIndividual": "0032507480",
      "employeeId": "198010022807",
      "firstName": "Impressionist",
      "lastName": "Vindsstege"
  },
  {
      "partnerNumberIndividual": "0032507506",
      "employeeId": "198010023706",
      "firstName": "Flersidig",
      "lastName": "Läckerriska"
  },
  {
      "partnerNumberIndividual": "0032508823",
      "employeeId": "198411230249",
      "firstName": "Regelbaserad",
      "lastName": "Svartbärpickare"
  },
  {
      "partnerNumberIndividual": "0032510173",
      "employeeId": "198010038209",
      "firstName": "Allrabäst",
      "lastName": "Deklamator"
  },
  {
      "partnerNumberIndividual": "0032511250",
      "employeeId": "198010044207",
      "firstName": "Hetsig",
      "lastName": "Förstorare"
  },
  {
      "partnerNumberIndividual": "0032514113",
      "employeeId": "198411273942",
      "firstName": "Sagolik",
      "lastName": "Vichyregering"
  },
  {
      "partnerNumberIndividual": "0032515369",
      "employeeId": "198010066200",
      "firstName": "Pikerad",
      "lastName": "Synkroniserare"
  },
  {
      "partnerNumberIndividual": "0032516353",
      "employeeId": "198010072208",
      "firstName": "Otålmodig",
      "lastName": "Tennjodid"
  },
  {
      "partnerNumberIndividual": "0032518610",
      "employeeId": "198010085804",
      "firstName": "Pektin",
      "lastName": "Korselasticitet"
  },
  {
      "partnerNumberIndividual": "0032518637",
      "employeeId": "198010085200",
      "firstName": "Varkunnsam",
      "lastName": "Begravningsgudstjänst"
  },
  {
      "partnerNumberIndividual": "0032521489",
      "employeeId": "198011096305",
      "firstName": "Vedisk",
      "lastName": "Vichyregering"
  },
  {
      "partnerNumberIndividual": "0032521529",
      "employeeId": "198011096909",
      "firstName": "Folkmordsliknande",
      "lastName": "Försnillande"
  },
  {
      "partnerNumberIndividual": "0032521628",
      "employeeId": "198411017844",
      "firstName": "Utankänsel",
      "lastName": "Systemvetenskap"
  },
  {
      "partnerNumberIndividual": "0032521894",
      "employeeId": "198011097808",
      "firstName": "Senromersk",
      "lastName": "Operettsångerska"
  },
  {
      "partnerNumberIndividual": "0032522527",
      "employeeId": "198011102608",
      "firstName": "Uppvispad",
      "lastName": "Svets"
  },
  {
      "partnerNumberIndividual": "0032522625",
      "employeeId": "198411024741",
      "firstName": "Fullskalig",
      "lastName": "Australiskhavssula"
  },
  {
      "partnerNumberIndividual": "0032523010",
      "employeeId": "198011103200",
      "firstName": "Flersidig",
      "lastName": "Naturligläggning"
  },
  {
      "partnerNumberIndividual": "0032525366",
      "employeeId": "198411044343",
      "firstName": "Turbinelektrisk",
      "lastName": "Universitetstryckeri"
  },
  {
      "partnerNumberIndividual": "0032525446",
      "employeeId": "198011118901",
      "firstName": "Suppletiv",
      "lastName": "Datorstab"
  },
  {
      "partnerNumberIndividual": "0032525922",
      "employeeId": "198411046140",
      "firstName": "Endomorf",
      "lastName": "Ränteparitetsteori"
  },
  {
      "partnerNumberIndividual": "0032526002",
      "employeeId": "198011122507",
      "firstName": "Radiärsymmetrisk",
      "lastName": "Gramaner"
  },
  {
      "partnerNumberIndividual": "0032526551",
      "employeeId": "198011124008",
      "firstName": "Gladiatorklädd",
      "lastName": "Syndaförlåtelsetillstånd"
  },
  {
      "partnerNumberIndividual": "0032528946",
      "employeeId": "198011138503",
      "firstName": "Välarmerad",
      "lastName": "Svågerpolitik"
  },
  {
      "partnerNumberIndividual": "0032529265",
      "employeeId": "198011139709",
      "firstName": "Sportig",
      "lastName": "Kringkastning"
  },
  {
      "partnerNumberIndividual": "0032529309",
      "employeeId": "198011139105",
      "firstName": "Herrskapsliknande",
      "lastName": "Esofagusperforation"
  },
  {
      "partnerNumberIndividual": "0032529827",
      "employeeId": "198011143909",
      "firstName": "Yazidisk",
      "lastName": "Charkuteri"
  },
  {
      "partnerNumberIndividual": "0032529880",
      "employeeId": "198011144501",
      "firstName": "Sammanhållen",
      "lastName": "Transformatorstation"
  },
  {
      "partnerNumberIndividual": "0032529927",
      "employeeId": "198011144204",
      "firstName": "Postakut",
      "lastName": "Tidsaspekt"
  },
  {
      "partnerNumberIndividual": "0032537728",
      "employeeId": "198011192401",
      "firstName": "Gråaktig",
      "lastName": "Oktalsiffra"
  },
  {
      "partnerNumberIndividual": "0032538139",
      "employeeId": "198011193904",
      "firstName": "Babyblå",
      "lastName": "Växelryttare"
  },
  {
      "partnerNumberIndividual": "0032538454",
      "employeeId": "198011194209",
      "firstName": "Evasiv",
      "lastName": "Skirning"
  },
  {
      "partnerNumberIndividual": "0032541391",
      "employeeId": "198011214700",
      "firstName": "Osteriliserad",
      "lastName": "Kyrkomusiker"
  },
  {
      "partnerNumberIndividual": "0032544625",
      "employeeId": "198011236109",
      "firstName": "Postsilurisk",
      "lastName": "Paradisflugsnappare"
  },
  {
      "partnerNumberIndividual": "0032546166",
      "employeeId": "198011249409",
      "firstName": "Torkkänslig",
      "lastName": "Dränglön"
  },
  {
      "partnerNumberIndividual": "0032547205",
      "employeeId": "198011256909",
      "firstName": "Förbikörande",
      "lastName": "Blåtjocknäbb"
  },
  {
      "partnerNumberIndividual": "0032547680",
      "employeeId": "198011257204",
      "firstName": "Okollegial",
      "lastName": "Synkroniserare"
  },
  {
      "partnerNumberIndividual": "0032549595",
      "employeeId": "198011260505",
      "firstName": "Krabbätande",
      "lastName": "Bomullslump"
  },
  {
      "partnerNumberIndividual": "0032549620",
      "employeeId": "198011260802",
      "firstName": "Strup",
      "lastName": "Kulvert"
  },
  {
      "partnerNumberIndividual": "0032556043",
      "employeeId": "198011013706",
      "firstName": "Svängningsbar",
      "lastName": "Puaiohi"
  },
  {
      "partnerNumberIndividual": "0032558929",
      "employeeId": "198011032409",
      "firstName": "Jämspelt",
      "lastName": "Torpedhantverkare"
  },
  {
      "partnerNumberIndividual": "0032559299",
      "employeeId": "198011032706",
      "firstName": "Cirkusaktig",
      "lastName": "Finansmagnat"
  },
  {
      "partnerNumberIndividual": "0032559397",
      "employeeId": "198011033902",
      "firstName": "Monolitisk",
      "lastName": "Rasfördom"
  },
  {
      "partnerNumberIndividual": "0032559811",
      "employeeId": "198011034207",
      "firstName": "Gladiatorklädd",
      "lastName": "Dvärgmalkoha"
  },
  {
      "partnerNumberIndividual": "0032562292",
      "employeeId": "198011048702",
      "firstName": "Storbystad",
      "lastName": "Alkaliskcell"
  },
  {
      "partnerNumberIndividual": "0032562811",
      "employeeId": "198011040204",
      "firstName": "Utrörd",
      "lastName": "Restaurationskomedi"
  },
  {
      "partnerNumberIndividual": "0032563929",
      "employeeId": "198011056200",
      "firstName": "Alkalilöslig",
      "lastName": "Applikationsfil"
  },
  {
      "partnerNumberIndividual": "0032569651",
      "employeeId": "198011080903",
      "firstName": "Redobogen",
      "lastName": "Stenbädd"
  },
  {
      "partnerNumberIndividual": "0032581751",
      "employeeId": "198501098951",
      "firstName": "Tight",
      "lastName": "Kundkommunikatör"
  },
  {
      "partnerNumberIndividual": "0032585567",
      "employeeId": "198501118254",
      "firstName": "Moralistisk",
      "lastName": "Biltelefon"
  },
  {
      "partnerNumberIndividual": "0032586485",
      "employeeId": "198501123957",
      "firstName": "Finstämd",
      "lastName": "Parisiska"
  },
  {
      "partnerNumberIndividual": "0032592353",
      "employeeId": "198501165255",
      "firstName": "Umbärlig",
      "lastName": "Fraktionsdestillation"
  },
  {
      "partnerNumberIndividual": "0032592820",
      "employeeId": "198501167954",
      "firstName": "Affiliative",
      "lastName": "Vapeninköp"
  },
  {
      "partnerNumberIndividual": "0032596889",
      "employeeId": "198501194750",
      "firstName": "Konstintresserad",
      "lastName": "Manskram"
  },
  {
      "partnerNumberIndividual": "0032602166",
      "employeeId": "198501229457",
      "firstName": "Rättad",
      "lastName": "Paparazzo"
  },
  {
      "partnerNumberIndividual": "0032609429",
      "employeeId": "198501278850",
      "firstName": "Avskrapande",
      "lastName": "Platan"
  },
  {
      "partnerNumberIndividual": "0032618709",
      "employeeId": "198501027257",
      "firstName": "Märkesskyddad",
      "lastName": "Riktverkan"
  },
  {
      "partnerNumberIndividual": "0032624843",
      "employeeId": "198501069754",
      "firstName": "Mural",
      "lastName": "Jordmån"
  },
  {
      "partnerNumberIndividual": "0032625291",
      "employeeId": "198307218035",
      "firstName": "Interkontinental",
      "lastName": "Duplextalkanal"
  },
  {
      "partnerNumberIndividual": "0032626128",
      "employeeId": "198501076353",
      "firstName": "Turbinelektrisk",
      "lastName": "Varumärkesrätt"
  },
  {
      "partnerNumberIndividual": "0032626194",
      "employeeId": "198501077856",
      "firstName": "Mellan",
      "lastName": "Rödöradbulbyl"
  },
  {
      "partnerNumberIndividual": "0032627040",
      "employeeId": "198501082658",
      "firstName": "Metalltäckt",
      "lastName": "Valbarhet"
  },
  {
      "partnerNumberIndividual": "0032629095",
      "employeeId": "198101106915",
      "firstName": "Orsakas",
      "lastName": "Någonannanväg"
  },
  {
      "partnerNumberIndividual": "0032629101",
      "employeeId": "198101106014",
      "firstName": "Mintgrön",
      "lastName": "Gulkronadtyrann"
  },
  {
      "partnerNumberIndividual": "0032629372",
      "employeeId": "198502093753",
      "firstName": "Ärtväxt",
      "lastName": "Stapeldiagram"
  },
  {
      "partnerNumberIndividual": "0032630045",
      "employeeId": "198101112319",
      "firstName": "Akrondroplastisk",
      "lastName": "Neuroskada"
  },
  {
      "partnerNumberIndividual": "0032632226",
      "employeeId": "198502109757",
      "firstName": "Etnifierad",
      "lastName": "Avbärgning"
  },
  {
      "partnerNumberIndividual": "0032633242",
      "employeeId": "198101128919",
      "firstName": "Moralistisk",
      "lastName": "Molekylärbiologi"
  },
  {
      "partnerNumberIndividual": "0032634076",
      "employeeId": "198101133711",
      "firstName": "Kringvärvd",
      "lastName": "Luftstrupe"
  },
  {
      "partnerNumberIndividual": "0032634099",
      "employeeId": "198101134313",
      "firstName": "Reglementarisk",
      "lastName": "Kaliumtiocyanat"
  },
  {
      "partnerNumberIndividual": "0032636365",
      "employeeId": "198502133856",
      "firstName": "Väldifferentierad",
      "lastName": "Esofagusperforation"
  },
  {
      "partnerNumberIndividual": "0032636632",
      "employeeId": "198101149113",
      "firstName": "Vedisk",
      "lastName": "Direktorat"
  },
  {
      "partnerNumberIndividual": "0032636967",
      "employeeId": "198502136255",
      "firstName": "Smidbar",
      "lastName": "Heavyband"
  },
  {
      "partnerNumberIndividual": "0032637617",
      "employeeId": "198101154212",
      "firstName": "Bianco",
      "lastName": "Baljbotten"
  },
  {
      "partnerNumberIndividual": "0032641483",
      "employeeId": "198101174715",
      "firstName": "Obeivrad",
      "lastName": "Korselasticitet"
  },
  {
      "partnerNumberIndividual": "0032645512",
      "employeeId": "198502182358",
      "firstName": "Påkopplad",
      "lastName": "Expojkvän"
  },
  {
      "partnerNumberIndividual": "0032645545",
      "employeeId": "198502182655",
      "firstName": "Vattrad",
      "lastName": "Svets"
  },
  {
      "partnerNumberIndividual": "0032649055",
      "employeeId": "198101217811",
      "firstName": "Självcentrerande",
      "lastName": "Pariservitt"
  },
  {
      "partnerNumberIndividual": "0032649131",
      "employeeId": "198502202859",
      "firstName": "Barbituratisk",
      "lastName": "Köksinredning"
  },
  {
      "partnerNumberIndividual": "0032653302",
      "employeeId": "198101239815",
      "firstName": "Igenkänningsbar",
      "lastName": "Bränslesamlare"
  },
  {
      "partnerNumberIndividual": "0032654699",
      "employeeId": "198101245218",
      "firstName": "Scenvan",
      "lastName": "Farsdagen"
  },
  {
      "partnerNumberIndividual": "0032657143",
      "employeeId": "198101259417",
      "firstName": "Frånkopplad",
      "lastName": "Kabeldistributör"
  },
  {
      "partnerNumberIndividual": "0032658446",
      "employeeId": "198101267816",
      "firstName": "Råkall",
      "lastName": "Ondtunga"
  },
  {
      "partnerNumberIndividual": "0032658466",
      "employeeId": "198101267212",
      "firstName": "Sjöfarande",
      "lastName": "Epitelcell"
  },
  {
      "partnerNumberIndividual": "0032658979",
      "employeeId": "198101272618",
      "firstName": "Mystagogisk",
      "lastName": "Begravningsgudstjänst"
  },
  {
      "partnerNumberIndividual": "0032659430",
      "employeeId": "198101273210",
      "firstName": "Urnupen",
      "lastName": "Utmanövrering"
  },
  {
      "partnerNumberIndividual": "0032660255",
      "employeeId": "198502252557",
      "firstName": "Asbestinnehållande",
      "lastName": "Börsspekulant"
  },
  {
      "partnerNumberIndividual": "0032660309",
      "employeeId": "198502252854",
      "firstName": "Beige",
      "lastName": "Arabiskaalfabetet"
  },
  {
      "partnerNumberIndividual": "0032660330",
      "employeeId": "198502253753",
      "firstName": "Heldags",
      "lastName": "Barnsligtillgivenhet"
  },
  {
      "partnerNumberIndividual": "0032662381",
      "employeeId": "198502266458",
      "firstName": "Dimhöljd",
      "lastName": "Ingetillamenat"
  },
  {
      "partnerNumberIndividual": "0032662773",
      "employeeId": "198502267357",
      "firstName": "Prydd",
      "lastName": "Oljekastarbricka"
  },
  {
      "partnerNumberIndividual": "0032663781",
      "employeeId": "198502272753",
      "firstName": "Välhängd",
      "lastName": "Stenbädd"
  },
  {
      "partnerNumberIndividual": "0032668467",
      "employeeId": "198502017851",
      "firstName": "Björnaktig",
      "lastName": "Joddel"
  },
  {
      "partnerNumberIndividual": "0032673078",
      "employeeId": "198502039855",
      "firstName": "Gulgrön",
      "lastName": "Lastningselevator"
  },
  {
      "partnerNumberIndividual": "0032673624",
      "employeeId": "198502046157",
      "firstName": "Brännskadad",
      "lastName": "Ansiktsvenen"
  },
  {
      "partnerNumberIndividual": "0032675952",
      "employeeId": "198502059457",
      "firstName": "Paltig",
      "lastName": "Engganoglasögonfågel"
  },
  {
      "partnerNumberIndividual": "0032676008",
      "employeeId": "198502059754",
      "firstName": "Anglobrasiliansk",
      "lastName": "Finansmagnat"
  },
  {
      "partnerNumberIndividual": "0032681729",
      "employeeId": "198502088050",
      "firstName": "Basilar",
      "lastName": "Cyanidlutning"
  },
  {
      "partnerNumberIndividual": "0032684238",
      "employeeId": "198503102751",
      "firstName": "Nedrullad",
      "lastName": "Algmjöl"
  },
  {
      "partnerNumberIndividual": "0032685602",
      "employeeId": "198101085515",
      "firstName": "Halvautonom",
      "lastName": "Jetstråle"
  },
  {
      "partnerNumberIndividual": "0032686038",
      "employeeId": "198101086117",
      "firstName": "Kopparröd",
      "lastName": "Huvudsajt"
  },
  {
      "partnerNumberIndividual": "0032690148",
      "employeeId": "198102102616",
      "firstName": "Rundnätt",
      "lastName": "Enterostomi"
  },
  {
      "partnerNumberIndividual": "0032691622",
      "employeeId": "198503145859",
      "firstName": "Oefterliknelig",
      "lastName": "Internetbokhandel"
  },
  {
      "partnerNumberIndividual": "0032695431",
      "employeeId": "198503167259",
      "firstName": "Posttraumatisk",
      "lastName": "Klepsydra"
  },
  {
      "partnerNumberIndividual": "0032696245",
      "employeeId": "198503172655",
      "firstName": "Varefter",
      "lastName": "Antiperistaltik"
  },
  {
      "partnerNumberIndividual": "0032696645",
      "employeeId": "198503173257",
      "firstName": "Elektiv",
      "lastName": "Sidovinst"
  },
  {
      "partnerNumberIndividual": "0032698390",
      "employeeId": "198503187752",
      "firstName": "Omöjlig",
      "lastName": "Besittningtagande"
  },
  {
      "partnerNumberIndividual": "0032698844",
      "employeeId": "198102137919",
      "firstName": "Framröstad",
      "lastName": "Anropande"
  },
  {
      "partnerNumberIndividual": "0032698906",
      "employeeId": "198102138214",
      "firstName": "Accentfri",
      "lastName": "Jordgubbsland"
  },
  {
      "partnerNumberIndividual": "0032699763",
      "employeeId": "198503195854",
      "firstName": "Interak",
      "lastName": "Splittrad"
  },
  {
      "partnerNumberIndividual": "0032702241",
      "employeeId": "198503208558",
      "firstName": "Bergs",
      "lastName": "Höghastighetsnät"
  },
  {
      "partnerNumberIndividual": "0032702268",
      "employeeId": "198503208855",
      "firstName": "Skenfager",
      "lastName": "Ansiktsvenen"
  },
  {
      "partnerNumberIndividual": "0032704073",
      "employeeId": "198503216957",
      "firstName": "Turbinelektrisk",
      "lastName": "Arnaudbarbett"
  },
  {
      "partnerNumberIndividual": "0032707001",
      "employeeId": "198503220850",
      "firstName": "Stillasittande",
      "lastName": "Stenbädd"
  },
  {
      "partnerNumberIndividual": "0032709816",
      "employeeId": "198102187914",
      "firstName": "Medsaltsmak",
      "lastName": "Samhörighet"
  },
  {
      "partnerNumberIndividual": "0032711225",
      "employeeId": "198102192716",
      "firstName": "Grönbete",
      "lastName": "Hattmakare"
  },
  {
      "partnerNumberIndividual": "0032714263",
      "employeeId": "198102206912",
      "firstName": "Brunaktig",
      "lastName": "Widescreenskärm"
  },
  {
      "partnerNumberIndividual": "0032714341",
      "employeeId": "198102207811",
      "firstName": "Esoterisk",
      "lastName": "Maskinfabrikant"
  },
  {
      "partnerNumberIndividual": "0032714719",
      "employeeId": "198102207217",
      "firstName": "Avgudifierad",
      "lastName": "Kreditförlustreserv"
  },
  {
      "partnerNumberIndividual": "0032715702",
      "employeeId": "198102213215",
      "firstName": "Långlivad",
      "lastName": "Ringbrynja"
  },
  {
      "partnerNumberIndividual": "0032715807",
      "employeeId": "198503277850",
      "firstName": "Tiodubbel",
      "lastName": "Ektypografi"
  },
  {
      "partnerNumberIndividual": "0032719188",
      "employeeId": "198102229815",
      "firstName": "Dagsfärsk",
      "lastName": "Byggnadstimmer"
  },
  {
      "partnerNumberIndividual": "0032719710",
      "employeeId": "198102233718",
      "firstName": "Blott",
      "lastName": "Utgiftutanförbudget"
  },
  {
      "partnerNumberIndividual": "0032720153",
      "employeeId": "198102234310",
      "firstName": "Livegen",
      "lastName": "Svek"
  },
  {
      "partnerNumberIndividual": "0032723457",
      "employeeId": "198102249110",
      "firstName": "Heterosexistisk",
      "lastName": "Magoperation"
  },
  {
      "partnerNumberIndividual": "0032723841",
      "employeeId": "198102241513",
      "firstName": "Deltidsanställd",
      "lastName": "Hedersgubbe"
  },
  {
      "partnerNumberIndividual": "0032724724",
      "employeeId": "198102254813",
      "firstName": "Mural",
      "lastName": "Stridsvagnsduell"
  },
  {
      "partnerNumberIndividual": "0032725605",
      "employeeId": "198102257212",
      "firstName": "Episkopal",
      "lastName": "Mejeributik"
  },
  {
      "partnerNumberIndividual": "0032728644",
      "employeeId": "198102260513",
      "firstName": "Polyteknisk",
      "lastName": "Marmorflis"
  },
  {
      "partnerNumberIndividual": "0032729624",
      "employeeId": "198503036157",
      "firstName": "Doxologisk",
      "lastName": "Årsöversikt"
  },
  {
      "partnerNumberIndividual": "0032733650",
      "employeeId": "198102013714",
      "firstName": "Begynnelse",
      "lastName": "Algtoxin"
  },
  {
      "partnerNumberIndividual": "0032734479",
      "employeeId": "198503062351",
      "firstName": "Skimmelfärgad",
      "lastName": "Danism"
  },
  {
      "partnerNumberIndividual": "0032734872",
      "employeeId": "198503062955",
      "firstName": "Spröd",
      "lastName": "Getberget"
  },
  {
      "partnerNumberIndividual": "0032734875",
      "employeeId": "198503062054",
      "firstName": "Rökblå",
      "lastName": "Ärftlighetsgen"
  },
  {
      "partnerNumberIndividual": "0032741529",
      "employeeId": "198102040519",
      "firstName": "Navelskådande",
      "lastName": "Vävnad"
  },
  {
      "partnerNumberIndividual": "0032742326",
      "employeeId": "198102053512",
      "firstName": "Guldfärgad",
      "lastName": "Ekorrbäver"
  },
  {
      "partnerNumberIndividual": "0032742363",
      "employeeId": "198102053819",
      "firstName": "Otadlig",
      "lastName": "Droppeihavet"
  },
  {
      "partnerNumberIndividual": "0032745073",
      "employeeId": "198504100853",
      "firstName": "Tiodubbel",
      "lastName": "Jetstråle"
  },
  {
      "partnerNumberIndividual": "0032745597",
      "employeeId": "198504114755",
      "firstName": "Utankänsel",
      "lastName": "Dagspress"
  },
  {
      "partnerNumberIndividual": "0032748138",
      "employeeId": "198102076414",
      "firstName": "Transversell",
      "lastName": "Sanitetsinstallation"
  },
  {
      "partnerNumberIndividual": "0032748628",
      "employeeId": "198102077313",
      "firstName": "Mod",
      "lastName": "Marmorflis"
  },
  {
      "partnerNumberIndividual": "0032749619",
      "employeeId": "198102082412",
      "firstName": "Algin",
      "lastName": "Prästrock"
  },
  {
      "partnerNumberIndividual": "0032749721",
      "employeeId": "198102082719",
      "firstName": "Elektrohydraulisk",
      "lastName": "Nickel"
  },
  {
      "partnerNumberIndividual": "0032752575",
      "employeeId": "198103092618",
      "firstName": "Parhelisk",
      "lastName": "Företagsöverlåtelse"
  },
  {
      "partnerNumberIndividual": "0032752679",
      "employeeId": "198103092915",
      "firstName": "Utbränd",
      "lastName": "Privatisering"
  },
  {
      "partnerNumberIndividual": "0032753094",
      "employeeId": "198103093210",
      "firstName": "Närbesläktad",
      "lastName": "Utbytestransfusion"
  },
  {
      "partnerNumberIndividual": "0032753674",
      "employeeId": "198504157853",
      "firstName": "Bågig",
      "lastName": "Öljätte"
  },
  {
      "partnerNumberIndividual": "0032756119",
      "employeeId": "198103108612",
      "firstName": "Midströms",
      "lastName": "Operettsångerska"
  },
  {
      "partnerNumberIndividual": "0032757330",
      "employeeId": "198103112812",
      "firstName": "Sociologiskt",
      "lastName": "Mossa"
  },
  {
      "partnerNumberIndividual": "0032758337",
      "employeeId": "198504182554",
      "firstName": "Födoämnes",
      "lastName": "Hjärtskiljevägg"
  },
  {
      "partnerNumberIndividual": "0032758539",
      "employeeId": "198504183750",
      "firstName": "Urskiljbar",
      "lastName": "Valkalv"
  },
  {
      "partnerNumberIndividual": "0032761336",
      "employeeId": "198103128511",
      "firstName": "Peonisk",
      "lastName": "Kritsnöre"
  },
  {
      "partnerNumberIndividual": "0032761410",
      "employeeId": "198103128214",
      "firstName": "Linje",
      "lastName": "Syre"
  },
  {
      "partnerNumberIndividual": "0032765987",
      "employeeId": "198504224752",
      "firstName": "Medhjälpande",
      "lastName": "Signor"
  },
  {
      "partnerNumberIndividual": "0032766619",
      "employeeId": "198103140516",
      "firstName": "Mittenavoktober",
      "lastName": "Koronaurladdning"
  },
  {
      "partnerNumberIndividual": "0032766651",
      "employeeId": "198103140813",
      "firstName": "Rättad",
      "lastName": "Någonannanväg"
  },
  {
      "partnerNumberIndividual": "0032769961",
      "employeeId": "198504245856",
      "firstName": "Konvertibel",
      "lastName": "Moskovit"
  },
  {
      "partnerNumberIndividual": "0032770825",
      "employeeId": "198504247357",
      "firstName": "Havregrynsgröt",
      "lastName": "Störresultanspett"
  },
  {
      "partnerNumberIndividual": "0032774038",
      "employeeId": "198103183615",
      "firstName": "Khaki",
      "lastName": "Träldomsok"
  },
  {
      "partnerNumberIndividual": "0032774667",
      "employeeId": "198504267256",
      "firstName": "Onkologisk",
      "lastName": "Marknadsfokuserad"
  },
  {
      "partnerNumberIndividual": "0032779190",
      "employeeId": "198103202316",
      "firstName": "Västerut",
      "lastName": "Yttervingturbin"
  },
  {
      "partnerNumberIndividual": "0032779268",
      "employeeId": "198103202613",
      "firstName": "Domhavande",
      "lastName": "Arbetsmarknadspension"
  },
  {
      "partnerNumberIndividual": "0032779759",
      "employeeId": "198103204411",
      "firstName": "Kortsvansad",
      "lastName": "Grundskolekompetens"
  },
  {
      "partnerNumberIndividual": "0032779769",
      "employeeId": "198103204718",
      "firstName": "Kategorisk",
      "lastName": "EIDE"
  },
  {
      "partnerNumberIndividual": "0032783442",
      "employeeId": "198103218916",
      "firstName": "Minutlång",
      "lastName": "Vinnarserie"
  },
  {
      "partnerNumberIndividual": "0032784165",
      "employeeId": "198103223718",
      "firstName": "Impressionist",
      "lastName": "Inköpsagent"
  },
  {
      "partnerNumberIndividual": "0032784882",
      "employeeId": "198103226117",
      "firstName": "Ickeaktiv",
      "lastName": "Stapeldiagram"
  },
  {
      "partnerNumberIndividual": "0032785536",
      "employeeId": "198504026157",
      "firstName": "Färgframkallande",
      "lastName": "Naturbruk"
  },
  {
      "partnerNumberIndividual": "0032787164",
      "employeeId": "198103239417",
      "firstName": "Himmelsvid",
      "lastName": "Observatörsvariation"
  },
  {
      "partnerNumberIndividual": "0032790344",
      "employeeId": "198103252618",
      "firstName": "Lättläst",
      "lastName": "Klosterföreståndarinna"
  },
  {
      "partnerNumberIndividual": "0032790531",
      "employeeId": "198504053250",
      "firstName": "Mångfunktionell",
      "lastName": "Flyttbestyr"
  },
  {
      "partnerNumberIndividual": "0032790895",
      "employeeId": "198103253210",
      "firstName": "Lämplig",
      "lastName": "Borrplats"
  },
  {
      "partnerNumberIndividual": "0032791728",
      "employeeId": "198504050850",
      "firstName": "Tillföljdav",
      "lastName": "Svarskupong"
  },
  {
      "partnerNumberIndividual": "0032792761",
      "employeeId": "198103250810",
      "firstName": "Tvådelad",
      "lastName": "Brandriktning"
  },
  {
      "partnerNumberIndividual": "0032793090",
      "employeeId": "198504072557",
      "firstName": "Oratorisk",
      "lastName": "Sossignal"
  },
  {
      "partnerNumberIndividual": "0032794169",
      "employeeId": "198103266212",
      "firstName": "Akvmarinfärgad",
      "lastName": "Akademikerbarn"
  },
  {
      "partnerNumberIndividual": "0032806358",
      "employeeId": "198505147853",
      "firstName": "Responsiv",
      "lastName": "Oframkomlighet"
  },
  {
      "partnerNumberIndividual": "0032808701",
      "employeeId": "198103018217",
      "firstName": "Små",
      "lastName": "Mjölkchoklad"
  },
  {
      "partnerNumberIndividual": "0032809181",
      "employeeId": "198103022417",
      "firstName": "Oljerik",
      "lastName": "Filmklubb"
  },
  {
      "partnerNumberIndividual": "0032811475",
      "employeeId": "198505172851",
      "firstName": "Solar",
      "lastName": "Längdskidlopp"
  },
  {
      "partnerNumberIndividual": "0032812936",
      "employeeId": "198103037811",
      "firstName": "Strömsnål",
      "lastName": "Öljätte"
  },
  {
      "partnerNumberIndividual": "0032813062",
      "employeeId": "198103038116",
      "firstName": "Sank",
      "lastName": "Stranguri"
  },
  {
      "partnerNumberIndividual": "0032813462",
      "employeeId": "198103030519",
      "firstName": "Riktningsstabil",
      "lastName": "Resform"
  },
  {
      "partnerNumberIndividual": "0032813470",
      "employeeId": "198103030816",
      "firstName": "Behårad",
      "lastName": "Nödochlust"
  },
  {
      "partnerNumberIndividual": "0032813493",
      "employeeId": "198103030212",
      "firstName": "Arkadförsedd",
      "lastName": "Återbesättning"
  },
  {
      "partnerNumberIndividual": "0032814801",
      "employeeId": "198505188857",
      "firstName": "Datormanipulerad",
      "lastName": "Självhypnos"
  },
  {
      "partnerNumberIndividual": "0032814864",
      "employeeId": "198505189152",
      "firstName": "Översvinnelig",
      "lastName": "Svarttaxi"
  },
  {
      "partnerNumberIndividual": "0032815361",
      "employeeId": "198505193659",
      "firstName": "Hållfast",
      "lastName": "Stridsvagnsduell"
  },
  {
      "partnerNumberIndividual": "0032815769",
      "employeeId": "198505196355",
      "firstName": "Ödesbestämd",
      "lastName": "Redigeringsrum"
  },
  {
      "partnerNumberIndividual": "0032816355",
      "employeeId": "198505202351",
      "firstName": "Nordgrönländsk",
      "lastName": "Agrypni"
  },
  {
      "partnerNumberIndividual": "0032817434",
      "employeeId": "198103059815",
      "firstName": "Fnaskaktig",
      "lastName": "Kommunstöd"
  },
  {
      "partnerNumberIndividual": "0032818734",
      "employeeId": "198505216252",
      "firstName": "Styrka",
      "lastName": "Luftstrupe"
  },
  {
      "partnerNumberIndividual": "0032822306",
      "employeeId": "198103086313",
      "firstName": "Lättläst",
      "lastName": "Hämtköpsvaruhus"
  },
  {
      "partnerNumberIndividual": "0032822750",
      "employeeId": "198103087816",
      "firstName": "Västerut",
      "lastName": "Frostskyddsapparat"
  },
  {
      "partnerNumberIndividual": "0032823057",
      "employeeId": "198505238256",
      "firstName": "Kortvågig",
      "lastName": "Utsändning"
  },
  {
      "partnerNumberIndividual": "0032823630",
      "employeeId": "198505242456",
      "firstName": "Hemmaboende",
      "lastName": "Kronvrak"
  },
  {
      "partnerNumberIndividual": "0032823928",
      "employeeId": "198505243959",
      "firstName": "Obehårad",
      "lastName": "Totalomkostnad"
  },
  {
      "partnerNumberIndividual": "0032828039",
      "employeeId": "198104103711",
      "firstName": "Femtusenårig",
      "lastName": "Tamgås"
  },
  {
      "partnerNumberIndividual": "0032828540",
      "employeeId": "198104105211",
      "firstName": "Små",
      "lastName": "Stigförmåga"
  },
  {
      "partnerNumberIndividual": "0032831288",
      "employeeId": "198104118511",
      "firstName": "Orginell",
      "lastName": "Expojkvän"
  },
  {
      "partnerNumberIndividual": "0032831663",
      "employeeId": "198104119410",
      "firstName": "Mördad",
      "lastName": "Postsparbanksbok"
  },
  {
      "partnerNumberIndividual": "0032832727",
      "employeeId": "198104124816",
      "firstName": "Deriverbar",
      "lastName": "Halogenpuck"
  },
  {
      "partnerNumberIndividual": "0032835529",
      "employeeId": "198104139319",
      "firstName": "Fågel",
      "lastName": "Cellteknologi"
  },
  {
      "partnerNumberIndividual": "0032838210",
      "employeeId": "198505015852",
      "firstName": "Tvådelad",
      "lastName": "Fjädervilt"
  },
  {
      "partnerNumberIndividual": "0032838880",
      "employeeId": "198104152510",
      "firstName": "Obeskrivlig",
      "lastName": "Öppenvårdsbesök"
  },
  {
      "partnerNumberIndividual": "0032842892",
      "employeeId": "198104166411",
      "firstName": "Oförlåtande",
      "lastName": "Langslagning"
  },
  {
      "partnerNumberIndividual": "0032843022",
      "employeeId": "198104166114",
      "firstName": "Bokföringsskyldig",
      "lastName": "Känsloskala"
  },
  {
      "partnerNumberIndividual": "0032844227",
      "employeeId": "198104172419",
      "firstName": "Uzbekistansk",
      "lastName": "Kylslinga"
  },
  {
      "partnerNumberIndividual": "0032844333",
      "employeeId": "198505056252",
      "firstName": "Prydd",
      "lastName": "Revision"
  },
  {
      "partnerNumberIndividual": "0032844563",
      "employeeId": "198104172716",
      "firstName": "Oljerik",
      "lastName": "Tiggarstaven"
  },
  {
      "partnerNumberIndividual": "0032844684",
      "employeeId": "198104172112",
      "firstName": "Fingrad",
      "lastName": "Brandsyn"
  },
  {
      "partnerNumberIndividual": "0032844709",
      "employeeId": "198104173615",
      "firstName": "Pikerad",
      "lastName": "Vindsbjälklag"
  },
  {
      "partnerNumberIndividual": "0032844999",
      "employeeId": "198104173011",
      "firstName": "Handlingsduglig",
      "lastName": "Rödnäbbadfrankolin"
  },
  {
      "partnerNumberIndividual": "0032845707",
      "employeeId": "198505064058",
      "firstName": "Bekymmersfri",
      "lastName": "Jordgubbsland"
  },
  {
      "partnerNumberIndividual": "0032848280",
      "employeeId": "198505077951",
      "firstName": "Bukig",
      "lastName": "Modem"
  },
  {
      "partnerNumberIndividual": "0032848684",
      "employeeId": "198104186914",
      "firstName": "Oefterliknelig",
      "lastName": "Mårdhår"
  },
  {
      "partnerNumberIndividual": "0032849775",
      "employeeId": "198104192318",
      "firstName": "Lockförsedd",
      "lastName": "Elektrodynamometer"
  },
  {
      "partnerNumberIndividual": "0032850198",
      "employeeId": "198104192615",
      "firstName": "EUklassad",
      "lastName": "Kinesisktaggsovare"
  },
  {
      "partnerNumberIndividual": "0032852072",
      "employeeId": "198506096257",
      "firstName": "Sportig",
      "lastName": "Stopptavla"
  },
  {
      "partnerNumberIndividual": "0032855320",
      "employeeId": "198104215812",
      "firstName": "Monografisk",
      "lastName": "Midsommarsol"
  },
  {
      "partnerNumberIndividual": "0032855610",
      "employeeId": "198506116154",
      "firstName": "Musikantisk",
      "lastName": "Växtsamling"
  },
  {
      "partnerNumberIndividual": "0032859910",
      "employeeId": "198104234813",
      "firstName": "Strupstor",
      "lastName": "Flygplansutrustning"
  },
  {
      "partnerNumberIndividual": "0032860380",
      "employeeId": "198104236313",
      "firstName": "Kapitalistisk",
      "lastName": "Syre"
  },
  {
      "partnerNumberIndividual": "0032860577",
      "employeeId": "198506142358",
      "firstName": "Urnupen",
      "lastName": "Fartsladd"
  },
  {
      "partnerNumberIndividual": "0032864039",
      "employeeId": "198506159857",
      "firstName": "Kymig",
      "lastName": "Snickare"
  },
  {
      "partnerNumberIndividual": "0032866143",
      "employeeId": "198104262814",
      "firstName": "Salutogen",
      "lastName": "Stapeldiagram"
  },
  {
      "partnerNumberIndividual": "0032866228",
      "employeeId": "198104264018",
      "firstName": "Meterhög",
      "lastName": "Menlöshet"
  },
  {
      "partnerNumberIndividual": "0032868231",
      "employeeId": "198506184251",
      "firstName": "Piprökande",
      "lastName": "Fenobarbitol"
  },
  {
      "partnerNumberIndividual": "0032869211",
      "employeeId": "198104278513",
      "firstName": "Beviljbar",
      "lastName": "Våldsgata"
  },
  {
      "partnerNumberIndividual": "0032869557",
      "employeeId": "198104279115",
      "firstName": "Anstötlig",
      "lastName": "Importintressen"
  },
  {
      "partnerNumberIndividual": "0032872007",
      "employeeId": "198506206252",
      "firstName": "Tyskvänlig",
      "lastName": "Introduktionspris"
  },
  {
      "partnerNumberIndividual": "0032876261",
      "employeeId": "198506228256",
      "firstName": "Elokvent",
      "lastName": "Scintillationsräknare"
  },
  {
      "partnerNumberIndividual": "0032877243",
      "employeeId": "198104013316",
      "firstName": "Slumpmässig",
      "lastName": "Ugnsgaller"
  },
  {
      "partnerNumberIndividual": "0032882208",
      "employeeId": "198104020212",
      "firstName": "Välsittande",
      "lastName": "Realtid"
  },
  {
      "partnerNumberIndividual": "0032882540",
      "employeeId": "198506269854",
      "firstName": "Itmedveten",
      "lastName": "Allvarsman"
  },
  {
      "partnerNumberIndividual": "0032882658",
      "employeeId": "198104033512",
      "firstName": "Månadförmånad",
      "lastName": "Konjunkturteori"
  },
  {
      "partnerNumberIndividual": "0032883063",
      "employeeId": "198104033215",
      "firstName": "Utledsen",
      "lastName": "Landet"
  },
  {
      "partnerNumberIndividual": "0032883799",
      "employeeId": "198506275257",
      "firstName": "Torkkänslig",
      "lastName": "Förhandlingspolitik"
  },
  {
      "partnerNumberIndividual": "0032886431",
      "employeeId": "198104049815",
      "firstName": "Kvadrofonisk",
      "lastName": "Kontrollmanometer"
  },
  {
      "partnerNumberIndividual": "0032888093",
      "employeeId": "198104057016",
      "firstName": "Fabulös",
      "lastName": "Hukställning"
  },
  {
      "partnerNumberIndividual": "0032889019",
      "employeeId": "198104062412",
      "firstName": "Blåklädd",
      "lastName": "Nyhetsförmedling"
  },
  {
      "partnerNumberIndividual": "0032890698",
      "employeeId": "198506019754",
      "firstName": "Blårutig",
      "lastName": "Marschformation"
  },
  {
      "partnerNumberIndividual": "0032893041",
      "employeeId": "198506032658",
      "firstName": "Parhelisk",
      "lastName": "Glykokoll"
  },
  {
      "partnerNumberIndividual": "0032897882",
      "employeeId": "198105092517",
      "firstName": "Oälskad",
      "lastName": "Gruppbildning"
  },
  {
      "partnerNumberIndividual": "0032898275",
      "employeeId": "198105092814",
      "firstName": "Påsig",
      "lastName": "Medljud"
  },
  {
      "partnerNumberIndividual": "0032902318",
      "employeeId": "198105113917",
      "firstName": "Ljum",
      "lastName": "Vinägrettsås"
  },
  {
      "partnerNumberIndividual": "0032904871",
      "employeeId": "198507106451",
      "firstName": "Nordisk",
      "lastName": "Färjelinje"
  },
  {
      "partnerNumberIndividual": "0032907366",
      "employeeId": "198507110651",
      "firstName": "Afanitisk",
      "lastName": "Jordräknare"
  },
  {
      "partnerNumberIndividual": "0032907961",
      "employeeId": "198105134715",
      "firstName": "Dominerad",
      "lastName": "Överkonstapel"
  },
  {
      "partnerNumberIndividual": "0032908380",
      "employeeId": "198105135613",
      "firstName": "Köpstark",
      "lastName": "Söksträng"
  },
  {
      "partnerNumberIndividual": "0032908461",
      "employeeId": "198105136215",
      "firstName": "Däst",
      "lastName": "Megaerbjudande"
  },
  {
      "partnerNumberIndividual": "0032909811",
      "employeeId": "198105142510",
      "firstName": "Sim",
      "lastName": "Förstorare"
  },
  {
      "partnerNumberIndividual": "0032911414",
      "employeeId": "198105149812",
      "firstName": "Uzbekistansk",
      "lastName": "Inteckningshandling"
  },
  {
      "partnerNumberIndividual": "0032911945",
      "employeeId": "198507152554",
      "firstName": "Sydöster",
      "lastName": "Ickekärnvapenmakt"
  },
  {
      "partnerNumberIndividual": "0032912442",
      "employeeId": "198507155250",
      "firstName": "Förvärkt",
      "lastName": "Baggbölare"
  },
  {
      "partnerNumberIndividual": "0032912766",
      "employeeId": "198105155819",
      "firstName": "Reparerbar",
      "lastName": "Jordgubbsland"
  },
  {
      "partnerNumberIndividual": "0032913748",
      "employeeId": "198105158219",
      "firstName": "Uppkopplad",
      "lastName": "Fraktionsdestillation"
  },
  {
      "partnerNumberIndividual": "0032918055",
      "employeeId": "198105177813",
      "firstName": "Kroppsstor",
      "lastName": "Bolagsstämma"
  },
  {
      "partnerNumberIndividual": "0032919066",
      "employeeId": "198105183811",
      "firstName": "Daggvåt",
      "lastName": "Plunta"
  },
  {
      "partnerNumberIndividual": "0032919122",
      "employeeId": "198105183217",
      "firstName": "Nittioårs",
      "lastName": "Rörligpensionsålder"
  },
  {
      "partnerNumberIndividual": "0032919176",
      "employeeId": "198105184710",
      "firstName": "Knarrande",
      "lastName": "Akademikerbarn"
  },
  {
      "partnerNumberIndividual": "0032929159",
      "employeeId": "198105226917",
      "firstName": "Heteropolär",
      "lastName": "Toppmatch"
  },
  {
      "partnerNumberIndividual": "0032929403",
      "employeeId": "198507265851",
      "firstName": "Leklysten",
      "lastName": "Storskulden"
  },
  {
      "partnerNumberIndividual": "0032929642",
      "employeeId": "198105227212",
      "firstName": "Evasiv",
      "lastName": "Hukställning"
  },
  {
      "partnerNumberIndividual": "0032929802",
      "employeeId": "198507266156",
      "firstName": "Vulvaliknande",
      "lastName": "Utsago"
  },
  {
      "partnerNumberIndividual": "0032930631",
      "employeeId": "198105232311",
      "firstName": "Jävelns",
      "lastName": "Mycketväsenföringenting"
  },
  {
      "partnerNumberIndividual": "0032938551",
      "employeeId": "198105268513",
      "firstName": "Gassig",
      "lastName": "Matbit"
  },
  {
      "partnerNumberIndividual": "0032939477",
      "employeeId": "198105272416",
      "firstName": "Krympsäker",
      "lastName": "Dådlöshet"
  },
  {
      "partnerNumberIndividual": "0032939794",
      "employeeId": "198507017252",
      "firstName": "Ospenderad",
      "lastName": "Vinnarserie"
  },
  {
      "partnerNumberIndividual": "0032939997",
      "employeeId": "198105274818",
      "firstName": "Trafikstyrd",
      "lastName": "Stångjärnshammare"
  },
  {
      "partnerNumberIndividual": "0032946302",
      "employeeId": "198507058850",
      "firstName": "Impressionist",
      "lastName": "Förhandsavgift"
  },
  {
      "partnerNumberIndividual": "0032946751",
      "employeeId": "198507062753",
      "firstName": "Livegen",
      "lastName": "Cyanidlutning"
  },
  {
      "partnerNumberIndividual": "0032951352",
      "employeeId": "198105010212",
      "firstName": "Hormon",
      "lastName": "Icketroende"
  },
  {
      "partnerNumberIndividual": "0032952678",
      "employeeId": "198105025616",
      "firstName": "Ödesbestämd",
      "lastName": "Asbestfiberplatta"
  },
  {
      "partnerNumberIndividual": "0032955522",
      "employeeId": "198105038916",
      "firstName": "Årligen",
      "lastName": "Puaiohi"
  },
  {
      "partnerNumberIndividual": "0032955627",
      "employeeId": "198105039815",
      "firstName": "Förflugen",
      "lastName": "Mindreskatfink"
  },
  {
      "partnerNumberIndividual": "0032957096",
      "employeeId": "198105045218",
      "firstName": "Puckelformig",
      "lastName": "Omsvaranhålles"
  },
  {
      "partnerNumberIndividual": "0032957518",
      "employeeId": "198105047313",
      "firstName": "Tiohörnig",
      "lastName": "Bensoylglycin"
  },
  {
      "partnerNumberIndividual": "0032957683",
      "employeeId": "198508123257",
      "firstName": "Midströms",
      "lastName": "Höghastighetsnät"
  },
  {
      "partnerNumberIndividual": "0032958462",
      "employeeId": "198105052412",
      "firstName": "Bokföringsskyldig",
      "lastName": "Investeringsavveckling"
  },
  {
      "partnerNumberIndividual": "0032961031",
      "employeeId": "198508142554",
      "firstName": "Förväxlad",
      "lastName": "Brokigplaty"
  },
  {
      "partnerNumberIndividual": "0032961058",
      "employeeId": "198508142851",
      "firstName": "Konturlös",
      "lastName": "Privatägdbro"
  },
  {
      "partnerNumberIndividual": "0032961225",
      "employeeId": "198105066313",
      "firstName": "Australiensisk",
      "lastName": "Utsändning"
  },
  {
      "partnerNumberIndividual": "0032961317",
      "employeeId": "198105067816",
      "firstName": "Asturisk",
      "lastName": "Fläcktjockfot"
  },
  {
      "partnerNumberIndividual": "0032962223",
      "employeeId": "198105072311",
      "firstName": "Kartagisk",
      "lastName": "Finansmagnat"
  },
  {
      "partnerNumberIndividual": "0032967924",
      "employeeId": "198508170852",
      "firstName": "Botswanisk",
      "lastName": "Charkuteri"
  },
  {
      "partnerNumberIndividual": "0032968322",
      "employeeId": "198106097911",
      "firstName": "Driftsklar",
      "lastName": "Gulstrupigbulbyl"
  },
  {
      "partnerNumberIndividual": "0032968672",
      "employeeId": "198106098216",
      "firstName": "Frankfurtbo",
      "lastName": "Myggblomster"
  },
  {
      "partnerNumberIndividual": "0032968686",
      "employeeId": "198106099719",
      "firstName": "Ensamma",
      "lastName": "Expojkvän"
  },
  {
      "partnerNumberIndividual": "0032972728",
      "employeeId": "198508213652",
      "firstName": "Intetillgänglig",
      "lastName": "Sjuplaning"
  },
  {
      "partnerNumberIndividual": "0032975472",
      "employeeId": "198508227256",
      "firstName": "Fågel",
      "lastName": "Amerikanskmånfröranka"
  },
  {
      "partnerNumberIndividual": "0032978431",
      "employeeId": "198106145215",
      "firstName": "Otadlig",
      "lastName": "Kariol"
  },
  {
      "partnerNumberIndividual": "0032978809",
      "employeeId": "198106147310",
      "firstName": "Dubbelbottnad",
      "lastName": "Avloppsslam"
  },
  {
      "partnerNumberIndividual": "0032981833",
      "employeeId": "198508269159",
      "firstName": "Bågig",
      "lastName": "Öppenvårdsbesök"
  },
  {
      "partnerNumberIndividual": "0032982706",
      "employeeId": "198106167813",
      "firstName": "Mestavlägset",
      "lastName": "Nysrot"
  },
  {
      "partnerNumberIndividual": "0032984136",
      "employeeId": "198106174710",
      "firstName": "Bulldogslik",
      "lastName": "Ulster"
  },
  {
      "partnerNumberIndividual": "0032987154",
      "employeeId": "198106188611",
      "firstName": "Uppkörd",
      "lastName": "Fjädervilt"
  },
  {
      "partnerNumberIndividual": "0032987646",
      "employeeId": "198106189817",
      "firstName": "Tidstrogen",
      "lastName": "Mönsterexemplar"
  },
  {
      "partnerNumberIndividual": "0032988901",
      "employeeId": "198106195814",
      "firstName": "Bionomisk",
      "lastName": "Trådekerhjul"
  },
  {
      "partnerNumberIndividual": "0032989339",
      "employeeId": "198106196119",
      "firstName": "Närbesläktad",
      "lastName": "Snöklocka"
  },
  {
      "partnerNumberIndividual": "0032994021",
      "employeeId": "198106222311",
      "firstName": "Värmealstrande",
      "lastName": "Ljudbild"
  },
  {
      "partnerNumberIndividual": "0032996095",
      "employeeId": "198508047357",
      "firstName": "Genomandad",
      "lastName": "Tillhandahållnatjänster"
  },
  {
      "partnerNumberIndividual": "0032996179",
      "employeeId": "198106235313",
      "firstName": "Profan",
      "lastName": "Klärobskyr"
  },
  {
      "partnerNumberIndividual": "0032996202",
      "employeeId": "198106235610",
      "firstName": "Välskapad",
      "lastName": "Väggborrmaskin"
  },
  {
      "partnerNumberIndividual": "0032996659",
      "employeeId": "198106236212",
      "firstName": "Bilmekanisk",
      "lastName": "Glykokoll"
  },
  {
      "partnerNumberIndividual": "0032997691",
      "employeeId": "198106242814",
      "firstName": "Ytterligare",
      "lastName": "Sjöborre"
  },
  {
      "partnerNumberIndividual": "0032999484",
      "employeeId": "198508067850",
      "firstName": "Opersonlig",
      "lastName": "Bradykinin"
  },
  {
      "partnerNumberIndividual": "0033000409",
      "employeeId": "198508073551",
      "firstName": "Riktningsstabil",
      "lastName": "Kommunstöd"
  },
  {
      "partnerNumberIndividual": "0033000570",
      "employeeId": "198508074757",
      "firstName": "Senantik",
      "lastName": "Föräldrar"
  },
  {
      "partnerNumberIndividual": "0033001077",
      "employeeId": "198508076257",
      "firstName": "Trädbeskuggad",
      "lastName": "Societetshus"
  },
  {
      "partnerNumberIndividual": "0033001556",
      "employeeId": "198106258513",
      "firstName": "Rundnätt",
      "lastName": "Ledningsmaterialavsilver"
  },
  {
      "partnerNumberIndividual": "0033002207",
      "employeeId": "198106262416",
      "firstName": "Lantbruksekonomisk",
      "lastName": "Stigförmåga"
  },
  {
      "partnerNumberIndividual": "0033005899",
      "employeeId": "198509107259",
      "firstName": "Störtförälskad",
      "lastName": "Betongblandning"
  },
  {
      "partnerNumberIndividual": "0033009935",
      "employeeId": "198509132554",
      "firstName": "Svåranträffbar",
      "lastName": "Deklamator"
  },
  {
      "partnerNumberIndividual": "0033010490",
      "employeeId": "198509134055",
      "firstName": "Elektrohydraulisk",
      "lastName": "Brass"
  },
  {
      "partnerNumberIndividual": "0033010904",
      "employeeId": "198509135250",
      "firstName": "Förbuskad",
      "lastName": "Fruktdiet"
  },
  {
      "partnerNumberIndividual": "0033012755",
      "employeeId": "198106015616",
      "firstName": "Överkritisk",
      "lastName": "Tidvattenskraft"
  },
  {
      "partnerNumberIndividual": "0033012799",
      "employeeId": "198509149152",
      "firstName": "Oefterliknelig",
      "lastName": "Expatient"
  },
  {
      "partnerNumberIndividual": "0033017427",
      "employeeId": "198106035812",
      "firstName": "Läckande",
      "lastName": "Ärtprotein"
  },
  {
      "partnerNumberIndividual": "0033017539",
      "employeeId": "198106035218",
      "firstName": "Tidvattens",
      "lastName": "Skenfot"
  },
  {
      "partnerNumberIndividual": "0033017900",
      "employeeId": "198106036117",
      "firstName": "Hemtrevlig",
      "lastName": "Hårdförman"
  },
  {
      "partnerNumberIndividual": "0033018807",
      "employeeId": "198106042412",
      "firstName": "Påhittig",
      "lastName": "Praktsalvia"
  },
  {
      "partnerNumberIndividual": "0033020766",
      "employeeId": "198106041810",
      "firstName": "Alkalilöslig",
      "lastName": "Biljettbokning"
  },
  {
      "partnerNumberIndividual": "0033021063",
      "employeeId": "198509202456",
      "firstName": "Förbluffande",
      "lastName": "Laternamagica"
  },
  {
      "partnerNumberIndividual": "0033021135",
      "employeeId": "198509202753",
      "firstName": "Hörsam",
      "lastName": "Avhorning"
  },
  {
      "partnerNumberIndividual": "0033021763",
      "employeeId": "198106056313",
      "firstName": "Levrad",
      "lastName": "Tavetavävare"
  },
  {
      "partnerNumberIndividual": "0033023116",
      "employeeId": "198106062618",
      "firstName": "Lågtemperatur",
      "lastName": "Spolhjul"
  },
  {
      "partnerNumberIndividual": "0033023587",
      "employeeId": "198509216951",
      "firstName": "Provocerande",
      "lastName": "Huvudsajt"
  },
  {
      "partnerNumberIndividual": "0033024452",
      "employeeId": "198509222355",
      "firstName": "Lykantropisk",
      "lastName": "Halvapa"
  },
  {
      "partnerNumberIndividual": "0033025572",
      "employeeId": "198106076519",
      "firstName": "Omflyttbar",
      "lastName": "Äxing"
  },
  {
      "partnerNumberIndividual": "0033026060",
      "employeeId": "198106078911",
      "firstName": "Akrondroplastisk",
      "lastName": "Nickel"
  },
  {
      "partnerNumberIndividual": "0033026958",
      "employeeId": "198106082517",
      "firstName": "Konkurrensduglig",
      "lastName": "Kriminalteknisktlaboratorium"
  },
  {
      "partnerNumberIndividual": "0033031223",
      "employeeId": "198107094214",
      "firstName": "Ifrågasättande",
      "lastName": "Maltesare"
  },
  {
      "partnerNumberIndividual": "0033034512",
      "employeeId": "198107100516",
      "firstName": "Spikrak",
      "lastName": "Utskiftning"
  },
  {
      "partnerNumberIndividual": "0033034819",
      "employeeId": "198107100219",
      "firstName": "Demokratiserbar",
      "lastName": "Genomsnittsvikt"
  },
  {
      "partnerNumberIndividual": "0033035414",
      "employeeId": "198107114715",
      "firstName": "Fnaskaktig",
      "lastName": "Irislorikit"
  },
  {
      "partnerNumberIndividual": "0033039291",
      "employeeId": "198107135215",
      "firstName": "Ocensurerad",
      "lastName": "Nollningsvecka"
  },
  {
      "partnerNumberIndividual": "0033040654",
      "employeeId": "198509022854",
      "firstName": "Postakut",
      "lastName": "Sotlavskrika"
  },
  {
      "partnerNumberIndividual": "0033040677",
      "employeeId": "198509023753",
      "firstName": "Radiostyrd",
      "lastName": "Svågerpolitik"
  },
  {
      "partnerNumberIndividual": "0033043547",
      "employeeId": "198509038553",
      "firstName": "Pressad",
      "lastName": "Duodiod"
  },
  {
      "partnerNumberIndividual": "0033043665",
      "employeeId": "198107157813",
      "firstName": "Adderbar",
      "lastName": "Cyanfettsyror"
  },
  {
      "partnerNumberIndividual": "0033044557",
      "employeeId": "198107162318",
      "firstName": "Jordig",
      "lastName": "Sjuplaning"
  },
  {
      "partnerNumberIndividual": "0033044998",
      "employeeId": "198107163811",
      "firstName": "Avmätt",
      "lastName": "Kosterpiprensare"
  },
  {
      "partnerNumberIndividual": "0033049476",
      "employeeId": "198107183710",
      "firstName": "Atypisk",
      "lastName": "Natursiden"
  },
  {
      "partnerNumberIndividual": "0033049808",
      "employeeId": "198107184015",
      "firstName": "Kortvågig",
      "lastName": "Skiktmoln"
  },
  {
      "partnerNumberIndividual": "0033050282",
      "employeeId": "198107186119",
      "firstName": "Onyttig",
      "lastName": "Brandklämtning"
  },
  {
      "partnerNumberIndividual": "0033050975",
      "employeeId": "198509085257",
      "firstName": "Bakanför",
      "lastName": "Avbärgning"
  },
  {
      "partnerNumberIndividual": "0033052400",
      "employeeId": "198107198510",
      "firstName": "Oljeproducerande",
      "lastName": "Niltilapia"
  },
  {
      "partnerNumberIndividual": "0033054344",
      "employeeId": "198510102356",
      "firstName": "Skolfri",
      "lastName": "Blåsning"
  },
  {
      "partnerNumberIndividual": "0033054365",
      "employeeId": "198510102653",
      "firstName": "Elokvent",
      "lastName": "Sågverksflis"
  },
  {
      "partnerNumberIndividual": "0033054951",
      "employeeId": "198107212311",
      "firstName": "Onyttig",
      "lastName": "Läkekonst"
  },
  {
      "partnerNumberIndividual": "0033058264",
      "employeeId": "198107225917",
      "firstName": "Långlivad",
      "lastName": "Majolika"
  },
  {
      "partnerNumberIndividual": "0033058387",
      "employeeId": "198107226212",
      "firstName": "Såpoperalik",
      "lastName": "Noronhavireo"
  },
  {
      "partnerNumberIndividual": "0033062975",
      "employeeId": "198107247317",
      "firstName": "Studieintresserad",
      "lastName": "Upplevelseindustri"
  },
  {
      "partnerNumberIndividual": "0033063266",
      "employeeId": "198107248810",
      "firstName": "Genomkokt",
      "lastName": "Spjälsäng"
  },
  {
      "partnerNumberIndividual": "0033063419",
      "employeeId": "198107248216",
      "firstName": "Omeddelsam",
      "lastName": "Kolpulvereldning"
  },
  {
      "partnerNumberIndividual": "0033064098",
      "employeeId": "198107252416",
      "firstName": "Kymig",
      "lastName": "Jordmån"
  },
  {
      "partnerNumberIndividual": "0033064224",
      "employeeId": "198107252713",
      "firstName": "Herrskapsliknande",
      "lastName": "Ärftlighetsgen"
  },
  {
      "partnerNumberIndividual": "0033066020",
      "employeeId": "198510172557",
      "firstName": "Statskontrollerad",
      "lastName": "Apa"
  },
  {
      "partnerNumberIndividual": "0033067505",
      "employeeId": "198510179859",
      "firstName": "Taklös",
      "lastName": "Hörspel"
  },
  {
      "partnerNumberIndividual": "0033068506",
      "employeeId": "198510186151",
      "firstName": "Fullskalig",
      "lastName": "Strålskyddsrör"
  },
  {
      "partnerNumberIndividual": "0033068568",
      "employeeId": "198107273214",
      "firstName": "Söder",
      "lastName": "Tidskorridor"
  },
  {
      "partnerNumberIndividual": "0033071006",
      "employeeId": "198510207858",
      "firstName": "Varmrökt",
      "lastName": "Årstidsvind"
  },
  {
      "partnerNumberIndividual": "0033071883",
      "employeeId": "198510212650",
      "firstName": "Puckelformig",
      "lastName": "Fotbollshysteri"
  },
  {
      "partnerNumberIndividual": "0033071965",
      "employeeId": "198510214755",
      "firstName": "Etnografisk",
      "lastName": "FemStora"
  },
  {
      "partnerNumberIndividual": "0033078315",
      "employeeId": "198510257259",
      "firstName": "Tvåhändig",
      "lastName": "Sjukvårdsinrättning"
  },
  {
      "partnerNumberIndividual": "0033078737",
      "employeeId": "198510262358",
      "firstName": "Obillig",
      "lastName": "Pjask"
  },
  {
      "partnerNumberIndividual": "0033078812",
      "employeeId": "198510262655",
      "firstName": "Oroväckande",
      "lastName": "Stenbädd"
  },
  {
      "partnerNumberIndividual": "0033081732",
      "employeeId": "198107026414",
      "firstName": "Fördelaktig",
      "lastName": "Ångstrykjärn"
  },
  {
      "partnerNumberIndividual": "0033083736",
      "employeeId": "198107039714",
      "firstName": "Pankreatisk",
      "lastName": "Tvåtaktsmotor"
  },
  {
      "partnerNumberIndividual": "0033085046",
      "employeeId": "198107046313",
      "firstName": "Sjöfarande",
      "lastName": "Morgonstjärna"
  },
  {
      "partnerNumberIndividual": "0033085077",
      "employeeId": "198107046917",
      "firstName": "Tillyxad",
      "lastName": "Sommarförkylning"
  },
  {
      "partnerNumberIndividual": "0033086667",
      "employeeId": "198107053210",
      "firstName": "Senantik",
      "lastName": "Bullerochbång"
  },
  {
      "partnerNumberIndividual": "0033089826",
      "employeeId": "198107068317",
      "firstName": "Musikantisk",
      "lastName": "Styrspel"
  },
  {
      "partnerNumberIndividual": "0033090366",
      "employeeId": "198107072517",
      "firstName": "Guldgul",
      "lastName": "Asbestfiberplatta"
  },
  {
      "partnerNumberIndividual": "0033094316",
      "employeeId": "198107089719",
      "firstName": "Endräktig",
      "lastName": "Statsägande"
  },
  {
      "partnerNumberIndividual": "0033096094",
      "employeeId": "198510075255",
      "firstName": "Interak",
      "lastName": "Bildatlas"
  },
  {
      "partnerNumberIndividual": "0033096157",
      "employeeId": "198510077350",
      "firstName": "Nordisk",
      "lastName": "Algmjöl"
  },
  {
      "partnerNumberIndividual": "0033096660",
      "employeeId": "198108098412",
      "firstName": "Stressig",
      "lastName": "Malteserkors"
  },
  {
      "partnerNumberIndividual": "0033097977",
      "employeeId": "198510089751",
      "firstName": "Bröstsjuk",
      "lastName": "Lagbud"
  },
  {
      "partnerNumberIndividual": "0033098880",
      "employeeId": "198108112510",
      "firstName": "Naiv",
      "lastName": "Vätgaselektrod"
  },
  {
      "partnerNumberIndividual": "0033101326",
      "employeeId": "198511112552",
      "firstName": "Besegrad",
      "lastName": "Jobbschema"
  },
  {
      "partnerNumberIndividual": "0033101728",
      "employeeId": "198108125819",
      "firstName": "Inbillad",
      "lastName": "Risktagning"
  },
  {
      "partnerNumberIndividual": "0033101852",
      "employeeId": "198108126411",
      "firstName": "Postakut",
      "lastName": "Tilläggsbudget"
  },
  {
      "partnerNumberIndividual": "0033102997",
      "employeeId": "198108132419",
      "firstName": "Fatisk",
      "lastName": "Ingetillamenat"
  },
  {
      "partnerNumberIndividual": "0033105762",
      "employeeId": "198108146914",
      "firstName": "Neurotoxikologisk",
      "lastName": "Nerslagning"
  },
  {
      "partnerNumberIndividual": "0033106807",
      "employeeId": "198511154752",
      "firstName": "Årligen",
      "lastName": "Osfresiologisk"
  },
  {
      "partnerNumberIndividual": "0033107152",
      "employeeId": "198108153217",
      "firstName": "Tätbebyggd",
      "lastName": "Överföringavanslag"
  },
  {
      "partnerNumberIndividual": "0033108078",
      "employeeId": "198511162557",
      "firstName": "Brabantsk",
      "lastName": "Bukbandage"
  },
  {
      "partnerNumberIndividual": "0033109835",
      "employeeId": "198511176151",
      "firstName": "Imperatorisk",
      "lastName": "Avbrytarvals"
  },
  {
      "partnerNumberIndividual": "0033110186",
      "employeeId": "198108169817",
      "firstName": "Minnes",
      "lastName": "Arkivlag"
  },
  {
      "partnerNumberIndividual": "0033111028",
      "employeeId": "198108175210",
      "firstName": "Uzbekistansk",
      "lastName": "Telefonminne"
  },
  {
      "partnerNumberIndividual": "0033112091",
      "employeeId": "198511196951",
      "firstName": "Hopkrupen",
      "lastName": "Avbetalningslag"
  },
  {
      "partnerNumberIndividual": "0033112215",
      "employeeId": "198511197850",
      "firstName": "Anställd",
      "lastName": "Örn"
  },
  {
      "partnerNumberIndividual": "0033113477",
      "employeeId": "198108188510",
      "firstName": "Djuptrotad",
      "lastName": "Skenfot"
  },
  {
      "partnerNumberIndividual": "0033114908",
      "employeeId": "198108194211",
      "firstName": "Bäst",
      "lastName": "Regionaltstöd"
  },
  {
      "partnerNumberIndividual": "0033115327",
      "employeeId": "198511219852",
      "firstName": "Tillrufsad",
      "lastName": "Ringbrynja"
  },
  {
      "partnerNumberIndividual": "0033116215",
      "employeeId": "198511226154",
      "firstName": "Djungelaktig",
      "lastName": "Heavyband"
  },
  {
      "partnerNumberIndividual": "0033116767",
      "employeeId": "198108202014",
      "firstName": "Vikariats",
      "lastName": "Internetbokhandel"
  },
  {
      "partnerNumberIndividual": "0033117965",
      "employeeId": "198511238852",
      "firstName": "Plandels",
      "lastName": "Stortungkg"
  },
  {
      "partnerNumberIndividual": "0033118213",
      "employeeId": "198511239751",
      "firstName": "Missbelåten",
      "lastName": "Nyckelord"
  },
  {
      "partnerNumberIndividual": "0033119198",
      "employeeId": "198108215610",
      "firstName": "Uppvispad",
      "lastName": "Lochiarubra"
  },
  {
      "partnerNumberIndividual": "0033120663",
      "employeeId": "198511250253",
      "firstName": "Biskops",
      "lastName": "Sjukvårdsinrättning"
  },
  {
      "partnerNumberIndividual": "0033120675",
      "employeeId": "198108222814",
      "firstName": "Tätbebyggd",
      "lastName": "Observatörsvariation"
  },
  {
      "partnerNumberIndividual": "0033126896",
      "employeeId": "198108257810",
      "firstName": "Akter",
      "lastName": "Platan"
  },
  {
      "partnerNumberIndividual": "0033127703",
      "employeeId": "198108250211",
      "firstName": "Umbärlig",
      "lastName": "Skirning"
  },
  {
      "partnerNumberIndividual": "0033128130",
      "employeeId": "198108263214",
      "firstName": "Umbärlig",
      "lastName": "Nyårsgåva"
  },
  {
      "partnerNumberIndividual": "0033128759",
      "employeeId": "198511022454",
      "firstName": "Åkbar",
      "lastName": "Utsändning"
  },
  {
      "partnerNumberIndividual": "0033129093",
      "employeeId": "198511022157",
      "firstName": "Expropierad",
      "lastName": "Medvetandeström"
  },
  {
      "partnerNumberIndividual": "0033131531",
      "employeeId": "198108279517",
      "firstName": "Likaberättigad",
      "lastName": "Djup"
  },
  {
      "partnerNumberIndividual": "0033134993",
      "employeeId": "198511065255",
      "firstName": "Mellan",
      "lastName": "Dragbult"
  },
  {
      "partnerNumberIndividual": "0033140774",
      "employeeId": "198108015812",
      "firstName": "Parhelisk",
      "lastName": "Etnomusikologi"
  },
  {
      "partnerNumberIndividual": "0033140789",
      "employeeId": "198108015218",
      "firstName": "Strumpförsedd",
      "lastName": "Öppenvårdsbesök"
  },
  {
      "partnerNumberIndividual": "0033151609",
      "employeeId": "198108064315",
      "firstName": "Mittenavoktober",
      "lastName": "Växtsamling"
  },
  {
      "partnerNumberIndividual": "0033154166",
      "employeeId": "198108078513",
      "firstName": "Begynnelse",
      "lastName": "Upplevelseindustri"
  },
  {
      "partnerNumberIndividual": "0033154214",
      "employeeId": "198108079719",
      "firstName": "Demonterad",
      "lastName": "Gjutstål"
  },
  {
      "partnerNumberIndividual": "0033154250",
      "employeeId": "198108079115",
      "firstName": "Adderbar",
      "lastName": "Världsrekord"
  },
  {
      "partnerNumberIndividual": "0033155128",
      "employeeId": "198108083919",
      "firstName": "Numinös",
      "lastName": "Snövithasselmätare"
  },
  {
      "partnerNumberIndividual": "0033159208",
      "employeeId": "198109096217",
      "firstName": "Missbelåten",
      "lastName": "Ljuvalivet"
  },
  {
      "partnerNumberIndividual": "0033162981",
      "employeeId": "198109115512",
      "firstName": "Tvungen",
      "lastName": "Musikbibliotek"
  },
  {
      "partnerNumberIndividual": "0033163023",
      "employeeId": "198109115819",
      "firstName": "Oljeabsorberande",
      "lastName": "Pendelavstånd"
  },
  {
      "partnerNumberIndividual": "0033163301",
      "employeeId": "198109116411",
      "firstName": "Marin",
      "lastName": "Segelhållare"
  },
  {
      "partnerNumberIndividual": "0033167261",
      "employeeId": "198109137813",
      "firstName": "Lykantropisk",
      "lastName": "Hjärterot"
  },
  {
      "partnerNumberIndividual": "0033167866",
      "employeeId": "198109142615",
      "firstName": "Afferent",
      "lastName": "Extraläxa"
  },
  {
      "partnerNumberIndividual": "0033172860",
      "employeeId": "198109165814",
      "firstName": "Anställd",
      "lastName": "Gräsrotsrörelse"
  },
  {
      "partnerNumberIndividual": "0033172896",
      "employeeId": "198109165210",
      "firstName": "Debattlysten",
      "lastName": "Frostförsäkring"
  },
  {
      "partnerNumberIndividual": "0033177079",
      "employeeId": "198109184211",
      "firstName": "Inbillad",
      "lastName": "Lochiarubra"
  },
  {
      "partnerNumberIndividual": "0033180344",
      "employeeId": "198109190515",
      "firstName": "Lödd",
      "lastName": "Avhämtning"
  },
  {
      "partnerNumberIndividual": "0033180392",
      "employeeId": "198109190218",
      "firstName": "Cartesiansk",
      "lastName": "Växelryttare"
  },
  {
      "partnerNumberIndividual": "0033181009",
      "employeeId": "198109205313",
      "firstName": "Tropologisk",
      "lastName": "Nickel"
  },
  {
      "partnerNumberIndividual": "0033182279",
      "employeeId": "198601096962",
      "firstName": "Uppdragbar",
      "lastName": "Medvetandeström"
  },
  {
      "partnerNumberIndividual": "0033184750",
      "employeeId": "198109228513",
      "firstName": "Homopolymerisk",
      "lastName": "Arkivdepå"
  },
  {
      "partnerNumberIndividual": "0033184924",
      "employeeId": "198601118667",
      "firstName": "Ikonisk",
      "lastName": "Nordsjöstubb"
  },
  {
      "partnerNumberIndividual": "0033185221",
      "employeeId": "198109229115",
      "firstName": "Renochskär",
      "lastName": "Elektroniskhandel"
  },
  {
      "partnerNumberIndividual": "0033185412",
      "employeeId": "198601122560",
      "firstName": "Spolad",
      "lastName": "Cognacsessens"
  },
  {
      "partnerNumberIndividual": "0033185524",
      "employeeId": "198109232416",
      "firstName": "Opåverkbar",
      "lastName": "Delningslinje"
  },
  {
      "partnerNumberIndividual": "0033186216",
      "employeeId": "198109233919",
      "firstName": "Anemometrisk",
      "lastName": "Valbarhet"
  },
  {
      "partnerNumberIndividual": "0033186334",
      "employeeId": "198109234214",
      "firstName": "Saltförande",
      "lastName": "Stålrör"
  },
  {
      "partnerNumberIndividual": "0033189395",
      "employeeId": "198601151767",
      "firstName": "Sportig",
      "lastName": "Hämtköpsvaruhus"
  },
  {
      "partnerNumberIndividual": "0033190016",
      "employeeId": "198109254717",
      "firstName": "Sekret",
      "lastName": "Emersion"
  },
  {
      "partnerNumberIndividual": "0033192545",
      "employeeId": "198601186466",
      "firstName": "Friarmässig",
      "lastName": "Fodermjöl"
  },
  {
      "partnerNumberIndividual": "0033192571",
      "employeeId": "198601186169",
      "firstName": "Konfliktskapande",
      "lastName": "Bolagsstämma"
  },
  {
      "partnerNumberIndividual": "0033193072",
      "employeeId": "198601192761",
      "firstName": "Invalid",
      "lastName": "Nyårsgåva"
  },
  {
      "partnerNumberIndividual": "0033194657",
      "employeeId": "198601207866",
      "firstName": "Biltog",
      "lastName": "Resonansneutron"
  },
  {
      "partnerNumberIndividual": "0033197172",
      "employeeId": "198601229563",
      "firstName": "Neurotoxikologisk",
      "lastName": "Cellteknologi"
  },
  {
      "partnerNumberIndividual": "0033197947",
      "employeeId": "198601235867",
      "firstName": "Oförtruten",
      "lastName": "Ektypografi"
  },
  {
      "partnerNumberIndividual": "0033201858",
      "employeeId": "198109012412",
      "firstName": "Pirrig",
      "lastName": "Satellitbild"
  },
  {
      "partnerNumberIndividual": "0033205000",
      "employeeId": "198109026917",
      "firstName": "Responsiv",
      "lastName": "Öljätte"
  },
  {
      "partnerNumberIndividual": "0033205186",
      "employeeId": "198109027816",
      "firstName": "Femtusenårig",
      "lastName": "Expatient"
  },
  {
      "partnerNumberIndividual": "0033205976",
      "employeeId": "198109032311",
      "firstName": "Högernationalistisk",
      "lastName": "Gurkhakniv"
  },
  {
      "partnerNumberIndividual": "0033206389",
      "employeeId": "198109032915",
      "firstName": "Styrka",
      "lastName": "Rödöradbulbyl"
  },
  {
      "partnerNumberIndividual": "0033212453",
      "employeeId": "198109067317",
      "firstName": "Välkonserverad",
      "lastName": "Affärsknep"
  },
  {
      "partnerNumberIndividual": "0033212926",
      "employeeId": "198109068216",
      "firstName": "Vördad",
      "lastName": "Bästaanfallstiden"
  },
  {
      "partnerNumberIndividual": "0033213891",
      "employeeId": "198109074214",
      "firstName": "Azoisk",
      "lastName": "Ljuvalivet"
  },
  {
      "partnerNumberIndividual": "0033217723",
      "employeeId": "198109089014",
      "firstName": "Finstämd",
      "lastName": "Sändarkrets"
  },
  {
      "partnerNumberIndividual": "0033217896",
      "employeeId": "198602092069",
      "firstName": "Beklagande",
      "lastName": "Plausibilitet"
  },
  {
      "partnerNumberIndividual": "0033219382",
      "employeeId": "198602106265",
      "firstName": "Abelsk",
      "lastName": "Markränta"
  },
  {
      "partnerNumberIndividual": "0033220840",
      "employeeId": "198110099812",
      "firstName": "Förväxlad",
      "lastName": "Resdatum"
  },
  {
      "partnerNumberIndividual": "0033221942",
      "employeeId": "198602127964",
      "firstName": "Anankastisk",
      "lastName": "Läkarspalt"
  },
  {
      "partnerNumberIndividual": "0033223060",
      "employeeId": "198110112714",
      "firstName": "Leklysten",
      "lastName": "Macquarierall"
  },
  {
      "partnerNumberIndividual": "0033225503",
      "employeeId": "198110127811",
      "firstName": "Okollegial",
      "lastName": "Allmänskog"
  },
  {
      "partnerNumberIndividual": "0033226749",
      "employeeId": "198110134718",
      "firstName": "Pulverlackerad",
      "lastName": "Fartsladd"
  },
  {
      "partnerNumberIndividual": "0033228218",
      "employeeId": "198602178264",
      "firstName": "Lågtemperatur",
      "lastName": "Sändarkrets"
  },
  {
      "partnerNumberIndividual": "0033228637",
      "employeeId": "198602182761",
      "firstName": "Stimulerande",
      "lastName": "Teckenstorlek"
  },
  {
      "partnerNumberIndividual": "0033229905",
      "employeeId": "198110149815",
      "firstName": "Tiohörnig",
      "lastName": "Svågerpolitik"
  },
  {
      "partnerNumberIndividual": "0033230839",
      "employeeId": "198602196365",
      "firstName": "Samlarlysten",
      "lastName": "Moskovit"
  },
  {
      "partnerNumberIndividual": "0033231275",
      "employeeId": "198110155218",
      "firstName": "Färdigsydd",
      "lastName": "Bröstlidande"
  },
  {
      "partnerNumberIndividual": "0033231586",
      "employeeId": "198602202361",
      "firstName": "Kärlekskrank",
      "lastName": "Segmentering"
  },
  {
      "partnerNumberIndividual": "0033233580",
      "employeeId": "198110168518",
      "firstName": "Spolad",
      "lastName": "Kubansktodi"
  },
  {
      "partnerNumberIndividual": "0033233932",
      "employeeId": "198602218367",
      "firstName": "Levnadstrött",
      "lastName": "Fusion"
  },
  {
      "partnerNumberIndividual": "0033234683",
      "employeeId": "198110173914",
      "firstName": "Tilltagen",
      "lastName": "Algtoxin"
  },
  {
      "partnerNumberIndividual": "0033236138",
      "employeeId": "198110182311",
      "firstName": "Spjälad",
      "lastName": "Fjärrgodstransport"
  },
  {
      "partnerNumberIndividual": "0033238216",
      "employeeId": "198602252366",
      "firstName": "Halvlång",
      "lastName": "Flygplansutrustning"
  },
  {
      "partnerNumberIndividual": "0033238395",
      "employeeId": "198110196816",
      "firstName": "Deriverbar",
      "lastName": "Konturspår"
  },
  {
      "partnerNumberIndividual": "0033239275",
      "employeeId": "198110202515",
      "firstName": "Hudvänlig",
      "lastName": "Kaseinfärg"
  },
  {
      "partnerNumberIndividual": "0033242304",
      "employeeId": "198110218511",
      "firstName": "Högernationalistisk",
      "lastName": "Värmeisolering"
  },
  {
      "partnerNumberIndividual": "0033243060",
      "employeeId": "198110222414",
      "firstName": "Vegetabilisk",
      "lastName": "Kyrkolag"
  },
  {
      "partnerNumberIndividual": "0033245103",
      "employeeId": "198602019161",
      "firstName": "Antikrigs",
      "lastName": "Jordbruksekonom"
  },
  {
      "partnerNumberIndividual": "0033245133",
      "employeeId": "198602022462",
      "firstName": "Avskrapande",
      "lastName": "Vätskeindikator"
  },
  {
      "partnerNumberIndividual": "0033245148",
      "employeeId": "198602022165",
      "firstName": "Söder",
      "lastName": "Internetbokhandel"
  },
  {
      "partnerNumberIndividual": "0033246728",
      "employeeId": "198602037262",
      "firstName": "Mesaktig",
      "lastName": "Flasktransportör"
  },
  {
      "partnerNumberIndividual": "0033247585",
      "employeeId": "198602043260",
      "firstName": "Fastklistrad",
      "lastName": "Importintressen"
  },
  {
      "partnerNumberIndividual": "0033247910",
      "employeeId": "198110245316",
      "firstName": "Etnisk",
      "lastName": "Gatubrottsling"
  },
  {
      "partnerNumberIndividual": "0033250458",
      "employeeId": "198110259812",
      "firstName": "Sommarvarm",
      "lastName": "Försnillande"
  },
  {
      "partnerNumberIndividual": "0033250479",
      "employeeId": "198602064068",
      "firstName": "Matrelaterad",
      "lastName": "Gulbentflugsnappare"
  },
  {
      "partnerNumberIndividual": "0033251536",
      "employeeId": "198110266114",
      "firstName": "Scenvan",
      "lastName": "Ljusbågeskydd"
  },
  {
      "partnerNumberIndividual": "0033257608",
      "employeeId": "198603119465",
      "firstName": "Deskriptiv",
      "lastName": "Vantrevnad"
  },
  {
      "partnerNumberIndividual": "0033258536",
      "employeeId": "198603124267",
      "firstName": "Decenniumlång",
      "lastName": "Utsändning"
  },
  {
      "partnerNumberIndividual": "0033261040",
      "employeeId": "198603130868",
      "firstName": "Outhärdlig",
      "lastName": "Månkalender"
  },
  {
      "partnerNumberIndividual": "0033262466",
      "employeeId": "198603152268",
      "firstName": "Stressig",
      "lastName": "Toppvinkel"
  },
  {
      "partnerNumberIndividual": "0033264371",
      "employeeId": "198603165260",
      "firstName": "Xeromorfisk",
      "lastName": "Konventdeltagare"
  },
  {
      "partnerNumberIndividual": "0033264552",
      "employeeId": "198110020818",
      "firstName": "Pikerad",
      "lastName": "Medicinutgift"
  },
  {
      "partnerNumberIndividual": "0033266521",
      "employeeId": "198110042515",
      "firstName": "Vårdkrävande",
      "lastName": "Sandblästerskydd"
  },
  {
      "partnerNumberIndividual": "0033266582",
      "employeeId": "198110043711",
      "firstName": "Ytterligare",
      "lastName": "Föreläsningssal"
  },
  {
      "partnerNumberIndividual": "0033269941",
      "employeeId": "198110058214",
      "firstName": "Sydsvensk",
      "lastName": "Guadalkanalgräsfågel"
  },
  {
      "partnerNumberIndividual": "0033271567",
      "employeeId": "198603214365",
      "firstName": "Oljeabsorberande",
      "lastName": "Förståndsutveckling"
  },
  {
      "partnerNumberIndividual": "0033277184",
      "employeeId": "198111095819",
      "firstName": "Expropierad",
      "lastName": "Trycklocksburk"
  },
  {
      "partnerNumberIndividual": "0033277189",
      "employeeId": "198111095215",
      "firstName": "Ejavhämtad",
      "lastName": "Spikbleck"
  },
  {
      "partnerNumberIndividual": "0033277245",
      "employeeId": "198111096114",
      "firstName": "Utankärlek",
      "lastName": "Glansmedel"
  },
  {
      "partnerNumberIndividual": "0033277889",
      "employeeId": "198603262562",
      "firstName": "Tråd",
      "lastName": "Avbärgning"
  },
  {
      "partnerNumberIndividual": "0033278001",
      "employeeId": "198603263768",
      "firstName": "Dubbelbestruken",
      "lastName": "Magnesiumstearat"
  },
  {
      "partnerNumberIndividual": "0033278092",
      "employeeId": "198111102417",
      "firstName": "Spacey",
      "lastName": "Öglemutter"
  },
  {
      "partnerNumberIndividual": "0033278124",
      "employeeId": "198111102714",
      "firstName": "Reparerbar",
      "lastName": "Flyttbestyr"
  },
  {
      "partnerNumberIndividual": "0033280643",
      "employeeId": "198111116912",
      "firstName": "Epicen",
      "lastName": "Audigram"
  },
  {
      "partnerNumberIndividual": "0033281093",
      "employeeId": "198111117217",
      "firstName": "Antikrigs",
      "lastName": "Kapacitetsandel"
  },
  {
      "partnerNumberIndividual": "0033285267",
      "employeeId": "198111139815",
      "firstName": "Musikantisk",
      "lastName": "Grundskolekompetens"
  },
  {
      "partnerNumberIndividual": "0033286466",
      "employeeId": "198603012462",
      "firstName": "Tillvitas",
      "lastName": "Puaiohi"
  },
  {
      "partnerNumberIndividual": "0033288517",
      "employeeId": "198111159714",
      "firstName": "Ugnsrostad",
      "lastName": "Förkroppsling"
  },
  {
      "partnerNumberIndividual": "0033288773",
      "employeeId": "198603027866",
      "firstName": "Konstnärlig",
      "lastName": "Blystearat"
  },
  {
      "partnerNumberIndividual": "0033291673",
      "employeeId": "198111170513",
      "firstName": "Huvudsaklig",
      "lastName": "Vattenstäkra"
  },
  {
      "partnerNumberIndividual": "0033292081",
      "employeeId": "198603049266",
      "firstName": "Ärekär",
      "lastName": "Accelerationspotential"
  },
  {
      "partnerNumberIndividual": "0033292590",
      "employeeId": "198603055263",
      "firstName": "Sammanhållande",
      "lastName": "Hoptryckning"
  },
  {
      "partnerNumberIndividual": "0033293156",
      "employeeId": "198111186212",
      "firstName": "Geotermisk",
      "lastName": "Platå"
  },
  {
      "partnerNumberIndividual": "0033294018",
      "employeeId": "198111192517",
      "firstName": "Durativ",
      "lastName": "Ledarställning"
  },
  {
      "partnerNumberIndividual": "0033294111",
      "employeeId": "198603069462",
      "firstName": "Allrabäst",
      "lastName": "Drossel"
  },
  {
      "partnerNumberIndividual": "0033294364",
      "employeeId": "198603069769",
      "firstName": "Elektronegativ",
      "lastName": "Hämtköpsvaruhus"
  },
  {
      "partnerNumberIndividual": "0033295169",
      "employeeId": "198603076368",
      "firstName": "Meterhög",
      "lastName": "Skinka"
  },
  {
      "partnerNumberIndividual": "0033296726",
      "employeeId": "198111206119",
      "firstName": "Bonapartistisk",
      "lastName": "Dalöppning"
  },
  {
      "partnerNumberIndividual": "0033297760",
      "employeeId": "198111213917",
      "firstName": "Svårbemästrad",
      "lastName": "Hermelinsskinn"
  },
  {
      "partnerNumberIndividual": "0033299979",
      "employeeId": "198604107360",
      "firstName": "Biltog",
      "lastName": "Karminastrild"
  },
  {
      "partnerNumberIndividual": "0033300178",
      "employeeId": "198604108566",
      "firstName": "Reformvänlig",
      "lastName": "Betongvara"
  },
  {
      "partnerNumberIndividual": "0033300233",
      "employeeId": "198111233212",
      "firstName": "Behandlande",
      "lastName": "Mönsterexemplar"
  },
  {
      "partnerNumberIndividual": "0033302214",
      "employeeId": "198111248913",
      "firstName": "Peonisk",
      "lastName": "Svek"
  },
  {
      "partnerNumberIndividual": "0033302786",
      "employeeId": "198111254010",
      "firstName": "Brännskadad",
      "lastName": "Flampunkt"
  },
  {
      "partnerNumberIndividual": "0033304774",
      "employeeId": "198604136260",
      "firstName": "Anställd",
      "lastName": "Kandidat"
  },
  {
      "partnerNumberIndividual": "0033305791",
      "employeeId": "198111269414",
      "firstName": "Impressionist",
      "lastName": "Hermelinsskinn"
  },
  {
      "partnerNumberIndividual": "0033305806",
      "employeeId": "198111269711",
      "firstName": "Linje",
      "lastName": "Glansmedel"
  },
  {
      "partnerNumberIndividual": "0033306212",
      "employeeId": "198111260611",
      "firstName": "Renad",
      "lastName": "Stenkastare"
  },
  {
      "partnerNumberIndividual": "0033307166",
      "employeeId": "198111276914",
      "firstName": "Gotländsk",
      "lastName": "Deformationskraft"
  },
  {
      "partnerNumberIndividual": "0033307239",
      "employeeId": "198604155260",
      "firstName": "Moralistisk",
      "lastName": "Beslutomdödförklaring"
  },
  {
      "partnerNumberIndividual": "0033307308",
      "employeeId": "198604157969",
      "firstName": "Pacifistisk",
      "lastName": "Elektroretinograf"
  },
  {
      "partnerNumberIndividual": "0033311067",
      "employeeId": "198604182363",
      "firstName": "Herrskapsliknande",
      "lastName": "Asfaltprimer"
  },
  {
      "partnerNumberIndividual": "0033311376",
      "employeeId": "198604183262",
      "firstName": "Självförhärligande",
      "lastName": "Fotbollskänsla"
  },
  {
      "partnerNumberIndividual": "0033313341",
      "employeeId": "198111013218",
      "firstName": "Metalltäckt",
      "lastName": "Ondtunga"
  },
  {
      "partnerNumberIndividual": "0033313483",
      "employeeId": "198604198963",
      "firstName": "Hemtrevlig",
      "lastName": "Resdatum"
  },
  {
      "partnerNumberIndividual": "0033314218",
      "employeeId": "198604203763",
      "firstName": "Storbystad",
      "lastName": "Maltaduva"
  },
  {
      "partnerNumberIndividual": "0033315873",
      "employeeId": "198111026210",
      "firstName": "Ädel",
      "lastName": "Storskulden"
  },
  {
      "partnerNumberIndividual": "0033316097",
      "employeeId": "198604219462",
      "firstName": "Asocial",
      "lastName": "Kronvrak"
  },
  {
      "partnerNumberIndividual": "0033316616",
      "employeeId": "198604224868",
      "firstName": "Darrhänt",
      "lastName": "Pendelavstånd"
  },
  {
      "partnerNumberIndividual": "0033316817",
      "employeeId": "198604224264",
      "firstName": "Krabbätande",
      "lastName": "Ärtprotein"
  },
  {
      "partnerNumberIndividual": "0033316949",
      "employeeId": "198604226962",
      "firstName": "Rörelsemässig",
      "lastName": "Politisksociologi"
  },
  {
      "partnerNumberIndividual": "0033319611",
      "employeeId": "198111047919",
      "firstName": "Vidrörd",
      "lastName": "Handöverfräs"
  },
  {
      "partnerNumberIndividual": "0033319623",
      "employeeId": "198111048511",
      "firstName": "Keff",
      "lastName": "Spiralfjäder"
  },
  {
      "partnerNumberIndividual": "0033319960",
      "employeeId": "198604246267",
      "firstName": "Mörkhårig",
      "lastName": "Ytfärg"
  },
  {
      "partnerNumberIndividual": "0033320561",
      "employeeId": "198111052711",
      "firstName": "Illa",
      "lastName": "Trycklocksburk"
  },
  {
      "partnerNumberIndividual": "0033323885",
      "employeeId": "198111074715",
      "firstName": "Illa",
      "lastName": "Giftigtämne"
  },
  {
      "partnerNumberIndividual": "0033324010",
      "employeeId": "198604272768",
      "firstName": "Nuklid",
      "lastName": "Resonansneutron"
  },
  {
      "partnerNumberIndividual": "0033329558",
      "employeeId": "198604017866",
      "firstName": "Dominerad",
      "lastName": "Investeringsfond"
  },
  {
      "partnerNumberIndividual": "0033329770",
      "employeeId": "198604010267",
      "firstName": "Bröstsjuk",
      "lastName": "Lagändring"
  },
  {
      "partnerNumberIndividual": "0033330185",
      "employeeId": "198604022668",
      "firstName": "Regelbaserad",
      "lastName": "Sanitetsinstallation"
  },
  {
      "partnerNumberIndividual": "0033330241",
      "employeeId": "198604023260",
      "firstName": "Pyroteknisk",
      "lastName": "Förhörsledare"
  },
  {
      "partnerNumberIndividual": "0033330250",
      "employeeId": "198604024763",
      "firstName": "Durativ",
      "lastName": "Tvåtaktsmotor"
  },
  {
      "partnerNumberIndividual": "0033332449",
      "employeeId": "198604039860",
      "firstName": "Kortklippt",
      "lastName": "Fridlysning"
  },
  {
      "partnerNumberIndividual": "0033332999",
      "employeeId": "198604045867",
      "firstName": "Mångordig",
      "lastName": "Inteckningshandling"
  },
  {
      "partnerNumberIndividual": "0033334611",
      "employeeId": "198604059769",
      "firstName": "Oljeabsorberande",
      "lastName": "Tyrrhenuggla"
  },
  {
      "partnerNumberIndividual": "0033335612",
      "employeeId": "198604067267",
      "firstName": "Tyngdkrafts",
      "lastName": "Allvarsman"
  },
  {
      "partnerNumberIndividual": "0033340497",
      "employeeId": "198605098865",
      "firstName": "Feber",
      "lastName": "Grenadjärgarde"
  },
  {
      "partnerNumberIndividual": "0033340508",
      "employeeId": "198605099467",
      "firstName": "Oupptäckt",
      "lastName": "Stridstyrka"
  },
  {
      "partnerNumberIndividual": "0033341413",
      "employeeId": "198605104267",
      "firstName": "Självförhärligande",
      "lastName": "Yrkessjukdom"
  },
  {
      "partnerNumberIndividual": "0033343531",
      "employeeId": "198605124760",
      "firstName": "Morfisk",
      "lastName": "Konvolvulus"
  },
  {
      "partnerNumberIndividual": "0033346859",
      "employeeId": "198605147969",
      "firstName": "Pulverlackerad",
      "lastName": "Gjutstål"
  },
  {
      "partnerNumberIndividual": "0033350146",
      "employeeId": "198605167264",
      "firstName": "Rosthindrande",
      "lastName": "Jordbrukszon"
  },
  {
      "partnerNumberIndividual": "0033350937",
      "employeeId": "198605172660",
      "firstName": "Kostnadseffektiv",
      "lastName": "Duodiod"
  },
  {
      "partnerNumberIndividual": "0033351062",
      "employeeId": "198605173262",
      "firstName": "Påfågelsblå",
      "lastName": "Trådlöstelefon"
  },
  {
      "partnerNumberIndividual": "0033353547",
      "employeeId": "198605192569",
      "firstName": "Meterhög",
      "lastName": "Dans"
  },
  {
      "partnerNumberIndividual": "0033355674",
      "employeeId": "198605208266",
      "firstName": "Feldebiterad",
      "lastName": "Glasögonuggla"
  },
  {
      "partnerNumberIndividual": "0033356598",
      "employeeId": "198605214868",
      "firstName": "Okontant",
      "lastName": "Cellteknologi"
  },
  {
      "partnerNumberIndividual": "0033362512",
      "employeeId": "198605258865",
      "firstName": "Uppvärmbar",
      "lastName": "Hjortpark"
  },
  {
      "partnerNumberIndividual": "0033362543",
      "employeeId": "198605258261",
      "firstName": "Tunnklädd",
      "lastName": "Mexikospadnäbb"
  },
  {
      "partnerNumberIndividual": "0033363132",
      "employeeId": "198605264269",
      "firstName": "Numerär",
      "lastName": "Tillhandahållnatjänster"
  },
  {
      "partnerNumberIndividual": "0033364288",
      "employeeId": "198605276966",
      "firstName": "Största",
      "lastName": "Övningsgranat"
  },
  {
      "partnerNumberIndividual": "0033372537",
      "employeeId": "198605028961",
      "firstName": "Alvlik",
      "lastName": "Etnomusikologi"
  },
  {
      "partnerNumberIndividual": "0033373231",
      "employeeId": "198605033763",
      "firstName": "Självförstörande",
      "lastName": "Nollningsvecka"
  },
  {
      "partnerNumberIndividual": "0033373730",
      "employeeId": "198605036162",
      "firstName": "Ejkonvertibel",
      "lastName": "Storskulden"
  },
  {
      "partnerNumberIndividual": "0033374264",
      "employeeId": "198605042467",
      "firstName": "Färdigsydd",
      "lastName": "Nödochlust"
  },
  {
      "partnerNumberIndividual": "0033375543",
      "employeeId": "198605049769",
      "firstName": "Halvlång",
      "lastName": "Chokladpudding"
  },
  {
      "partnerNumberIndividual": "0033376581",
      "employeeId": "198605057861",
      "firstName": "Förmånlig",
      "lastName": "Tolkprogram"
  },
  {
      "partnerNumberIndividual": "0033379107",
      "employeeId": "198605076267",
      "firstName": "Kors",
      "lastName": "Spjälsäng"
  },
  {
      "partnerNumberIndividual": "0033382817",
      "employeeId": "198201099820",
      "firstName": "Bifalls",
      "lastName": "Mexikospadnäbb"
  },
  {
      "partnerNumberIndividual": "0033383522",
      "employeeId": "198606100868",
      "firstName": "Svåranträffbar",
      "lastName": "Halvlitersflaska"
  },
  {
      "partnerNumberIndividual": "0033383805",
      "employeeId": "198201105221",
      "firstName": "Invalid",
      "lastName": "Stannosulfid"
  },
  {
      "partnerNumberIndividual": "0033383922",
      "employeeId": "198606115668",
      "firstName": "Otillrådlig",
      "lastName": "Kortärm"
  },
  {
      "partnerNumberIndividual": "0033387036",
      "employeeId": "198606135864",
      "firstName": "Behäftadmedfel",
      "lastName": "Konventdeltagare"
  },
  {
      "partnerNumberIndividual": "0033387507",
      "employeeId": "198201126326",
      "firstName": "Snart",
      "lastName": "Cateringverksamhet"
  },
  {
      "partnerNumberIndividual": "0033387553",
      "employeeId": "198201126920",
      "firstName": "Atonal",
      "lastName": "Tempocykel"
  },
  {
      "partnerNumberIndividual": "0033389572",
      "employeeId": "198606157868",
      "firstName": "Sölig",
      "lastName": "Blystearat"
  },
  {
      "partnerNumberIndividual": "0033389573",
      "employeeId": "198201133827",
      "firstName": "Asbestinnehållande",
      "lastName": "Klosterföreståndarinna"
  },
  {
      "partnerNumberIndividual": "0033390032",
      "employeeId": "198606162660",
      "firstName": "Exakt",
      "lastName": "Avhämtning"
  },
  {
      "partnerNumberIndividual": "0033392763",
      "employeeId": "198201148924",
      "firstName": "Metalltäckt",
      "lastName": "Sotlavskrika"
  },
  {
      "partnerNumberIndividual": "0033394229",
      "employeeId": "198201154021",
      "firstName": "Påfrifot",
      "lastName": "Liechtensteinare"
  },
  {
      "partnerNumberIndividual": "0033394297",
      "employeeId": "198606198268",
      "firstName": "Svenskamerikansk",
      "lastName": "Pansarsköld"
  },
  {
      "partnerNumberIndividual": "0033394362",
      "employeeId": "198201155226",
      "firstName": "Saknad",
      "lastName": "Direktsumma"
  },
  {
      "partnerNumberIndividual": "0033395966",
      "employeeId": "198606212366",
      "firstName": "Opatriotisk",
      "lastName": "FNkonvention"
  },
  {
      "partnerNumberIndividual": "0033396015",
      "employeeId": "198606212069",
      "firstName": "Nordisk",
      "lastName": "Färgseparation"
  },
  {
      "partnerNumberIndividual": "0033396909",
      "employeeId": "198606219965",
      "firstName": "Djupliggande",
      "lastName": "Telefonminne"
  },
  {
      "partnerNumberIndividual": "0033397332",
      "employeeId": "198201168229",
      "firstName": "Etnografisk",
      "lastName": "Jobbredovisning"
  },
  {
      "partnerNumberIndividual": "0033397440",
      "employeeId": "198201169128",
      "firstName": "Vikariats",
      "lastName": "Danism"
  },
  {
      "partnerNumberIndividual": "0033397840",
      "employeeId": "198201160929",
      "firstName": "Opåvisad",
      "lastName": "Köksbänk"
  },
  {
      "partnerNumberIndividual": "0033398417",
      "employeeId": "198201175422",
      "firstName": "Sträckt",
      "lastName": "Sånghöna"
  },
  {
      "partnerNumberIndividual": "0033399920",
      "employeeId": "198606246463",
      "firstName": "Ametistfärgad",
      "lastName": "Hermelinsskinn"
  },
  {
      "partnerNumberIndividual": "0033400021",
      "employeeId": "198606246166",
      "firstName": "Inbillad",
      "lastName": "Risktagning"
  },
  {
      "partnerNumberIndividual": "0033401373",
      "employeeId": "198201180224",
      "firstName": "Vedisk",
      "lastName": "Maltesare"
  },
  {
      "partnerNumberIndividual": "0033402392",
      "employeeId": "198606267865",
      "firstName": "Främst",
      "lastName": "Myggblomster"
  },
  {
      "partnerNumberIndividual": "0033402422",
      "employeeId": "198606267261",
      "firstName": "Halvgenomskinlig",
      "lastName": "Överföringavanslag"
  },
  {
      "partnerNumberIndividual": "0033402457",
      "employeeId": "198201195628",
      "firstName": "Impressionist",
      "lastName": "Vindsstege"
  },
  {
      "partnerNumberIndividual": "0033402966",
      "employeeId": "198201196220",
      "firstName": "Tvåhändig",
      "lastName": "Agrypni"
  },
  {
      "partnerNumberIndividual": "0033405819",
      "employeeId": "198201200725",
      "firstName": "Absent",
      "lastName": "Bröstlidande"
  },
  {
      "partnerNumberIndividual": "0033405844",
      "employeeId": "198201201327",
      "firstName": "Didaktisk",
      "lastName": "Återtaganderätt"
  },
  {
      "partnerNumberIndividual": "0033408361",
      "employeeId": "198606018961",
      "firstName": "Cartesiansk",
      "lastName": "Studieutbyte"
  },
  {
      "partnerNumberIndividual": "0033408919",
      "employeeId": "198201224220",
      "firstName": "Osteriliserad",
      "lastName": "Maosko"
  },
  {
      "partnerNumberIndividual": "0033408971",
      "employeeId": "198606024365",
      "firstName": "Flersidig",
      "lastName": "Informationssystem"
  },
  {
      "partnerNumberIndividual": "0033411214",
      "employeeId": "198201236927",
      "firstName": "Utslätad",
      "lastName": "Vattenbehållare"
  },
  {
      "partnerNumberIndividual": "0033411333",
      "employeeId": "198606039462",
      "firstName": "Skogsmässig",
      "lastName": "Ödehus"
  },
  {
      "partnerNumberIndividual": "0033411551",
      "employeeId": "198201237826",
      "firstName": "Läckande",
      "lastName": "Getost"
  },
  {
      "partnerNumberIndividual": "0033411611",
      "employeeId": "198201237222",
      "firstName": "Puckelformig",
      "lastName": "Förstorare"
  },
  {
      "partnerNumberIndividual": "0033412596",
      "employeeId": "198201242628",
      "firstName": "Moltyst",
      "lastName": "Födelsekyrka"
  },
  {
      "partnerNumberIndividual": "0033412744",
      "employeeId": "198606052366",
      "firstName": "Knäckt",
      "lastName": "Någonannanväg"
  },
  {
      "partnerNumberIndividual": "0033412766",
      "employeeId": "198201243220",
      "firstName": "Rockklädd",
      "lastName": "Franchising"
  },
  {
      "partnerNumberIndividual": "0033413052",
      "employeeId": "198201244723",
      "firstName": "Påminnande",
      "lastName": "Ärtprotein"
  },
  {
      "partnerNumberIndividual": "0033413102",
      "employeeId": "198606053265",
      "firstName": "Levnadstrött",
      "lastName": "Tyrolerdräkt"
  },
  {
      "partnerNumberIndividual": "0033414410",
      "employeeId": "198606066267",
      "firstName": "Spjälad",
      "lastName": "Söksträng"
  },
  {
      "partnerNumberIndividual": "0033414952",
      "employeeId": "198606072562",
      "firstName": "Reglementarisk",
      "lastName": "Mellankomst"
  },
  {
      "partnerNumberIndividual": "0033416592",
      "employeeId": "198606088865",
      "firstName": "Utsmyckad",
      "lastName": "Tidvattensteori"
  },
  {
      "partnerNumberIndividual": "0033419834",
      "employeeId": "198201279422",
      "firstName": "Bacillär",
      "lastName": "Frostskyddsapparat"
  },
  {
      "partnerNumberIndividual": "0033426959",
      "employeeId": "198607172866",
      "firstName": "Opatriotisk",
      "lastName": "Motocross"
  },
  {
      "partnerNumberIndividual": "0033427000",
      "employeeId": "198607174367",
      "firstName": "Hemmaboende",
      "lastName": "Beklädnadsförråd"
  },
  {
      "partnerNumberIndividual": "0033428910",
      "employeeId": "198607189464",
      "firstName": "Obillig",
      "lastName": "Strilkondensor"
  },
  {
      "partnerNumberIndividual": "0033429528",
      "employeeId": "198201022624",
      "firstName": "Kymig",
      "lastName": "Kvartärgeologi"
  },
  {
      "partnerNumberIndividual": "0033429572",
      "employeeId": "198201022921",
      "firstName": "Tuvig",
      "lastName": "Mindrekilstjärtsångare"
  },
  {
      "partnerNumberIndividual": "0033429616",
      "employeeId": "198201023226",
      "firstName": "Heterosexistisk",
      "lastName": "Cyanfettsyror"
  },
  {
      "partnerNumberIndividual": "0033432447",
      "employeeId": "198201036228",
      "firstName": "Vattenburen",
      "lastName": "Laplacetransformation"
  },
  {
      "partnerNumberIndividual": "0033436527",
      "employeeId": "198201057927",
      "firstName": "Svenskamerikansk",
      "lastName": "Paperback"
  },
  {
      "partnerNumberIndividual": "0033437910",
      "employeeId": "198607262360",
      "firstName": "Visuell",
      "lastName": "Hobbyrum"
  },
  {
      "partnerNumberIndividual": "0033437980",
      "employeeId": "198201063925",
      "firstName": "Navelskådande",
      "lastName": "Friochrättigheter"
  },
  {
      "partnerNumberIndividual": "0033441504",
      "employeeId": "198201084723",
      "firstName": "Musikalisk",
      "lastName": "Platan"
  },
  {
      "partnerNumberIndividual": "0033441746",
      "employeeId": "198201085621",
      "firstName": "Bilmekanisk",
      "lastName": "Långpassning"
  },
  {
      "partnerNumberIndividual": "0033441846",
      "employeeId": "198201086223",
      "firstName": "Absent",
      "lastName": "Jackfält"
  },
  {
      "partnerNumberIndividual": "0033444113",
      "employeeId": "198202095520",
      "firstName": "Superheterodyn",
      "lastName": "Företagsöverlåtelse"
  },
  {
      "partnerNumberIndividual": "0033444162",
      "employeeId": "198202095223",
      "firstName": "Midströms",
      "lastName": "Strilkondensor"
  },
  {
      "partnerNumberIndividual": "0033444579",
      "employeeId": "198202096122",
      "firstName": "Numerär",
      "lastName": "Risktagning"
  },
  {
      "partnerNumberIndividual": "0033445396",
      "employeeId": "198202102425",
      "firstName": "Tvungen",
      "lastName": "Kaplanturbin"
  },
  {
      "partnerNumberIndividual": "0033446433",
      "employeeId": "198607016469",
      "firstName": "Hermitesk",
      "lastName": "Hjortpark"
  },
  {
      "partnerNumberIndividual": "0033448334",
      "employeeId": "198202116326",
      "firstName": "Krabbätande",
      "lastName": "Stapeldiagram"
  },
  {
      "partnerNumberIndividual": "0033448617",
      "employeeId": "198607036368",
      "firstName": "Visuell",
      "lastName": "Gasverk"
  },
  {
      "partnerNumberIndividual": "0033448648",
      "employeeId": "198607036962",
      "firstName": "Artskild",
      "lastName": "Ömlåga"
  },
  {
      "partnerNumberIndividual": "0033448761",
      "employeeId": "198202117225",
      "firstName": "Absent",
      "lastName": "Esofagusperforation"
  },
  {
      "partnerNumberIndividual": "0033449197",
      "employeeId": "198202122324",
      "firstName": "Mellan",
      "lastName": "Glycerinvatten"
  },
  {
      "partnerNumberIndividual": "0033451677",
      "employeeId": "198607063768",
      "firstName": "Krympsäker",
      "lastName": "Kalkaneus"
  },
  {
      "partnerNumberIndividual": "0033452721",
      "employeeId": "198202139823",
      "firstName": "Överens",
      "lastName": "Vinägrettsås"
  },
  {
      "partnerNumberIndividual": "0033453086",
      "employeeId": "198202142520",
      "firstName": "Informations",
      "lastName": "Fullnav"
  },
  {
      "partnerNumberIndividual": "0033453600",
      "employeeId": "198607077362",
      "firstName": "Demokratiserbar",
      "lastName": "Grönaracari"
  },
  {
      "partnerNumberIndividual": "0033453634",
      "employeeId": "198607077966",
      "firstName": "Hormon",
      "lastName": "Fabriksgård"
  },
  {
      "partnerNumberIndividual": "0033453661",
      "employeeId": "198607078568",
      "firstName": "Sträckt",
      "lastName": "Klosterföreståndarinna"
  },
  {
      "partnerNumberIndividual": "0033455554",
      "employeeId": "198202158526",
      "firstName": "Örnnäst",
      "lastName": "Mindrekilstjärtsångare"
  },
  {
      "partnerNumberIndividual": "0033455605",
      "employeeId": "198202158229",
      "firstName": "Kringvärvd",
      "lastName": "Köksinredning"
  },
  {
      "partnerNumberIndividual": "0033455672",
      "employeeId": "198202159128",
      "firstName": "Konkurrensduglig",
      "lastName": "Betongblandning"
  },
  {
      "partnerNumberIndividual": "0033456642",
      "employeeId": "198202164227",
      "firstName": "Gassig",
      "lastName": "Kärandesidan"
  },
  {
      "partnerNumberIndividual": "0033458521",
      "employeeId": "198608116169",
      "firstName": "Ful",
      "lastName": "Förstärkare"
  },
  {
      "partnerNumberIndividual": "0033458999",
      "employeeId": "198608122464",
      "firstName": "Felande",
      "lastName": "Carnotit"
  },
  {
      "partnerNumberIndividual": "0033461824",
      "employeeId": "198608142660",
      "firstName": "Eutrof",
      "lastName": "Blåringadängelfisk"
  },
  {
      "partnerNumberIndividual": "0033461870",
      "employeeId": "198608143866",
      "firstName": "Hedersam",
      "lastName": "Höftstöd"
  },
  {
      "partnerNumberIndividual": "0033464687",
      "employeeId": "198608164367",
      "firstName": "Toskansk",
      "lastName": "Intvålning"
  },
  {
      "partnerNumberIndividual": "0033466044",
      "employeeId": "198608178565",
      "firstName": "Avdomnad",
      "lastName": "Förhandlingspolitik"
  },
  {
      "partnerNumberIndividual": "0033466111",
      "employeeId": "198608178268",
      "firstName": "Keff",
      "lastName": "Rehabilitering"
  },
  {
      "partnerNumberIndividual": "0033466247",
      "employeeId": "198202206424",
      "firstName": "Kromosomskadad",
      "lastName": "Majolika"
  },
  {
      "partnerNumberIndividual": "0033466277",
      "employeeId": "198202206127",
      "firstName": "Utbränd",
      "lastName": "Autokod"
  },
  {
      "partnerNumberIndividual": "0033466474",
      "employeeId": "198202207323",
      "firstName": "Genotypisk",
      "lastName": "Blixtlampa"
  },
  {
      "partnerNumberIndividual": "0033466512",
      "employeeId": "198202207927",
      "firstName": "Mörkhårig",
      "lastName": "Världsrekord"
  },
  {
      "partnerNumberIndividual": "0033466635",
      "employeeId": "198202208529",
      "firstName": "Vattenburen",
      "lastName": "Oxfordrörelsemedlem"
  },
  {
      "partnerNumberIndividual": "0033466716",
      "employeeId": "198202208222",
      "firstName": "Dualistisk",
      "lastName": "Segmentering"
  },
  {
      "partnerNumberIndividual": "0033466895",
      "employeeId": "198608184563",
      "firstName": "Omflyttbar",
      "lastName": "Växelryttare"
  },
  {
      "partnerNumberIndividual": "0033467053",
      "employeeId": "198608186360",
      "firstName": "Hemlös",
      "lastName": "Vätgaselektrod"
  },
  {
      "partnerNumberIndividual": "0033467219",
      "employeeId": "198202212422",
      "firstName": "Fortlevande",
      "lastName": "Allvarsman"
  },
  {
      "partnerNumberIndividual": "0033467585",
      "employeeId": "198202212729",
      "firstName": "Psykokemisk",
      "lastName": "Huvudsajt"
  },
  {
      "partnerNumberIndividual": "0033467945",
      "employeeId": "198608192061",
      "firstName": "Epokgörande",
      "lastName": "Flanör"
  },
  {
      "partnerNumberIndividual": "0033468093",
      "employeeId": "198202214220",
      "firstName": "Decenniumlång",
      "lastName": "Jordräknare"
  },
  {
      "partnerNumberIndividual": "0033469793",
      "employeeId": "198608206267",
      "firstName": "Oefterliknelig",
      "lastName": "Nyckelord"
  },
  {
      "partnerNumberIndividual": "0033471361",
      "employeeId": "198202232925",
      "firstName": "Ohederlig",
      "lastName": "Deformationskraft"
  },
  {
      "partnerNumberIndividual": "0033472098",
      "employeeId": "198608225861",
      "firstName": "Deltidsanställd",
      "lastName": "Etnomusikologi"
  },
  {
      "partnerNumberIndividual": "0033472144",
      "employeeId": "198608226463",
      "firstName": "Ensamma",
      "lastName": "Vitfläckigpygmérall"
  },
  {
      "partnerNumberIndividual": "0033473021",
      "employeeId": "198608232768",
      "firstName": "Ejavhämtad",
      "lastName": "Grundskolekompetens"
  },
  {
      "partnerNumberIndividual": "0033476646",
      "employeeId": "198202254325",
      "firstName": "Tidvattens",
      "lastName": "Trådekerhjul"
  },
  {
      "partnerNumberIndividual": "0033476669",
      "employeeId": "198202254622",
      "firstName": "Finans",
      "lastName": "Öringfiske"
  },
  {
      "partnerNumberIndividual": "0033480291",
      "employeeId": "198202269422",
      "firstName": "Horisontutvidgande",
      "lastName": "Modem"
  },
  {
      "partnerNumberIndividual": "0033480299",
      "employeeId": "198202269729",
      "firstName": "Frygisk",
      "lastName": "Hårklädsel"
  },
  {
      "partnerNumberIndividual": "0033481257",
      "employeeId": "198202276328",
      "firstName": "Zetetisk",
      "lastName": "Repulsor"
  },
  {
      "partnerNumberIndividual": "0033485142",
      "employeeId": "198608033265",
      "firstName": "Sövande",
      "lastName": "Penningmarknadslån"
  },
  {
      "partnerNumberIndividual": "0033488180",
      "employeeId": "198202028927",
      "firstName": "Didaktisk",
      "lastName": "Överkonstapel"
  },
  {
      "partnerNumberIndividual": "0033490036",
      "employeeId": "198608067362",
      "firstName": "Närsynt",
      "lastName": "Fjärrgodstransport"
  },
  {
      "partnerNumberIndividual": "0033491251",
      "employeeId": "198202031327",
      "firstName": "Uppkörd",
      "lastName": "Arabiskaalfabetet"
  },
  {
      "partnerNumberIndividual": "0033492572",
      "employeeId": "198202047323",
      "firstName": "Färgframkallande",
      "lastName": "Chokladpudding"
  },
  {
      "partnerNumberIndividual": "0033492905",
      "employeeId": "198202048529",
      "firstName": "Tillvitas",
      "lastName": "Skenfot"
  },
  {
      "partnerNumberIndividual": "0033492909",
      "employeeId": "198202048826",
      "firstName": "Blästrad",
      "lastName": "Årsmötesdeltagare"
  },
  {
      "partnerNumberIndividual": "0033492964",
      "employeeId": "198202048222",
      "firstName": "Hormon",
      "lastName": "Stadshusmöte"
  },
  {
      "partnerNumberIndividual": "0033492976",
      "employeeId": "198202049428",
      "firstName": "Underskön",
      "lastName": "Valkalv"
  },
  {
      "partnerNumberIndividual": "0033493372",
      "employeeId": "198202049121",
      "firstName": "Från",
      "lastName": "Socialbidrag"
  },
  {
      "partnerNumberIndividual": "0033493913",
      "employeeId": "198609098960",
      "firstName": "Synergisk",
      "lastName": "Menlöshet"
  },
  {
      "partnerNumberIndividual": "0033494202",
      "employeeId": "198202054220",
      "firstName": "Ifrågasättande",
      "lastName": "Asbestfiberplatta"
  },
  {
      "partnerNumberIndividual": "0033494716",
      "employeeId": "198609104362",
      "firstName": "Preskriberad",
      "lastName": "Språkdiskriminering"
  },
  {
      "partnerNumberIndividual": "0033495113",
      "employeeId": "198609106169",
      "firstName": "Endoplasmatisk",
      "lastName": "Blåsning"
  },
  {
      "partnerNumberIndividual": "0033499234",
      "employeeId": "198609133262",
      "firstName": "Örnnäst",
      "lastName": "Öljätte"
  },
  {
      "partnerNumberIndividual": "0033501158",
      "employeeId": "198609152569",
      "firstName": "Förbuskad",
      "lastName": "Lamaull"
  },
  {
      "partnerNumberIndividual": "0033501219",
      "employeeId": "198609153765",
      "firstName": "Knarrande",
      "lastName": "Släthammare"
  },
  {
      "partnerNumberIndividual": "0033502044",
      "employeeId": "198203092427",
      "firstName": "Äppelkindad",
      "lastName": "Lastnät"
  },
  {
      "partnerNumberIndividual": "0033502582",
      "employeeId": "198203093029",
      "firstName": "Sagolik",
      "lastName": "Beklädnadsförråd"
  },
  {
      "partnerNumberIndividual": "0033503663",
      "employeeId": "198609176360",
      "firstName": "Gudfruktig",
      "lastName": "Molekylärbiologi"
  },
  {
      "partnerNumberIndividual": "0033505829",
      "employeeId": "198203106326",
      "firstName": "Ödesbestämd",
      "lastName": "Avskedsuppvaktning"
  },
  {
      "partnerNumberIndividual": "0033507299",
      "employeeId": "198203112324",
      "firstName": "Tjockflytande",
      "lastName": "Fregattfågel"
  },
  {
      "partnerNumberIndividual": "0033507398",
      "employeeId": "198203112928",
      "firstName": "Trendmedveten",
      "lastName": "Startström"
  },
  {
      "partnerNumberIndividual": "0033507787",
      "employeeId": "198203113520",
      "firstName": "Kortskaftad",
      "lastName": "Tonfrekvens"
  },
  {
      "partnerNumberIndividual": "0033507862",
      "employeeId": "198203113223",
      "firstName": "Bifokal",
      "lastName": "Arkivlag"
  },
  {
      "partnerNumberIndividual": "0033509608",
      "employeeId": "198609223360",
      "firstName": "Knäpptyst",
      "lastName": "Sandblästerskydd"
  },
  {
      "partnerNumberIndividual": "0033511906",
      "employeeId": "198609242667",
      "firstName": "Intetillgänglig",
      "lastName": "Berylliumjodid"
  },
  {
      "partnerNumberIndividual": "0033512229",
      "employeeId": "198609243269",
      "firstName": "Dualistisk",
      "lastName": "Deformationskraft"
  },
  {
      "partnerNumberIndividual": "0033512677",
      "employeeId": "198203133726",
      "firstName": "Driftsklar",
      "lastName": "Stortungkg"
  },
  {
      "partnerNumberIndividual": "0033515343",
      "employeeId": "198609266161",
      "firstName": "Oljerik",
      "lastName": "Dans"
  },
  {
      "partnerNumberIndividual": "0033516908",
      "employeeId": "198203154227",
      "firstName": "Heterosexistisk",
      "lastName": "Arbetsmarknadspension"
  },
  {
      "partnerNumberIndividual": "0033517066",
      "employeeId": "198609278869",
      "firstName": "Sentblommande",
      "lastName": "Halvpence"
  },
  {
      "partnerNumberIndividual": "0033517093",
      "employeeId": "198609279768",
      "firstName": "Dubbelbottnad",
      "lastName": "Nahanifrankolin"
  },
  {
      "partnerNumberIndividual": "0033517321",
      "employeeId": "198203156628",
      "firstName": "Interkontinental",
      "lastName": "Ärftlighetsgen"
  },
  {
      "partnerNumberIndividual": "0033518206",
      "employeeId": "198203162022",
      "firstName": "Fumlande",
      "lastName": "Enfrågepolitik"
  },
  {
      "partnerNumberIndividual": "0033520670",
      "employeeId": "198203174720",
      "firstName": "Tragikomisk",
      "lastName": "Djup"
  },
  {
      "partnerNumberIndividual": "0033521243",
      "employeeId": "198203176527",
      "firstName": "Cyklonartad",
      "lastName": "Ragu"
  },
  {
      "partnerNumberIndividual": "0033521844",
      "employeeId": "198609017267",
      "firstName": "Vardagslik",
      "lastName": "Utsago"
  },
  {
      "partnerNumberIndividual": "0033523328",
      "employeeId": "198609020261",
      "firstName": "Oklangad",
      "lastName": "Köpmansgille"
  },
  {
      "partnerNumberIndividual": "0033524264",
      "employeeId": "198609035962",
      "firstName": "Bröstsjuk",
      "lastName": "Vänskapshandling"
  },
  {
      "partnerNumberIndividual": "0033524789",
      "employeeId": "198203181329",
      "firstName": "Datorinriktad",
      "lastName": "Gulbentflugskvätta"
  },
  {
      "partnerNumberIndividual": "0033525192",
      "employeeId": "198609042562",
      "firstName": "Oantastlig",
      "lastName": "Brandklämtning"
  },
  {
      "partnerNumberIndividual": "0033526118",
      "employeeId": "198203196129",
      "firstName": "Opåvisad",
      "lastName": "Arkitektkollega"
  },
  {
      "partnerNumberIndividual": "0033526610",
      "employeeId": "198203198828",
      "firstName": "Tvungen",
      "lastName": "Attackdivision"
  },
  {
      "partnerNumberIndividual": "0033531162",
      "employeeId": "198203217222",
      "firstName": "Långlivad",
      "lastName": "Mindrekilstjärtsångare"
  },
  {
      "partnerNumberIndividual": "0033531553",
      "employeeId": "198610094362",
      "firstName": "Nuklid",
      "lastName": "Hexaklorcyklohexan"
  },
  {
      "partnerNumberIndividual": "0033531972",
      "employeeId": "198203222628",
      "firstName": "Inkontinent",
      "lastName": "Finansmagnat"
  },
  {
      "partnerNumberIndividual": "0033532061",
      "employeeId": "198203223220",
      "firstName": "Västerut",
      "lastName": "Svågerpolitik"
  },
  {
      "partnerNumberIndividual": "0033532600",
      "employeeId": "198610102769",
      "firstName": "Imperatorisk",
      "lastName": "Chancroid"
  },
  {
      "partnerNumberIndividual": "0033535178",
      "employeeId": "198610123260",
      "firstName": "Bommad",
      "lastName": "Fyrsken"
  },
  {
      "partnerNumberIndividual": "0033536942",
      "employeeId": "198203245223",
      "firstName": "Miljövårds",
      "lastName": "Carnotit"
  },
  {
      "partnerNumberIndividual": "0033537605",
      "employeeId": "198610145263",
      "firstName": "Navelskådande",
      "lastName": "Flanör"
  },
  {
      "partnerNumberIndividual": "0033539663",
      "employeeId": "198610159769",
      "firstName": "Tävlingslysten",
      "lastName": "Häxkraft"
  },
  {
      "partnerNumberIndividual": "0033542505",
      "employeeId": "198610184767",
      "firstName": "Minus",
      "lastName": "Nysrot"
  },
  {
      "partnerNumberIndividual": "0033543882",
      "employeeId": "198203272920",
      "firstName": "Tråd",
      "lastName": "Ärftlighetsgen"
  },
  {
      "partnerNumberIndividual": "0033543980",
      "employeeId": "198203273225",
      "firstName": "Reparerbar",
      "lastName": "Vidareanvändning"
  },
  {
      "partnerNumberIndividual": "0033545826",
      "employeeId": "198203270221",
      "firstName": "Råkall",
      "lastName": "Fläktkylning"
  },
  {
      "partnerNumberIndividual": "0033547081",
      "employeeId": "198610226964",
      "firstName": "Syndfri",
      "lastName": "Ränteparitetsteori"
  },
  {
      "partnerNumberIndividual": "0033547126",
      "employeeId": "198610227566",
      "firstName": "Klinklagd",
      "lastName": "Applikationsfil"
  },
  {
      "partnerNumberIndividual": "0033547149",
      "employeeId": "198610227269",
      "firstName": "Kringvärvd",
      "lastName": "Nollningsvecka"
  },
  {
      "partnerNumberIndividual": "0033551017",
      "employeeId": "198610256169",
      "firstName": "Oklippt",
      "lastName": "Hukställning"
  },
  {
      "partnerNumberIndividual": "0033552053",
      "employeeId": "198610269766",
      "firstName": "Uppbyggande",
      "lastName": "Hobbyrum"
  },
  {
      "partnerNumberIndividual": "0033556272",
      "employeeId": "198203016525",
      "firstName": "Dimhöljd",
      "lastName": "Socialrätt"
  },
  {
      "partnerNumberIndividual": "0033556775",
      "employeeId": "198203018323",
      "firstName": "Submolekylär",
      "lastName": "Politisksociologi"
  },
  {
      "partnerNumberIndividual": "0033562054",
      "employeeId": "198203039725",
      "firstName": "Immun",
      "lastName": "Kaplanturbin"
  },
  {
      "partnerNumberIndividual": "0033562071",
      "employeeId": "198203039121",
      "firstName": "Varmrökt",
      "lastName": "Risktagning"
  },
  {
      "partnerNumberIndividual": "0033562706",
      "employeeId": "198610067863",
      "firstName": "Cykelburen",
      "lastName": "Växelryttare"
  },
  {
      "partnerNumberIndividual": "0033563222",
      "employeeId": "198610074760",
      "firstName": "Labyrintisk",
      "lastName": "Arglist"
  },
  {
      "partnerNumberIndividual": "0033565457",
      "employeeId": "198203050821",
      "firstName": "Solar",
      "lastName": "Smågnat"
  },
  {
      "partnerNumberIndividual": "0033565480",
      "employeeId": "198203050227",
      "firstName": "Västtysk",
      "lastName": "Midsommarsol"
  },
  {
      "partnerNumberIndividual": "0033568987",
      "employeeId": "198611132567",
      "firstName": "Nittioårs",
      "lastName": "Hårrörskärl"
  },
  {
      "partnerNumberIndividual": "0033569401",
      "employeeId": "198203079226",
      "firstName": "Inkontinent",
      "lastName": "Mellankomst"
  },
  {
      "partnerNumberIndividual": "0033569409",
      "employeeId": "198611133763",
      "firstName": "Smittfri",
      "lastName": "Gny"
  },
  {
      "partnerNumberIndividual": "0033570529",
      "employeeId": "198203085520",
      "firstName": "Surrealistisk",
      "lastName": "Smiley"
  },
  {
      "partnerNumberIndividual": "0033570603",
      "employeeId": "198203085223",
      "firstName": "Kippskodd",
      "lastName": "Rödöradbulbyl"
  },
  {
      "partnerNumberIndividual": "0033571208",
      "employeeId": "198611148563",
      "firstName": "Döpt",
      "lastName": "Gurkhakniv"
  },
  {
      "partnerNumberIndividual": "0033574464",
      "employeeId": "198204096328",
      "firstName": "Anstötlig",
      "lastName": "Kryptografi"
  },
  {
      "partnerNumberIndividual": "0033574598",
      "employeeId": "198204097524",
      "firstName": "Styckevis",
      "lastName": "Hjortpark"
  },
  {
      "partnerNumberIndividual": "0033574675",
      "employeeId": "198611182869",
      "firstName": "Utankänsel",
      "lastName": "Omao"
  },
  {
      "partnerNumberIndividual": "0033576073",
      "employeeId": "198611196166",
      "firstName": "Strupstor",
      "lastName": "Läkemedelskontroll"
  },
  {
      "partnerNumberIndividual": "0033576121",
      "employeeId": "198611197362",
      "firstName": "Äppelkindad",
      "lastName": "Akterskepp"
  },
  {
      "partnerNumberIndividual": "0033576125",
      "employeeId": "198204103223",
      "firstName": "Decenniumlång",
      "lastName": "Läkartjänst"
  },
  {
      "partnerNumberIndividual": "0033578794",
      "employeeId": "198204116829",
      "firstName": "Reglementarisk",
      "lastName": "Glansmedel"
  },
  {
      "partnerNumberIndividual": "0033579048",
      "employeeId": "198611223267",
      "firstName": "Kostnadsfri",
      "lastName": "Alefnoll"
  },
  {
      "partnerNumberIndividual": "0033579078",
      "employeeId": "198204118320",
      "firstName": "Begreppsmässig",
      "lastName": "Utgiftutanförbudget"
  },
  {
      "partnerNumberIndividual": "0033579600",
      "employeeId": "198204122520",
      "firstName": "Svängningsbar",
      "lastName": "Värmeisolering"
  },
  {
      "partnerNumberIndividual": "0033580114",
      "employeeId": "198204124328",
      "firstName": "Dualistisk",
      "lastName": "Emersion"
  },
  {
      "partnerNumberIndividual": "0033582543",
      "employeeId": "198611258867",
      "firstName": "Mod",
      "lastName": "Gitterkvadrat"
  },
  {
      "partnerNumberIndividual": "0033583556",
      "employeeId": "198204138526",
      "firstName": "Herrskapsliknande",
      "lastName": "Etnomusikologi"
  },
  {
      "partnerNumberIndividual": "0033583675",
      "employeeId": "198204139425",
      "firstName": "Ljum",
      "lastName": "Fiskerikontroll"
  },
  {
      "partnerNumberIndividual": "0033583695",
      "employeeId": "198204139722",
      "firstName": "Västerut",
      "lastName": "Torpedhantverkare"
  },
  {
      "partnerNumberIndividual": "0033583978",
      "employeeId": "198204139128",
      "firstName": "Skattepliktig",
      "lastName": "Blindarkad"
  },
  {
      "partnerNumberIndividual": "0033585093",
      "employeeId": "198204144524",
      "firstName": "Åsyna",
      "lastName": "Gratulationskort"
  },
  {
      "partnerNumberIndividual": "0033585608",
      "employeeId": "198204146321",
      "firstName": "Famlande",
      "lastName": "Läkekonst"
  },
  {
      "partnerNumberIndividual": "0033589448",
      "employeeId": "198204150224",
      "firstName": "Ytterligare",
      "lastName": "Observationsbrunn"
  },
  {
      "partnerNumberIndividual": "0033592070",
      "employeeId": "198204172525",
      "firstName": "Eutrof",
      "lastName": "Svartkindadskogssångare"
  },
  {
      "partnerNumberIndividual": "0033593507",
      "employeeId": "198611063267",
      "firstName": "Bronkitsnörd",
      "lastName": "Yrkesgrupp"
  },
  {
      "partnerNumberIndividual": "0033595332",
      "employeeId": "198611079867",
      "firstName": "Översvinnelig",
      "lastName": "Bortval"
  },
  {
      "partnerNumberIndividual": "0033596337",
      "employeeId": "198204192721",
      "firstName": "Smidbar",
      "lastName": "Vapenkammare"
  },
  {
      "partnerNumberIndividual": "0033599075",
      "employeeId": "198204207222",
      "firstName": "Inkonsekvent",
      "lastName": "Nyårsgåva"
  },
  {
      "partnerNumberIndividual": "0033605471",
      "employeeId": "198204234325",
      "firstName": "Membranlik",
      "lastName": "Räntetabell"
  },
  {
      "partnerNumberIndividual": "0033605900",
      "employeeId": "198204234028",
      "firstName": "Risig",
      "lastName": "Stålrör"
  },
  {
      "partnerNumberIndividual": "0033605956",
      "employeeId": "198204236429",
      "firstName": "Infällbar",
      "lastName": "Träldomsok"
  },
  {
      "partnerNumberIndividual": "0033609368",
      "employeeId": "198204249422",
      "firstName": "Inlösbar",
      "lastName": "Stridsvagnsduell"
  },
  {
      "partnerNumberIndividual": "0033613156",
      "employeeId": "198204260528",
      "firstName": "Dualistisk",
      "lastName": "Stenbädd"
  },
  {
      "partnerNumberIndividual": "0033613191",
      "employeeId": "198204260221",
      "firstName": "Förvärkt",
      "lastName": "Taiwanvisseltrast"
  },
  {
      "partnerNumberIndividual": "0033614578",
      "employeeId": "198204276227",
      "firstName": "Tvåhändig",
      "lastName": "Upprullningsmaskin"
  },
  {
      "partnerNumberIndividual": "0033614609",
      "employeeId": "198204277423",
      "firstName": "Israelvänlig",
      "lastName": "Ryssvinter"
  },
  {
      "partnerNumberIndividual": "0033615098",
      "employeeId": "198204278629",
      "firstName": "Tioårig",
      "lastName": "Teknikterm"
  },
  {
      "partnerNumberIndividual": "0033624134",
      "employeeId": "198204013729",
      "firstName": "Inbördeskrigliknande",
      "lastName": "Motocross"
  },
  {
      "partnerNumberIndividual": "0033627913",
      "employeeId": "198204028222",
      "firstName": "Känd",
      "lastName": "Borrspån"
  },
  {
      "partnerNumberIndividual": "0033628513",
      "employeeId": "198204032729",
      "firstName": "Hemtrevlig",
      "lastName": "Privatägdbro"
  },
  {
      "partnerNumberIndividual": "0033633879",
      "employeeId": "198705098971",
      "firstName": "Konstintresserad",
      "lastName": "Bravuraria"
  },
  {
      "partnerNumberIndividual": "0033634881",
      "employeeId": "198705229477",
      "firstName": "Pleuritisk",
      "lastName": "Tandfyllningsmaterial"
  },
  {
      "partnerNumberIndividual": "0033636597",
      "employeeId": "198204068921",
      "firstName": "Labyrintisk",
      "lastName": "Vichyregering"
  },
  {
      "partnerNumberIndividual": "0033636986",
      "employeeId": "198204069820",
      "firstName": "Kostnadspolitisk",
      "lastName": "Börsspekulant"
  },
  {
      "partnerNumberIndividual": "0033637942",
      "employeeId": "198204075520",
      "firstName": "Gott",
      "lastName": "Naturligläggning"
  },
  {
      "partnerNumberIndividual": "0033637965",
      "employeeId": "198204075827",
      "firstName": "Srilankesisk",
      "lastName": "Medvetandeström"
  },
  {
      "partnerNumberIndividual": "0033637990",
      "employeeId": "198204075223",
      "firstName": "Krympsäker",
      "lastName": "Blodvätska"
  },
  {
      "partnerNumberIndividual": "0033638214",
      "employeeId": "198708198273",
      "firstName": "Rödbrokig",
      "lastName": "Kryckkäpp"
  },
  {
      "partnerNumberIndividual": "0033642511",
      "employeeId": "198205092326",
      "firstName": "Proforma",
      "lastName": "Potage"
  },
  {
      "partnerNumberIndividual": "0033642585",
      "employeeId": "198205092623",
      "firstName": "Helkul",
      "lastName": "Cyanidlutning"
  },
  {
      "partnerNumberIndividual": "0033642846",
      "employeeId": "198205092029",
      "firstName": "Osystematisk",
      "lastName": "Enmiljon"
  },
  {
      "partnerNumberIndividual": "0033644813",
      "employeeId": "198803138984",
      "firstName": "Datormanipulerad",
      "lastName": "Operettsångerska"
  },
  {
      "partnerNumberIndividual": "0033645299",
      "employeeId": "198803303075",
      "firstName": "Uzbekistansk",
      "lastName": "Jackfält"
  },
  {
      "partnerNumberIndividual": "0033645403",
      "employeeId": "198803019986",
      "firstName": "Uppvispad",
      "lastName": "Hjärtskiljevägg"
  },
  {
      "partnerNumberIndividual": "0033645971",
      "employeeId": "198804219387",
      "firstName": "Underkuvande",
      "lastName": "Vinylgummi"
  },
  {
      "partnerNumberIndividual": "0033648798",
      "employeeId": "198807053783",
      "firstName": "Högernationalistisk",
      "lastName": "Halvapa"
  },
  {
      "partnerNumberIndividual": "0033649718",
      "employeeId": "198205128229",
      "firstName": "Postakut",
      "lastName": "Syre"
  },
  {
      "partnerNumberIndividual": "0033649862",
      "employeeId": "198809029880",
      "firstName": "Däst",
      "lastName": "Jordmån"
  },
  {
      "partnerNumberIndividual": "0033650305",
      "employeeId": "198810267289",
      "firstName": "Modellanpassad",
      "lastName": "Stångstål"
  },
  {
      "partnerNumberIndividual": "0033651661",
      "employeeId": "198205136321",
      "firstName": "Välskapad",
      "lastName": "Kumin"
  },
  {
      "partnerNumberIndividual": "0033655148",
      "employeeId": "199001272294",
      "firstName": "Oljerik",
      "lastName": "Stålverksarbetare"
  },
  {
      "partnerNumberIndividual": "0033655162",
      "employeeId": "198205140224",
      "firstName": "Atypisk",
      "lastName": "Öppenvårdsbesök"
  },
  {
      "partnerNumberIndividual": "0033656188",
      "employeeId": "198205155321",
      "firstName": "Renad",
      "lastName": "Klosterföreståndarinna"
  },
  {
      "partnerNumberIndividual": "0033656213",
      "employeeId": "199010046994",
      "firstName": "Iglädjerus",
      "lastName": "Resonansenergi"
  },
  {
      "partnerNumberIndividual": "0033656218",
      "employeeId": "198205155628",
      "firstName": "Genomandad",
      "lastName": "Manchongsida"
  },
  {
      "partnerNumberIndividual": "0033659796",
      "employeeId": "198205175824",
      "firstName": "Utdömd",
      "lastName": "Störrevitstrupigtukan"
  },
  {
      "partnerNumberIndividual": "0033660961",
      "employeeId": "198205183927",
      "firstName": "Förvägen",
      "lastName": "Tandfyllningsmaterial"
  },
  {
      "partnerNumberIndividual": "0033663649",
      "employeeId": "198205196929",
      "firstName": "Saknad",
      "lastName": "Längdskidlopp"
  },
  {
      "partnerNumberIndividual": "0033664463",
      "employeeId": "198205199329",
      "firstName": "Matrelaterad",
      "lastName": "Paperback"
  },
  {
      "partnerNumberIndividual": "0033664996",
      "employeeId": "198205202925",
      "firstName": "Livegen",
      "lastName": "Snöplighet"
  },
  {
      "partnerNumberIndividual": "0033665461",
      "employeeId": "198205204723",
      "firstName": "Medhjälpande",
      "lastName": "Grönaracari"
  },
  {
      "partnerNumberIndividual": "0033669325",
      "employeeId": "198205224028",
      "firstName": "Hanseatisk",
      "lastName": "Ditforsling"
  },
  {
      "partnerNumberIndividual": "0033669765",
      "employeeId": "198205226122",
      "firstName": "Sagolik",
      "lastName": "Manligfullmäktigeledamot"
  },
  {
      "partnerNumberIndividual": "0033671538",
      "employeeId": "198205239422",
      "firstName": "Zoografisk",
      "lastName": "Smågnat"
  },
  {
      "partnerNumberIndividual": "0033671541",
      "employeeId": "198205239729",
      "firstName": "Kortskaftad",
      "lastName": "Magnesiumstearat"
  },
  {
      "partnerNumberIndividual": "0033672723",
      "employeeId": "198205246922",
      "firstName": "Genotypisk",
      "lastName": "Sidovinst"
  },
  {
      "partnerNumberIndividual": "0033673228",
      "employeeId": "198205252623",
      "firstName": "Eolitisk",
      "lastName": "Småstiltatryck"
  },
  {
      "partnerNumberIndividual": "0033674775",
      "employeeId": "198205250825",
      "firstName": "Heldags",
      "lastName": "Cyanfettsyror"
  },
  {
      "partnerNumberIndividual": "0033675047",
      "employeeId": "198205250221",
      "firstName": "Mellan",
      "lastName": "Politisksociologi"
  },
  {
      "partnerNumberIndividual": "0033676586",
      "employeeId": "198205268025",
      "firstName": "Tariffmässig",
      "lastName": "Bananglass"
  },
  {
      "partnerNumberIndividual": "0033677164",
      "employeeId": "198205272522",
      "firstName": "Grammofon",
      "lastName": "Färgseparation"
  },
  {
      "partnerNumberIndividual": "0033685291",
      "employeeId": "198205017323",
      "firstName": "Prelatensisk",
      "lastName": "Osthyvelprincip"
  },
  {
      "partnerNumberIndividual": "0033685509",
      "employeeId": "198205018222",
      "firstName": "Ganskakort",
      "lastName": "Fritidsbåtbyggare"
  },
  {
      "partnerNumberIndividual": "0033685909",
      "employeeId": "198205022422",
      "firstName": "Kortskaftad",
      "lastName": "Offshoreverksamhet"
  },
  {
      "partnerNumberIndividual": "0033686233",
      "employeeId": "198205023024",
      "firstName": "Urtjatad",
      "lastName": "Grågumpadträdseglare"
  },
  {
      "partnerNumberIndividual": "0033688269",
      "employeeId": "198205037826",
      "firstName": "Pressad",
      "lastName": "Alefnoll"
  },
  {
      "partnerNumberIndividual": "0033688658",
      "employeeId": "198205030821",
      "firstName": "Saltbeständig",
      "lastName": "Introduktionspris"
  },
  {
      "partnerNumberIndividual": "0033689226",
      "employeeId": "198205044723",
      "firstName": "Tillvitas",
      "lastName": "Förkänning"
  },
  {
      "partnerNumberIndividual": "0033689570",
      "employeeId": "198205046223",
      "firstName": "Ful",
      "lastName": "Klepsydra"
  },
  {
      "partnerNumberIndividual": "0033691875",
      "employeeId": "198205065223",
      "firstName": "Malisk",
      "lastName": "Kritsnöre"
  },
  {
      "partnerNumberIndividual": "0033692521",
      "employeeId": "198205072724",
      "firstName": "Sträckt",
      "lastName": "Tamgås"
  },
  {
      "partnerNumberIndividual": "0033692968",
      "employeeId": "198205070025",
      "firstName": "Sopig",
      "lastName": "Migrationsteori"
  },
  {
      "partnerNumberIndividual": "0033693278",
      "employeeId": "198205086328",
      "firstName": "Intekunna",
      "lastName": "Pumpning"
  },
  {
      "partnerNumberIndividual": "0033715398",
      "employeeId": "198504156954",
      "firstName": "Senromersk",
      "lastName": "Silvervinge"
  },
  {
      "partnerNumberIndividual": "0033720365",
      "employeeId": "198505200553",
      "firstName": "Ocensurerad",
      "lastName": "Chancroid"
  },
  {
      "partnerNumberIndividual": "0033723296",
      "employeeId": "198704176471",
      "firstName": "Akter",
      "lastName": "Matrisfilning"
  },
  {
      "partnerNumberIndividual": "0033724143",
      "employeeId": "198407022246",
      "firstName": "Förbikörande",
      "lastName": "Väggborrmaskin"
  },
  {
      "partnerNumberIndividual": "0033725670",
      "employeeId": "198301146935",
      "firstName": "Fumlande",
      "lastName": "Medicinutgift"
  },
  {
      "partnerNumberIndividual": "0033727422",
      "employeeId": "198506268955",
      "firstName": "Pacifistisk",
      "lastName": "Trådlöstelefon"
  },
  {
      "partnerNumberIndividual": "0033727639",
      "employeeId": "198609169761",
      "firstName": "Struntfin",
      "lastName": "Utsago"
  },
  {
      "partnerNumberIndividual": "0033727910",
      "employeeId": "198202163922",
      "firstName": "Reformvänlig",
      "lastName": "Jetstråle"
  },
  {
      "partnerNumberIndividual": "0033728151",
      "employeeId": "198808072386",
      "firstName": "Färdigutbildad",
      "lastName": "Fregattfågel"
  },
  {
      "partnerNumberIndividual": "0033728773",
      "employeeId": "198406122948",
      "firstName": "Risig",
      "lastName": "Resonansneutron"
  },
  {
      "partnerNumberIndividual": "0033729713",
      "employeeId": "198603229165",
      "firstName": "Mångstavig",
      "lastName": "Allaktivist"
  },
  {
      "partnerNumberIndividual": "0033731374",
      "employeeId": "198411070843",
      "firstName": "Översvinnelig",
      "lastName": "Örlogsbesök"
  },
  {
      "partnerNumberIndividual": "0033731485",
      "employeeId": "198507064254",
      "firstName": "Trendmedveten",
      "lastName": "Gurkhakniv"
  },
  {
      "partnerNumberIndividual": "0033731570",
      "employeeId": "198508095851",
      "firstName": "Anemometrisk",
      "lastName": "Kylslinga"
  },
  {
      "partnerNumberIndividual": "0033732885",
      "employeeId": "198605082562",
      "firstName": "Likvärdigmed",
      "lastName": "Sågverksflis"
  },
  {
      "partnerNumberIndividual": "0033733264",
      "employeeId": "198004193705",
      "firstName": "Artskild",
      "lastName": "Chokladtyrann"
  },
  {
      "partnerNumberIndividual": "0033733615",
      "employeeId": "198509219351",
      "firstName": "Alldaglig",
      "lastName": "Ledarställning"
  },
  {
      "partnerNumberIndividual": "0033733925",
      "employeeId": "198611217269",
      "firstName": "Grovmalen",
      "lastName": "Envisman"
  },
  {
      "partnerNumberIndividual": "0033734214",
      "employeeId": "198302162832",
      "firstName": "Bekymmersfri",
      "lastName": "Sandnarv"
  },
  {
      "partnerNumberIndividual": "0033735051",
      "employeeId": "198611022867",
      "firstName": "Enaxlad",
      "lastName": "Sommarväder"
  },
  {
      "partnerNumberIndividual": "0033735208",
      "employeeId": "198606052960",
      "firstName": "Trädbeskuggad",
      "lastName": "Konceptbevis"
  },
  {
      "partnerNumberIndividual": "0033736950",
      "employeeId": "198502023255",
      "firstName": "Illistig",
      "lastName": "Därvaro"
  },
  {
      "partnerNumberIndividual": "0033737281",
      "employeeId": "198107088513",
      "firstName": "Kategorisk",
      "lastName": "Kunskapsspridning"
  },
  {
      "partnerNumberIndividual": "0033737749",
      "employeeId": "198109123318",
      "firstName": "Rockklädd",
      "lastName": "Språkdiskriminering"
  },
  {
      "partnerNumberIndividual": "0033737892",
      "employeeId": "198507242652",
      "firstName": "Konstintresserad",
      "lastName": "Bränslesamlare"
  },
  {
      "partnerNumberIndividual": "0033739341",
      "employeeId": "198504212351",
      "firstName": "Oljeriven",
      "lastName": "Landet"
  },
  {
      "partnerNumberIndividual": "0033739346",
      "employeeId": "198506204752",
      "firstName": "Utbränd",
      "lastName": "Konventionalstraff"
  },
  {
      "partnerNumberIndividual": "0033739478",
      "employeeId": "198607015263",
      "firstName": "Utsmyckad",
      "lastName": "Tjänsteman"
  },
  {
      "partnerNumberIndividual": "0033739679",
      "employeeId": "198003227207",
      "firstName": "Sammanhållande",
      "lastName": "Expojkvän"
  },
  {
      "partnerNumberIndividual": "0033740118",
      "employeeId": "198508190454",
      "firstName": "Blåklädd",
      "lastName": "Långpassning"
  },
  {
      "partnerNumberIndividual": "0033740643",
      "employeeId": "198801228589",
      "firstName": "Snällmot",
      "lastName": "Klibbsticka"
  },
  {
      "partnerNumberIndividual": "0033741227",
      "employeeId": "198606272667",
      "firstName": "Hemtrevlig",
      "lastName": "Omvikningsstål"
  },
  {
      "partnerNumberIndividual": "0033741525",
      "employeeId": "198003094300",
      "firstName": "Spikrak",
      "lastName": "Stridsvagnsduell"
  },
  {
      "partnerNumberIndividual": "0033741546",
      "employeeId": "198008041900",
      "firstName": "Prasslande",
      "lastName": "Getost"
  },
  {
      "partnerNumberIndividual": "0033742437",
      "employeeId": "198207087423",
      "firstName": "Sentimental",
      "lastName": "Satellitbild"
  },
  {
      "partnerNumberIndividual": "0033745912",
      "employeeId": "198602265665",
      "firstName": "Didaktisk",
      "lastName": "Penningmarknadslån"
  },
  {
      "partnerNumberIndividual": "0033746514",
      "employeeId": "198609107365",
      "firstName": "Okollegial",
      "lastName": "Affärsknep"
  },
  {
      "partnerNumberIndividual": "0033748300",
      "employeeId": "198406208549",
      "firstName": "Tiohörnig",
      "lastName": "Vattenstäkra"
  },
  {
      "partnerNumberIndividual": "0033748454",
      "employeeId": "198605049462",
      "firstName": "Keff",
      "lastName": "Platå"
  },
  {
      "partnerNumberIndividual": "0033749102",
      "employeeId": "198610012968",
      "firstName": "Lerbestruken",
      "lastName": "Returströmbana"
  },
  {
      "partnerNumberIndividual": "0033749137",
      "employeeId": "198205108924",
      "firstName": "Ospenderad",
      "lastName": "Äktenskapsfrekvens"
  },
  {
      "partnerNumberIndividual": "0033749239",
      "employeeId": "198510122552",
      "firstName": "Basilar",
      "lastName": "Fotbollskänsla"
  },
  {
      "partnerNumberIndividual": "0033749331",
      "employeeId": "198007138103",
      "firstName": "Tillvitas",
      "lastName": "Kolpulvereldning"
  },
  {
      "partnerNumberIndividual": "0033749752",
      "employeeId": "198310049732",
      "firstName": "Piskande",
      "lastName": "Sjöborre"
  },
  {
      "partnerNumberIndividual": "0033750681",
      "employeeId": "198505022155",
      "firstName": "Taklös",
      "lastName": "Variabilitet"
  },
  {
      "partnerNumberIndividual": "0033750772",
      "employeeId": "198601188264",
      "firstName": "Prelatensisk",
      "lastName": "Kryssunderbramsegel"
  },
  {
      "partnerNumberIndividual": "0033751247",
      "employeeId": "198202122027",
      "firstName": "Rosafärgad",
      "lastName": "Störresultanspett"
  },
  {
      "partnerNumberIndividual": "0033751264",
      "employeeId": "198209094526",
      "firstName": "Strömsnål",
      "lastName": "Svartstreckadhonungsfågel"
  },
  {
      "partnerNumberIndividual": "0033751496",
      "employeeId": "198604266166",
      "firstName": "Kiselhaltig",
      "lastName": "Fregattfågel"
  },
  {
      "partnerNumberIndividual": "0033751514",
      "employeeId": "198605242869",
      "firstName": "Pyroforisk",
      "lastName": "Chokladtyrann"
  },
  {
      "partnerNumberIndividual": "0033751627",
      "employeeId": "198610208566",
      "firstName": "Tillvitas",
      "lastName": "Platå"
  },
  {
      "partnerNumberIndividual": "0033751798",
      "employeeId": "198008059100",
      "firstName": "Generell",
      "lastName": "Polarexpedition"
  },
  {
      "partnerNumberIndividual": "0033752581",
      "employeeId": "198809084083",
      "firstName": "Tiodubbel",
      "lastName": "Molekylärbiologi"
  },
  {
      "partnerNumberIndividual": "0033753026",
      "employeeId": "198303216132",
      "firstName": "Senromantisk",
      "lastName": "Frittinträde"
  },
  {
      "partnerNumberIndividual": "0033753284",
      "employeeId": "198406139843",
      "firstName": "Mestavlägset",
      "lastName": "Skändning"
  },
  {
      "partnerNumberIndividual": "0033753513",
      "employeeId": "198104263713",
      "firstName": "Närbesläktad",
      "lastName": "Ränteparitetsteori"
  },
  {
      "partnerNumberIndividual": "0033754078",
      "employeeId": "198604202864",
      "firstName": "Genotypisk",
      "lastName": "Guldsnodd"
  },
  {
      "partnerNumberIndividual": "0033754896",
      "employeeId": "198603144760",
      "firstName": "Insufficient",
      "lastName": "Teknikterm"
  },
  {
      "partnerNumberIndividual": "0033755596",
      "employeeId": "198608142066",
      "firstName": "Rörelsemässig",
      "lastName": "Födelsekyrka"
  },
  {
      "partnerNumberIndividual": "0033755689",
      "employeeId": "198105182615",
      "firstName": "Sirapsaktig",
      "lastName": "Gratulationskort"
  },
  {
      "partnerNumberIndividual": "0033757531",
      "employeeId": "198302232130",
      "firstName": "Avtäckt",
      "lastName": "Tempocykel"
  },
  {
      "partnerNumberIndividual": "0033757594",
      "employeeId": "198103067016",
      "firstName": "Ospenderad",
      "lastName": "Yrkesbrev"
  },
  {
      "partnerNumberIndividual": "0033758705",
      "employeeId": "198007228508",
      "firstName": "Vördad",
      "lastName": "Mårdhår"
  },
  {
      "partnerNumberIndividual": "0033758899",
      "employeeId": "198509222652",
      "firstName": "Översvinnelig",
      "lastName": "Fissionsbränsle"
  },
  {
      "partnerNumberIndividual": "0033759325",
      "employeeId": "198508256156",
      "firstName": "Sim",
      "lastName": "Nonsinelaudeapprobatur"
  },
  {
      "partnerNumberIndividual": "0033760947",
      "employeeId": "198507148958",
      "firstName": "Leklysten",
      "lastName": "Statsägande"
  },
  {
      "partnerNumberIndividual": "0033761207",
      "employeeId": "198811222887",
      "firstName": "Piprökande",
      "lastName": "Tangentialturbin"
  },
  {
      "partnerNumberIndividual": "0033761286",
      "employeeId": "198008265806",
      "firstName": "Krympsäker",
      "lastName": "Gramaner"
  },
  {
      "partnerNumberIndividual": "0033761780",
      "employeeId": "198209253023",
      "firstName": "Doxologisk",
      "lastName": "Parisiska"
  },
  {
      "partnerNumberIndividual": "0033762102",
      "employeeId": "198606156365",
      "firstName": "Självcentrerande",
      "lastName": "Lagändring"
  },
  {
      "partnerNumberIndividual": "0033762320",
      "employeeId": "198501257458",
      "firstName": "Färdigsydd",
      "lastName": "Toppvinkel"
  },
  {
      "partnerNumberIndividual": "0033762837",
      "employeeId": "198602204763",
      "firstName": "Syndfri",
      "lastName": "Konservutrustning"
  },
  {
      "partnerNumberIndividual": "0033763573",
      "employeeId": "198611195267",
      "firstName": "Urfälld",
      "lastName": "Utsago"
  },
  {
      "partnerNumberIndividual": "0033764093",
      "employeeId": "198607110460",
      "firstName": "Interkontinental",
      "lastName": "Gratispassagerare"
  },
  {
      "partnerNumberIndividual": "0033764151",
      "employeeId": "198602250261",
      "firstName": "Utdömd",
      "lastName": "Rödnäbbadfrankolin"
  },
  {
      "partnerNumberIndividual": "0033764649",
      "employeeId": "198608137868",
      "firstName": "Solar",
      "lastName": "Aneroxi"
  },
  {
      "partnerNumberIndividual": "0033764732",
      "employeeId": "198611222368",
      "firstName": "Mörkhårig",
      "lastName": "Dvärgmalkoha"
  },
  {
      "partnerNumberIndividual": "0033765137",
      "employeeId": "198510101754",
      "firstName": "Slumpmässig",
      "lastName": "Jägaresamlare"
  },
  {
      "partnerNumberIndividual": "0033765879",
      "employeeId": "198603033260",
      "firstName": "Bonusberättigad",
      "lastName": "Kryssunderbramsegel"
  },
  {
      "partnerNumberIndividual": "0033766043",
      "employeeId": "198609112464",
      "firstName": "Blårutig",
      "lastName": "Plausibilitet"
  },
  {
      "partnerNumberIndividual": "0033766593",
      "employeeId": "198605103962",
      "firstName": "Lokomotorisk",
      "lastName": "Apokryfiskbok"
  },
  {
      "partnerNumberIndividual": "0033767400",
      "employeeId": "198602065263",
      "firstName": "Heltmotsatt",
      "lastName": "Driftsättning"
  },
  {
      "partnerNumberIndividual": "0033768094",
      "employeeId": "198409018846",
      "firstName": "Marxist",
      "lastName": "Nerslagning"
  },
  {
      "partnerNumberIndividual": "0033768560",
      "employeeId": "198607238568",
      "firstName": "Välställd",
      "lastName": "Synkroniserare"
  },
  {
      "partnerNumberIndividual": "0033770094",
      "employeeId": "198201041921",
      "firstName": "Murgrönebekransad",
      "lastName": "Medhjälpare"
  },
  {
      "partnerNumberIndividual": "0033770854",
      "employeeId": "198102171611",
      "firstName": "Inkräktande",
      "lastName": "Agronomkollega"
  },
  {
      "partnerNumberIndividual": "0033770939",
      "employeeId": "198609237261",
      "firstName": "Jobbig",
      "lastName": "Utsago"
  },
  {
      "partnerNumberIndividual": "0033771600",
      "employeeId": "198611057863",
      "firstName": "Direktörsaktig",
      "lastName": "Lastnät"
  },
  {
      "partnerNumberIndividual": "0033772167",
      "employeeId": "198601166260",
      "firstName": "Heterosexistisk",
      "lastName": "Utländskmoderbolag"
  },
  {
      "partnerNumberIndividual": "0033772711",
      "employeeId": "198206083522",
      "firstName": "Framröstad",
      "lastName": "Blåtjocknäbb"
  },
  {
      "partnerNumberIndividual": "0033772750",
      "employeeId": "198305128038",
      "firstName": "Staccato",
      "lastName": "Älsklingen"
  },
  {
      "partnerNumberIndividual": "0033773766",
      "employeeId": "198503166954",
      "firstName": "Guldfärgad",
      "lastName": "Blodvätska"
  },
  {
      "partnerNumberIndividual": "0033773845",
      "employeeId": "198005100204",
      "firstName": "Rödbrokig",
      "lastName": "Cateringverksamhet"
  },
  {
      "partnerNumberIndividual": "0033774802",
      "employeeId": "198801212583",
      "firstName": "Självförhärligande",
      "lastName": "Procentsiffra"
  },
  {
      "partnerNumberIndividual": "0033775455",
      "employeeId": "198604092869",
      "firstName": "Flamhärdig",
      "lastName": "Skivproducent"
  },
  {
      "partnerNumberIndividual": "0033775651",
      "employeeId": "198503209754",
      "firstName": "Silver",
      "lastName": "Bukbandage"
  },
  {
      "partnerNumberIndividual": "0033777728",
      "employeeId": "198409157149",
      "firstName": "Självsvåldig",
      "lastName": "Upprullningsmaskin"
  },
  {
      "partnerNumberIndividual": "0033778257",
      "employeeId": "198507236951",
      "firstName": "Svårbemästrad",
      "lastName": "Puaiohi"
  },
  {
      "partnerNumberIndividual": "0033778260",
      "employeeId": "198511045059",
      "firstName": "Levrad",
      "lastName": "Huvudsajt"
  },
  {
      "partnerNumberIndividual": "0033778805",
      "employeeId": "198509148550",
      "firstName": "Oför",
      "lastName": "Kortärm"
  },
  {
      "partnerNumberIndividual": "0033779054",
      "employeeId": "198603159867",
      "firstName": "Herrskapsliknande",
      "lastName": "Inkassoperiod"
  },
  {
      "partnerNumberIndividual": "0033779316",
      "employeeId": "198205030227",
      "firstName": "Metalltäckt",
      "lastName": "Bataljon"
  },
  {
      "partnerNumberIndividual": "0033779874",
      "employeeId": "198401062347",
      "firstName": "Flamhärdig",
      "lastName": "Kricketlag"
  },
  {
      "partnerNumberIndividual": "0033780014",
      "employeeId": "198209184327",
      "firstName": "Proforma",
      "lastName": "Baggbölare"
  },
  {
      "partnerNumberIndividual": "0033780778",
      "employeeId": "198506052557",
      "firstName": "Självstyrd",
      "lastName": "Algtoxin"
  },
  {
      "partnerNumberIndividual": "0033781291",
      "employeeId": "198003072603",
      "firstName": "Synergisk",
      "lastName": "ERA"
  },
  {
      "partnerNumberIndividual": "0033781670",
      "employeeId": "198605098261",
      "firstName": "Avgrundslik",
      "lastName": "Stadshusmöte"
  },
  {
      "partnerNumberIndividual": "0033782012",
      "employeeId": "198608159862",
      "firstName": "Oljeproducerande",
      "lastName": "Ekosofi"
  },
  {
      "partnerNumberIndividual": "0033782148",
      "employeeId": "198606157264",
      "firstName": "Pyroforisk",
      "lastName": "Ledningsmaterialavsilver"
  },
  {
      "partnerNumberIndividual": "0033783004",
      "employeeId": "198501192358",
      "firstName": "Enhjulig",
      "lastName": "Yrkesgrupp"
  },
  {
      "partnerNumberIndividual": "0033783711",
      "employeeId": "198605208563",
      "firstName": "Termostatreglerad",
      "lastName": "Bestrålningstid"
  },
  {
      "partnerNumberIndividual": "0033784452",
      "employeeId": "198606092461",
      "firstName": "EUklassad",
      "lastName": "Snickare"
  },
  {
      "partnerNumberIndividual": "0033785861",
      "employeeId": "198607064360",
      "firstName": "Geotermisk",
      "lastName": "Fettfärg"
  },
  {
      "partnerNumberIndividual": "0033789065",
      "employeeId": "198108189112",
      "firstName": "Vedisk",
      "lastName": "Försnillande"
  },
  {
      "partnerNumberIndividual": "0033789152",
      "employeeId": "198605209769",
      "firstName": "Vördad",
      "lastName": "Exorcist"
  },
  {
      "partnerNumberIndividual": "0033789319",
      "employeeId": "198611153969",
      "firstName": "Mittenavoktober",
      "lastName": "Frostförsäkring"
  },
  {
      "partnerNumberIndividual": "0033791079",
      "employeeId": "198606066564",
      "firstName": "Denotativ",
      "lastName": "Ekosofi"
  },
  {
      "partnerNumberIndividual": "0033791478",
      "employeeId": "198610232665",
      "firstName": "Påfrifot",
      "lastName": "Tursam"
  },
  {
      "partnerNumberIndividual": "0033791787",
      "employeeId": "198602128269",
      "firstName": "Basilar",
      "lastName": "Förhörsledare"
  },
  {
      "partnerNumberIndividual": "0033791876",
      "employeeId": "198610232368",
      "firstName": "Färdigutbildad",
      "lastName": "Längdskidlopp"
  },
  {
      "partnerNumberIndividual": "0033792740",
      "employeeId": "198608190263",
      "firstName": "Kraft",
      "lastName": "Vitaminbrist"
  },
  {
      "partnerNumberIndividual": "0033793141",
      "employeeId": "198001203200",
      "firstName": "Rysk",
      "lastName": "Ostronodling"
  },
  {
      "partnerNumberIndividual": "0033793239",
      "employeeId": "198404120647",
      "firstName": "Fyradörrars",
      "lastName": "Tomgångsström"
  },
  {
      "partnerNumberIndividual": "0033794087",
      "employeeId": "198002103102",
      "firstName": "Kymig",
      "lastName": "Årsöversikt"
  },
  {
      "partnerNumberIndividual": "0033794420",
      "employeeId": "198403099941",
      "firstName": "Interatomär",
      "lastName": "Ljusbågeskydd"
  },
  {
      "partnerNumberIndividual": "0033794426",
      "employeeId": "198401056349",
      "firstName": "Submolekylär",
      "lastName": "Varumärkesrätt"
  },
  {
      "partnerNumberIndividual": "0033794435",
      "employeeId": "198809241386",
      "firstName": "Vördad",
      "lastName": "Dans"
  },
  {
      "partnerNumberIndividual": "0033794585",
      "employeeId": "198606087966",
      "firstName": "Bas",
      "lastName": "Gratulationskort"
  },
  {
      "partnerNumberIndividual": "0033795745",
      "employeeId": "198311254232",
      "firstName": "Samskole",
      "lastName": "Härjare"
  },
  {
      "partnerNumberIndividual": "0033797022",
      "employeeId": "198204033628",
      "firstName": "Helfodrad",
      "lastName": "Nivåfluktuation"
  },
  {
      "partnerNumberIndividual": "0033797057",
      "employeeId": "198110202812",
      "firstName": "Försumlig",
      "lastName": "Australiskhavssula"
  },
  {
      "partnerNumberIndividual": "0033797270",
      "employeeId": "198803053084",
      "firstName": "Pulverlackerad",
      "lastName": "Klibbsticka"
  },
  {
      "partnerNumberIndividual": "0033798274",
      "employeeId": "198603187868",
      "firstName": "Miljövårds",
      "lastName": "Blankspik"
  },
  {
      "partnerNumberIndividual": "0033799875",
      "employeeId": "198606108465",
      "firstName": "Datorinriktad",
      "lastName": "Kryckkäpp"
  },
  {
      "partnerNumberIndividual": "0033799967",
      "employeeId": "198011172809",
      "firstName": "Muslik",
      "lastName": "Gny"
  },
  {
      "partnerNumberIndividual": "0033800013",
      "employeeId": "198605152464",
      "firstName": "Transversell",
      "lastName": "Känsloskala"
  },
  {
      "partnerNumberIndividual": "0033800071",
      "employeeId": "198501102555",
      "firstName": "Inkonsekvent",
      "lastName": "Berylliumjodid"
  },
  {
      "partnerNumberIndividual": "0033800282",
      "employeeId": "198209046922",
      "firstName": "Söndersupen",
      "lastName": "Korsikanskhare"
  },
  {
      "partnerNumberIndividual": "0033801725",
      "employeeId": "198504252456",
      "firstName": "Rysk",
      "lastName": "Återflöde"
  },
  {
      "partnerNumberIndividual": "0033802781",
      "employeeId": "198506232159",
      "firstName": "Alvlik",
      "lastName": "Direktsumma"
  },
  {
      "partnerNumberIndividual": "0033803109",
      "employeeId": "198410173648",
      "firstName": "Häftade",
      "lastName": "Fjädervilt"
  },
  {
      "partnerNumberIndividual": "0033803376",
      "employeeId": "198405057343",
      "firstName": "Sovrad",
      "lastName": "Vichyregering"
  },
  {
      "partnerNumberIndividual": "0033803810",
      "employeeId": "198502266151",
      "firstName": "Monolitisk",
      "lastName": "Broskvävnad"
  },
  {
      "partnerNumberIndividual": "0033804125",
      "employeeId": "198408262643",
      "firstName": "Ytterligare",
      "lastName": "Morgonstjärna"
  },
  {
      "partnerNumberIndividual": "0033804558",
      "employeeId": "198502024758",
      "firstName": "Tangentbordsstyrd",
      "lastName": "Medljud"
  },
  {
      "partnerNumberIndividual": "0033805089",
      "employeeId": "198308216137",
      "firstName": "Översvinnelig",
      "lastName": "Bomullslump"
  },
  {
      "partnerNumberIndividual": "0033807530",
      "employeeId": "198405133847",
      "firstName": "Fumlande",
      "lastName": "Fallskärmspacke"
  },
  {
      "partnerNumberIndividual": "0033807623",
      "employeeId": "198509222959",
      "firstName": "Arkadförsedd",
      "lastName": "Sommarväder"
  },
  {
      "partnerNumberIndividual": "0033807706",
      "employeeId": "198606142761",
      "firstName": "Ejöverlämnad",
      "lastName": "Naturbruk"
  },
  {
      "partnerNumberIndividual": "0033808699",
      "employeeId": "198806149988",
      "firstName": "Förbuskad",
      "lastName": "Australiskhavssula"
  },
  {
      "partnerNumberIndividual": "0033808841",
      "employeeId": "198809189882",
      "firstName": "Trendmedveten",
      "lastName": "Högmedeltiden"
  },
  {
      "partnerNumberIndividual": "0033809561",
      "employeeId": "198511128558",
      "firstName": "Mystagogisk",
      "lastName": "Stilsystem"
  },
  {
      "partnerNumberIndividual": "0033809578",
      "employeeId": "198402023744",
      "firstName": "Knarrig",
      "lastName": "Realtid"
  },
  {
      "partnerNumberIndividual": "0033809870",
      "employeeId": "198109268915",
      "firstName": "Fyrfota",
      "lastName": "Elektroniskhandel"
  },
  {
      "partnerNumberIndividual": "0033810657",
      "employeeId": "198609106466",
      "firstName": "Senantik",
      "lastName": "Öppenvårdsbesök"
  },
  {
      "partnerNumberIndividual": "0033811040",
      "employeeId": "198603213763",
      "firstName": "Allrabäst",
      "lastName": "Dans"
  },
  {
      "partnerNumberIndividual": "0033811484",
      "employeeId": "198605262461",
      "firstName": "Vardagslik",
      "lastName": "Lochiarubra"
  },
  {
      "partnerNumberIndividual": "0033812063",
      "employeeId": "198602266267",
      "firstName": "Självförhärligande",
      "lastName": "Motocross"
  },
  {
      "partnerNumberIndividual": "0033812139",
      "employeeId": "198202170521",
      "firstName": "Senare",
      "lastName": "Vårdutrymme"
  },
  {
      "partnerNumberIndividual": "0033812235",
      "employeeId": "198206167929",
      "firstName": "Utelämnad",
      "lastName": "Plausibilitet"
  },
  {
      "partnerNumberIndividual": "0033813387",
      "employeeId": "198407272049",
      "firstName": "Sammanhållen",
      "lastName": "Ringbrynja"
  },
  {
      "partnerNumberIndividual": "0033814148",
      "employeeId": "198409203547",
      "firstName": "Endomorf",
      "lastName": "Variabilitet"
  },
  {
      "partnerNumberIndividual": "0033814231",
      "employeeId": "198607172569",
      "firstName": "Månadförmånad",
      "lastName": "Marmorflis"
  },
  {
      "partnerNumberIndividual": "0033814235",
      "employeeId": "198608253269",
      "firstName": "Svanslös",
      "lastName": "Palaumarkduva"
  },
  {
      "partnerNumberIndividual": "0033815442",
      "employeeId": "198601103560",
      "firstName": "Styckevis",
      "lastName": "Maltaduva"
  },
  {
      "partnerNumberIndividual": "0033816639",
      "employeeId": "198606087362",
      "firstName": "Tvågångs",
      "lastName": "Applikationsfil"
  },
  {
      "partnerNumberIndividual": "0033816643",
      "employeeId": "198607222562",
      "firstName": "Samlarlysten",
      "lastName": "Blåringadängelfisk"
  },
  {
      "partnerNumberIndividual": "0033817503",
      "employeeId": "198111255215",
      "firstName": "Ormrik",
      "lastName": "Susande"
  },
  {
      "partnerNumberIndividual": "0033817794",
      "employeeId": "198508053959",
      "firstName": "Brandfri",
      "lastName": "Jordbruksekonom"
  },
  {
      "partnerNumberIndividual": "0033818276",
      "employeeId": "198304208237",
      "firstName": "Rankig",
      "lastName": "Manchongsida"
  },
  {
      "partnerNumberIndividual": "0033821791",
      "employeeId": "198203259422",
      "firstName": "Farlig",
      "lastName": "Nonsinelaudeapprobatur"
  },
  {
      "partnerNumberIndividual": "0033822228",
      "employeeId": "198610075668",
      "firstName": "Sydsvensk",
      "lastName": "Ansiktsvenen"
  },
  {
      "partnerNumberIndividual": "0033822520",
      "employeeId": "198602066162",
      "firstName": "Främst",
      "lastName": "Broskvävnad"
  },
  {
      "partnerNumberIndividual": "0033822836",
      "employeeId": "198601082764",
      "firstName": "Membranlik",
      "lastName": "Nickel"
  },
  {
      "partnerNumberIndividual": "0033823840",
      "employeeId": "198806246081",
      "firstName": "Logisk",
      "lastName": "Spraymunstycke"
  },
  {
      "partnerNumberIndividual": "0033824503",
      "employeeId": "198607175265",
      "firstName": "Störtförälskad",
      "lastName": "Klibbsticka"
  },
  {
      "partnerNumberIndividual": "0033825146",
      "employeeId": "198404163746",
      "firstName": "Bonapartistisk",
      "lastName": "Enfrågepolitik"
  },
  {
      "partnerNumberIndividual": "0033825437",
      "employeeId": "198407195844",
      "firstName": "Grynings",
      "lastName": "Cateringverksamhet"
  },
  {
      "partnerNumberIndividual": "0033825787",
      "employeeId": "198005068906",
      "firstName": "Brunaktig",
      "lastName": "Stridsvagnsduell"
  },
  {
      "partnerNumberIndividual": "0033826264",
      "employeeId": "198602218961",
      "firstName": "Omusikalisk",
      "lastName": "Pulsåderförträngning"
  },
  {
      "partnerNumberIndividual": "0033827659",
      "employeeId": "198007067302",
      "firstName": "Darrhänt",
      "lastName": "Dalöppning"
  },
  {
      "partnerNumberIndividual": "0033828720",
      "employeeId": "198404275243",
      "firstName": "Scenvan",
      "lastName": "Brokigplaty"
  },
  {
      "partnerNumberIndividual": "0033829593",
      "employeeId": "198802258981",
      "firstName": "Bortkommenterad",
      "lastName": "Svartstreckadhonungsfågel"
  },
  {
      "partnerNumberIndividual": "0033830267",
      "employeeId": "198110239319",
      "firstName": "Otålmodig",
      "lastName": "Mopsansikte"
  },
  {
      "partnerNumberIndividual": "0033832010",
      "employeeId": "198608115260",
      "firstName": "Obeskrivlig",
      "lastName": "Jetstråle"
  },
  {
      "partnerNumberIndividual": "0033832247",
      "employeeId": "198606045469",
      "firstName": "Självstyrd",
      "lastName": "Vitaminbrist"
  },
  {
      "partnerNumberIndividual": "0033833045",
      "employeeId": "198103197813",
      "firstName": "Respektive",
      "lastName": "Ljusbågeskydd"
  },
  {
      "partnerNumberIndividual": "0033833591",
      "employeeId": "198611042766",
      "firstName": "Färdigsydd",
      "lastName": "Cyanidlutning"
  },
  {
      "partnerNumberIndividual": "0033833879",
      "employeeId": "198806018589",
      "firstName": "Tumultartad",
      "lastName": "Lastnät"
  },
  {
      "partnerNumberIndividual": "0033834266",
      "employeeId": "198811278988",
      "firstName": "Inkontinent",
      "lastName": "Kultje"
  },
  {
      "partnerNumberIndividual": "0033834355",
      "employeeId": "198509042753",
      "firstName": "Mångstavig",
      "lastName": "Aneroxi"
  },
  {
      "partnerNumberIndividual": "0033835543",
      "employeeId": "198808182383",
      "firstName": "Peonisk",
      "lastName": "Fenobarbitol"
  },
  {
      "partnerNumberIndividual": "0033836417",
      "employeeId": "198201058222",
      "firstName": "Beige",
      "lastName": "Kortärm"
  },
  {
      "partnerNumberIndividual": "0033849061",
      "employeeId": "198006119807",
      "firstName": "Silver",
      "lastName": "Ekosofi"
  },
  {
      "partnerNumberIndividual": "0033851019",
      "employeeId": "198408138546",
      "firstName": "Självförhärligande",
      "lastName": "Bradykinin"
  },
  {
      "partnerNumberIndividual": "0033851419",
      "employeeId": "198210202621",
      "firstName": "Frapperande",
      "lastName": "Avbetalningslag"
  },
  {
      "partnerNumberIndividual": "0033851538",
      "employeeId": "198606272964",
      "firstName": "Fatisk",
      "lastName": "Morgonstjärna"
  },
  {
      "partnerNumberIndividual": "0033852945",
      "employeeId": "198601097267",
      "firstName": "Varmrökt",
      "lastName": "Smiley"
  },
  {
      "partnerNumberIndividual": "0033853367",
      "employeeId": "198107268719",
      "firstName": "Radiostyrd",
      "lastName": "Kuhlsfladdermus"
  },
  {
      "partnerNumberIndividual": "0033853859",
      "employeeId": "198103072719",
      "firstName": "Läckande",
      "lastName": "Blystearat"
  },
  {
      "partnerNumberIndividual": "0033854196",
      "employeeId": "198701164272",
      "firstName": "Hemlös",
      "lastName": "Oljekastarbricka"
  },
  {
      "partnerNumberIndividual": "0033856981",
      "employeeId": "198204172822",
      "firstName": "Orätt",
      "lastName": "Bestrålningstid"
  },
  {
      "partnerNumberIndividual": "0033857652",
      "employeeId": "198605220865",
      "firstName": "Snart",
      "lastName": "Justeringavfinansiellöversikt"
  },
  {
      "partnerNumberIndividual": "0033857786",
      "employeeId": "198610234760",
      "firstName": "Asocial",
      "lastName": "Talsymbol"
  },
  {
      "partnerNumberIndividual": "0033858620",
      "employeeId": "198609155265",
      "firstName": "Stillstående",
      "lastName": "Elektrodynamometer"
  },
  {
      "partnerNumberIndividual": "0033859278",
      "employeeId": "198608136365",
      "firstName": "Opublicerad",
      "lastName": "Äkthet"
  },
  {
      "partnerNumberIndividual": "0033860608",
      "employeeId": "198807214088",
      "firstName": "Lämplig",
      "lastName": "Alpsporre"
  },
  {
      "partnerNumberIndividual": "0033861110",
      "employeeId": "198511223755",
      "firstName": "Missbelåten",
      "lastName": "Stopptavla"
  },
  {
      "partnerNumberIndividual": "0033861214",
      "employeeId": "198606156969",
      "firstName": "Taklös",
      "lastName": "Förhandlingspolitik"
  },
  {
      "partnerNumberIndividual": "0033862192",
      "employeeId": "198709029774",
      "firstName": "Flockblommig",
      "lastName": "Risktagning"
  },
  {
      "partnerNumberIndividual": "0033864094",
      "employeeId": "198210154723",
      "firstName": "Knäpptyst",
      "lastName": "Asfaltprimer"
  },
  {
      "partnerNumberIndividual": "0033868849",
      "employeeId": "198107010715",
      "firstName": "Deltid",
      "lastName": "Flampunkt"
  },
  {
      "partnerNumberIndividual": "0033873647",
      "employeeId": "198211031722",
      "firstName": "Vardagslik",
      "lastName": "Yrkesgrupp"
  },
  {
      "partnerNumberIndividual": "0033873849",
      "employeeId": "198303245339",
      "firstName": "Lämpad",
      "lastName": "Felkalkyl"
  },
  {
      "partnerNumberIndividual": "0033874015",
      "employeeId": "198001114001",
      "firstName": "Paradoxal",
      "lastName": "Hukställning"
  },
  {
      "partnerNumberIndividual": "0033886475",
      "employeeId": "198107120712",
      "firstName": "Skenfager",
      "lastName": "Långpassning"
  },
  {
      "partnerNumberIndividual": "0033890201",
      "employeeId": "198811014086",
      "firstName": "Absent",
      "lastName": "Intvålning"
  },
  {
      "partnerNumberIndividual": "0033890470",
      "employeeId": "198910217994",
      "firstName": "Pulserande",
      "lastName": "Heavyband"
  },
  {
      "partnerNumberIndividual": "0033890724",
      "employeeId": "198701094370",
      "firstName": "Vedisk",
      "lastName": "Pupalstadium"
  },
  {
      "partnerNumberIndividual": "0033891103",
      "employeeId": "198707084078",
      "firstName": "Domhavande",
      "lastName": "Allaktivist"
  },
  {
      "partnerNumberIndividual": "0033891418",
      "employeeId": "198709174372",
      "firstName": "Handlingsklar",
      "lastName": "Broskvävnad"
  },
  {
      "partnerNumberIndividual": "0033891915",
      "employeeId": "198803095283",
      "firstName": "Obillig",
      "lastName": "Svetsanordning"
  },
  {
      "partnerNumberIndividual": "0033892668",
      "employeeId": "198810135882",
      "firstName": "Behårad",
      "lastName": "Omvikningsstål"
  },
  {
      "partnerNumberIndividual": "0033892720",
      "employeeId": "198807069482",
      "firstName": "Krisdrabbad",
      "lastName": "Ordanvändning"
  },
  {
      "partnerNumberIndividual": "0033893236",
      "employeeId": "198910176398",
      "firstName": "Förbuskad",
      "lastName": "Marschformation"
  },
  {
      "partnerNumberIndividual": "0033893472",
      "employeeId": "198704044778",
      "firstName": "Agathaltig",
      "lastName": "Dubbelpropellerångare"
  },
  {
      "partnerNumberIndividual": "0033893591",
      "employeeId": "198702107270",
      "firstName": "Halvprivat",
      "lastName": "Nyhetsförmedling"
  },
  {
      "partnerNumberIndividual": "0033893756",
      "employeeId": "198704064370",
      "firstName": "Hermitesk",
      "lastName": "Hjärtskiljevägg"
  },
  {
      "partnerNumberIndividual": "0033894847",
      "employeeId": "198808155280",
      "firstName": "Motsägelsebar",
      "lastName": "Jordbrukszon"
  },
  {
      "partnerNumberIndividual": "0033895178",
      "employeeId": "198808176989",
      "firstName": "Levnadstrött",
      "lastName": "Gjutugn"
  },
  {
      "partnerNumberIndividual": "0033895329",
      "employeeId": "198703249774",
      "firstName": "Sommarvarm",
      "lastName": "Ondtunga"
  },
  {
      "partnerNumberIndividual": "0033895330",
      "employeeId": "198708267573",
      "firstName": "Högernationalistisk",
      "lastName": "Digitalmusik"
  },
  {
      "partnerNumberIndividual": "0033896760",
      "employeeId": "198108237911",
      "firstName": "Bombmattefällande",
      "lastName": "Öljätte"
  },
  {
      "partnerNumberIndividual": "0033897051",
      "employeeId": "198902263592",
      "firstName": "Brandfri",
      "lastName": "Världsrekord"
  },
  {
      "partnerNumberIndividual": "0033897827",
      "employeeId": "198711236979",
      "firstName": "Perfekt",
      "lastName": "Luftstrupe"
  },
  {
      "partnerNumberIndividual": "0033898021",
      "employeeId": "198909185798",
      "firstName": "Husdjursetisk",
      "lastName": "Ångstrykjärn"
  },
  {
      "partnerNumberIndividual": "0033898232",
      "employeeId": "198501144755",
      "firstName": "Stillasittande",
      "lastName": "Försnillande"
  },
  {
      "partnerNumberIndividual": "0033898491",
      "employeeId": "198804078684",
      "firstName": "Utsmyckad",
      "lastName": "Ärtprotein"
  },
  {
      "partnerNumberIndividual": "0033898681",
      "employeeId": "198909054093",
      "firstName": "Halvvåt",
      "lastName": "Amöbainfektion"
  },
  {
      "partnerNumberIndividual": "0033898796",
      "employeeId": "198911082595",
      "firstName": "Sociologiskt",
      "lastName": "Standardegenskap"
  },
  {
      "partnerNumberIndividual": "0033898933",
      "employeeId": "198806086982",
      "firstName": "Pektin",
      "lastName": "Våldsgata"
  },
  {
      "partnerNumberIndividual": "0033899218",
      "employeeId": "198702272074",
      "firstName": "Taklös",
      "lastName": "Etikettsfel"
  },
  {
      "partnerNumberIndividual": "0033899388",
      "employeeId": "198708157279",
      "firstName": "Iglädjerus",
      "lastName": "Karttekniker"
  },
  {
      "partnerNumberIndividual": "0033899970",
      "employeeId": "198809014783",
      "firstName": "Matrelaterad",
      "lastName": "Dalöppning"
  },
  {
      "partnerNumberIndividual": "0033900316",
      "employeeId": "198802215882",
      "firstName": "Konkret",
      "lastName": "Dubbelpropellerångare"
  },
  {
      "partnerNumberIndividual": "0033900424",
      "employeeId": "198803157984",
      "firstName": "Påkopplad",
      "lastName": "Fraktionsdestillation"
  },
  {
      "partnerNumberIndividual": "0033900912",
      "employeeId": "198603054365",
      "firstName": "Xeromorfisk",
      "lastName": "Bomullslump"
  },
  {
      "partnerNumberIndividual": "0033902187",
      "employeeId": "198709015872",
      "firstName": "Suggererande",
      "lastName": "Byggjobbare"
  },
  {
      "partnerNumberIndividual": "0033902434",
      "employeeId": "198707028372",
      "firstName": "Mesaktig",
      "lastName": "Drossel"
  },
  {
      "partnerNumberIndividual": "0033902877",
      "employeeId": "198807187284",
      "firstName": "Kråmande",
      "lastName": "Kringkastning"
  },
  {
      "partnerNumberIndividual": "0033903138",
      "employeeId": "198906107894",
      "firstName": "Renochskär",
      "lastName": "Kungsmagnolia"
  },
  {
      "partnerNumberIndividual": "0033903912",
      "employeeId": "198004013804",
      "firstName": "Knäckt",
      "lastName": "Mussla"
  },
  {
      "partnerNumberIndividual": "0033904484",
      "employeeId": "198701205273",
      "firstName": "Finans",
      "lastName": "Representantskapsmöte"
  },
  {
      "partnerNumberIndividual": "0033904520",
      "employeeId": "198808067881",
      "firstName": "Opåverkbar",
      "lastName": "Hårdförman"
  },
  {
      "partnerNumberIndividual": "0033904896",
      "employeeId": "198706156174",
      "firstName": "Oroväckande",
      "lastName": "Karttekniker"
  },
  {
      "partnerNumberIndividual": "0033904952",
      "employeeId": "198808070885",
      "firstName": "Bonusberättigad",
      "lastName": "Normering"
  },
  {
      "partnerNumberIndividual": "0033905045",
      "employeeId": "198911063298",
      "firstName": "Ganskakort",
      "lastName": "Utgiftutanförbudget"
  },
  {
      "partnerNumberIndividual": "0033905279",
      "employeeId": "198708100873",
      "firstName": "Avtäckt",
      "lastName": "Långklagolista"
  },
  {
      "partnerNumberIndividual": "0033905302",
      "employeeId": "198806039981",
      "firstName": "Samlarlysten",
      "lastName": "Enterostomi"
  },
  {
      "partnerNumberIndividual": "0033905590",
      "employeeId": "198701010574",
      "firstName": "Mod",
      "lastName": "Kapacitetsandel"
  },
  {
      "partnerNumberIndividual": "0033905813",
      "employeeId": "198811125288",
      "firstName": "Copyrightfri",
      "lastName": "Ickekärnvapenmakt"
  },
  {
      "partnerNumberIndividual": "0033905871",
      "employeeId": "198802216484",
      "firstName": "Yazidisk",
      "lastName": "Mikrovektor"
  },
  {
      "partnerNumberIndividual": "0033905929",
      "employeeId": "198811236184",
      "firstName": "Inbördeskrigliknande",
      "lastName": "Hike"
  },
  {
      "partnerNumberIndividual": "0033906049",
      "employeeId": "198806030287",
      "firstName": "Bisynkron",
      "lastName": "Ansiktsgymnastik"
  },
  {
      "partnerNumberIndividual": "0033906060",
      "employeeId": "198604073265",
      "firstName": "Tredjefrånslutet",
      "lastName": "Sjöborre"
  },
  {
      "partnerNumberIndividual": "0033906065",
      "employeeId": "198801080881",
      "firstName": "Känd",
      "lastName": "Agronomkollega"
  },
  {
      "partnerNumberIndividual": "0033906154",
      "employeeId": "198806246982",
      "firstName": "Drömfri",
      "lastName": "Arkivdepå"
  },
  {
      "partnerNumberIndividual": "0033906364",
      "employeeId": "198902263295",
      "firstName": "Lättsinnig",
      "lastName": "Eftermiddagsskift"
  },
  {
      "partnerNumberIndividual": "0033906669",
      "employeeId": "198811257289",
      "firstName": "Intetillgänglig",
      "lastName": "Ljusstöparverkstad"
  },
  {
      "partnerNumberIndividual": "0033906900",
      "employeeId": "198808088986",
      "firstName": "Bukig",
      "lastName": "Mussla"
  },
  {
      "partnerNumberIndividual": "0033907669",
      "employeeId": "198905144690",
      "firstName": "Retlig",
      "lastName": "Moskovit"
  },
  {
      "partnerNumberIndividual": "0033908089",
      "employeeId": "198803053985",
      "firstName": "Berusande",
      "lastName": "Dagspress"
  },
  {
      "partnerNumberIndividual": "0033908565",
      "employeeId": "198802020886",
      "firstName": "Storbystad",
      "lastName": "Släthammare"
  },
  {
      "partnerNumberIndividual": "0033908978",
      "employeeId": "198909172796",
      "firstName": "Akrondroplastisk",
      "lastName": "Dykdjup"
  },
  {
      "partnerNumberIndividual": "0033909477",
      "employeeId": "198805256388",
      "firstName": "Peonisk",
      "lastName": "Sommarförkylning"
  },
  {
      "partnerNumberIndividual": "0033909764",
      "employeeId": "198410186343",
      "firstName": "Feber",
      "lastName": "Svartkronadsiska"
  },
  {
      "partnerNumberIndividual": "0033910278",
      "employeeId": "198805027086",
      "firstName": "Esoterisk",
      "lastName": "Fettfärg"
  },
  {
      "partnerNumberIndividual": "0033911217",
      "employeeId": "198801073084",
      "firstName": "Monografisk",
      "lastName": "Ledarställning"
  },
  {
      "partnerNumberIndividual": "0033911370",
      "employeeId": "198702222673",
      "firstName": "Anställd",
      "lastName": "Yrkessjukdom"
  },
  {
      "partnerNumberIndividual": "0033911495",
      "employeeId": "198705098377",
      "firstName": "Tätbebyggd",
      "lastName": "Teknikterm"
  },
  {
      "partnerNumberIndividual": "0033911499",
      "employeeId": "198708047272",
      "firstName": "Behårad",
      "lastName": "Giftdryck"
  },
  {
      "partnerNumberIndividual": "0033911749",
      "employeeId": "198706070573",
      "firstName": "Oljeproducerande",
      "lastName": "Avbärgning"
  },
  {
      "partnerNumberIndividual": "0033912215",
      "employeeId": "198706044073",
      "firstName": "Anamorfisk",
      "lastName": "Kapacitetsandel"
  },
  {
      "partnerNumberIndividual": "0033912767",
      "employeeId": "198804043985",
      "firstName": "Likaberättigad",
      "lastName": "Fotbollskänsla"
  },
  {
      "partnerNumberIndividual": "0033912966",
      "employeeId": "198807027886",
      "firstName": "Georgisk",
      "lastName": "Vapeninköp"
  },
  {
      "partnerNumberIndividual": "0033912984",
      "employeeId": "198910070898",
      "firstName": "Angloholländsk",
      "lastName": "Arkivdepå"
  },
  {
      "partnerNumberIndividual": "0033913123",
      "employeeId": "198910045890",
      "firstName": "Paraguayansk",
      "lastName": "Stortungkg"
  },
  {
      "partnerNumberIndividual": "0033913744",
      "employeeId": "198701254073",
      "firstName": "Ickeaktiv",
      "lastName": "Spolhjul"
  },
  {
      "partnerNumberIndividual": "0033914094",
      "employeeId": "198808067287",
      "firstName": "Obillig",
      "lastName": "Vårdutrymme"
  },
  {
      "partnerNumberIndividual": "0033914604",
      "employeeId": "198906099794",
      "firstName": "Blott",
      "lastName": "Äkthet"
  },
  {
      "partnerNumberIndividual": "0033915648",
      "employeeId": "198907012895",
      "firstName": "Påfrifot",
      "lastName": "Haschsmuggling"
  },
  {
      "partnerNumberIndividual": "0033915719",
      "employeeId": "198811103285",
      "firstName": "Endomorf",
      "lastName": "Cyanidlutning"
  },
  {
      "partnerNumberIndividual": "0033916374",
      "employeeId": "198806064088",
      "firstName": "Sydvästra",
      "lastName": "Genomsnittsvikt"
  },
  {
      "partnerNumberIndividual": "0033916380",
      "employeeId": "198906015691",
      "firstName": "Bionomisk",
      "lastName": "Internetmonster"
  },
  {
      "partnerNumberIndividual": "0033916408",
      "employeeId": "198903030891",
      "firstName": "Behandlande",
      "lastName": "Observatörsvariation"
  },
  {
      "partnerNumberIndividual": "0033916696",
      "employeeId": "198906174795",
      "firstName": "Anställd",
      "lastName": "Handöverfräs"
  },
  {
      "partnerNumberIndividual": "0033916733",
      "employeeId": "198505079452",
      "firstName": "Utomrättslig",
      "lastName": "Härjare"
  },
  {
      "partnerNumberIndividual": "0033917082",
      "employeeId": "198808086287",
      "firstName": "Kabbalistisk",
      "lastName": "Förstärkare"
  },
  {
      "partnerNumberIndividual": "0033917870",
      "employeeId": "198903178294",
      "firstName": "Förtretlig",
      "lastName": "Härjare"
  },
  {
      "partnerNumberIndividual": "0033917922",
      "employeeId": "198802062482",
      "firstName": "Miljövårds",
      "lastName": "Brandriktning"
  },
  {
      "partnerNumberIndividual": "0033918374",
      "employeeId": "198810050289",
      "firstName": "Hemlös",
      "lastName": "Konventdeltagare"
  },
  {
      "partnerNumberIndividual": "0033918749",
      "employeeId": "198803277287",
      "firstName": "Glasögonbärande",
      "lastName": "Stångstål"
  },
  {
      "partnerNumberIndividual": "0033919000",
      "employeeId": "198807167385",
      "firstName": "Biskops",
      "lastName": "Fjärrbehandling"
  },
  {
      "partnerNumberIndividual": "0033919068",
      "employeeId": "198707277276",
      "firstName": "Fullriggad",
      "lastName": "Förkänning"
  },
  {
      "partnerNumberIndividual": "0033919668",
      "employeeId": "198505152952",
      "firstName": "Blygrå",
      "lastName": "Ränteparitetsteori"
  },
  {
      "partnerNumberIndividual": "0033919680",
      "employeeId": "198909212592",
      "firstName": "Förflugen",
      "lastName": "Småstiltatryck"
  },
  {
      "partnerNumberIndividual": "0033919818",
      "employeeId": "198808134186",
      "firstName": "Naiv",
      "lastName": "Hattmakare"
  },
  {
      "partnerNumberIndividual": "0033920473",
      "employeeId": "198805053280",
      "firstName": "Friarmässig",
      "lastName": "Avloppsslam"
  },
  {
      "partnerNumberIndividual": "0033921256",
      "employeeId": "198807278588",
      "firstName": "Styrka",
      "lastName": "Stångjärnshammare"
  },
  {
      "partnerNumberIndividual": "0033921547",
      "employeeId": "198701137476",
      "firstName": "Pulserande",
      "lastName": "Omao"
  },
  {
      "partnerNumberIndividual": "0033921621",
      "employeeId": "198806149384",
      "firstName": "Datorinriktad",
      "lastName": "Opiumfält"
  },
  {
      "partnerNumberIndividual": "0033921962",
      "employeeId": "198703235278",
      "firstName": "Ospenderad",
      "lastName": "Fakturarabatt"
  },
  {
      "partnerNumberIndividual": "0033922026",
      "employeeId": "198703054778",
      "firstName": "Värmealstrande",
      "lastName": "Marknadsfokuserad"
  },
  {
      "partnerNumberIndividual": "0033922376",
      "employeeId": "198908023990",
      "firstName": "Hal",
      "lastName": "Övningsgranat"
  },
  {
      "partnerNumberIndividual": "0033923693",
      "employeeId": "198910273997",
      "firstName": "Obäddad",
      "lastName": "Tvådagarstidning"
  },
  {
      "partnerNumberIndividual": "0033923847",
      "employeeId": "198909029392",
      "firstName": "Kusttillkust",
      "lastName": "Sportlov"
  },
  {
      "partnerNumberIndividual": "0033923983",
      "employeeId": "198805249185",
      "firstName": "Frankfurtbo",
      "lastName": "Allaktivist"
  },
  {
      "partnerNumberIndividual": "0033924342",
      "employeeId": "198910245698",
      "firstName": "Förbuskad",
      "lastName": "Kefalin"
  },
  {
      "partnerNumberIndividual": "0033924531",
      "employeeId": "198904133298",
      "firstName": "Tvungen",
      "lastName": "Medeltidsliv"
  },
  {
      "partnerNumberIndividual": "0033924799",
      "employeeId": "198803226383",
      "firstName": "Olycksfri",
      "lastName": "Månkalender"
  },
  {
      "partnerNumberIndividual": "0033924978",
      "employeeId": "198902152092",
      "firstName": "Högupplösnings",
      "lastName": "Medvetandeström"
  },
  {
      "partnerNumberIndividual": "0033926263",
      "employeeId": "198803060584",
      "firstName": "Arkadförsedd",
      "lastName": "Sjukvårdsinrättning"
  },
  {
      "partnerNumberIndividual": "0033926651",
      "employeeId": "198909263496",
      "firstName": "Ormrik",
      "lastName": "Häxkraft"
  },
  {
      "partnerNumberIndividual": "0033926734",
      "employeeId": "198803144081",
      "firstName": "Bifalls",
      "lastName": "Stenkastare"
  },
  {
      "partnerNumberIndividual": "0033926791",
      "employeeId": "198703269970",
      "firstName": "Urfälld",
      "lastName": "Konjunkturteori"
  },
  {
      "partnerNumberIndividual": "0033927045",
      "employeeId": "198703032170",
      "firstName": "Femtusenårig",
      "lastName": "Konjunkturteori"
  },
  {
      "partnerNumberIndividual": "0033927968",
      "employeeId": "198904022392",
      "firstName": "Förtretlig",
      "lastName": "Landet"
  },
  {
      "partnerNumberIndividual": "0033927970",
      "employeeId": "198907052990",
      "firstName": "Bonapartistisk",
      "lastName": "Kortärm"
  },
  {
      "partnerNumberIndividual": "0033928232",
      "employeeId": "198809123881",
      "firstName": "Avresande",
      "lastName": "Resegaranti"
  },
  {
      "partnerNumberIndividual": "0033929357",
      "employeeId": "198709077971",
      "firstName": "Rosthindrande",
      "lastName": "Prisberäkning"
  },
  {
      "partnerNumberIndividual": "0033929419",
      "employeeId": "198701026273",
      "firstName": "Tuvig",
      "lastName": "Medeltidsliv"
  },
  {
      "partnerNumberIndividual": "0033929858",
      "employeeId": "198704022774",
      "firstName": "Georgisk",
      "lastName": "Bariumprotoxide"
  },
  {
      "partnerNumberIndividual": "0033929906",
      "employeeId": "198705049578",
      "firstName": "Video",
      "lastName": "Ryssvinter"
  },
  {
      "partnerNumberIndividual": "0033929952",
      "employeeId": "198903067091",
      "firstName": "Import",
      "lastName": "Broskvävnad"
  },
  {
      "partnerNumberIndividual": "0033930113",
      "employeeId": "198703256373",
      "firstName": "Grönbete",
      "lastName": "Återbesättning"
  },
  {
      "partnerNumberIndividual": "0033930907",
      "employeeId": "198910066391",
      "firstName": "Flersidig",
      "lastName": "Gratulationskort"
  },
  {
      "partnerNumberIndividual": "0033931299",
      "employeeId": "198202262120",
      "firstName": "Konkurrensduglig",
      "lastName": "Längdskidlopp"
  },
  {
      "partnerNumberIndividual": "0033931751",
      "employeeId": "198810204886",
      "firstName": "Mittenavoktober",
      "lastName": "Kalkaneus"
  },
  {
      "partnerNumberIndividual": "0033931879",
      "employeeId": "198807055580",
      "firstName": "Halvautonom",
      "lastName": "Stenkastare"
  },
  {
      "partnerNumberIndividual": "0033932109",
      "employeeId": "198911029893",
      "firstName": "Taklös",
      "lastName": "Rödöradbulbyl"
  },
  {
      "partnerNumberIndividual": "0033932913",
      "employeeId": "198902236499",
      "firstName": "Vegetabilisk",
      "lastName": "Duodiod"
  },
  {
      "partnerNumberIndividual": "0033933461",
      "employeeId": "198811015588",
      "firstName": "Alldaglig",
      "lastName": "Duodiod"
  },
  {
      "partnerNumberIndividual": "0033933555",
      "employeeId": "198804086489",
      "firstName": "Nattblå",
      "lastName": "Stannosulfid"
  },
  {
      "partnerNumberIndividual": "0033933699",
      "employeeId": "198701206479",
      "firstName": "Polygenisk",
      "lastName": "Plausibilitet"
  },
  {
      "partnerNumberIndividual": "0033933758",
      "employeeId": "198905252899",
      "firstName": "Odämpad",
      "lastName": "Hanjar"
  },
  {
      "partnerNumberIndividual": "0033933824",
      "employeeId": "198706067272",
      "firstName": "Tillföljdav",
      "lastName": "Partistyrelse"
  },
  {
      "partnerNumberIndividual": "0033934428",
      "employeeId": "198811180986",
      "firstName": "Labyrintisk",
      "lastName": "Fuling"
  },
  {
      "partnerNumberIndividual": "0033935203",
      "employeeId": "198809208583",
      "firstName": "Endräktig",
      "lastName": "Självhypnos"
  },
  {
      "partnerNumberIndividual": "0033935286",
      "employeeId": "198905269794",
      "firstName": "Halvlång",
      "lastName": "Svarttaxi"
  },
  {
      "partnerNumberIndividual": "0033935900",
      "employeeId": "198803213084",
      "firstName": "Cartesiansk",
      "lastName": "Svetsomformare"
  },
  {
      "partnerNumberIndividual": "0033936063",
      "employeeId": "198910022394",
      "firstName": "Överens",
      "lastName": "Ickekärnvapenmakt"
  },
  {
      "partnerNumberIndividual": "0033936415",
      "employeeId": "198806243989",
      "firstName": "Cirkusaktig",
      "lastName": "Glansmedel"
  },
  {
      "partnerNumberIndividual": "0033936487",
      "employeeId": "198703275373",
      "firstName": "Giftasvuxen",
      "lastName": "Jordbrukszon"
  },
  {
      "partnerNumberIndividual": "0033936511",
      "employeeId": "198709263274",
      "firstName": "Sportig",
      "lastName": "Huvudsajt"
  },
  {
      "partnerNumberIndividual": "0033936921",
      "employeeId": "198804147984",
      "firstName": "Utdömd",
      "lastName": "Regleringssteg"
  },
  {
      "partnerNumberIndividual": "0033937146",
      "employeeId": "198811147282",
      "firstName": "Övertalningsbar",
      "lastName": "Lärofrihet"
  },
  {
      "partnerNumberIndividual": "0033937546",
      "employeeId": "198907235298",
      "firstName": "Nuklid",
      "lastName": "Fotbollshysteri"
  },
  {
      "partnerNumberIndividual": "0033937559",
      "employeeId": "198705215872",
      "firstName": "Tillföljdav",
      "lastName": "Enfrågepolitik"
  },
  {
      "partnerNumberIndividual": "0033938157",
      "employeeId": "198705214370",
      "firstName": "Hankönad",
      "lastName": "Studieutbyte"
  },
  {
      "partnerNumberIndividual": "0033938413",
      "employeeId": "198806162585",
      "firstName": "Förbikörande",
      "lastName": "Nollningsvecka"
  },
  {
      "partnerNumberIndividual": "0033938703",
      "employeeId": "198911012394",
      "firstName": "Tight",
      "lastName": "Menlöshet"
  },
  {
      "partnerNumberIndividual": "0033938704",
      "employeeId": "198911012691",
      "firstName": "Ametistfärgad",
      "lastName": "Kulvert"
  },
  {
      "partnerNumberIndividual": "0033939495",
      "employeeId": "198201091322",
      "firstName": "Ejavhämtad",
      "lastName": "Magnetmotstånd"
  },
  {
      "partnerNumberIndividual": "0033939673",
      "employeeId": "198806217488",
      "firstName": "Vållande",
      "lastName": "Gitterkvadrat"
  },
  {
      "partnerNumberIndividual": "0033939921",
      "employeeId": "198907100898",
      "firstName": "Stimulerande",
      "lastName": "Inteckningshandling"
  },
  {
      "partnerNumberIndividual": "0033939978",
      "employeeId": "198705277070",
      "firstName": "Självsvåldig",
      "lastName": "Straffverkställighet"
  },
  {
      "partnerNumberIndividual": "0033939989",
      "employeeId": "198808017589",
      "firstName": "Tredjefrånslutet",
      "lastName": "Vattenstäkra"
  },
  {
      "partnerNumberIndividual": "0033940066",
      "employeeId": "198808023280",
      "firstName": "Svenskamerikansk",
      "lastName": "Bradykinin"
  },
  {
      "partnerNumberIndividual": "0033940391",
      "employeeId": "198903233099",
      "firstName": "Cykelburen",
      "lastName": "Blåsvarteufonia"
  },
  {
      "partnerNumberIndividual": "0033940703",
      "employeeId": "198810253982",
      "firstName": "Rödbrokig",
      "lastName": "Förstorare"
  },
  {
      "partnerNumberIndividual": "0033941034",
      "employeeId": "198809098588",
      "firstName": "Imperatorisk",
      "lastName": "Nåtsåg"
  },
  {
      "partnerNumberIndividual": "0033941854",
      "employeeId": "198805054783",
      "firstName": "Barbituratisk",
      "lastName": "Avbärgning"
  },
  {
      "partnerNumberIndividual": "0033942167",
      "employeeId": "198503126255",
      "firstName": "Sim",
      "lastName": "Cateringverksamhet"
  },
  {
      "partnerNumberIndividual": "0033942871",
      "employeeId": "198901199193",
      "firstName": "Virtuos",
      "lastName": "Räntetabell"
  },
  {
      "partnerNumberIndividual": "0033943324",
      "employeeId": "198802099583",
      "firstName": "Tillsammantagen",
      "lastName": "Brandsyn"
  },
  {
      "partnerNumberIndividual": "0033943584",
      "employeeId": "198805138289",
      "firstName": "Självsvåldig",
      "lastName": "Orfeusgärdsmyg"
  },
  {
      "partnerNumberIndividual": "0033944089",
      "employeeId": "198806022185",
      "firstName": "Bisynkron",
      "lastName": "Kortärm"
  },
  {
      "partnerNumberIndividual": "0033944292",
      "employeeId": "198805260588",
      "firstName": "Partitrogen",
      "lastName": "Tyrrhenuggla"
  },
  {
      "partnerNumberIndividual": "0033944307",
      "employeeId": "198703074073",
      "firstName": "Guldbelagd",
      "lastName": "Broelement"
  },
  {
      "partnerNumberIndividual": "0033944351",
      "employeeId": "198710026371",
      "firstName": "Gapskrattande",
      "lastName": "Modem"
  },
  {
      "partnerNumberIndividual": "0033945436",
      "employeeId": "198804036484",
      "firstName": "Struntfin",
      "lastName": "Skifferbrytning"
  },
  {
      "partnerNumberIndividual": "0033945449",
      "employeeId": "198805235283",
      "firstName": "Nyfunnen",
      "lastName": "Dragbult"
  },
  {
      "partnerNumberIndividual": "0033946025",
      "employeeId": "198805164780",
      "firstName": "Rysk",
      "lastName": "Algtoxin"
  },
  {
      "partnerNumberIndividual": "0033946825",
      "employeeId": "198707195577",
      "firstName": "Hanseatisk",
      "lastName": "Endag"
  },
  {
      "partnerNumberIndividual": "0033947281",
      "employeeId": "198706086272",
      "firstName": "Driftsklar",
      "lastName": "Giftdryck"
  },
  {
      "partnerNumberIndividual": "0033947557",
      "employeeId": "198906222990",
      "firstName": "Israelockuperad",
      "lastName": "Bortval"
  },
  {
      "partnerNumberIndividual": "0033947612",
      "employeeId": "198910017899",
      "firstName": "Specialanpassad",
      "lastName": "Systemvetenskap"
  },
  {
      "partnerNumberIndividual": "0033948005",
      "employeeId": "198809257382",
      "firstName": "Antikolonial",
      "lastName": "Teckenstorlek"
  },
  {
      "partnerNumberIndividual": "0033948231",
      "employeeId": "198601032462",
      "firstName": "Lockförsedd",
      "lastName": "Bradykinin"
  },
  {
      "partnerNumberIndividual": "0033948716",
      "employeeId": "198910109191",
      "firstName": "Igenkänningsbar",
      "lastName": "Energiproducerandemineral"
  },
  {
      "partnerNumberIndividual": "0033948717",
      "employeeId": "198910059198",
      "firstName": "Evasiv",
      "lastName": "Köksbänk"
  },
  {
      "partnerNumberIndividual": "0033949214",
      "employeeId": "198907052693",
      "firstName": "Kostnadsfri",
      "lastName": "Etnomusikologi"
  },
  {
      "partnerNumberIndividual": "0033949239",
      "employeeId": "198909082094",
      "firstName": "Obrytlig",
      "lastName": "Flasktransportör"
  },
  {
      "partnerNumberIndividual": "0033949618",
      "employeeId": "198303215837",
      "firstName": "Sovrad",
      "lastName": "Allvarsman"
  },
  {
      "partnerNumberIndividual": "0033949784",
      "employeeId": "198206097423",
      "firstName": "Beställnings",
      "lastName": "Bearbetaning"
  },
  {
      "partnerNumberIndividual": "0033949806",
      "employeeId": "198611259766",
      "firstName": "Skönast",
      "lastName": "Ansiktsgymnastik"
  },
  {
      "partnerNumberIndividual": "0033949984",
      "employeeId": "198802107386",
      "firstName": "Örnnäst",
      "lastName": "Kolpulvereldning"
  },
  {
      "partnerNumberIndividual": "0033950195",
      "employeeId": "198903117391",
      "firstName": "Konkret",
      "lastName": "Magnetmotstånd"
  },
  {
      "partnerNumberIndividual": "0033950258",
      "employeeId": "198907047594",
      "firstName": "Otillämpbar",
      "lastName": "Plantavstånd"
  },
  {
      "partnerNumberIndividual": "0033950267",
      "employeeId": "198908066197",
      "firstName": "Varmrökt",
      "lastName": "Fotbollskänsla"
  },
  {
      "partnerNumberIndividual": "0033950624",
      "employeeId": "198802077886",
      "firstName": "Aerotropisk",
      "lastName": "Våldsgata"
  },
  {
      "partnerNumberIndividual": "0033950805",
      "employeeId": "198810252489",
      "firstName": "Olycksbenägen",
      "lastName": "Byggjobbare"
  },
  {
      "partnerNumberIndividual": "0033950982",
      "employeeId": "198802099880",
      "firstName": "Knipslug",
      "lastName": "Kulvert"
  },
  {
      "partnerNumberIndividual": "0033951134",
      "employeeId": "198405132641",
      "firstName": "Lämplig",
      "lastName": "Aerosolsprutning"
  },
  {
      "partnerNumberIndividual": "0033951199",
      "employeeId": "198708225373",
      "firstName": "Anemometrisk",
      "lastName": "Förkroppsling"
  },
  {
      "partnerNumberIndividual": "0033951559",
      "employeeId": "198704140279",
      "firstName": "Vulvaliknande",
      "lastName": "Yrkessjukdom"
  },
  {
      "partnerNumberIndividual": "0033952161",
      "employeeId": "198908196093",
      "firstName": "Huvudlöstförälskad",
      "lastName": "Ordanvändning"
  },
  {
      "partnerNumberIndividual": "0033952202",
      "employeeId": "198701205570",
      "firstName": "Frapperande",
      "lastName": "Kvartärgeologi"
  },
  {
      "partnerNumberIndividual": "0033952284",
      "employeeId": "198906107597",
      "firstName": "Abelsk",
      "lastName": "Medelhansvärlden"
  },
  {
      "partnerNumberIndividual": "0033952613",
      "employeeId": "198811126484",
      "firstName": "Friarmässig",
      "lastName": "Halvpence"
  },
  {
      "partnerNumberIndividual": "0033952631",
      "employeeId": "198708024073",
      "firstName": "Bombmattefällande",
      "lastName": "Vårdutrymme"
  },
  {
      "partnerNumberIndividual": "0033952668",
      "employeeId": "198804015686",
      "firstName": "Företagsbetald",
      "lastName": "Svanhus"
  },
  {
      "partnerNumberIndividual": "0033952768",
      "employeeId": "198711148976",
      "firstName": "Studentaktiv",
      "lastName": "Nordsjöstubb"
  },
  {
      "partnerNumberIndividual": "0033953430",
      "employeeId": "198611243760",
      "firstName": "Helförsäkrad",
      "lastName": "Menlöshet"
  },
  {
      "partnerNumberIndividual": "0033953497",
      "employeeId": "198703139173",
      "firstName": "Tunnsliten",
      "lastName": "Läkemedelskontroll"
  },
  {
      "partnerNumberIndividual": "0033953933",
      "employeeId": "198803249286",
      "firstName": "Deltid",
      "lastName": "Laplacetransformation"
  },
  {
      "partnerNumberIndividual": "0033954410",
      "employeeId": "198901252497",
      "firstName": "Urfälld",
      "lastName": "Nedsmutsare"
  },
  {
      "partnerNumberIndividual": "0033954451",
      "employeeId": "198902174096",
      "firstName": "Urkomisk",
      "lastName": "Laddapparat"
  },
  {
      "partnerNumberIndividual": "0033954535",
      "employeeId": "198903030594",
      "firstName": "Bekymmersfri",
      "lastName": "Frostskyddsapparat"
  },
  {
      "partnerNumberIndividual": "0033954553",
      "employeeId": "198904147199",
      "firstName": "Musikalisk",
      "lastName": "Jordbrukszon"
  },
  {
      "partnerNumberIndividual": "0033954554",
      "employeeId": "198904168591",
      "firstName": "Små",
      "lastName": "Tilläggsbudget"
  },
  {
      "partnerNumberIndividual": "0033954563",
      "employeeId": "198904263798",
      "firstName": "Neolitisk",
      "lastName": "Sidostöttning"
  },
  {
      "partnerNumberIndividual": "0033954618",
      "employeeId": "198905010297",
      "firstName": "Tunnklädd",
      "lastName": "Maltaduva"
  },
  {
      "partnerNumberIndividual": "0033954629",
      "employeeId": "198905089291",
      "firstName": "Inbördeskrigliknande",
      "lastName": "TimmenT"
  },
  {
      "partnerNumberIndividual": "0033954676",
      "employeeId": "198906057297",
      "firstName": "Yazidisk",
      "lastName": "Tempocykel"
  },
  {
      "partnerNumberIndividual": "0033954688",
      "employeeId": "198907137999",
      "firstName": "Avresande",
      "lastName": "Mikrovektor"
  },
  {
      "partnerNumberIndividual": "0033954705",
      "employeeId": "198907249190",
      "firstName": "Enaxlad",
      "lastName": "Aneroxi"
  },
  {
      "partnerNumberIndividual": "0033954875",
      "employeeId": "198911098591",
      "firstName": "Minutlång",
      "lastName": "Tvådagarstidning"
  },
  {
      "partnerNumberIndividual": "0033955773",
      "employeeId": "198806086388",
      "firstName": "Syndfri",
      "lastName": "Glykokoll"
  },
  {
      "partnerNumberIndividual": "0033955857",
      "employeeId": "198907144292",
      "firstName": "Onyttig",
      "lastName": "Ladugårdsbacke"
  },
  {
      "partnerNumberIndividual": "0033955952",
      "employeeId": "198806140888",
      "firstName": "Tätting",
      "lastName": "Streamadvideo"
  },
  {
      "partnerNumberIndividual": "0033956088",
      "employeeId": "198809208286",
      "firstName": "Rosafärgad",
      "lastName": "Upprorsförsök"
  },
  {
      "partnerNumberIndividual": "0033956451",
      "employeeId": "198908090890",
      "firstName": "Intekunna",
      "lastName": "Bomullslump"
  },
  {
      "partnerNumberIndividual": "0033957310",
      "employeeId": "198906189892",
      "firstName": "Uzbekistansk",
      "lastName": "Störresultanspett"
  },
  {
      "partnerNumberIndividual": "0033957583",
      "employeeId": "198809081386",
      "firstName": "Oefterliknelig",
      "lastName": "Snöklocka"
  },
  {
      "partnerNumberIndividual": "0033957875",
      "employeeId": "198709242476",
      "firstName": "Medinsjunketansikte",
      "lastName": "Studiosus"
  },
  {
      "partnerNumberIndividual": "0033958235",
      "employeeId": "198908259990",
      "firstName": "Föräldra",
      "lastName": "Kappress"
  },
  {
      "partnerNumberIndividual": "0033958413",
      "employeeId": "198805256982",
      "firstName": "Intevärdig",
      "lastName": "Gråvingadkotinga"
  },
  {
      "partnerNumberIndividual": "0033958657",
      "employeeId": "198903179193",
      "firstName": "Påfrifot",
      "lastName": "Flugsnappare"
  },
  {
      "partnerNumberIndividual": "0033959009",
      "employeeId": "198903159294",
      "firstName": "Omflyttbar",
      "lastName": "Upplevelseindustri"
  },
  {
      "partnerNumberIndividual": "0033959091",
      "employeeId": "198901185291",
      "firstName": "Tropologisk",
      "lastName": "Sidostöttning"
  },
  {
      "partnerNumberIndividual": "0033959762",
      "employeeId": "198703034275",
      "firstName": "Flersidig",
      "lastName": "Kryssunderbramsegel"
  },
  {
      "partnerNumberIndividual": "0033960276",
      "employeeId": "198802195381",
      "firstName": "Helkul",
      "lastName": "Nedmjölning"
  },
  {
      "partnerNumberIndividual": "0033960448",
      "employeeId": "198704265670",
      "firstName": "Israelvänlig",
      "lastName": "Ärftlighetsgen"
  },
  {
      "partnerNumberIndividual": "0033960452",
      "employeeId": "198711091374",
      "firstName": "Tjänsteförrättande",
      "lastName": "Tystmajoritet"
  },
  {
      "partnerNumberIndividual": "0033960464",
      "employeeId": "198809235685",
      "firstName": "Kamelhårsfärgad",
      "lastName": "Fissionsbränsle"
  },
  {
      "partnerNumberIndividual": "0033960534",
      "employeeId": "198808120581",
      "firstName": "Feldebiterad",
      "lastName": "Moskovit"
  },
  {
      "partnerNumberIndividual": "0033960589",
      "employeeId": "198703260276",
      "firstName": "Ultimo",
      "lastName": "Stormaktstid"
  },
  {
      "partnerNumberIndividual": "0033960686",
      "employeeId": "198905273994",
      "firstName": "Hungersnöddrabbad",
      "lastName": "Penningutbud"
  },
  {
      "partnerNumberIndividual": "0033960794",
      "employeeId": "198909187893",
      "firstName": "Proforma",
      "lastName": "Sangvinism"
  },
  {
      "partnerNumberIndividual": "0033961222",
      "employeeId": "198903183997",
      "firstName": "Monografisk",
      "lastName": "Batterilåda"
  },
  {
      "partnerNumberIndividual": "0033962005",
      "employeeId": "198802148984",
      "firstName": "Självsvåldig",
      "lastName": "Drossel"
  },
  {
      "partnerNumberIndividual": "0033962459",
      "employeeId": "198802279185",
      "firstName": "Själfull",
      "lastName": "Effektivitetsrevision"
  },
  {
      "partnerNumberIndividual": "0033962586",
      "employeeId": "198807215283",
      "firstName": "Kostnadsfri",
      "lastName": "Mordhistoria"
  },
  {
      "partnerNumberIndividual": "0033962991",
      "employeeId": "198207039226",
      "firstName": "Åsyna",
      "lastName": "Valkalv"
  },
  {
      "partnerNumberIndividual": "0033963631",
      "employeeId": "198802265283",
      "firstName": "Synergisk",
      "lastName": "Festtåg"
  },
  {
      "partnerNumberIndividual": "0033963725",
      "employeeId": "198704066177",
      "firstName": "Aerotropisk",
      "lastName": "Hemläkare"
  },
  {
      "partnerNumberIndividual": "0033964449",
      "employeeId": "198911234790",
      "firstName": "Tyst",
      "lastName": "Sandblästerskydd"
  },
  {
      "partnerNumberIndividual": "0033965714",
      "employeeId": "198901066293",
      "firstName": "Västerut",
      "lastName": "Tursam"
  },
  {
      "partnerNumberIndividual": "0033965889",
      "employeeId": "198703234073",
      "firstName": "Illa",
      "lastName": "Signor"
  },
  {
      "partnerNumberIndividual": "0033966040",
      "employeeId": "198803094989",
      "firstName": "Tyngdkrafts",
      "lastName": "Fjädervilt"
  },
  {
      "partnerNumberIndividual": "0033967004",
      "employeeId": "198904099895",
      "firstName": "Svängningsbar",
      "lastName": "Högmedeltiden"
  },
  {
      "partnerNumberIndividual": "0033967267",
      "employeeId": "198807145381",
      "firstName": "Klinklagd",
      "lastName": "Forbol"
  },
  {
      "partnerNumberIndividual": "0033967905",
      "employeeId": "198303152832",
      "firstName": "Överstånden",
      "lastName": "Årsöversikt"
  },
  {
      "partnerNumberIndividual": "0033968066",
      "employeeId": "198703207277",
      "firstName": "Brännskadad",
      "lastName": "Kanadagås"
  },
  {
      "partnerNumberIndividual": "0033968158",
      "employeeId": "198705035676",
      "firstName": "Debattlysten",
      "lastName": "Andrahandsval"
  },
  {
      "partnerNumberIndividual": "0033968315",
      "employeeId": "198710030274",
      "firstName": "Synergisk",
      "lastName": "Byggjobbare"
  },
  {
      "partnerNumberIndividual": "0033968393",
      "employeeId": "198801069488",
      "firstName": "Självförstörande",
      "lastName": "Fariseism"
  },
  {
      "partnerNumberIndividual": "0033968490",
      "employeeId": "198804063280",
      "firstName": "Midströms",
      "lastName": "Felmeddelande"
  },
  {
      "partnerNumberIndividual": "0033968539",
      "employeeId": "198806244284",
      "firstName": "Huvudsaklig",
      "lastName": "Fotbollshysteri"
  },
  {
      "partnerNumberIndividual": "0033968591",
      "employeeId": "198808223989",
      "firstName": "Adjektivisk",
      "lastName": "Omvikningsstål"
  },
  {
      "partnerNumberIndividual": "0033969279",
      "employeeId": "198708203974",
      "firstName": "Decenniumlång",
      "lastName": "Katepsin"
  },
  {
      "partnerNumberIndividual": "0033969579",
      "employeeId": "198702085872",
      "firstName": "Biskops",
      "lastName": "Våtdräkt"
  },
  {
      "partnerNumberIndividual": "0033969684",
      "employeeId": "198911172693",
      "firstName": "Rättad",
      "lastName": "Konvolvulus"
  },
  {
      "partnerNumberIndividual": "0033969784",
      "employeeId": "198810066285",
      "firstName": "Bortkommenterad",
      "lastName": "Folkkyrkopräst"
  },
  {
      "partnerNumberIndividual": "0033970157",
      "employeeId": "198809077483",
      "firstName": "Sagolik",
      "lastName": "Tennjodid"
  },
  {
      "partnerNumberIndividual": "0033970482",
      "employeeId": "198909214093",
      "firstName": "Inbillad",
      "lastName": "Storgalangarot"
  },
  {
      "partnerNumberIndividual": "0033970745",
      "employeeId": "198811124380",
      "firstName": "Utledsen",
      "lastName": "Föreläsningssal"
  },
  {
      "partnerNumberIndividual": "0033971662",
      "employeeId": "198607119867",
      "firstName": "Virtuos",
      "lastName": "Glasning"
  },
  {
      "partnerNumberIndividual": "0033972077",
      "employeeId": "198802168883",
      "firstName": "Gott",
      "lastName": "Myggblomster"
  },
  {
      "partnerNumberIndividual": "0033972118",
      "employeeId": "198803248387",
      "firstName": "Beroendeav",
      "lastName": "Yrkesbrev"
  },
  {
      "partnerNumberIndividual": "0033972237",
      "employeeId": "198807102580",
      "firstName": "Bukig",
      "lastName": "Utländskmoderbolag"
  },
  {
      "partnerNumberIndividual": "0033972286",
      "employeeId": "198809097986",
      "firstName": "Opåverkbar",
      "lastName": "Berylliumjodid"
  },
  {
      "partnerNumberIndividual": "0033972295",
      "employeeId": "198809188389",
      "firstName": "Skärm",
      "lastName": "Jägaresamlare"
  },
  {
      "partnerNumberIndividual": "0033972325",
      "employeeId": "198810248586",
      "firstName": "Störtskön",
      "lastName": "Lyssnarbrev"
  },
  {
      "partnerNumberIndividual": "0033973159",
      "employeeId": "198711057979",
      "firstName": "Glad",
      "lastName": "Jobbschema"
  },
  {
      "partnerNumberIndividual": "0033973646",
      "employeeId": "198808251386",
      "firstName": "Behårad",
      "lastName": "Maltaduva"
  },
  {
      "partnerNumberIndividual": "0033974269",
      "employeeId": "198809028981",
      "firstName": "Samlarlysten",
      "lastName": "Delbruk"
  },
  {
      "partnerNumberIndividual": "0033974604",
      "employeeId": "198807214385",
      "firstName": "Konkurrensduglig",
      "lastName": "Getberget"
  },
  {
      "partnerNumberIndividual": "0033974619",
      "employeeId": "198809194080",
      "firstName": "Andragrads",
      "lastName": "Laplacetransformation"
  },
  {
      "partnerNumberIndividual": "0033974635",
      "employeeId": "198810267883",
      "firstName": "Israelvänlig",
      "lastName": "Arktisktklima"
  },
  {
      "partnerNumberIndividual": "0033975492",
      "employeeId": "198611112361",
      "firstName": "Skolfri",
      "lastName": "Lagändring"
  },
  {
      "partnerNumberIndividual": "0033976076",
      "employeeId": "198803207383",
      "firstName": "Sedd",
      "lastName": "Trekantigtoppsegel"
  },
  {
      "partnerNumberIndividual": "0033976168",
      "employeeId": "198805164186",
      "firstName": "Djuptrotad",
      "lastName": "Vävnad"
  },
  {
      "partnerNumberIndividual": "0033976173",
      "employeeId": "198805179887",
      "firstName": "Bukstinn",
      "lastName": "Överföringavanslag"
  },
  {
      "partnerNumberIndividual": "0033976253",
      "employeeId": "198807234888",
      "firstName": "Meterhög",
      "lastName": "Karttekniker"
  },
  {
      "partnerNumberIndividual": "0033976357",
      "employeeId": "198810129885",
      "firstName": "Trafikstyrd",
      "lastName": "Skenfot"
  },
  {
      "partnerNumberIndividual": "0033976365",
      "employeeId": "198810157282",
      "firstName": "Skimmelfärgad",
      "lastName": "Udde"
  },
  {
      "partnerNumberIndividual": "0033976499",
      "employeeId": "198902175291",
      "firstName": "Fotostat",
      "lastName": "Ansiktsvenen"
  },
  {
      "partnerNumberIndividual": "0033977351",
      "employeeId": "198701102777",
      "firstName": "Ejgodkänd",
      "lastName": "Enfrågepolitik"
  },
  {
      "partnerNumberIndividual": "0033977411",
      "employeeId": "198707152479",
      "firstName": "Självsvåldig",
      "lastName": "Ekorrbäver"
  },
  {
      "partnerNumberIndividual": "0033977655",
      "employeeId": "198905232693",
      "firstName": "Tyngdkrafts",
      "lastName": "Aneroxi"
  },
  {
      "partnerNumberIndividual": "0033977664",
      "employeeId": "198905019991",
      "firstName": "Västmanländsk",
      "lastName": "Cirkulärpartikelaccelerator"
  },
  {
      "partnerNumberIndividual": "0033977665",
      "employeeId": "198905052190",
      "firstName": "Omedelbart",
      "lastName": "Ekorrbäver"
  },
  {
      "partnerNumberIndividual": "0033977689",
      "employeeId": "198908222899",
      "firstName": "Närsynt",
      "lastName": "Grågumpadträdseglare"
  },
  {
      "partnerNumberIndividual": "0033978254",
      "employeeId": "198707104876",
      "firstName": "Mångstavig",
      "lastName": "Dådlöshet"
  },
  {
      "partnerNumberIndividual": "0033978285",
      "employeeId": "198810247984",
      "firstName": "Bakåtsträvande",
      "lastName": "Engelsklektion"
  },
  {
      "partnerNumberIndividual": "0033978730",
      "employeeId": "198804216987",
      "firstName": "Uppodlad",
      "lastName": "Oframkomlighet"
  },
  {
      "partnerNumberIndividual": "0033978890",
      "employeeId": "198306172837",
      "firstName": "Sjöfarande",
      "lastName": "Tidsaspekt"
  },
  {
      "partnerNumberIndividual": "0033979379",
      "employeeId": "198804224783",
      "firstName": "Fylletrött",
      "lastName": "Konceptbevis"
  },
  {
      "partnerNumberIndividual": "0033979384",
      "employeeId": "198906149193",
      "firstName": "Giftasvuxen",
      "lastName": "Amöbainfektion"
  },
  {
      "partnerNumberIndividual": "0033979687",
      "employeeId": "198808023884",
      "firstName": "Atypisk",
      "lastName": "Majolika"
  },
  {
      "partnerNumberIndividual": "0033979715",
      "employeeId": "198704044174",
      "firstName": "Pankreatisk",
      "lastName": "Danism"
  },
  {
      "partnerNumberIndividual": "0033980417",
      "employeeId": "198711036270",
      "firstName": "Underskön",
      "lastName": "Tandfyllningsmaterial"
  },
  {
      "partnerNumberIndividual": "0033980726",
      "employeeId": "198806064385",
      "firstName": "Penningorienterad",
      "lastName": "Blindarkad"
  },
  {
      "partnerNumberIndividual": "0033980872",
      "employeeId": "198905255892",
      "firstName": "Radiostyrd",
      "lastName": "Avhämtning"
  },
  {
      "partnerNumberIndividual": "0033981036",
      "employeeId": "198702079875",
      "firstName": "Svårbemästrad",
      "lastName": "Fabriksgård"
  },
  {
      "partnerNumberIndividual": "0033981041",
      "employeeId": "198708019875",
      "firstName": "Helfransk",
      "lastName": "ERA"
  },
  {
      "partnerNumberIndividual": "0033981053",
      "employeeId": "198901019896",
      "firstName": "Fatisk",
      "lastName": "Ektypografi"
  },
  {
      "partnerNumberIndividual": "0033981059",
      "employeeId": "198906279990",
      "firstName": "Dagvill",
      "lastName": "Cyanfettsyror"
  },
  {
      "partnerNumberIndividual": "0033981302",
      "employeeId": "198810210586",
      "firstName": "Vrensk",
      "lastName": "Vågmästare"
  },
  {
      "partnerNumberIndividual": "0033981837",
      "employeeId": "198901248297",
      "firstName": "Impressionist",
      "lastName": "Jordgubbsland"
  },
  {
      "partnerNumberIndividual": "0033982422",
      "employeeId": "198907187390",
      "firstName": "Finstämd",
      "lastName": "Franchising"
  },
  {
      "partnerNumberIndividual": "0033982929",
      "employeeId": "198904127894",
      "firstName": "Alldaglig",
      "lastName": "Väggborrmaskin"
  },
  {
      "partnerNumberIndividual": "0033983581",
      "employeeId": "198804107285",
      "firstName": "Torkkänslig",
      "lastName": "Biltelefon"
  },
  {
      "partnerNumberIndividual": "0033983691",
      "employeeId": "198911279696",
      "firstName": "Domhavande",
      "lastName": "Glasning"
  },
  {
      "partnerNumberIndividual": "0033984145",
      "employeeId": "198704114373",
      "firstName": "Säsongskorrigerad",
      "lastName": "Pappersprodukt"
  },
  {
      "partnerNumberIndividual": "0033984305",
      "employeeId": "198909254792",
      "firstName": "Oälskad",
      "lastName": "Mycketväsenföringenting"
  },
  {
      "partnerNumberIndividual": "0033984965",
      "employeeId": "198701158571",
      "firstName": "Alkalilöslig",
      "lastName": "Isobutylacetat"
  },
  {
      "partnerNumberIndividual": "0033986451",
      "employeeId": "198907073798",
      "firstName": "Förbikörande",
      "lastName": "Revision"
  },
  {
      "partnerNumberIndividual": "0033986471",
      "employeeId": "198909102595",
      "firstName": "Drömfri",
      "lastName": "Energiproducerandemineral"
  },
  {
      "partnerNumberIndividual": "0033986571",
      "employeeId": "198904083295",
      "firstName": "Vikariats",
      "lastName": "Medicinutgift"
  },
  {
      "partnerNumberIndividual": "0033987541",
      "employeeId": "198710136378",
      "firstName": "Skenfager",
      "lastName": "Resegaranti"
  },
  {
      "partnerNumberIndividual": "0033987781",
      "employeeId": "198901246192",
      "firstName": "Saltbeständig",
      "lastName": "Affischklistrare"
  },
  {
      "partnerNumberIndividual": "0033987799",
      "employeeId": "198907033396",
      "firstName": "Tragikomisk",
      "lastName": "Guadalkanalgräsfågel"
  },
  {
      "partnerNumberIndividual": "0033988048",
      "employeeId": "198605083768",
      "firstName": "Gott",
      "lastName": "Åldringar"
  },
  {
      "partnerNumberIndividual": "0033988628",
      "employeeId": "198703144272",
      "firstName": "Friarmässig",
      "lastName": "Universitetstryckeri"
  },
  {
      "partnerNumberIndividual": "0033988707",
      "employeeId": "198908203295",
      "firstName": "Hörsam",
      "lastName": "Arnaudbarbett"
  },
  {
      "partnerNumberIndividual": "0033989313",
      "employeeId": "198710246979",
      "firstName": "Hängmörad",
      "lastName": "Miljöhinder"
  },
  {
      "partnerNumberIndividual": "0033989361",
      "employeeId": "198804148586",
      "firstName": "Otadlig",
      "lastName": "Plättpanna"
  },
  {
      "partnerNumberIndividual": "0033989985",
      "employeeId": "198805118687",
      "firstName": "Skimmelfärgad",
      "lastName": "Kortärm"
  },
  {
      "partnerNumberIndividual": "0033991326",
      "employeeId": "198702148571",
      "firstName": "Grammofon",
      "lastName": "Slum"
  },
  {
      "partnerNumberIndividual": "0033991604",
      "employeeId": "198809060885",
      "firstName": "Absent",
      "lastName": "Smågnat"
  },
  {
      "partnerNumberIndividual": "0033991796",
      "employeeId": "198802148380",
      "firstName": "Kopparröd",
      "lastName": "Intvålning"
  },
  {
      "partnerNumberIndividual": "0033991933",
      "employeeId": "198909278593",
      "firstName": "Mördad",
      "lastName": "Avhorning"
  },
  {
      "partnerNumberIndividual": "0033992051",
      "employeeId": "198205182127",
      "firstName": "Nosgrann",
      "lastName": "Handöverfräs"
  },
  {
      "partnerNumberIndividual": "0033992252",
      "employeeId": "198807215580",
      "firstName": "Illa",
      "lastName": "Ulster"
  },
  {
      "partnerNumberIndividual": "0033992953",
      "employeeId": "198910113995",
      "firstName": "Rankig",
      "lastName": "Resolharts"
  },
  {
      "partnerNumberIndividual": "0033993614",
      "employeeId": "198806106285",
      "firstName": "Närbesläktad",
      "lastName": "Rökskåpsdörr"
  },
  {
      "partnerNumberIndividual": "0033994845",
      "employeeId": "198701089578",
      "firstName": "Sovrad",
      "lastName": "Halvapa"
  },
  {
      "partnerNumberIndividual": "0033996013",
      "employeeId": "198802153182",
      "firstName": "Förtörnadpå",
      "lastName": "Konstruktionsstandard"
  },
  {
      "partnerNumberIndividual": "0033996448",
      "employeeId": "198704059578",
      "firstName": "Etnisk",
      "lastName": "Hjärtkontusion"
  },
  {
      "partnerNumberIndividual": "0033996913",
      "employeeId": "198606274762",
      "firstName": "Sölig",
      "lastName": "Amerikanskpimpernöt"
  },
  {
      "partnerNumberIndividual": "0033997059",
      "employeeId": "198806180983",
      "firstName": "Likaberättigad",
      "lastName": "Gurkhakniv"
  },
  {
      "partnerNumberIndividual": "0033997088",
      "employeeId": "198808016987",
      "firstName": "Mystagogisk",
      "lastName": "Dans"
  },
  {
      "partnerNumberIndividual": "0033997832",
      "employeeId": "198704218679",
      "firstName": "Kontraintuitiv",
      "lastName": "Tyngdlag"
  },
  {
      "partnerNumberIndividual": "0033998312",
      "employeeId": "198601100863",
      "firstName": "Tadelfri",
      "lastName": "Avbärgning"
  },
  {
      "partnerNumberIndividual": "0033998539",
      "employeeId": "198806250281",
      "firstName": "Bronkitsnörd",
      "lastName": "Fodermjöl"
  },
  {
      "partnerNumberIndividual": "0033998578",
      "employeeId": "198809035580",
      "firstName": "Sank",
      "lastName": "Bukbandage"
  },
  {
      "partnerNumberIndividual": "0033998764",
      "employeeId": "198911235391",
      "firstName": "Nedsmord",
      "lastName": "Sotlavskrika"
  },
  {
      "partnerNumberIndividual": "0033999068",
      "employeeId": "198808177888",
      "firstName": "Opåverkbar",
      "lastName": "Glansmedel"
  },
  {
      "partnerNumberIndividual": "0033999291",
      "employeeId": "198803255283",
      "firstName": "Geotermisk",
      "lastName": "Kopparsvart"
  },
  {
      "partnerNumberIndividual": "0033999442",
      "employeeId": "198608073360",
      "firstName": "Krabbätande",
      "lastName": "Revision"
  },
  {
      "partnerNumberIndividual": "0034000370",
      "employeeId": "198905158591",
      "firstName": "Etnifierad",
      "lastName": "Åtskildhet"
  },
  {
      "partnerNumberIndividual": "0034001503",
      "employeeId": "198705012477",
      "firstName": "Tariffmässig",
      "lastName": "Extraläxa"
  },
  {
      "partnerNumberIndividual": "0034001596",
      "employeeId": "198801072482",
      "firstName": "Lokomotorisk",
      "lastName": "Blomskaft"
  },
  {
      "partnerNumberIndividual": "0034001603",
      "employeeId": "198802202583",
      "firstName": "Stingande",
      "lastName": "Natursiden"
  },
  {
      "partnerNumberIndividual": "0034001616",
      "employeeId": "198803255580",
      "firstName": "Malolaktisk",
      "lastName": "Tempocykel"
  },
  {
      "partnerNumberIndividual": "0034001663",
      "employeeId": "198806042688",
      "firstName": "Stillstående",
      "lastName": "Innaturaskatt"
  },
  {
      "partnerNumberIndividual": "0034001784",
      "employeeId": "198906112399",
      "firstName": "Ikonisk",
      "lastName": "Sockerbagare"
  },
  {
      "partnerNumberIndividual": "0034002769",
      "employeeId": "198807062487",
      "firstName": "Häftade",
      "lastName": "Kopparsvart"
  },
  {
      "partnerNumberIndividual": "0034003105",
      "employeeId": "198808244787",
      "firstName": "Lättläst",
      "lastName": "Barfrost"
  },
  {
      "partnerNumberIndividual": "0034003503",
      "employeeId": "198809172680",
      "firstName": "Osystematisk",
      "lastName": "Hittegodsexpedition"
  },
  {
      "partnerNumberIndividual": "0034004546",
      "employeeId": "198711244775",
      "firstName": "Tillväxtförstoppad",
      "lastName": "Spraymunstycke"
  },
  {
      "partnerNumberIndividual": "0034004628",
      "employeeId": "198208257322",
      "firstName": "Itmedveten",
      "lastName": "Strandgata"
  },
  {
      "partnerNumberIndividual": "0034005671",
      "employeeId": "198803073280",
      "firstName": "Afferent",
      "lastName": "Tandfyllningsmaterial"
  },
  {
      "partnerNumberIndividual": "0034006956",
      "employeeId": "198801227086",
      "firstName": "Oljeproducerande",
      "lastName": "Resform"
  },
  {
      "partnerNumberIndividual": "0034007589",
      "employeeId": "198905205897",
      "firstName": "Frontad",
      "lastName": "Ugnsgaller"
  },
  {
      "partnerNumberIndividual": "0034007659",
      "employeeId": "198410262540",
      "firstName": "Zoografisk",
      "lastName": "Långhålsborrmaskin"
  },
  {
      "partnerNumberIndividual": "0034007976",
      "employeeId": "198702063275",
      "firstName": "Nosgrann",
      "lastName": "Hedersgubbe"
  },
  {
      "partnerNumberIndividual": "0034008409",
      "employeeId": "198811103889",
      "firstName": "Invalid",
      "lastName": "Friochrättigheter"
  },
  {
      "partnerNumberIndividual": "0034008625",
      "employeeId": "198904194498",
      "firstName": "Uppvispad",
      "lastName": "Lochiarubra"
  },
  {
      "partnerNumberIndividual": "0034009053",
      "employeeId": "198811098782",
      "firstName": "Bianco",
      "lastName": "Stannosulfid"
  },
  {
      "partnerNumberIndividual": "0034009479",
      "employeeId": "198806197284",
      "firstName": "Uteliggande",
      "lastName": "Festtåg"
  },
  {
      "partnerNumberIndividual": "0034009622",
      "employeeId": "198807076388",
      "firstName": "Havs",
      "lastName": "Scintillationsräknare"
  },
  {
      "partnerNumberIndividual": "0034009767",
      "employeeId": "198704045973",
      "firstName": "Respektive",
      "lastName": "Ordanvändning"
  },
  {
      "partnerNumberIndividual": "0034010439",
      "employeeId": "198705186370",
      "firstName": "Förbliven",
      "lastName": "Månkalender"
  },
  {
      "partnerNumberIndividual": "0034010617",
      "employeeId": "198701213970",
      "firstName": "Knarrande",
      "lastName": "Blindarkad"
  },
  {
      "partnerNumberIndividual": "0034010662",
      "employeeId": "198706016972",
      "firstName": "Förtörnadpå",
      "lastName": "Mönsterexemplar"
  },
  {
      "partnerNumberIndividual": "0034010844",
      "employeeId": "198909076997",
      "firstName": "Ugnsrostad",
      "lastName": "Ektypografi"
  },
  {
      "partnerNumberIndividual": "0034011134",
      "employeeId": "198704218976",
      "firstName": "Profan",
      "lastName": "Kringkastning"
  },
  {
      "partnerNumberIndividual": "0034011221",
      "employeeId": "198804085887",
      "firstName": "Konvertibel",
      "lastName": "Tyrrhenuggla"
  },
  {
      "partnerNumberIndividual": "0034011247",
      "employeeId": "198710045678",
      "firstName": "Dominerad",
      "lastName": "Sandblästerskydd"
  },
  {
      "partnerNumberIndividual": "0034011437",
      "employeeId": "198808072683",
      "firstName": "Kostnadspolitisk",
      "lastName": "Digitalmusik"
  },
  {
      "partnerNumberIndividual": "0034011809",
      "employeeId": "198704154478",
      "firstName": "Tunnsliten",
      "lastName": "Nysrot"
  },
  {
      "partnerNumberIndividual": "0034012272",
      "employeeId": "198706086579",
      "firstName": "Nordgrönländsk",
      "lastName": "Biltelefon"
  },
  {
      "partnerNumberIndividual": "0034013181",
      "employeeId": "198706129072",
      "firstName": "Påhittig",
      "lastName": "Lustslott"
  },
  {
      "partnerNumberIndividual": "0034013186",
      "employeeId": "198905191394",
      "firstName": "Tillföljdav",
      "lastName": "Ragu"
  },
  {
      "partnerNumberIndividual": "0034013357",
      "employeeId": "198702222970",
      "firstName": "Oförlåtande",
      "lastName": "Fyrsken"
  },
  {
      "partnerNumberIndividual": "0034013544",
      "employeeId": "198708052678",
      "firstName": "Babyblå",
      "lastName": "Cirkulärpartikelaccelerator"
  },
  {
      "partnerNumberIndividual": "0034013756",
      "employeeId": "198807143881",
      "firstName": "Radhusliknande",
      "lastName": "Paradisflugsnappare"
  },
  {
      "partnerNumberIndividual": "0034014292",
      "employeeId": "198811090284",
      "firstName": "Polygenisk",
      "lastName": "Söksträng"
  },
  {
      "partnerNumberIndividual": "0034014868",
      "employeeId": "198908030292",
      "firstName": "Härleddav",
      "lastName": "Jordmån"
  },
  {
      "partnerNumberIndividual": "0034017044",
      "employeeId": "198811063786",
      "firstName": "Prydd",
      "lastName": "Jordkällare"
  },
  {
      "partnerNumberIndividual": "0034017656",
      "employeeId": "198705165572",
      "firstName": "Hopkrupen",
      "lastName": "Ondtunga"
  },
  {
      "partnerNumberIndividual": "0034017819",
      "employeeId": "198904237297",
      "firstName": "Snart",
      "lastName": "Störrevitstrupigtukan"
  },
  {
      "partnerNumberIndividual": "0034017849",
      "employeeId": "198907228392",
      "firstName": "Georgisk",
      "lastName": "Energiproducerandemineral"
  },
  {
      "partnerNumberIndividual": "0034018515",
      "employeeId": "198701048871",
      "firstName": "Dubbelbottnad",
      "lastName": "Karakullamm"
  },
  {
      "partnerNumberIndividual": "0034018628",
      "employeeId": "198801199087",
      "firstName": "Bröstsjuk",
      "lastName": "Felmeddelande"
  },
  {
      "partnerNumberIndividual": "0034018638",
      "employeeId": "198803102485",
      "firstName": "Metalltäckt",
      "lastName": "Mopsansikte"
  },
  {
      "partnerNumberIndividual": "0034018709",
      "employeeId": "198901087091",
      "firstName": "Saltförande",
      "lastName": "Väggborrmaskin"
  },
  {
      "partnerNumberIndividual": "0034018860",
      "employeeId": "198810100589",
      "firstName": "Lerbestruken",
      "lastName": "Agronomkollega"
  },
  {
      "partnerNumberIndividual": "0034018986",
      "employeeId": "198001198103",
      "firstName": "Våtvärmande",
      "lastName": "Segmentering"
  },
  {
      "partnerNumberIndividual": "0034019057",
      "employeeId": "198802242381",
      "firstName": "Sexfotad",
      "lastName": "Gitterkvadrat"
  },
  {
      "partnerNumberIndividual": "0034019092",
      "employeeId": "198703212673",
      "firstName": "Tvådelad",
      "lastName": "Söksträng"
  },
  {
      "partnerNumberIndividual": "0034019103",
      "employeeId": "198707208271",
      "firstName": "Driftsklar",
      "lastName": "Återflöde"
  },
  {
      "partnerNumberIndividual": "0034019454",
      "employeeId": "198705119777",
      "firstName": "Konkurrensduglig",
      "lastName": "Skräckromantik"
  },
  {
      "partnerNumberIndividual": "0034019972",
      "employeeId": "198811127086",
      "firstName": "Spjälad",
      "lastName": "Offshoreverksamhet"
  },
  {
      "partnerNumberIndividual": "0034020223",
      "employeeId": "198111164516",
      "firstName": "Epicen",
      "lastName": "Platan"
  },
  {
      "partnerNumberIndividual": "0034020327",
      "employeeId": "198703164775",
      "firstName": "Termostatstyrd",
      "lastName": "Sommarväder"
  },
  {
      "partnerNumberIndividual": "0034020510",
      "employeeId": "198801179782",
      "firstName": "Läckande",
      "lastName": "Justeringavfinansiellöversikt"
  },
  {
      "partnerNumberIndividual": "0034021011",
      "employeeId": "198910198095",
      "firstName": "Submolekylär",
      "lastName": "Pannstensbildning"
  },
  {
      "partnerNumberIndividual": "0034021602",
      "employeeId": "198703185275",
      "firstName": "Antistatisk",
      "lastName": "Algtoxin"
  },
  {
      "partnerNumberIndividual": "0034021995",
      "employeeId": "198901137391",
      "firstName": "Ametistliknande",
      "lastName": "Pickochpack"
  },
  {
      "partnerNumberIndividual": "0034021997",
      "employeeId": "198901204290",
      "firstName": "Prasslande",
      "lastName": "Tilläggsbudget"
  },
  {
      "partnerNumberIndividual": "0034022066",
      "employeeId": "198903051392",
      "firstName": "Speedig",
      "lastName": "Tyrolerdräkt"
  },
  {
      "partnerNumberIndividual": "0034023056",
      "employeeId": "198906078996",
      "firstName": "Antiimperialist",
      "lastName": "Utanverk"
  },
  {
      "partnerNumberIndividual": "0034023242",
      "employeeId": "198911139890",
      "firstName": "Interatomär",
      "lastName": "Apa"
  },
  {
      "partnerNumberIndividual": "0034023425",
      "employeeId": "198909144795",
      "firstName": "Nattblå",
      "lastName": "Avskedsuppvaktning"
  },
  {
      "partnerNumberIndividual": "0034024123",
      "employeeId": "198709036977",
      "firstName": "Omflyttbar",
      "lastName": "Bradykinin"
  },
  {
      "partnerNumberIndividual": "0034024406",
      "employeeId": "198805075283",
      "firstName": "Svängningsbar",
      "lastName": "Karvestren"
  },
  {
      "partnerNumberIndividual": "0034024426",
      "employeeId": "198907026499",
      "firstName": "Vördad",
      "lastName": "Paparazzo"
  },
  {
      "partnerNumberIndividual": "0034024899",
      "employeeId": "198911216391",
      "firstName": "Datormanipulerad",
      "lastName": "Tyrolerdräkt"
  },
  {
      "partnerNumberIndividual": "0034025018",
      "employeeId": "198710233977",
      "firstName": "Kiselhaltig",
      "lastName": "Kanadagås"
  },
  {
      "partnerNumberIndividual": "0034025086",
      "employeeId": "198809263984",
      "firstName": "Kontraintuitiv",
      "lastName": "Slum"
  },
  {
      "partnerNumberIndividual": "0034025512",
      "employeeId": "198806272889",
      "firstName": "Etnisk",
      "lastName": "Örlogsbesök"
  },
  {
      "partnerNumberIndividual": "0034025897",
      "employeeId": "198801030886",
      "firstName": "Infällbar",
      "lastName": "Dahliesort"
  },
  {
      "partnerNumberIndividual": "0034026053",
      "employeeId": "198703150576",
      "firstName": "Iglädjerus",
      "lastName": "Vapeninköp"
  },
  {
      "partnerNumberIndividual": "0034026270",
      "employeeId": "198907212396",
      "firstName": "Bröstsjuk",
      "lastName": "Arktisktklima"
  },
  {
      "partnerNumberIndividual": "0034026513",
      "employeeId": "198806037886",
      "firstName": "Postakut",
      "lastName": "Bergsklättrare"
  },
  {
      "partnerNumberIndividual": "0034026701",
      "employeeId": "198506199358",
      "firstName": "Exkretorisk",
      "lastName": "Segmentering"
  },
  {
      "partnerNumberIndividual": "0034027492",
      "employeeId": "198909146295",
      "firstName": "Ambivalent",
      "lastName": "Kalkalg"
  },
  {
      "partnerNumberIndividual": "0034028160",
      "employeeId": "198803047987",
      "firstName": "Sydsvensk",
      "lastName": "Danism"
  },
  {
      "partnerNumberIndividual": "0034028217",
      "employeeId": "198806218981",
      "firstName": "Persulfat",
      "lastName": "Kontrollmanometer"
  },
  {
      "partnerNumberIndividual": "0034028257",
      "employeeId": "198808202884",
      "firstName": "Tumultartad",
      "lastName": "Fläktkylning"
  },
  {
      "partnerNumberIndividual": "0034029103",
      "employeeId": "198907139797",
      "firstName": "Kinesisktalande",
      "lastName": "Jig"
  },
  {
      "partnerNumberIndividual": "0034029685",
      "employeeId": "198804110883",
      "firstName": "Överstånden",
      "lastName": "Broelement"
  },
  {
      "partnerNumberIndividual": "0034030399",
      "employeeId": "198404247242",
      "firstName": "Pulserande",
      "lastName": "Beklädnadsförråd"
  },
  {
      "partnerNumberIndividual": "0034030930",
      "employeeId": "198707077478",
      "firstName": "Uppdragbar",
      "lastName": "Blystearat"
  },
  {
      "partnerNumberIndividual": "0034032167",
      "employeeId": "198902188294",
      "firstName": "Medsaltsmak",
      "lastName": "Icketroende"
  },
  {
      "partnerNumberIndividual": "0034033187",
      "employeeId": "198806045384",
      "firstName": "Dubbelbottnad",
      "lastName": "Framtidsrädsla"
  },
  {
      "partnerNumberIndividual": "0034033224",
      "employeeId": "198711107378",
      "firstName": "Ospenderad",
      "lastName": "Investeringsavveckling"
  },
  {
      "partnerNumberIndividual": "0034035476",
      "employeeId": "198707098573",
      "firstName": "Rockklädd",
      "lastName": "Palaumarkduva"
  },
  {
      "partnerNumberIndividual": "0034039267",
      "employeeId": "198810024086",
      "firstName": "Dagvill",
      "lastName": "Krökningsgrad"
  },
  {
      "partnerNumberIndividual": "0034039398",
      "employeeId": "198903080292",
      "firstName": "Omflyttbar",
      "lastName": "Blixtlampa"
  },
  {
      "partnerNumberIndividual": "0034040210",
      "employeeId": "198808176682",
      "firstName": "Flodhästliknande",
      "lastName": "Ytfinhet"
  },
  {
      "partnerNumberIndividual": "0034042470",
      "employeeId": "198907069895",
      "firstName": "Från",
      "lastName": "Sandblästerskydd"
  },
  {
      "partnerNumberIndividual": "0034044549",
      "employeeId": "198801010987",
      "firstName": "Bommad",
      "lastName": "Pansarsköld"
  },
  {
      "partnerNumberIndividual": "0034045524",
      "employeeId": "198711209877",
      "firstName": "Ultimo",
      "lastName": "Kokainförgiftning"
  },
  {
      "partnerNumberIndividual": "0034046062",
      "employeeId": "198701185970",
      "firstName": "Scenvan",
      "lastName": "Restvärdesförsäkring"
  },
  {
      "partnerNumberIndividual": "0034046418",
      "employeeId": "198810088289",
      "firstName": "Ametistliknande",
      "lastName": "Jig"
  },
  {
      "partnerNumberIndividual": "0034049842",
      "employeeId": "198409182741",
      "firstName": "Kippskodd",
      "lastName": "Överklassdygd"
  },
  {
      "partnerNumberIndividual": "0034049848",
      "employeeId": "198702238075",
      "firstName": "Förvärkt",
      "lastName": "Resegaranti"
  },
  {
      "partnerNumberIndividual": "0034050506",
      "employeeId": "198801273783",
      "firstName": "Begreppsmässig",
      "lastName": "Rutigtmönster"
  },
  {
      "partnerNumberIndividual": "0034051085",
      "employeeId": "198701159173",
      "firstName": "Samskole",
      "lastName": "Neuroskada"
  },
  {
      "partnerNumberIndividual": "0034051350",
      "employeeId": "198706070870",
      "firstName": "Ankyloserande",
      "lastName": "Mycketväsenföringenting"
  },
  {
      "partnerNumberIndividual": "0034053914",
      "employeeId": "198501262557",
      "firstName": "Felande",
      "lastName": "Kvartärgeologi"
  },
  {
      "partnerNumberIndividual": "0034053937",
      "employeeId": "198911125691",
      "firstName": "Förvägen",
      "lastName": "Tangentialturbin"
  },
  {
      "partnerNumberIndividual": "0034054683",
      "employeeId": "198707081371",
      "firstName": "Rysk",
      "lastName": "Kroppsspråk"
  },
  {
      "partnerNumberIndividual": "0034055803",
      "employeeId": "198808066982",
      "firstName": "Utslätad",
      "lastName": "Kommunitet"
  },
  {
      "partnerNumberIndividual": "0034056884",
      "employeeId": "198808272184",
      "firstName": "Konkret",
      "lastName": "Förhandsbetalning"
  },
  {
      "partnerNumberIndividual": "0034064657",
      "employeeId": "198801247282",
      "firstName": "Tredjefrånslutet",
      "lastName": "Sandblästerskydd"
  },
  {
      "partnerNumberIndividual": "0034065837",
      "employeeId": "198709083979",
      "firstName": "Osteriliserad",
      "lastName": "Raffinadkoppar"
  },
  {
      "partnerNumberIndividual": "0034066670",
      "employeeId": "198707242577",
      "firstName": "Terrester",
      "lastName": "Mussla"
  },
  {
      "partnerNumberIndividual": "0034075336",
      "employeeId": "198808162484",
      "firstName": "Bilmekanisk",
      "lastName": "Baggbölare"
  },
  {
      "partnerNumberIndividual": "0034082320",
      "employeeId": "198803192882",
      "firstName": "Peonisk",
      "lastName": "Ulster"
  },
  {
      "partnerNumberIndividual": "0034084095",
      "employeeId": "198901182892",
      "firstName": "Posttraumatisk",
      "lastName": "Magnesiumbad"
  },
  {
      "partnerNumberIndividual": "0034085056",
      "employeeId": "198706272773",
      "firstName": "Postakut",
      "lastName": "Gulstrupigbulbyl"
  },
  {
      "partnerNumberIndividual": "0034086089",
      "employeeId": "198702128375",
      "firstName": "Heltmotsatt",
      "lastName": "Rödnäbbadfrankolin"
  },
  {
      "partnerNumberIndividual": "0034088638",
      "employeeId": "198706088377",
      "firstName": "Konstruktiv",
      "lastName": "Jordmån"
  },
  {
      "partnerNumberIndividual": "0034090904",
      "employeeId": "198704169872",
      "firstName": "Utankärlek",
      "lastName": "Dubbelpropellerångare"
  },
  {
      "partnerNumberIndividual": "0034094150",
      "employeeId": "198705076373",
      "firstName": "Västtysk",
      "lastName": "Signor"
  },
  {
      "partnerNumberIndividual": "0034094331",
      "employeeId": "198708204279",
      "firstName": "Basilar",
      "lastName": "Bergsklättrare"
  },
  {
      "partnerNumberIndividual": "0034094332",
      "employeeId": "198801184287",
      "firstName": "Tumultartad",
      "lastName": "Resonansenergi"
  },
  {
      "partnerNumberIndividual": "0034095096",
      "employeeId": "198806203587",
      "firstName": "Skotträdd",
      "lastName": "Genomsnittsvikt"
  },
  {
      "partnerNumberIndividual": "0034095737",
      "employeeId": "198805118083",
      "firstName": "EUanställd",
      "lastName": "Kreditförlustreserv"
  },
  {
      "partnerNumberIndividual": "0034097712",
      "employeeId": "198807242386",
      "firstName": "Rörformad",
      "lastName": "Hattmakare"
  },
  {
      "partnerNumberIndividual": "0034102270",
      "employeeId": "198703012271",
      "firstName": "Förbluffande",
      "lastName": "Smågnat"
  },
  {
      "partnerNumberIndividual": "0034103619",
      "employeeId": "198907028297",
      "firstName": "Obeskrivlig",
      "lastName": "Expatient"
  },
  {
      "partnerNumberIndividual": "0034103935",
      "employeeId": "198806024280",
      "firstName": "Färgframkallande",
      "lastName": "Familjelikhet"
  },
  {
      "partnerNumberIndividual": "0034108880",
      "employeeId": "198607189167",
      "firstName": "Uppkörd",
      "lastName": "Guadalkanalgräsfågel"
  },
  {
      "partnerNumberIndividual": "0034111713",
      "employeeId": "198708248573",
      "firstName": "Lykantropisk",
      "lastName": "Kulvert"
  },
  {
      "partnerNumberIndividual": "0034111978",
      "employeeId": "198709126174",
      "firstName": "Medsaltsmak",
      "lastName": "Vinylgummi"
  },
  {
      "partnerNumberIndividual": "0034114965",
      "employeeId": "198604092265",
      "firstName": "Halvlång",
      "lastName": "Avskedsuppvaktning"
  },
  {
      "partnerNumberIndividual": "0034116262",
      "employeeId": "198708046373",
      "firstName": "Självsvåldig",
      "lastName": "Valkalv"
  },
  {
      "partnerNumberIndividual": "0034116453",
      "employeeId": "198702176275",
      "firstName": "Tävlingslysten",
      "lastName": "Enfrågepolitik"
  },
  {
      "partnerNumberIndividual": "0034116560",
      "employeeId": "198706025676",
      "firstName": "Oklangad",
      "lastName": "Världsrekord"
  },
  {
      "partnerNumberIndividual": "0034116590",
      "employeeId": "198708226272",
      "firstName": "Pappaktig",
      "lastName": "Halogenpuck"
  },
  {
      "partnerNumberIndividual": "0034116677",
      "employeeId": "198801117386",
      "firstName": "Oljeriven",
      "lastName": "Maskinfabrikant"
  },
  {
      "partnerNumberIndividual": "0034116723",
      "employeeId": "198802085681",
      "firstName": "Situationsanpassad",
      "lastName": "Fallskärmspacke"
  },
  {
      "partnerNumberIndividual": "0034116801",
      "employeeId": "198805076182",
      "firstName": "Hemlös",
      "lastName": "Gräsrotsrörelse"
  },
  {
      "partnerNumberIndividual": "0034116908",
      "employeeId": "198810087380",
      "firstName": "Svåranskaffad",
      "lastName": "Långhålsborrmaskin"
  },
  {
      "partnerNumberIndividual": "0034116909",
      "employeeId": "198811105686",
      "firstName": "Kopparröd",
      "lastName": "Årstidsvind"
  },
  {
      "partnerNumberIndividual": "0034117167",
      "employeeId": "198907116290",
      "firstName": "Bonusberättigad",
      "lastName": "Mönsterexemplar"
  },
  {
      "partnerNumberIndividual": "0034117871",
      "employeeId": "198803227282",
      "firstName": "Fotostat",
      "lastName": "FemStora"
  },
  {
      "partnerNumberIndividual": "0034118183",
      "employeeId": "198909083290",
      "firstName": "Underskön",
      "lastName": "Gulkronadmajna"
  },
  {
      "partnerNumberIndividual": "0034118832",
      "employeeId": "198903073990",
      "firstName": "Åkbar",
      "lastName": "Hemläkare"
  },
  {
      "partnerNumberIndividual": "0034119022",
      "employeeId": "198803088684",
      "firstName": "Amerikansk",
      "lastName": "Krökningsgrad"
  },
  {
      "partnerNumberIndividual": "0034119168",
      "employeeId": "198709104775",
      "firstName": "Cirkusaktig",
      "lastName": "Opiumfält"
  },
  {
      "partnerNumberIndividual": "0034119282",
      "employeeId": "198710068571",
      "firstName": "Tvåhändig",
      "lastName": "Investeringsfond"
  },
  {
      "partnerNumberIndividual": "0034119283",
      "employeeId": "198706155879",
      "firstName": "Förbikörande",
      "lastName": "Guadalkanalgräsfågel"
  },
  {
      "partnerNumberIndividual": "0034119423",
      "employeeId": "198705278276",
      "firstName": "Pleuritisk",
      "lastName": "Enmiljon"
  },
  {
      "partnerNumberIndividual": "0034120383",
      "employeeId": "198903178591",
      "firstName": "Keff",
      "lastName": "Fusion"
  },
  {
      "partnerNumberIndividual": "0034120424",
      "employeeId": "198910252595",
      "firstName": "Termostatstyrd",
      "lastName": "Hanjar"
  },
  {
      "partnerNumberIndividual": "0034120648",
      "employeeId": "198706197475",
      "firstName": "Som",
      "lastName": "Repulsor"
  },
  {
      "partnerNumberIndividual": "0034120923",
      "employeeId": "198808149887",
      "firstName": "Dagvill",
      "lastName": "Strandgata"
  },
  {
      "partnerNumberIndividual": "0034121589",
      "employeeId": "198704239477",
      "firstName": "Bäst",
      "lastName": "Enfrågepolitik"
  },
  {
      "partnerNumberIndividual": "0034121891",
      "employeeId": "198606251562",
      "firstName": "Cyklonartad",
      "lastName": "Ledarställning"
  },
  {
      "partnerNumberIndividual": "0034122060",
      "employeeId": "198706045872",
      "firstName": "Israelvänlig",
      "lastName": "Mopsansikte"
  },
  {
      "partnerNumberIndividual": "0034122316",
      "employeeId": "198810272982",
      "firstName": "Skärbar",
      "lastName": "Stereoskopkamera"
  },
  {
      "partnerNumberIndividual": "0034122791",
      "employeeId": "198709216272",
      "firstName": "Avgudifierad",
      "lastName": "Medelhansvärlden"
  },
  {
      "partnerNumberIndividual": "0034123246",
      "employeeId": "198803163982",
      "firstName": "Ametistfärgad",
      "lastName": "Arabiskaalfabetet"
  },
  {
      "partnerNumberIndividual": "0034124281",
      "employeeId": "198911099193",
      "firstName": "Approximativ",
      "lastName": "Haschsmuggling"
  },
  {
      "partnerNumberIndividual": "0034124819",
      "employeeId": "198903072497",
      "firstName": "Tumultartad",
      "lastName": "Korselasticitet"
  },
  {
      "partnerNumberIndividual": "0034125235",
      "employeeId": "198911235698",
      "firstName": "Skogsmässig",
      "lastName": "Sändarkrets"
  },
  {
      "partnerNumberIndividual": "0034125630",
      "employeeId": "198807277986",
      "firstName": "Beställnings",
      "lastName": "Utsändning"
  },
  {
      "partnerNumberIndividual": "0034125873",
      "employeeId": "198904077891",
      "firstName": "Mod",
      "lastName": "Malteserkors"
  },
  {
      "partnerNumberIndividual": "0034125957",
      "employeeId": "198807186385",
      "firstName": "Skolfri",
      "lastName": "Trekantigtoppsegel"
  },
  {
      "partnerNumberIndividual": "0034126497",
      "employeeId": "198910272791",
      "firstName": "Felande",
      "lastName": "Nödochlust"
  },
  {
      "partnerNumberIndividual": "0034126862",
      "employeeId": "198904022699",
      "firstName": "Skärm",
      "lastName": "Flygkontrollant"
  },
  {
      "partnerNumberIndividual": "0034126993",
      "employeeId": "198911035890",
      "firstName": "Uzbekistansk",
      "lastName": "Lagbud"
  },
  {
      "partnerNumberIndividual": "0034127131",
      "employeeId": "198705228578",
      "firstName": "Bakanför",
      "lastName": "Plunta"
  },
  {
      "partnerNumberIndividual": "0034127171",
      "employeeId": "198704155673",
      "firstName": "Vållande",
      "lastName": "Karvestren"
  },
  {
      "partnerNumberIndividual": "0034128313",
      "employeeId": "198811263881",
      "firstName": "Kokett",
      "lastName": "Pressläktare"
  },
  {
      "partnerNumberIndividual": "0034128982",
      "employeeId": "198709215670",
      "firstName": "Pikerad",
      "lastName": "Megaerbjudande"
  },
  {
      "partnerNumberIndividual": "0034129282",
      "employeeId": "198911035296",
      "firstName": "Övermöblerad",
      "lastName": "Bröstlidande"
  },
  {
      "partnerNumberIndividual": "0034129392",
      "employeeId": "198809276986",
      "firstName": "Rankig",
      "lastName": "Stenbädd"
  },
  {
      "partnerNumberIndividual": "0034130141",
      "employeeId": "198705187279",
      "firstName": "Murgrönebekransad",
      "lastName": "Kaliumtiocyanat"
  },
  {
      "partnerNumberIndividual": "0034131292",
      "employeeId": "198702016273",
      "firstName": "Myeloid",
      "lastName": "Brandsyn"
  },
  {
      "partnerNumberIndividual": "0034131527",
      "employeeId": "198709040573",
      "firstName": "Örnnäst",
      "lastName": "Avloppsvatten"
  },
  {
      "partnerNumberIndividual": "0034131528",
      "employeeId": "198909159595",
      "firstName": "Stingande",
      "lastName": "Arkiater"
  },
  {
      "partnerNumberIndividual": "0034132690",
      "employeeId": "198603117964",
      "firstName": "Spjälad",
      "lastName": "Blomskaft"
  },
  {
      "partnerNumberIndividual": "0034132733",
      "employeeId": "198902103897",
      "firstName": "Inbillad",
      "lastName": "Ödehus"
  },
  {
      "partnerNumberIndividual": "0034133032",
      "employeeId": "198902216293",
      "firstName": "Hopkrupen",
      "lastName": "Trycklocksburk"
  },
  {
      "partnerNumberIndividual": "0034133147",
      "employeeId": "198902264798",
      "firstName": "Lättläst",
      "lastName": "Scintillationsräknare"
  },
  {
      "partnerNumberIndividual": "0034133758",
      "employeeId": "198707229970",
      "firstName": "Mångstavig",
      "lastName": "Skinka"
  },
  {
      "partnerNumberIndividual": "0034134551",
      "employeeId": "198807117380",
      "firstName": "Levnadstrött",
      "lastName": "Markränta"
  },
  {
      "partnerNumberIndividual": "0034134589",
      "employeeId": "198708052975",
      "firstName": "Ärekär",
      "lastName": "Lekplatsutrustning"
  },
  {
      "partnerNumberIndividual": "0034135836",
      "employeeId": "198904126995",
      "firstName": "Halvgenomskinlig",
      "lastName": "Gräsrotsrörelse"
  },
  {
      "partnerNumberIndividual": "0034136317",
      "employeeId": "198904059196",
      "firstName": "Knäckt",
      "lastName": "Stigförmåga"
  },
  {
      "partnerNumberIndividual": "0034136581",
      "employeeId": "198811130981",
      "firstName": "Guldgul",
      "lastName": "Restvärdesförsäkring"
  },
  {
      "partnerNumberIndividual": "0034136990",
      "employeeId": "198902217499",
      "firstName": "Dagsfärsk",
      "lastName": "Upprullningsmaskin"
  },
  {
      "partnerNumberIndividual": "0034137003",
      "employeeId": "198908107496",
      "firstName": "Oljeriven",
      "lastName": "Digitalsystem"
  },
  {
      "partnerNumberIndividual": "0034137005",
      "employeeId": "198909277991",
      "firstName": "Endräktig",
      "lastName": "Beslutomdödförklaring"
  },
  {
      "partnerNumberIndividual": "0034137264",
      "employeeId": "198505029754",
      "firstName": "Oratorisk",
      "lastName": "Vinnarserie"
  },
  {
      "partnerNumberIndividual": "0034137429",
      "employeeId": "198708066272",
      "firstName": "Beståndsbildande",
      "lastName": "Ledarställning"
  },
  {
      "partnerNumberIndividual": "0034137697",
      "employeeId": "198803054884",
      "firstName": "Kortklippt",
      "lastName": "Spjälsäng"
  },
  {
      "partnerNumberIndividual": "0034137714",
      "employeeId": "198905031392",
      "firstName": "Kunskapsintensiv",
      "lastName": "Friochrättigheter"
  },
  {
      "partnerNumberIndividual": "0034137817",
      "employeeId": "198909233994",
      "firstName": "Stressig",
      "lastName": "Kostall"
  },
  {
      "partnerNumberIndividual": "0034137832",
      "employeeId": "198910112799",
      "firstName": "Havs",
      "lastName": "Differentialrelä"
  },
  {
      "partnerNumberIndividual": "0034138653",
      "employeeId": "198707139872",
      "firstName": "Radiostyrd",
      "lastName": "Gratispassagerare"
  },
  {
      "partnerNumberIndividual": "0034138733",
      "employeeId": "198805206383",
      "firstName": "Bifalls",
      "lastName": "Prisberäkning"
  },
  {
      "partnerNumberIndividual": "0034139341",
      "employeeId": "198904017293",
      "firstName": "Svår",
      "lastName": "Kaplanturbin"
  },
  {
      "partnerNumberIndividual": "0034139575",
      "employeeId": "198901087992",
      "firstName": "Generell",
      "lastName": "Föreläsningssal"
  },
  {
      "partnerNumberIndividual": "0034140653",
      "employeeId": "198811264780",
      "firstName": "Allrabäst",
      "lastName": "Getberget"
  },
  {
      "partnerNumberIndividual": "0034140858",
      "employeeId": "198502273959",
      "firstName": "Oupptäckt",
      "lastName": "Yrkesbrev"
  },
  {
      "partnerNumberIndividual": "0034141099",
      "employeeId": "198706024778",
      "firstName": "Bianco",
      "lastName": "Mårdhår"
  },
  {
      "partnerNumberIndividual": "0034141138",
      "employeeId": "198907166295",
      "firstName": "Uteliggande",
      "lastName": "Gråbukadtragopan"
  },
  {
      "partnerNumberIndividual": "0034142039",
      "employeeId": "198908128294",
      "firstName": "Kapitalistisk",
      "lastName": "Danism"
  },
  {
      "partnerNumberIndividual": "0034143090",
      "employeeId": "198903052895",
      "firstName": "Numerär",
      "lastName": "Tyrrhenuggla"
  },
  {
      "partnerNumberIndividual": "0034143165",
      "employeeId": "198303259835",
      "firstName": "Största",
      "lastName": "Studiosus"
  },
  {
      "partnerNumberIndividual": "0034143201",
      "employeeId": "198801219885",
      "firstName": "Plakat",
      "lastName": "Flampunkt"
  },
  {
      "partnerNumberIndividual": "0034143347",
      "employeeId": "198902111395",
      "firstName": "Obestucken",
      "lastName": "Lyssnarbrev"
  },
  {
      "partnerNumberIndividual": "0034143861",
      "employeeId": "198803072985",
      "firstName": "Piezomagnetisk",
      "lastName": "Aerofon"
  },
  {
      "partnerNumberIndividual": "0034143875",
      "employeeId": "198805082180",
      "firstName": "Skönast",
      "lastName": "Redoxkatalysator"
  },
  {
      "partnerNumberIndividual": "0034144180",
      "employeeId": "198103093517",
      "firstName": "Förvägen",
      "lastName": "Tvådagarstidning"
  },
  {
      "partnerNumberIndividual": "0034145068",
      "employeeId": "198708210870",
      "firstName": "Deltid",
      "lastName": "Bokklubbsutgåva"
  },
  {
      "partnerNumberIndividual": "0034145557",
      "employeeId": "198702266977",
      "firstName": "Copyrightfri",
      "lastName": "Brandriktning"
  },
  {
      "partnerNumberIndividual": "0034145936",
      "employeeId": "198903204793",
      "firstName": "Bifokal",
      "lastName": "Boförvaltare"
  },
  {
      "partnerNumberIndividual": "0034146032",
      "employeeId": "198909055298",
      "firstName": "Förmånlig",
      "lastName": "Nollningsvecka"
  },
  {
      "partnerNumberIndividual": "0034146260",
      "employeeId": "198703233778",
      "firstName": "Olycksfri",
      "lastName": "Halogenpuck"
  },
  {
      "partnerNumberIndividual": "0034146409",
      "employeeId": "198911220294",
      "firstName": "Fatisk",
      "lastName": "Vitfläckigpygmérall"
  },
  {
      "partnerNumberIndividual": "0034146425",
      "employeeId": "198911060898",
      "firstName": "Infällbar",
      "lastName": "Våtdräkt"
  },
  {
      "partnerNumberIndividual": "0034147304",
      "employeeId": "198708210573",
      "firstName": "Heterosexistisk",
      "lastName": "Mopsansikte"
  },
  {
      "partnerNumberIndividual": "0034148134",
      "employeeId": "198803208282",
      "firstName": "Uppkörd",
      "lastName": "Anslutningsslang"
  },
  {
      "partnerNumberIndividual": "0034148156",
      "employeeId": "198705234279",
      "firstName": "Postakut",
      "lastName": "Mätarlarv"
  },
  {
      "partnerNumberIndividual": "0034148167",
      "employeeId": "198902172892",
      "firstName": "Introducerad",
      "lastName": "Förkroppsling"
  },
  {
      "partnerNumberIndividual": "0034148241",
      "employeeId": "198701276373",
      "firstName": "Okontant",
      "lastName": "Resdatum"
  },
  {
      "partnerNumberIndividual": "0034149181",
      "employeeId": "198909212899",
      "firstName": "Samhällsmedicinsk",
      "lastName": "Stenbädd"
  },
  {
      "partnerNumberIndividual": "0034149391",
      "employeeId": "198711044076",
      "firstName": "Urskiljbar",
      "lastName": "Regionaltstöd"
  },
  {
      "partnerNumberIndividual": "0034149427",
      "employeeId": "198908202693",
      "firstName": "Slumpmässig",
      "lastName": "Konjunkturteori"
  },
  {
      "partnerNumberIndividual": "0034149916",
      "employeeId": "198011207803",
      "firstName": "Hormon",
      "lastName": "Susande"
  },
  {
      "partnerNumberIndividual": "0034150599",
      "employeeId": "198902222895",
      "firstName": "Botswanisk",
      "lastName": "Rörligpensionsålder"
  },
  {
      "partnerNumberIndividual": "0034150755",
      "employeeId": "198805187989",
      "firstName": "Bakanför",
      "lastName": "Svartkindadskogssångare"
  },
  {
      "partnerNumberIndividual": "0034150962",
      "employeeId": "198805027987",
      "firstName": "Övermöblerad",
      "lastName": "Gulkronadtyrann"
  },
  {
      "partnerNumberIndividual": "0034151528",
      "employeeId": "198806223783",
      "firstName": "Söder",
      "lastName": "Investeringsfond"
  },
  {
      "partnerNumberIndividual": "0034151713",
      "employeeId": "198803116386",
      "firstName": "Renochskär",
      "lastName": "Socialbidrag"
  },
  {
      "partnerNumberIndividual": "0034151915",
      "employeeId": "198801136980",
      "firstName": "Snällmot",
      "lastName": "Magoperation"
  },
  {
      "partnerNumberIndividual": "0034152000",
      "employeeId": "198804154881",
      "firstName": "Tänkbar",
      "lastName": "Öglemutter"
  },
  {
      "partnerNumberIndividual": "0034152402",
      "employeeId": "198809166989",
      "firstName": "Cirkusaktig",
      "lastName": "Ljuspolarisation"
  },
  {
      "partnerNumberIndividual": "0034152626",
      "employeeId": "198703206972",
      "firstName": "Radhusliknande",
      "lastName": "Revision"
  },
  {
      "partnerNumberIndividual": "0034152810",
      "employeeId": "198901224793",
      "firstName": "Självstyrd",
      "lastName": "Acetofenon"
  },
  {
      "partnerNumberIndividual": "0034152900",
      "employeeId": "198906113298",
      "firstName": "Hormon",
      "lastName": "Studiosus"
  },
  {
      "partnerNumberIndividual": "0034153158",
      "employeeId": "198903087891",
      "firstName": "Profan",
      "lastName": "Joddel"
  },
  {
      "partnerNumberIndividual": "0034153245",
      "employeeId": "198708135275",
      "firstName": "Styrka",
      "lastName": "Stapeldiagram"
  },
  {
      "partnerNumberIndividual": "0034154142",
      "employeeId": "198802279482",
      "firstName": "Etnografisk",
      "lastName": "Förstärkare"
  },
  {
      "partnerNumberIndividual": "0034154196",
      "employeeId": "198702127476",
      "firstName": "Transitorisk",
      "lastName": "Glykokoll"
  },
  {
      "partnerNumberIndividual": "0034154391",
      "employeeId": "198904264093",
      "firstName": "Labyrintisk",
      "lastName": "Nummersexton"
  },
  {
      "partnerNumberIndividual": "0034154749",
      "employeeId": "198810093982",
      "firstName": "Afferent",
      "lastName": "Utmanövrering"
  },
  {
      "partnerNumberIndividual": "0034154832",
      "employeeId": "198601139465",
      "firstName": "Västmanländsk",
      "lastName": "Lekplatsutrustning"
  },
  {
      "partnerNumberIndividual": "0034154951",
      "employeeId": "198702023774",
      "firstName": "Omedelbart",
      "lastName": "Amerikanskpimpernöt"
  },
  {
      "partnerNumberIndividual": "0034155622",
      "employeeId": "198904196295",
      "firstName": "Datorinriktad",
      "lastName": "Cellteknologi"
  },
  {
      "partnerNumberIndividual": "0034155636",
      "employeeId": "198901140999",
      "firstName": "Taklös",
      "lastName": "Medljud"
  },
  {
      "partnerNumberIndividual": "0034155768",
      "employeeId": "198907163896",
      "firstName": "Heteropolär",
      "lastName": "Pannknöl"
  },
  {
      "partnerNumberIndividual": "0034155829",
      "employeeId": "198908225298",
      "firstName": "Accentfri",
      "lastName": "Riktverkan"
  },
  {
      "partnerNumberIndividual": "0034156413",
      "employeeId": "198701054275",
      "firstName": "Informations",
      "lastName": "Tillhandahållnatjänster"
  },
  {
      "partnerNumberIndividual": "0034157945",
      "employeeId": "198808017282",
      "firstName": "Tänkbar",
      "lastName": "Pappersprodukt"
  },
  {
      "partnerNumberIndividual": "0034158248",
      "employeeId": "198711202872",
      "firstName": "Intevärdig",
      "lastName": "Svarskupong"
  },
  {
      "partnerNumberIndividual": "0034158285",
      "employeeId": "198804223884",
      "firstName": "Knälång",
      "lastName": "Stortungkg"
  },
  {
      "partnerNumberIndividual": "0034158310",
      "employeeId": "198808112786",
      "firstName": "Julpimpande",
      "lastName": "Bolagsstämma"
  },
  {
      "partnerNumberIndividual": "0034158363",
      "employeeId": "198903024290",
      "firstName": "Rörformad",
      "lastName": "Stereoskopkamera"
  },
  {
      "partnerNumberIndividual": "0034158625",
      "employeeId": "198705172479",
      "firstName": "Cyklonartad",
      "lastName": "Bomullslump"
  },
  {
      "partnerNumberIndividual": "0034159009",
      "employeeId": "198801116180",
      "firstName": "Impressionist",
      "lastName": "Väggborrmaskin"
  },
  {
      "partnerNumberIndividual": "0034159326",
      "employeeId": "198504116552",
      "firstName": "Transversell",
      "lastName": "Betongvara"
  },
  {
      "partnerNumberIndividual": "0034160325",
      "employeeId": "198801163786",
      "firstName": "Avtäckt",
      "lastName": "Jobbschema"
  },
  {
      "partnerNumberIndividual": "0034161481",
      "employeeId": "198901093990",
      "firstName": "Fabulös",
      "lastName": "Manchongsida"
  },
  {
      "partnerNumberIndividual": "0034162018",
      "employeeId": "198801205389",
      "firstName": "Småfuktig",
      "lastName": "Avsättningsdom"
  },
  {
      "partnerNumberIndividual": "0034162131",
      "employeeId": "198807098986",
      "firstName": "Finstämd",
      "lastName": "Årsöversikt"
  },
  {
      "partnerNumberIndividual": "0034162183",
      "employeeId": "198809145280",
      "firstName": "Beståndsbildande",
      "lastName": "Glasögonuggla"
  },
  {
      "partnerNumberIndividual": "0034162218",
      "employeeId": "198810018088",
      "firstName": "Rättsvetenskaplig",
      "lastName": "Eaglescout"
  },
  {
      "partnerNumberIndividual": "0034163326",
      "employeeId": "198811209389",
      "firstName": "Anglobrasiliansk",
      "lastName": "Utbytestransfusion"
  },
  {
      "partnerNumberIndividual": "0034163829",
      "employeeId": "198803100687",
      "firstName": "Hanseatisk",
      "lastName": "Markränta"
  },
  {
      "partnerNumberIndividual": "0034163946",
      "employeeId": "198807278281",
      "firstName": "Senare",
      "lastName": "Sidostöttning"
  },
  {
      "partnerNumberIndividual": "0034164935",
      "employeeId": "198401222347",
      "firstName": "Rundnätt",
      "lastName": "Hexaklorcyklohexan"
  },
  {
      "partnerNumberIndividual": "0034165008",
      "employeeId": "198704108979",
      "firstName": "Halvvåt",
      "lastName": "Toppmatch"
  },
  {
      "partnerNumberIndividual": "0034165051",
      "employeeId": "198702113278",
      "firstName": "Parhelisk",
      "lastName": "Störresultanspett"
  },
  {
      "partnerNumberIndividual": "0034165286",
      "employeeId": "198909166491",
      "firstName": "Rovfågelsliknande",
      "lastName": "Skivproducent"
  },
  {
      "partnerNumberIndividual": "0034165397",
      "employeeId": "198602037866",
      "firstName": "Glaciär",
      "lastName": "Pickochpack"
  },
  {
      "partnerNumberIndividual": "0034165586",
      "employeeId": "198703011372",
      "firstName": "Amerikansk",
      "lastName": "Realtid"
  },
  {
      "partnerNumberIndividual": "0034165848",
      "employeeId": "198804222084",
      "firstName": "Individuell",
      "lastName": "Affärsknep"
  },
  {
      "partnerNumberIndividual": "0034165865",
      "employeeId": "198805275685",
      "firstName": "Läckande",
      "lastName": "Ärtprotein"
  },
  {
      "partnerNumberIndividual": "0034166618",
      "employeeId": "198910044091",
      "firstName": "Dubbelbestruken",
      "lastName": "Affischklistrare"
  },
  {
      "partnerNumberIndividual": "0034167238",
      "employeeId": "198708156370",
      "firstName": "Biskops",
      "lastName": "Klosterföreståndarinna"
  },
  {
      "partnerNumberIndividual": "0034167395",
      "employeeId": "198807187888",
      "firstName": "Knälång",
      "lastName": "Gulkronadtyrann"
  },
  {
      "partnerNumberIndividual": "0034167455",
      "employeeId": "198210126721",
      "firstName": "Guldgul",
      "lastName": "Driftsättning"
  },
  {
      "partnerNumberIndividual": "0034167672",
      "employeeId": "198905012392",
      "firstName": "Samhällsmedicinsk",
      "lastName": "Fullnav"
  },
  {
      "partnerNumberIndividual": "0034168309",
      "employeeId": "198803232381",
      "firstName": "Säsongskorrigerad",
      "lastName": "Plattjocklek"
  },
  {
      "partnerNumberIndividual": "0034168477",
      "employeeId": "198707082577",
      "firstName": "Säsongskorrigerad",
      "lastName": "Kopparsvart"
  },
  {
      "partnerNumberIndividual": "0034168485",
      "employeeId": "198804022583",
      "firstName": "Väldifferentierad",
      "lastName": "Hittegodsexpedition"
  },
  {
      "partnerNumberIndividual": "0034168690",
      "employeeId": "198802057383",
      "firstName": "Deriverbar",
      "lastName": "Förkänning"
  },
  {
      "partnerNumberIndividual": "0034169215",
      "employeeId": "198708052074",
      "firstName": "Sommarvarm",
      "lastName": "Ostronodling"
  },
  {
      "partnerNumberIndividual": "0034169822",
      "employeeId": "198411136248",
      "firstName": "Matrelaterad",
      "lastName": "Cykelhandtag"
  },
  {
      "partnerNumberIndividual": "0034169832",
      "employeeId": "198910230591",
      "firstName": "Surrealistisk",
      "lastName": "Kriminalteknisktlaboratorium"
  },
  {
      "partnerNumberIndividual": "0034169894",
      "employeeId": "198704196974",
      "firstName": "Minnessvag",
      "lastName": "Överklassdygd"
  },
  {
      "partnerNumberIndividual": "0034169972",
      "employeeId": "198709222577",
      "firstName": "Medsaltsmak",
      "lastName": "Etylortoformiat"
  },
  {
      "partnerNumberIndividual": "0034170162",
      "employeeId": "198811147886",
      "firstName": "Lödd",
      "lastName": "Ödehus"
  },
  {
      "partnerNumberIndividual": "0034170338",
      "employeeId": "198910177297",
      "firstName": "Underskön",
      "lastName": "Tvådagarstidning"
  },
  {
      "partnerNumberIndividual": "0034171046",
      "employeeId": "198310098234",
      "firstName": "Mesaktig",
      "lastName": "Arglist"
  },
  {
      "partnerNumberIndividual": "0034171180",
      "employeeId": "198709111374",
      "firstName": "Västtysk",
      "lastName": "Naturligläggning"
  },
  {
      "partnerNumberIndividual": "0034172041",
      "employeeId": "198904042895",
      "firstName": "Mestavlägset",
      "lastName": "Signor"
  },
  {
      "partnerNumberIndividual": "0034172182",
      "employeeId": "198706022970",
      "firstName": "Krisdrabbad",
      "lastName": "Ankoretliv"
  },
  {
      "partnerNumberIndividual": "0034172280",
      "employeeId": "198710190573",
      "firstName": "Gudfruktig",
      "lastName": "Domherre"
  },
  {
      "partnerNumberIndividual": "0034172617",
      "employeeId": "198906110898",
      "firstName": "Däst",
      "lastName": "Våtdräkt"
  },
  {
      "partnerNumberIndividual": "0034172738",
      "employeeId": "198005269603",
      "firstName": "Bågig",
      "lastName": "Öljätte"
  },
  {
      "partnerNumberIndividual": "0034172784",
      "employeeId": "198610117262",
      "firstName": "Beige",
      "lastName": "Stranguri"
  },
  {
      "partnerNumberIndividual": "0034172951",
      "employeeId": "198811168981",
      "firstName": "Utanort",
      "lastName": "Djurläkare"
  },
  {
      "partnerNumberIndividual": "0034172998",
      "employeeId": "198907012598",
      "firstName": "Tumultartad",
      "lastName": "Smiley"
  },
  {
      "partnerNumberIndividual": "0034173144",
      "employeeId": "198809152484",
      "firstName": "Utankänsel",
      "lastName": "Lagbud"
  },
  {
      "partnerNumberIndividual": "0034174073",
      "employeeId": "198709056272",
      "firstName": "Obehårad",
      "lastName": "Socioekonomi"
  },
  {
      "partnerNumberIndividual": "0034174213",
      "employeeId": "198805192484",
      "firstName": "Hal",
      "lastName": "Internetmonster"
  },
  {
      "partnerNumberIndividual": "0034175794",
      "employeeId": "198901089196",
      "firstName": "Påfågelsblå",
      "lastName": "Stilsystem"
  },
  {
      "partnerNumberIndividual": "0034176014",
      "employeeId": "198403263844",
      "firstName": "Lykantropisk",
      "lastName": "Hörspel"
  },
  {
      "partnerNumberIndividual": "0034176053",
      "employeeId": "198702196174",
      "firstName": "Nikotin",
      "lastName": "Valkalv"
  },
  {
      "partnerNumberIndividual": "0034176099",
      "employeeId": "198901088594",
      "firstName": "Fortlevande",
      "lastName": "Icketroende"
  },
  {
      "partnerNumberIndividual": "0034176362",
      "employeeId": "198909102298",
      "firstName": "Akvmarinfärgad",
      "lastName": "Jordbruksekonom"
  },
  {
      "partnerNumberIndividual": "0034176711",
      "employeeId": "198704043275",
      "firstName": "Tidstrogen",
      "lastName": "Kontrollmanometer"
  },
  {
      "partnerNumberIndividual": "0034177106",
      "employeeId": "198803150682",
      "firstName": "Lantbruksekonomisk",
      "lastName": "Glasögonuggla"
  },
  {
      "partnerNumberIndividual": "0034177598",
      "employeeId": "198801183982",
      "firstName": "Utdömd",
      "lastName": "Teaterkostym"
  },
  {
      "partnerNumberIndividual": "0034177665",
      "employeeId": "198110132316",
      "firstName": "Tänkbar",
      "lastName": "Gitterkvadrat"
  },
  {
      "partnerNumberIndividual": "0034177949",
      "employeeId": "198809062386",
      "firstName": "Fylletrött",
      "lastName": "Lärofrihet"
  },
  {
      "partnerNumberIndividual": "0034179166",
      "employeeId": "198803047383",
      "firstName": "Inkräktande",
      "lastName": "Världsrekord"
  },
  {
      "partnerNumberIndividual": "0034179180",
      "employeeId": "198704238578",
      "firstName": "Industrihistorisk",
      "lastName": "Guldgrävning"
  },
  {
      "partnerNumberIndividual": "0034179233",
      "employeeId": "198903177999",
      "firstName": "Havs",
      "lastName": "Amskrock"
  },
  {
      "partnerNumberIndividual": "0034179268",
      "employeeId": "198804112384",
      "firstName": "Pressande",
      "lastName": "Flasktransportör"
  },
  {
      "partnerNumberIndividual": "0034179783",
      "employeeId": "198803095887",
      "firstName": "Proportionell",
      "lastName": "Gjutugn"
  },
  {
      "partnerNumberIndividual": "0034179834",
      "employeeId": "198709014370",
      "firstName": "Monografisk",
      "lastName": "Offshoreverksamhet"
  },
  {
      "partnerNumberIndividual": "0034180324",
      "employeeId": "198809020186",
      "firstName": "Georgisk",
      "lastName": "Sandnarv"
  },
  {
      "partnerNumberIndividual": "0034180672",
      "employeeId": "198811172884",
      "firstName": "Uppdragbar",
      "lastName": "Växelryttare"
  },
  {
      "partnerNumberIndividual": "0034180703",
      "employeeId": "198903053794",
      "firstName": "Välsittande",
      "lastName": "Nyckelord"
  },
  {
      "partnerNumberIndividual": "0034180717",
      "employeeId": "198906243798",
      "firstName": "Respektive",
      "lastName": "Returströmbana"
  },
  {
      "partnerNumberIndividual": "0034181175",
      "employeeId": "198809188983",
      "firstName": "Naturstridig",
      "lastName": "Dubbelverkandeaxiallager"
  },
  {
      "partnerNumberIndividual": "0034181751",
      "employeeId": "198904264697",
      "firstName": "Kortskaftad",
      "lastName": "Bomullslump"
  },
  {
      "partnerNumberIndividual": "0034182180",
      "employeeId": "198703040272",
      "firstName": "Häftade",
      "lastName": "Alpsporre"
  },
  {
      "partnerNumberIndividual": "0034182382",
      "employeeId": "198907193695",
      "firstName": "Tuvig",
      "lastName": "Miljöhinder"
  },
  {
      "partnerNumberIndividual": "0034182546",
      "employeeId": "198804085283",
      "firstName": "Koncentrisk",
      "lastName": "Konceptbevis"
  },
  {
      "partnerNumberIndividual": "0034183380",
      "employeeId": "198801233985",
      "firstName": "Märkesskyddad",
      "lastName": "Påsporten"
  },
  {
      "partnerNumberIndividual": "0034183786",
      "employeeId": "198802084783",
      "firstName": "Tätbebyggd",
      "lastName": "Yrkessjukdom"
  },
  {
      "partnerNumberIndividual": "0034184537",
      "employeeId": "198909165899",
      "firstName": "Tight",
      "lastName": "Nordsjöstubb"
  },
  {
      "partnerNumberIndividual": "0034184753",
      "employeeId": "198808232386",
      "firstName": "Sjusärdelesfin",
      "lastName": "Tyrrhenuggla"
  },
  {
      "partnerNumberIndividual": "0034184984",
      "employeeId": "198808199288",
      "firstName": "Bakåtsträvande",
      "lastName": "Kontantköp"
  },
  {
      "partnerNumberIndividual": "0034185371",
      "employeeId": "198809220885",
      "firstName": "Störtskön",
      "lastName": "Offerpris"
  },
  {
      "partnerNumberIndividual": "0034185462",
      "employeeId": "198801142384",
      "firstName": "Endräktig",
      "lastName": "Socioekonomi"
  },
  {
      "partnerNumberIndividual": "0034186887",
      "employeeId": "198805186189",
      "firstName": "Grönbete",
      "lastName": "Resform"
  },
  {
      "partnerNumberIndividual": "0034188173",
      "employeeId": "198904218297",
      "firstName": "Doxologisk",
      "lastName": "Guadalkanalgräsfågel"
  },
  {
      "partnerNumberIndividual": "0034188719",
      "employeeId": "198903219890",
      "firstName": "Bommad",
      "lastName": "Flugsnappare"
  },
  {
      "partnerNumberIndividual": "0034188833",
      "employeeId": "198909143896",
      "firstName": "Industrihistorisk",
      "lastName": "Stenslunga"
  },
  {
      "partnerNumberIndividual": "0034189247",
      "employeeId": "198804037086",
      "firstName": "Ormrik",
      "lastName": "Kalkalg"
  },
  {
      "partnerNumberIndividual": "0034189315",
      "employeeId": "198804270885",
      "firstName": "Hal",
      "lastName": "Stilsystem"
  },
  {
      "partnerNumberIndividual": "0034189601",
      "employeeId": "198706155572",
      "firstName": "Kymig",
      "lastName": "Socioekonomi"
  },
  {
      "partnerNumberIndividual": "0034189974",
      "employeeId": "198911062696",
      "firstName": "Uppodlad",
      "lastName": "Förkänning"
  },
  {
      "partnerNumberIndividual": "0034190864",
      "employeeId": "198808024486",
      "firstName": "Sovrad",
      "lastName": "Trådekerhjul"
  },
  {
      "partnerNumberIndividual": "0034191117",
      "employeeId": "198904173997",
      "firstName": "Domhavande",
      "lastName": "Räntetabell"
  },
  {
      "partnerNumberIndividual": "0034191647",
      "employeeId": "198706223974",
      "firstName": "Felinställd",
      "lastName": "Alkoläsk"
  },
  {
      "partnerNumberIndividual": "0034192588",
      "employeeId": "198704225872",
      "firstName": "Öppenheladagen",
      "lastName": "Småstiltatryck"
  },
  {
      "partnerNumberIndividual": "0034192754",
      "employeeId": "198703139470",
      "firstName": "Färdigutbildad",
      "lastName": "Årsmötesdeltagare"
  },
  {
      "partnerNumberIndividual": "0034193416",
      "employeeId": "198410027844",
      "firstName": "Utelämnad",
      "lastName": "Azur"
  },
  {
      "partnerNumberIndividual": "0034193647",
      "employeeId": "198801227987",
      "firstName": "Allmäntbekant",
      "lastName": "Insektsmundel"
  },
  {
      "partnerNumberIndividual": "0034193690",
      "employeeId": "198805097881",
      "firstName": "Oälskad",
      "lastName": "Trådlöstelefon"
  },
  {
      "partnerNumberIndividual": "0034193723",
      "employeeId": "198806043884",
      "firstName": "Oefterliknelig",
      "lastName": "Getost"
  },
  {
      "partnerNumberIndividual": "0034193991",
      "employeeId": "198908127395",
      "firstName": "Tyst",
      "lastName": "Spraymunstycke"
  },
  {
      "partnerNumberIndividual": "0034194018",
      "employeeId": "198909166194",
      "firstName": "Obrytlig",
      "lastName": "Konservutrustning"
  },
  {
      "partnerNumberIndividual": "0034195239",
      "employeeId": "198508027151",
      "firstName": "Strömsnål",
      "lastName": "Dvärgmalkoha"
  },
  {
      "partnerNumberIndividual": "0034195272",
      "employeeId": "198803232985",
      "firstName": "Halvsfärisk",
      "lastName": "Konventdeltagare"
  },
  {
      "partnerNumberIndividual": "0034195282",
      "employeeId": "198806084888",
      "firstName": "Babylonisk",
      "lastName": "Expojkvän"
  },
  {
      "partnerNumberIndividual": "0034196700",
      "employeeId": "198809166385",
      "firstName": "Interkontinental",
      "lastName": "Karttekniker"
  },
  {
      "partnerNumberIndividual": "0034197733",
      "employeeId": "198901135296",
      "firstName": "Beroendeav",
      "lastName": "Stigförmåga"
  },
  {
      "partnerNumberIndividual": "0034198593",
      "employeeId": "198903273798",
      "firstName": "Brandfri",
      "lastName": "Överklassdygd"
  },
  {
      "partnerNumberIndividual": "0034198942",
      "employeeId": "198809062980",
      "firstName": "Deltid",
      "lastName": "Sidovinst"
  },
  {
      "partnerNumberIndividual": "0034199773",
      "employeeId": "198903232497",
      "firstName": "Sentimental",
      "lastName": "Samhörighet"
  },
  {
      "partnerNumberIndividual": "0034199795",
      "employeeId": "198503056957",
      "firstName": "Ateistisk",
      "lastName": "Källakvisten"
  },
  {
      "partnerNumberIndividual": "0034200503",
      "employeeId": "198903226499",
      "firstName": "Högsvansföring",
      "lastName": "Läkekonst"
  },
  {
      "partnerNumberIndividual": "0034200511",
      "employeeId": "198711056476",
      "firstName": "Logisk",
      "lastName": "Himlenrunthörnet"
  },
  {
      "partnerNumberIndividual": "0034200766",
      "employeeId": "198903225590",
      "firstName": "Handlingsduglig",
      "lastName": "Presbyter"
  },
  {
      "partnerNumberIndividual": "0034200835",
      "employeeId": "198701227277",
      "firstName": "Förbuskad",
      "lastName": "Ordanvändning"
  },
  {
      "partnerNumberIndividual": "0034200882",
      "employeeId": "198810182587",
      "firstName": "Tvågångs",
      "lastName": "Snigelcoua"
  },
  {
      "partnerNumberIndividual": "0034200977",
      "employeeId": "198908250593",
      "firstName": "Osteriliserad",
      "lastName": "Vatikanbiblioteket"
  },
  {
      "partnerNumberIndividual": "0034201963",
      "employeeId": "198101090317",
      "firstName": "Anamorfisk",
      "lastName": "Fribredd"
  },
  {
      "partnerNumberIndividual": "0034202288",
      "employeeId": "198710275275",
      "firstName": "Etnografisk",
      "lastName": "Markränta"
  },
  {
      "partnerNumberIndividual": "0034202348",
      "employeeId": "198802020282",
      "firstName": "Oförlåtande",
      "lastName": "Delbruk"
  },
  {
      "partnerNumberIndividual": "0034203055",
      "employeeId": "198806059286",
      "firstName": "Djurvänlig",
      "lastName": "Köpmansgille"
  },
  {
      "partnerNumberIndividual": "0034203335",
      "employeeId": "198508165456",
      "firstName": "Stingande",
      "lastName": "Fuling"
  },
  {
      "partnerNumberIndividual": "0034203475",
      "employeeId": "198706246579",
      "firstName": "Suggererande",
      "lastName": "Envisman"
  },
  {
      "partnerNumberIndividual": "0034203864",
      "employeeId": "198909209895",
      "firstName": "Företagsbetald",
      "lastName": "Lavulinsyra"
  },
  {
      "partnerNumberIndividual": "0034204185",
      "employeeId": "198807212587",
      "firstName": "Häftade",
      "lastName": "Betongblandning"
  },
  {
      "partnerNumberIndividual": "0034204372",
      "employeeId": "198905199595",
      "firstName": "Obrytlig",
      "lastName": "Plunta"
  },
  {
      "partnerNumberIndividual": "0034204720",
      "employeeId": "198503200951",
      "firstName": "Konvertibel",
      "lastName": "Läckerriska"
  },
  {
      "partnerNumberIndividual": "0034204727",
      "employeeId": "198504052054",
      "firstName": "Hal",
      "lastName": "Medvetandeström"
  },
  {
      "partnerNumberIndividual": "0034206808",
      "employeeId": "198904258095",
      "firstName": "Radhusliknande",
      "lastName": "Directmail"
  },
  {
      "partnerNumberIndividual": "0034207200",
      "employeeId": "198908182499",
      "firstName": "Visuell",
      "lastName": "Filmklubb"
  },
  {
      "partnerNumberIndividual": "0034207341",
      "employeeId": "198702065676",
      "firstName": "Kortskaftad",
      "lastName": "Stadshusmöte"
  },
  {
      "partnerNumberIndividual": "0034207820",
      "employeeId": "198808183282",
      "firstName": "Naiv",
      "lastName": "Årsmötesdeltagare"
  },
  {
      "partnerNumberIndividual": "0034209200",
      "employeeId": "198910022691",
      "firstName": "Bifalls",
      "lastName": "Mossa"
  },
  {
      "partnerNumberIndividual": "0034209523",
      "employeeId": "198805235887",
      "firstName": "Adjektivisk",
      "lastName": "Giftigtämne"
  },
  {
      "partnerNumberIndividual": "0034209779",
      "employeeId": "198705033275",
      "firstName": "Friarmässig",
      "lastName": "Gratulationskort"
  },
  {
      "partnerNumberIndividual": "0034210188",
      "employeeId": "198805119289",
      "firstName": "Rovfågelsliknande",
      "lastName": "Tennjodid"
  },
  {
      "partnerNumberIndividual": "0034210583",
      "employeeId": "198705124272",
      "firstName": "Störtskön",
      "lastName": "Familjelikhet"
  },
  {
      "partnerNumberIndividual": "0034210731",
      "employeeId": "198903227992",
      "firstName": "Däst",
      "lastName": "Karakullamm"
  },
  {
      "partnerNumberIndividual": "0034210866",
      "employeeId": "198805208181",
      "firstName": "Opåvisad",
      "lastName": "Fruktdiet"
  },
  {
      "partnerNumberIndividual": "0034210981",
      "employeeId": "198411051843",
      "firstName": "Havregrynsgröt",
      "lastName": "Skälmeri"
  },
  {
      "partnerNumberIndividual": "0034211330",
      "employeeId": "198711070576",
      "firstName": "Tragikomisk",
      "lastName": "Sändarkrets"
  },
  {
      "partnerNumberIndividual": "0034211451",
      "employeeId": "198708267276",
      "firstName": "Rosig",
      "lastName": "Ärevördighet"
  },
  {
      "partnerNumberIndividual": "0034211782",
      "employeeId": "198704045676",
      "firstName": "Heteropolär",
      "lastName": "Returströmbana"
  },
  {
      "partnerNumberIndividual": "0034211845",
      "employeeId": "198711202575",
      "firstName": "Ametistfärgad",
      "lastName": "Dragbult"
  },
  {
      "partnerNumberIndividual": "0034211872",
      "employeeId": "198802022684",
      "firstName": "Morfisk",
      "lastName": "Magoperation"
  },
  {
      "partnerNumberIndividual": "0034212016",
      "employeeId": "198904148692",
      "firstName": "Ormrik",
      "lastName": "Skenfot"
  },
  {
      "partnerNumberIndividual": "0034212024",
      "employeeId": "198904063099",
      "firstName": "Frontad",
      "lastName": "Asfaltprimer"
  },
  {
      "partnerNumberIndividual": "0034212533",
      "employeeId": "198902259392",
      "firstName": "Renad",
      "lastName": "Grundvattenskydd"
  },
  {
      "partnerNumberIndividual": "0034212918",
      "employeeId": "198506252652",
      "firstName": "Superheterodyn",
      "lastName": "Guldgrävning"
  },
  {
      "partnerNumberIndividual": "0034213016",
      "employeeId": "198902062598",
      "firstName": "Anställd",
      "lastName": "Storskulden"
  },
  {
      "partnerNumberIndividual": "0034213218",
      "employeeId": "198708100576",
      "firstName": "Piprökande",
      "lastName": "Resegaranti"
  },
  {
      "partnerNumberIndividual": "0034213544",
      "employeeId": "198802257488",
      "firstName": "Pressad",
      "lastName": "Våldsgata"
  },
  {
      "partnerNumberIndividual": "0034214205",
      "employeeId": "198903268996",
      "firstName": "Felande",
      "lastName": "Gråbukadtragopan"
  },
  {
      "partnerNumberIndividual": "0034214552",
      "employeeId": "198809098281",
      "firstName": "Kymig",
      "lastName": "Avbärgning"
  },
  {
      "partnerNumberIndividual": "0034214628",
      "employeeId": "198708140671",
      "firstName": "Fabulös",
      "lastName": "Energiflödestäthet"
  },
  {
      "partnerNumberIndividual": "0034214954",
      "employeeId": "198711099575",
      "firstName": "Jordig",
      "lastName": "Duplextalkanal"
  },
  {
      "partnerNumberIndividual": "0034215042",
      "employeeId": "198809200689",
      "firstName": "Föräldrarfin",
      "lastName": "Nyårsgåva"
  },
  {
      "partnerNumberIndividual": "0034215081",
      "employeeId": "198904209890",
      "firstName": "Sammanhållen",
      "lastName": "Tystmajoritet"
  },
  {
      "partnerNumberIndividual": "0034215100",
      "employeeId": "198906132595",
      "firstName": "Proforma",
      "lastName": "Förhörsledare"
  },
  {
      "partnerNumberIndividual": "0034215799",
      "employeeId": "198910043796",
      "firstName": "Snart",
      "lastName": "Flugsnappare"
  },
  {
      "partnerNumberIndividual": "0034215831",
      "employeeId": "198710122477",
      "firstName": "Feldebiterad",
      "lastName": "Decimalmått"
  },
  {
      "partnerNumberIndividual": "0034216051",
      "employeeId": "198109123615",
      "firstName": "Hermitesk",
      "lastName": "Valbarhet"
  },
  {
      "partnerNumberIndividual": "0034216321",
      "employeeId": "198908043295",
      "firstName": "Australiensisk",
      "lastName": "Handöverfräs"
  },
  {
      "partnerNumberIndividual": "0034216825",
      "employeeId": "198209027021",
      "firstName": "Flersidig",
      "lastName": "ERA"
  },
  {
      "partnerNumberIndividual": "0034217568",
      "employeeId": "198807119188",
      "firstName": "Polsktalande",
      "lastName": "Valbarhet"
  },
  {
      "partnerNumberIndividual": "0034218300",
      "employeeId": "198706239970",
      "firstName": "Tilltagen",
      "lastName": "Rostgumpadcanastero"
  },
  {
      "partnerNumberIndividual": "0034218883",
      "employeeId": "198810052384",
      "firstName": "Sydvästra",
      "lastName": "Släthammare"
  },
  {
      "partnerNumberIndividual": "0034219016",
      "employeeId": "198906223295",
      "firstName": "Kiselhaltig",
      "lastName": "Kulvert"
  },
  {
      "partnerNumberIndividual": "0034220091",
      "employeeId": "198805100883",
      "firstName": "Dålig",
      "lastName": "Expatient"
  },
  {
      "partnerNumberIndividual": "0034220907",
      "employeeId": "198803049181",
      "firstName": "Ljuslila",
      "lastName": "Teknikterm"
  },
  {
      "partnerNumberIndividual": "0034221374",
      "employeeId": "198905122696",
      "firstName": "Obeivrad",
      "lastName": "Nollningsvecka"
  },
  {
      "partnerNumberIndividual": "0034221771",
      "employeeId": "198704243974",
      "firstName": "Tiggaraktig",
      "lastName": "Marschformation"
  },
  {
      "partnerNumberIndividual": "0034222037",
      "employeeId": "198707098276",
      "firstName": "Översvinnelig",
      "lastName": "Utsago"
  },
  {
      "partnerNumberIndividual": "0034222131",
      "employeeId": "198807076982",
      "firstName": "Gravimetrisk",
      "lastName": "Giftdryck"
  },
  {
      "partnerNumberIndividual": "0034222162",
      "employeeId": "198702259477",
      "firstName": "Tätbebyggd",
      "lastName": "Startpedal"
  },
  {
      "partnerNumberIndividual": "0034222173",
      "employeeId": "198707146174",
      "firstName": "Genteknologisk",
      "lastName": "Humussyra"
  },
  {
      "partnerNumberIndividual": "0034222254",
      "employeeId": "198711264070",
      "firstName": "Färdigsydd",
      "lastName": "Automobilindustri"
  },
  {
      "partnerNumberIndividual": "0034222289",
      "employeeId": "198904132696",
      "firstName": "Spolad",
      "lastName": "Svartbärpickare"
  },
  {
      "partnerNumberIndividual": "0034223645",
      "employeeId": "198508012351",
      "firstName": "Svåranskaffad",
      "lastName": "Arabiskaalfabetet"
  },
  {
      "partnerNumberIndividual": "0034223846",
      "employeeId": "198806140284",
      "firstName": "Herrskapsliknande",
      "lastName": "Väggkarta"
  },
  {
      "partnerNumberIndividual": "0034224215",
      "employeeId": "198808205580",
      "firstName": "Varkunnsam",
      "lastName": "Delbruk"
  },
  {
      "partnerNumberIndividual": "0034224397",
      "employeeId": "198803159188",
      "firstName": "Daggvåt",
      "lastName": "Blåsvarteufonia"
  },
  {
      "partnerNumberIndividual": "0034224403",
      "employeeId": "198809099180",
      "firstName": "Missbelåten",
      "lastName": "Beklädnadsförråd"
  },
  {
      "partnerNumberIndividual": "0034224551",
      "employeeId": "198804132887",
      "firstName": "Sportig",
      "lastName": "Ickekärnvapenmakt"
  },
  {
      "partnerNumberIndividual": "0034224762",
      "employeeId": "198902126492",
      "firstName": "Ärekär",
      "lastName": "Gitterkvadrat"
  },
  {
      "partnerNumberIndividual": "0034225155",
      "employeeId": "198704017378",
      "firstName": "Hanseatisk",
      "lastName": "Etylortoformiat"
  },
  {
      "partnerNumberIndividual": "0034225730",
      "employeeId": "198907186194",
      "firstName": "Stillasittande",
      "lastName": "Hämtköpsvaruhus"
  },
  {
      "partnerNumberIndividual": "0034225915",
      "employeeId": "198911029299",
      "firstName": "Andragrads",
      "lastName": "Beklädnadsförråd"
  },
  {
      "partnerNumberIndividual": "0034227154",
      "employeeId": "198807228286",
      "firstName": "Bianco",
      "lastName": "Stortungkg"
  },
  {
      "partnerNumberIndividual": "0034227173",
      "employeeId": "198602017363",
      "firstName": "Beklagande",
      "lastName": "Störresultanspett"
  },
  {
      "partnerNumberIndividual": "0034227354",
      "employeeId": "198809145884",
      "firstName": "Utledsen",
      "lastName": "Karakullamm"
  },
  {
      "partnerNumberIndividual": "0034227406",
      "employeeId": "198709189172",
      "firstName": "Kommunalistisk",
      "lastName": "Cyanfettsyror"
  },
  {
      "partnerNumberIndividual": "0034229088",
      "employeeId": "198702270870",
      "firstName": "Tunnsliten",
      "lastName": "Arkivdepå"
  },
  {
      "partnerNumberIndividual": "0034229873",
      "employeeId": "198507169152",
      "firstName": "Oantastlig",
      "lastName": "Karttekniker"
  },
  {
      "partnerNumberIndividual": "0034230034",
      "employeeId": "198805130385",
      "firstName": "Kinesisktalande",
      "lastName": "Stenslunga"
  },
  {
      "partnerNumberIndividual": "0034230194",
      "employeeId": "198909208996",
      "firstName": "Pyroteknisk",
      "lastName": "Baljbotten"
  },
  {
      "partnerNumberIndividual": "0034230949",
      "employeeId": "198803254385",
      "firstName": "Piezomagnetisk",
      "lastName": "Gulkronadmajna"
  },
  {
      "partnerNumberIndividual": "0034231042",
      "employeeId": "198810039183",
      "firstName": "Cirkusaktig",
      "lastName": "Pannstensbildning"
  },
  {
      "partnerNumberIndividual": "0034231526",
      "employeeId": "198702039473",
      "firstName": "Samlarlysten",
      "lastName": "Krökningsgrad"
  },
  {
      "partnerNumberIndividual": "0034231561",
      "employeeId": "198909228598",
      "firstName": "Hormon",
      "lastName": "Palaumarkduva"
  },
  {
      "partnerNumberIndividual": "0034232416",
      "employeeId": "198811153587",
      "firstName": "Bilmekanisk",
      "lastName": "Ickekärnvapenmakt"
  },
  {
      "partnerNumberIndividual": "0034232744",
      "employeeId": "198703254279",
      "firstName": "Åsyna",
      "lastName": "EIDE"
  },
  {
      "partnerNumberIndividual": "0034232756",
      "employeeId": "198808024189",
      "firstName": "Murgrönebekransad",
      "lastName": "Jordräknare"
  },
  {
      "partnerNumberIndividual": "0034232935",
      "employeeId": "198805027383",
      "firstName": "Lättsmältande",
      "lastName": "Returströmbana"
  },
  {
      "partnerNumberIndividual": "0034233109",
      "employeeId": "198907233798",
      "firstName": "Konkretistisk",
      "lastName": "Utbytestransfusion"
  },
  {
      "partnerNumberIndividual": "0034233112",
      "employeeId": "198705165275",
      "firstName": "Exakt",
      "lastName": "Lustslott"
  },
  {
      "partnerNumberIndividual": "0034233114",
      "employeeId": "198906174498",
      "firstName": "Otillämpbar",
      "lastName": "Cellofantejp"
  },
  {
      "partnerNumberIndividual": "0034234294",
      "employeeId": "198101160219",
      "firstName": "Episkopal",
      "lastName": "Väggprydnad"
  },
  {
      "partnerNumberIndividual": "0034235265",
      "employeeId": "198801120984",
      "firstName": "Pleuritisk",
      "lastName": "Trycklocksburk"
  },
  {
      "partnerNumberIndividual": "0034235320",
      "employeeId": "198901134992",
      "firstName": "Introducerad",
      "lastName": "Kaplanturbin"
  },
  {
      "partnerNumberIndividual": "0034235345",
      "employeeId": "198904070599",
      "firstName": "Suppletiv",
      "lastName": "Arktisktklima"
  },
  {
      "partnerNumberIndividual": "0034236629",
      "employeeId": "198705276478",
      "firstName": "Helförsäkrad",
      "lastName": "Förkänning"
  },
  {
      "partnerNumberIndividual": "0034237088",
      "employeeId": "198710136071",
      "firstName": "Ickeofficiell",
      "lastName": "Offerpris"
  },
  {
      "partnerNumberIndividual": "0034237146",
      "employeeId": "198902040297",
      "firstName": "Bombmattefällande",
      "lastName": "Regissör"
  },
  {
      "partnerNumberIndividual": "0034237746",
      "employeeId": "198802064884",
      "firstName": "Absent",
      "lastName": "Gramaner"
  },
  {
      "partnerNumberIndividual": "0034237906",
      "employeeId": "198806197888",
      "firstName": "Industrihistorisk",
      "lastName": "Ljusbågeskydd"
  },
  {
      "partnerNumberIndividual": "0034238119",
      "employeeId": "198801249387",
      "firstName": "Försumlig",
      "lastName": "Strålskyddsrör"
  },
  {
      "partnerNumberIndividual": "0034238830",
      "employeeId": "198707033778",
      "firstName": "Anställd",
      "lastName": "Penningmarknadslån"
  },
  {
      "partnerNumberIndividual": "0034238883",
      "employeeId": "198709189776",
      "firstName": "Avgudadyrkande",
      "lastName": "Internetbokhandel"
  },
  {
      "partnerNumberIndividual": "0034238933",
      "employeeId": "198710045975",
      "firstName": "Köpstark",
      "lastName": "Finansmagnat"
  },
  {
      "partnerNumberIndividual": "0034239112",
      "employeeId": "198803142580",
      "firstName": "Miljövårds",
      "lastName": "Jordmån"
  },
  {
      "partnerNumberIndividual": "0034239215",
      "employeeId": "198805233783",
      "firstName": "Logisk",
      "lastName": "Vidareanvändning"
  },
  {
      "partnerNumberIndividual": "0034239236",
      "employeeId": "198805033985",
      "firstName": "Blåklädd",
      "lastName": "Kaseinfärg"
  },
  {
      "partnerNumberIndividual": "0034239345",
      "employeeId": "198808226388",
      "firstName": "Oantastlig",
      "lastName": "Konjunkturteori"
  },
  {
      "partnerNumberIndividual": "0034239395",
      "employeeId": "198809194387",
      "firstName": "Svårbemästrad",
      "lastName": "Pickochpack"
  },
  {
      "partnerNumberIndividual": "0034239422",
      "employeeId": "198809056081",
      "firstName": "Ometodisk",
      "lastName": "Handöverfräs"
  },
  {
      "partnerNumberIndividual": "0034239479",
      "employeeId": "198811187981",
      "firstName": "Flockblommig",
      "lastName": "Hörspel"
  },
  {
      "partnerNumberIndividual": "0034239566",
      "employeeId": "198901199490",
      "firstName": "Konstintresserad",
      "lastName": "Katepsin"
  },
  {
      "partnerNumberIndividual": "0034239947",
      "employeeId": "198908182796",
      "firstName": "Sydvästra",
      "lastName": "Sandblästerskydd"
  },
  {
      "partnerNumberIndividual": "0034240007",
      "employeeId": "198909186093",
      "firstName": "Nordgrönländsk",
      "lastName": "Stortungkg"
  },
  {
      "partnerNumberIndividual": "0034241789",
      "employeeId": "198804112988",
      "firstName": "Husdjursetisk",
      "lastName": "Blåringadängelfisk"
  },
  {
      "partnerNumberIndividual": "0034242762",
      "employeeId": "198801233084",
      "firstName": "Blårutig",
      "lastName": "Arkivlag"
  },
  {
      "partnerNumberIndividual": "0034243305",
      "employeeId": "198811016180",
      "firstName": "Julpimpande",
      "lastName": "Algtoxin"
  },
  {
      "partnerNumberIndividual": "0034243315",
      "employeeId": "198609020865",
      "firstName": "Orätt",
      "lastName": "Duplextalkanal"
  },
  {
      "partnerNumberIndividual": "0034243575",
      "employeeId": "198810253081",
      "firstName": "Darrhänt",
      "lastName": "Akademikerbarn"
  },
  {
      "partnerNumberIndividual": "0034244511",
      "employeeId": "198805185280",
      "firstName": "Provocerande",
      "lastName": "Avbetalningslag"
  },
  {
      "partnerNumberIndividual": "0034244783",
      "employeeId": "198801204788",
      "firstName": "Illistig",
      "lastName": "Polarexpedition"
  },
  {
      "partnerNumberIndividual": "0034245369",
      "employeeId": "198809036489",
      "firstName": "Georgisk",
      "lastName": "Inloppsrör"
  },
  {
      "partnerNumberIndividual": "0034246047",
      "employeeId": "198907074390",
      "firstName": "Suggererande",
      "lastName": "Åretruntboende"
  },
  {
      "partnerNumberIndividual": "0034246405",
      "employeeId": "198902042699",
      "firstName": "Rundnätt",
      "lastName": "Lastnät"
  },
  {
      "partnerNumberIndividual": "0034246829",
      "employeeId": "198809242582",
      "firstName": "Åsyna",
      "lastName": "Flythjälp"
  },
  {
      "partnerNumberIndividual": "0034246834",
      "employeeId": "198809049482",
      "firstName": "Behandlande",
      "lastName": "Jättefylla"
  },
  {
      "partnerNumberIndividual": "0034247063",
      "employeeId": "198909229190",
      "firstName": "Dubbelbottnad",
      "lastName": "Postsparbanksbok"
  },
  {
      "partnerNumberIndividual": "0034247096",
      "employeeId": "198911029596",
      "firstName": "Riktningsstabil",
      "lastName": "Resegaranti"
  },
  {
      "partnerNumberIndividual": "0034247717",
      "employeeId": "198702107874",
      "firstName": "Framröstad",
      "lastName": "Marknadsfokuserad"
  },
  {
      "partnerNumberIndividual": "0034247876",
      "employeeId": "198706245373",
      "firstName": "Likaberättigad",
      "lastName": "Drossel"
  },
  {
      "partnerNumberIndividual": "0034248238",
      "employeeId": "198805235580",
      "firstName": "Farlig",
      "lastName": "Utmanövrering"
  },
  {
      "partnerNumberIndividual": "0034248304",
      "employeeId": "198806044783",
      "firstName": "Bukig",
      "lastName": "Pupalstadium"
  },
  {
      "partnerNumberIndividual": "0034248377",
      "employeeId": "198808273380",
      "firstName": "Preskriberad",
      "lastName": "Myggblomster"
  },
  {
      "partnerNumberIndividual": "0034248769",
      "employeeId": "198903067992",
      "firstName": "Ejavstavad",
      "lastName": "Fjädervilt"
  },
  {
      "partnerNumberIndividual": "0034249071",
      "employeeId": "198910223992",
      "firstName": "Krabbätande",
      "lastName": "Risktagning"
  },
  {
      "partnerNumberIndividual": "0034249110",
      "employeeId": "198911192295",
      "firstName": "Inkonsekvent",
      "lastName": "Dahliesort"
  },
  {
      "partnerNumberIndividual": "0034249134",
      "employeeId": "198911078395",
      "firstName": "Interparlamentarisk",
      "lastName": "Överste"
  },
  {
      "partnerNumberIndividual": "0034249878",
      "employeeId": "198007184800",
      "firstName": "Sydsvensk",
      "lastName": "Bokstavsträldom"
  },
  {
      "partnerNumberIndividual": "0034249948",
      "employeeId": "198610123864",
      "firstName": "Konstruktiv",
      "lastName": "Hoptryckning"
  },
  {
      "partnerNumberIndividual": "0034250639",
      "employeeId": "198803136582",
      "firstName": "Svår",
      "lastName": "Förstärkare"
  },
  {
      "partnerNumberIndividual": "0034250803",
      "employeeId": "198905254093",
      "firstName": "Uppvärmbar",
      "lastName": "Mexikospadnäbb"
  },
  {
      "partnerNumberIndividual": "0034250996",
      "employeeId": "198801030282",
      "firstName": "Membranlik",
      "lastName": "Kortärm"
  },
  {
      "partnerNumberIndividual": "0034251136",
      "employeeId": "198711258973",
      "firstName": "Konturlös",
      "lastName": "Strålskyddsrör"
  },
  {
      "partnerNumberIndividual": "0034251217",
      "employeeId": "198601096665",
      "firstName": "Situationsanpassad",
      "lastName": "Återflöde"
  },
  {
      "partnerNumberIndividual": "0034251424",
      "employeeId": "198905253798",
      "firstName": "Evinnerligen",
      "lastName": "Redoxkatalysator"
  },
  {
      "partnerNumberIndividual": "0034251789",
      "employeeId": "198801246987",
      "firstName": "Tjänsteförrättande",
      "lastName": "Pengar"
  },
  {
      "partnerNumberIndividual": "0034251809",
      "employeeId": "198801164388",
      "firstName": "Försumlig",
      "lastName": "Oljekastarbricka"
  },
  {
      "partnerNumberIndividual": "0034251813",
      "employeeId": "198806043280",
      "firstName": "Ejavhämtad",
      "lastName": "Krökningsgrad"
  },
  {
      "partnerNumberIndividual": "0034252101",
      "employeeId": "198603096267",
      "firstName": "Förminskad",
      "lastName": "Skiktmoln"
  },
  {
      "partnerNumberIndividual": "0034252616",
      "employeeId": "198805228981",
      "firstName": "Khaki",
      "lastName": "Tvådagarstidning"
  },
  {
      "partnerNumberIndividual": "0034252729",
      "employeeId": "198701207378",
      "firstName": "Glömsk",
      "lastName": "Innehållsindikator"
  },
  {
      "partnerNumberIndividual": "0034254151",
      "employeeId": "198810046683",
      "firstName": "Scenvan",
      "lastName": "Kokainförgiftning"
  },
  {
      "partnerNumberIndividual": "0034254733",
      "employeeId": "198911276999",
      "firstName": "Reglementarisk",
      "lastName": "Allvarsman"
  },
  {
      "partnerNumberIndividual": "0034254801",
      "employeeId": "198805068981",
      "firstName": "Vrickad",
      "lastName": "Fruktdiet"
  },
  {
      "partnerNumberIndividual": "0034255146",
      "employeeId": "198802195985",
      "firstName": "Sekret",
      "lastName": "AssociateinArts"
  },
  {
      "partnerNumberIndividual": "0034255230",
      "employeeId": "198804092784",
      "firstName": "Mördad",
      "lastName": "Dunbar"
  },
  {
      "partnerNumberIndividual": "0034256660",
      "employeeId": "198303113339",
      "firstName": "Pektin",
      "lastName": "Totalomkostnad"
  },
  {
      "partnerNumberIndividual": "0034257331",
      "employeeId": "198804238981",
      "firstName": "Oljeproducerande",
      "lastName": "Genomstickning"
  },
  {
      "partnerNumberIndividual": "0034257887",
      "employeeId": "198201070821",
      "firstName": "Durativ",
      "lastName": "Svetsanordning"
  },
  {
      "partnerNumberIndividual": "0034258090",
      "employeeId": "198801108989",
      "firstName": "Ejkonvertibel",
      "lastName": "Fodermjöl"
  },
  {
      "partnerNumberIndividual": "0034258098",
      "employeeId": "198804176280",
      "firstName": "Gladiatorklädd",
      "lastName": "Luftstrupe"
  },
  {
      "partnerNumberIndividual": "0034258247",
      "employeeId": "198909240296",
      "firstName": "Levrad",
      "lastName": "Nyckelord"
  },
  {
      "partnerNumberIndividual": "0034258926",
      "employeeId": "198704162570",
      "firstName": "Skärbar",
      "lastName": "Aktiebank"
  },
  {
      "partnerNumberIndividual": "0034259192",
      "employeeId": "198911076290",
      "firstName": "Bilmekanisk",
      "lastName": "Dykdjup"
  },
  {
      "partnerNumberIndividual": "0034259247",
      "employeeId": "198904215897",
      "firstName": "Kapitalistisk",
      "lastName": "Regleringssteg"
  },
  {
      "partnerNumberIndividual": "0034259404",
      "employeeId": "198905081397",
      "firstName": "Illa",
      "lastName": "Politisksociologi"
  },
  {
      "partnerNumberIndividual": "0034259618",
      "employeeId": "198904056499",
      "firstName": "Nittioårs",
      "lastName": "Avdragsregel"
  },
  {
      "partnerNumberIndividual": "0034259733",
      "employeeId": "198911034091",
      "firstName": "Obäddad",
      "lastName": "Energiflödestäthet"
  },
  {
      "partnerNumberIndividual": "0034260064",
      "employeeId": "198702085278",
      "firstName": "Nykomponerad",
      "lastName": "Fregattfågel"
  },
  {
      "partnerNumberIndividual": "0034260536",
      "employeeId": "198911049495",
      "firstName": "Välhängd",
      "lastName": "Bullerochbång"
  },
  {
      "partnerNumberIndividual": "0034261167",
      "employeeId": "198804196189",
      "firstName": "Knäckt",
      "lastName": "Gulbentflugskvätta"
  },
  {
      "partnerNumberIndividual": "0034261437",
      "employeeId": "198904202598",
      "firstName": "Darrhänt",
      "lastName": "Hike"
  },
  {
      "partnerNumberIndividual": "0034261748",
      "employeeId": "198901184096",
      "firstName": "Beroendeav",
      "lastName": "Sidostöttning"
  },
  {
      "partnerNumberIndividual": "0034261886",
      "employeeId": "198102187617",
      "firstName": "Tjänsteförrättande",
      "lastName": "Getberget"
  },
  {
      "partnerNumberIndividual": "0034261888",
      "employeeId": "198401242840",
      "firstName": "Sekret",
      "lastName": "Stilsystem"
  },
  {
      "partnerNumberIndividual": "0034261945",
      "employeeId": "198709244274",
      "firstName": "Tvågångs",
      "lastName": "Omgestaltning"
  },
  {
      "partnerNumberIndividual": "0034262545",
      "employeeId": "198803069387",
      "firstName": "Hanseatisk",
      "lastName": "Ekosofi"
  },
  {
      "partnerNumberIndividual": "0034262730",
      "employeeId": "198801069181",
      "firstName": "Radiostyrd",
      "lastName": "Acetofenon"
  },
  {
      "partnerNumberIndividual": "0034263157",
      "employeeId": "198705118274",
      "firstName": "Ensamma",
      "lastName": "Fettfärg"
  },
  {
      "partnerNumberIndividual": "0034263174",
      "employeeId": "198802169485",
      "firstName": "Farlig",
      "lastName": "Svetsanordning"
  },
  {
      "partnerNumberIndividual": "0034263389",
      "employeeId": "198801178586",
      "firstName": "Bifokal",
      "lastName": "Ledarställning"
  },
  {
      "partnerNumberIndividual": "0034263643",
      "employeeId": "198810204282",
      "firstName": "Pleuritisk",
      "lastName": "Lamaull"
  },
  {
      "partnerNumberIndividual": "0034263810",
      "employeeId": "198705279175",
      "firstName": "Numerär",
      "lastName": "Vätgaselektrod"
  },
  {
      "partnerNumberIndividual": "0034263829",
      "employeeId": "198707060573",
      "firstName": "Kokett",
      "lastName": "Alkaliskcell"
  },
  {
      "partnerNumberIndividual": "0034263831",
      "employeeId": "198707078070",
      "firstName": "Torkkänslig",
      "lastName": "Magoperation"
  },
  {
      "partnerNumberIndividual": "0034263837",
      "employeeId": "198708199172",
      "firstName": "Irreal",
      "lastName": "Widescreenskärm"
  },
  {
      "partnerNumberIndividual": "0034263960",
      "employeeId": "198903122797",
      "firstName": "Atypisk",
      "lastName": "Tjänsteman"
  },
  {
      "partnerNumberIndividual": "0034264100",
      "employeeId": "198108016414",
      "firstName": "Nordisk",
      "lastName": "Vatikanbiblioteket"
  },
  {
      "partnerNumberIndividual": "0034264537",
      "employeeId": "198706224279",
      "firstName": "Urskiljbar",
      "lastName": "Etylortoformiat"
  },
  {
      "partnerNumberIndividual": "0034265296",
      "employeeId": "198906042497",
      "firstName": "Ejavhämtad",
      "lastName": "Genomsnittsvikt"
  },
  {
      "partnerNumberIndividual": "0034266362",
      "employeeId": "198702156079",
      "firstName": "Saknad",
      "lastName": "Jättefylla"
  },
  {
      "partnerNumberIndividual": "0034266480",
      "employeeId": "198301125830",
      "firstName": "Tillvitas",
      "lastName": "Svartstreckadhonungsfågel"
  },
  {
      "partnerNumberIndividual": "0034266551",
      "employeeId": "198705209271",
      "firstName": "Intevärdig",
      "lastName": "Midsommarsol"
  },
  {
      "partnerNumberIndividual": "0034267026",
      "employeeId": "198910226391",
      "firstName": "Antistatisk",
      "lastName": "Byggnadsritare"
  },
  {
      "partnerNumberIndividual": "0034267201",
      "employeeId": "198902105991",
      "firstName": "Storbystad",
      "lastName": "Sjuplaning"
  },
  {
      "partnerNumberIndividual": "0034267715",
      "employeeId": "198706039271",
      "firstName": "Lättsmältande",
      "lastName": "Varumärkesrätt"
  },
  {
      "partnerNumberIndividual": "0034268868",
      "employeeId": "198808109188",
      "firstName": "Rusig",
      "lastName": "Mesvisslare"
  },
  {
      "partnerNumberIndividual": "0034269372",
      "employeeId": "198804189887",
      "firstName": "Storbystad",
      "lastName": "Våtdräkt"
  },
  {
      "partnerNumberIndividual": "0034269584",
      "employeeId": "198809173282",
      "firstName": "Kartagisk",
      "lastName": "Kalkaneus"
  },
  {
      "partnerNumberIndividual": "0034269857",
      "employeeId": "198806155688",
      "firstName": "Uppodlad",
      "lastName": "Platå"
  },
  {
      "partnerNumberIndividual": "0034269902",
      "employeeId": "198901120199",
      "firstName": "Brännskadad",
      "lastName": "Begravningsgudstjänst"
  },
  {
      "partnerNumberIndividual": "0034270271",
      "employeeId": "198805144287",
      "firstName": "Vikariats",
      "lastName": "Envisman"
  },
  {
      "partnerNumberIndividual": "0034270463",
      "employeeId": "198808224284",
      "firstName": "EUanställd",
      "lastName": "Mönsterexemplar"
  },
  {
      "partnerNumberIndividual": "0034270477",
      "employeeId": "198904014290",
      "firstName": "Opatriotisk",
      "lastName": "Bradykinin"
  },
  {
      "partnerNumberIndividual": "0034270586",
      "employeeId": "198710142673",
      "firstName": "Konstnärlig",
      "lastName": "Läkarspalt"
  },
  {
      "partnerNumberIndividual": "0034271185",
      "employeeId": "198903199993",
      "firstName": "Logisk",
      "lastName": "Yrkesbrev"
  },
  {
      "partnerNumberIndividual": "0034271721",
      "employeeId": "198211212827",
      "firstName": "Antikolonial",
      "lastName": "Epitelcell"
  },
  {
      "partnerNumberIndividual": "0034271977",
      "employeeId": "198810113889",
      "firstName": "Frapperande",
      "lastName": "Kinesisktaggsovare"
  },
  {
      "partnerNumberIndividual": "0034273088",
      "employeeId": "198809076287",
      "firstName": "Specialkonstruerad",
      "lastName": "Eaglescout"
  },
  {
      "partnerNumberIndividual": "0034273867",
      "employeeId": "198908246393",
      "firstName": "Avgudadyrkande",
      "lastName": "Lekplatsutrustning"
  },
  {
      "partnerNumberIndividual": "0034274078",
      "employeeId": "198807102887",
      "firstName": "Spansk",
      "lastName": "Insprutningsförgasare"
  },
  {
      "partnerNumberIndividual": "0034274659",
      "employeeId": "198811079485",
      "firstName": "Laglös",
      "lastName": "Ringbrynja"
  },
  {
      "partnerNumberIndividual": "0034275497",
      "employeeId": "198808120284",
      "firstName": "Kraft",
      "lastName": "Signor"
  },
  {
      "partnerNumberIndividual": "0034277258",
      "employeeId": "198208166325",
      "firstName": "Eolitisk",
      "lastName": "Äkthet"
  },
  {
      "partnerNumberIndividual": "0034278568",
      "employeeId": "198805123182",
      "firstName": "Nattblå",
      "lastName": "Revision"
  },
  {
      "partnerNumberIndividual": "0034279301",
      "employeeId": "198802132087",
      "firstName": "Riktningsstabil",
      "lastName": "Fraktionsdestillation"
  },
  {
      "partnerNumberIndividual": "0034279609",
      "employeeId": "198803158289",
      "firstName": "Proportionell",
      "lastName": "Lågfjäll"
  },
  {
      "partnerNumberIndividual": "0034280250",
      "employeeId": "198908175899",
      "firstName": "Beviljbar",
      "lastName": "Blåsvarteufonia"
  },
  {
      "partnerNumberIndividual": "0034280989",
      "employeeId": "198802044084",
      "firstName": "Obäddad",
      "lastName": "Inteckningshandling"
  },
  {
      "partnerNumberIndividual": "0034281566",
      "employeeId": "198903115890",
      "firstName": "Pankreatisk",
      "lastName": "Öppenvårdsbesök"
  },
  {
      "partnerNumberIndividual": "0034282108",
      "employeeId": "198710116172",
      "firstName": "Närsynt",
      "lastName": "Droppeihavet"
  },
  {
      "partnerNumberIndividual": "0034282202",
      "employeeId": "198706120873",
      "firstName": "Sjöfarande",
      "lastName": "Expatient"
  },
  {
      "partnerNumberIndividual": "0034282211",
      "employeeId": "198708039774",
      "firstName": "Översvinnelig",
      "lastName": "Åkerböna"
  },
  {
      "partnerNumberIndividual": "0034282981",
      "employeeId": "198701207972",
      "firstName": "Nikotin",
      "lastName": "Macquarierall"
  },
  {
      "partnerNumberIndividual": "0034283262",
      "employeeId": "198707236579",
      "firstName": "Vedisk",
      "lastName": "Regionaltstöd"
  },
  {
      "partnerNumberIndividual": "0034283687",
      "employeeId": "198805137984",
      "firstName": "Jordbruksmässig",
      "lastName": "Trycklocksburk"
  },
  {
      "partnerNumberIndividual": "0034283700",
      "employeeId": "198805187088",
      "firstName": "Levnadstrött",
      "lastName": "Förhandsbetalning"
  },
  {
      "partnerNumberIndividual": "0034283959",
      "employeeId": "198811167488",
      "firstName": "Hormon",
      "lastName": "Pickochpack"
  },
  {
      "partnerNumberIndividual": "0034284056",
      "employeeId": "198902256992",
      "firstName": "Ihopvikbar",
      "lastName": "Inkassoperiod"
  },
  {
      "partnerNumberIndividual": "0034284181",
      "employeeId": "198908113791",
      "firstName": "Urfunktion",
      "lastName": "Automobilindustri"
  },
  {
      "partnerNumberIndividual": "0034284435",
      "employeeId": "198708267870",
      "firstName": "Riktningsstabil",
      "lastName": "Betongblandning"
  },
  {
      "partnerNumberIndividual": "0034284456",
      "employeeId": "198803122681",
      "firstName": "Individuell",
      "lastName": "Startström"
  },
  {
      "partnerNumberIndividual": "0034284519",
      "employeeId": "198907027398",
      "firstName": "Förtörnadpå",
      "lastName": "Rödöradbulbyl"
  },
  {
      "partnerNumberIndividual": "0034284650",
      "employeeId": "198803205288",
      "firstName": "Västtysk",
      "lastName": "Miljöhinder"
  },
  {
      "partnerNumberIndividual": "0034284884",
      "employeeId": "198508122655",
      "firstName": "Femtonhundratals",
      "lastName": "Medelhansvärlden"
  },
  {
      "partnerNumberIndividual": "0034285166",
      "employeeId": "198804078981",
      "firstName": "Hankönad",
      "lastName": "Sockerbagare"
  },
  {
      "partnerNumberIndividual": "0034286315",
      "employeeId": "198911214297",
      "firstName": "Ametistliknande",
      "lastName": "Drossel"
  },
  {
      "partnerNumberIndividual": "0034287234",
      "employeeId": "198403042347",
      "firstName": "Oförtruten",
      "lastName": "Moskovit"
  },
  {
      "partnerNumberIndividual": "0034288448",
      "employeeId": "198808025681",
      "firstName": "Opublicerad",
      "lastName": "Kaliumtiocyanat"
  },
  {
      "partnerNumberIndividual": "0034288864",
      "employeeId": "198707147370",
      "firstName": "Huvudsaklig",
      "lastName": "Hukställning"
  },
  {
      "partnerNumberIndividual": "0034289866",
      "employeeId": "198902258790",
      "firstName": "Spikrak",
      "lastName": "Nivåfluktuation"
  },
  {
      "partnerNumberIndividual": "0034290398",
      "employeeId": "198806250885",
      "firstName": "Termostatstyrd",
      "lastName": "Utländskmoderbolag"
  },
  {
      "partnerNumberIndividual": "0034291308",
      "employeeId": "198809256186",
      "firstName": "Persulfat",
      "lastName": "Sändarkrets"
  },
  {
      "partnerNumberIndividual": "0034291443",
      "employeeId": "198911173295",
      "firstName": "Frontad",
      "lastName": "Jordenssalt"
  },
  {
      "partnerNumberIndividual": "0034292269",
      "employeeId": "198103219518",
      "firstName": "Frapperande",
      "lastName": "Täckning"
  },
  {
      "partnerNumberIndividual": "0034292860",
      "employeeId": "198706183277",
      "firstName": "Srilankesisk",
      "lastName": "Justeringavfinansiellöversikt"
  },
  {
      "partnerNumberIndividual": "0034292992",
      "employeeId": "198906106995",
      "firstName": "Tiohörnig",
      "lastName": "Nickel"
  },
  {
      "partnerNumberIndividual": "0034293184",
      "employeeId": "198510159653",
      "firstName": "Angloholländsk",
      "lastName": "Terum"
  },
  {
      "partnerNumberIndividual": "0034293629",
      "employeeId": "198703187370",
      "firstName": "Handlingsklar",
      "lastName": "Stenbädd"
  },
  {
      "partnerNumberIndividual": "0034293955",
      "employeeId": "198705014275",
      "firstName": "Informations",
      "lastName": "Chokladtyrann"
  },
  {
      "partnerNumberIndividual": "0034293960",
      "employeeId": "198706025379",
      "firstName": "Försumlig",
      "lastName": "Barfrost"
  },
  {
      "partnerNumberIndividual": "0034294133",
      "employeeId": "198807054088",
      "firstName": "Välsittande",
      "lastName": "Ekorrbäver"
  },
  {
      "partnerNumberIndividual": "0034294399",
      "employeeId": "198810142185",
      "firstName": "Jävelns",
      "lastName": "Segmentering"
  },
  {
      "partnerNumberIndividual": "0034294784",
      "employeeId": "198704092975",
      "firstName": "Sjöfarande",
      "lastName": "Bariumprotoxide"
  },
  {
      "partnerNumberIndividual": "0034295079",
      "employeeId": "198902110793",
      "firstName": "Ovis",
      "lastName": "Plättpanna"
  },
  {
      "partnerNumberIndividual": "0034295159",
      "employeeId": "198704197279",
      "firstName": "Svåranträffbar",
      "lastName": "Baljbotten"
  },
  {
      "partnerNumberIndividual": "0034295370",
      "employeeId": "198906224194",
      "firstName": "Störtförälskad",
      "lastName": "Baalsdyrkan"
  },
  {
      "partnerNumberIndividual": "0034295400",
      "employeeId": "198811214785",
      "firstName": "Otillfredsställd",
      "lastName": "Gurkhakniv"
  },
  {
      "partnerNumberIndividual": "0034295751",
      "employeeId": "198811235889",
      "firstName": "Kinesisktalande",
      "lastName": "Obemärkthet"
  },
  {
      "partnerNumberIndividual": "0034296049",
      "employeeId": "198703061674",
      "firstName": "Vardagslik",
      "lastName": "Plättpanna"
  },
  {
      "partnerNumberIndividual": "0034296170",
      "employeeId": "198903072794",
      "firstName": "Företagsbetald",
      "lastName": "Fenobarbitol"
  },
  {
      "partnerNumberIndividual": "0034296257",
      "employeeId": "198902146391",
      "firstName": "Inkräktande",
      "lastName": "Godistillverkning"
  },
  {
      "partnerNumberIndividual": "0034296369",
      "employeeId": "198709188273",
      "firstName": "Bas",
      "lastName": "Restaurationskomedi"
  },
  {
      "partnerNumberIndividual": "0034296377",
      "employeeId": "198802168289",
      "firstName": "Samskole",
      "lastName": "Yrkessjukdom"
  },
  {
      "partnerNumberIndividual": "0034296468",
      "employeeId": "198907055399",
      "firstName": "Inkonsekvent",
      "lastName": "Cykelhandtag"
  },
  {
      "partnerNumberIndividual": "0034296628",
      "employeeId": "198810163280",
      "firstName": "Hormon",
      "lastName": "Beklädnadsförråd"
  },
  {
      "partnerNumberIndividual": "0034297319",
      "employeeId": "198902118994",
      "firstName": "Utlämningsbar",
      "lastName": "Laddapparat"
  },
  {
      "partnerNumberIndividual": "0034297427",
      "employeeId": "198709172574",
      "firstName": "Varefter",
      "lastName": "Insektsmundel"
  },
  {
      "partnerNumberIndividual": "0034297746",
      "employeeId": "198808044088",
      "firstName": "Bokstavlig",
      "lastName": "Lagbud"
  },
  {
      "partnerNumberIndividual": "0034298428",
      "employeeId": "198206099528",
      "firstName": "Olycksbenägen",
      "lastName": "Sjukvårdsinrättning"
  },
  {
      "partnerNumberIndividual": "0034298595",
      "employeeId": "198902077398",
      "firstName": "Tyst",
      "lastName": "Amskrock"
  },
  {
      "partnerNumberIndividual": "0034298645",
      "employeeId": "198707208578",
      "firstName": "Hermitesk",
      "lastName": "Nageltrång"
  },
  {
      "partnerNumberIndividual": "0034298879",
      "employeeId": "198710093272",
      "firstName": "Zen",
      "lastName": "Tomgångsström"
  },
  {
      "partnerNumberIndividual": "0034299040",
      "employeeId": "198906107290",
      "firstName": "Homopolymerisk",
      "lastName": "Klagorop"
  },
  {
      "partnerNumberIndividual": "0034299051",
      "employeeId": "198907275690",
      "firstName": "Oklippt",
      "lastName": "Intvålning"
  },
  {
      "partnerNumberIndividual": "0034299063",
      "employeeId": "198908087292",
      "firstName": "Underårig",
      "lastName": "Jobbredovisning"
  },
  {
      "partnerNumberIndividual": "0034299299",
      "employeeId": "198507169756",
      "firstName": "Territorial",
      "lastName": "Spiralfjäder"
  },
  {
      "partnerNumberIndividual": "0034300007",
      "employeeId": "198711020878",
      "firstName": "Råkall",
      "lastName": "Bortval"
  },
  {
      "partnerNumberIndividual": "0034300031",
      "employeeId": "198802243280",
      "firstName": "Fastnitad",
      "lastName": "Svek"
  },
  {
      "partnerNumberIndividual": "0034300351",
      "employeeId": "198805139485",
      "firstName": "Konstnärlig",
      "lastName": "Fettfärg"
  },
  {
      "partnerNumberIndividual": "0034300739",
      "employeeId": "198711042575",
      "firstName": "Konkret",
      "lastName": "Ansiktsvenen"
  },
  {
      "partnerNumberIndividual": "0034301362",
      "employeeId": "198804065681",
      "firstName": "Fingrad",
      "lastName": "Tennjodid"
  },
  {
      "partnerNumberIndividual": "0034302632",
      "employeeId": "198907139193",
      "firstName": "Durativ",
      "lastName": "Porslinsmålning"
  },
  {
      "partnerNumberIndividual": "0034302752",
      "employeeId": "198903252693",
      "firstName": "Gråaktig",
      "lastName": "Alpsporre"
  },
  {
      "partnerNumberIndividual": "0034303014",
      "employeeId": "198806202381",
      "firstName": "Puckelformig",
      "lastName": "Hörspel"
  },
  {
      "partnerNumberIndividual": "0034303420",
      "employeeId": "198805013789",
      "firstName": "Björnaktig",
      "lastName": "Inkassoperiod"
  },
  {
      "partnerNumberIndividual": "0034303437",
      "employeeId": "198904153791",
      "firstName": "Hängmörad",
      "lastName": "Obemärkthet"
  },
  {
      "partnerNumberIndividual": "0034303443",
      "employeeId": "198906173896",
      "firstName": "Membranlik",
      "lastName": "Himlenrunthörnet"
  },
  {
      "partnerNumberIndividual": "0034303456",
      "employeeId": "198405022347",
      "firstName": "Bulldogslik",
      "lastName": "Fregattfågel"
  },
  {
      "partnerNumberIndividual": "0034303503",
      "employeeId": "198804272683",
      "firstName": "Aggregerad",
      "lastName": "Lastningselevator"
  },
  {
      "partnerNumberIndividual": "0034303757",
      "employeeId": "198801074280",
      "firstName": "Linje",
      "lastName": "Försäkringskostnad"
  },
  {
      "partnerNumberIndividual": "0034304077",
      "employeeId": "198201132324",
      "firstName": "Laglös",
      "lastName": "Anföringsverb"
  },
  {
      "partnerNumberIndividual": "0034304084",
      "employeeId": "198901266992",
      "firstName": "Fotostat",
      "lastName": "Konventdeltagare"
  },
  {
      "partnerNumberIndividual": "0034305023",
      "employeeId": "198809172383",
      "firstName": "Gentlemannalik",
      "lastName": "Kemtvättsinrättning"
  },
  {
      "partnerNumberIndividual": "0034305051",
      "employeeId": "198801178289",
      "firstName": "Pittoresk",
      "lastName": "Ugnsgaller"
  },
  {
      "partnerNumberIndividual": "0034305204",
      "employeeId": "198704219578",
      "firstName": "Evasiv",
      "lastName": "Godistillverkning"
  },
  {
      "partnerNumberIndividual": "0034305585",
      "employeeId": "198704156275",
      "firstName": "Femtusenårig",
      "lastName": "Lastnät"
  },
  {
      "partnerNumberIndividual": "0034305991",
      "employeeId": "198506190258",
      "firstName": "Vattenburen",
      "lastName": "Akademikerbarn"
  },
  {
      "partnerNumberIndividual": "0034305998",
      "employeeId": "198704140873",
      "firstName": "Motsidig",
      "lastName": "Investeringsfond"
  },
  {
      "partnerNumberIndividual": "0034306018",
      "employeeId": "198809040986",
      "firstName": "Fortlevande",
      "lastName": "Längdskidlopp"
  },
  {
      "partnerNumberIndividual": "0034306157",
      "employeeId": "198709147279",
      "firstName": "Hedersam",
      "lastName": "Tempocykel"
  },
  {
      "partnerNumberIndividual": "0034306435",
      "employeeId": "198905249895",
      "firstName": "Leklysten",
      "lastName": "Skiktmoln"
  },
  {
      "partnerNumberIndividual": "0034306832",
      "employeeId": "198808038981",
      "firstName": "Gulgrön",
      "lastName": "Sandblästerskydd"
  },
  {
      "partnerNumberIndividual": "0034308307",
      "employeeId": "198702042477",
      "firstName": "Outhärdlig",
      "lastName": "Kriminalteknisktlaboratorium"
  },
  {
      "partnerNumberIndividual": "0034309066",
      "employeeId": "198401259141",
      "firstName": "Brännskadad",
      "lastName": "Omgestaltning"
  },
  {
      "partnerNumberIndividual": "0034310523",
      "employeeId": "198303020237",
      "firstName": "Respektive",
      "lastName": "Cateringverksamhet"
  },
  {
      "partnerNumberIndividual": "0034310546",
      "employeeId": "198309267337",
      "firstName": "Trefokals",
      "lastName": "Stannosulfid"
  },
  {
      "partnerNumberIndividual": "0034310942",
      "employeeId": "198704218372",
      "firstName": "Vattrad",
      "lastName": "Cellteknologi"
  },
  {
      "partnerNumberIndividual": "0034311122",
      "employeeId": "198708100279",
      "firstName": "Envis",
      "lastName": "Stridstyrka"
  },
  {
      "partnerNumberIndividual": "0034311143",
      "employeeId": "198708219376",
      "firstName": "Fullskalig",
      "lastName": "Arkiater"
  },
  {
      "partnerNumberIndividual": "0034311168",
      "employeeId": "198709104478",
      "firstName": "Video",
      "lastName": "Förhörsledare"
  },
  {
      "partnerNumberIndividual": "0034311278",
      "employeeId": "198711264377",
      "firstName": "Sköplig",
      "lastName": "Medhjälpare"
  },
  {
      "partnerNumberIndividual": "0034311338",
      "employeeId": "198806092980",
      "firstName": "Rundnätt",
      "lastName": "Läkemedelskontroll"
  },
  {
      "partnerNumberIndividual": "0034311426",
      "employeeId": "198809012688",
      "firstName": "Närsynt",
      "lastName": "Dränglön"
  },
  {
      "partnerNumberIndividual": "0034313161",
      "employeeId": "198807261386",
      "firstName": "Anankastisk",
      "lastName": "Känsloskala"
  },
  {
      "partnerNumberIndividual": "0034313218",
      "employeeId": "198706107375",
      "firstName": "Alkalilöslig",
      "lastName": "Droppeihavet"
  },
  {
      "partnerNumberIndividual": "0034313987",
      "employeeId": "198807165884",
      "firstName": "Gladiatorklädd",
      "lastName": "Avloppsslam"
  },
  {
      "partnerNumberIndividual": "0034314252",
      "employeeId": "198302247831",
      "firstName": "Inkräktande",
      "lastName": "Modem"
  },
  {
      "partnerNumberIndividual": "0034314281",
      "employeeId": "198401258549",
      "firstName": "Arkadförsedd",
      "lastName": "Upplevelseindustri"
  },
  {
      "partnerNumberIndividual": "0034314616",
      "employeeId": "198705171570",
      "firstName": "Okomprimerbar",
      "lastName": "Energiflödestäthet"
  },
  {
      "partnerNumberIndividual": "0034314983",
      "employeeId": "198810232887",
      "firstName": "Genomlysande",
      "lastName": "Svetsanordning"
  },
  {
      "partnerNumberIndividual": "0034315074",
      "employeeId": "198902215691",
      "firstName": "Laglös",
      "lastName": "Neurotiker"
  },
  {
      "partnerNumberIndividual": "0034316366",
      "employeeId": "198603234264",
      "firstName": "Rättad",
      "lastName": "Gruppbildning"
  },
  {
      "partnerNumberIndividual": "0034316704",
      "employeeId": "198706050971",
      "firstName": "Denaturerad",
      "lastName": "Borgerskap"
  },
  {
      "partnerNumberIndividual": "0034317528",
      "employeeId": "198608052869",
      "firstName": "Havsrättslig",
      "lastName": "Gruppcentral"
  },
  {
      "partnerNumberIndividual": "0034317531",
      "employeeId": "198611038863",
      "firstName": "Tillföljdav",
      "lastName": "Skirning"
  },
  {
      "partnerNumberIndividual": "0034318117",
      "employeeId": "198905138999",
      "firstName": "Tråd",
      "lastName": "Elektrodspänning"
  },
  {
      "partnerNumberIndividual": "0034319213",
      "employeeId": "198901121395",
      "firstName": "Cykelburen",
      "lastName": "Algtoxin"
  },
  {
      "partnerNumberIndividual": "0034319535",
      "employeeId": "198802112485",
      "firstName": "Pankreatisk",
      "lastName": "Dagspris"
  },
  {
      "partnerNumberIndividual": "0034319754",
      "employeeId": "198808114287",
      "firstName": "Ärekär",
      "lastName": "Broskvävnad"
  },
  {
      "partnerNumberIndividual": "0034320333",
      "employeeId": "198811216285",
      "firstName": "Datormanipulerad",
      "lastName": "Därvaro"
  },
  {
      "partnerNumberIndividual": "0034320714",
      "employeeId": "198703179872",
      "firstName": "Urfunktion",
      "lastName": "Läckerriska"
  },
  {
      "partnerNumberIndividual": "0034320751",
      "employeeId": "198707258276",
      "firstName": "Visuell",
      "lastName": "Bokstavsträldom"
  },
  {
      "partnerNumberIndividual": "0034321597",
      "employeeId": "198807119485",
      "firstName": "Georgisk",
      "lastName": "Halvpence"
  },
  {
      "partnerNumberIndividual": "0034334169",
      "employeeId": "198901023799",
      "firstName": "Påhittig",
      "lastName": "Hjärtskiljevägg"
  },
  {
      "partnerNumberIndividual": "0034334176",
      "employeeId": "198901026198",
      "firstName": "Elokvent",
      "lastName": "Öglemutter"
  },
  {
      "partnerNumberIndividual": "0034334235",
      "employeeId": "198901072598",
      "firstName": "Lantbruksekonomisk",
      "lastName": "Gerillakamp"
  },
  {
      "partnerNumberIndividual": "0034334700",
      "employeeId": "198903163791",
      "firstName": "Import",
      "lastName": "Epitelcell"
  },
  {
      "partnerNumberIndividual": "0034334922",
      "employeeId": "198903010992",
      "firstName": "Kostymerad",
      "lastName": "Jordbrukszon"
  },
  {
      "partnerNumberIndividual": "0034335037",
      "employeeId": "198904112490",
      "firstName": "Oförlåtande",
      "lastName": "Blomskaft"
  },
  {
      "partnerNumberIndividual": "0034335336",
      "employeeId": "198904022095",
      "firstName": "Brännskadad",
      "lastName": "Stopptavla"
  },
  {
      "partnerNumberIndividual": "0034335477",
      "employeeId": "198905123298",
      "firstName": "Åsyna",
      "lastName": "Upplevelseindustri"
  },
  {
      "partnerNumberIndividual": "0034335633",
      "employeeId": "198905199892",
      "firstName": "Ask",
      "lastName": "Jordbruksekonom"
  },
  {
      "partnerNumberIndividual": "0034335697",
      "employeeId": "198905255298",
      "firstName": "Kippskodd",
      "lastName": "Pannknöl"
  },
  {
      "partnerNumberIndividual": "0034335918",
      "employeeId": "198906112993",
      "firstName": "Uppodlad",
      "lastName": "Utsändning"
  },
  {
      "partnerNumberIndividual": "0034336042",
      "employeeId": "198906216992",
      "firstName": "Interatomär",
      "lastName": "Laddapparat"
  },
  {
      "partnerNumberIndividual": "0034336306",
      "employeeId": "198907122892",
      "firstName": "Underskön",
      "lastName": "Synkroniserare"
  },
  {
      "partnerNumberIndividual": "0034336333",
      "employeeId": "198907143096",
      "firstName": "Mångordig",
      "lastName": "Hjortpark"
  },
  {
      "partnerNumberIndividual": "0034336417",
      "employeeId": "198907206992",
      "firstName": "Mintgrön",
      "lastName": "Magnesiumbad"
  },
  {
      "partnerNumberIndividual": "0034336790",
      "employeeId": "198908197893",
      "firstName": "Okomprimerbar",
      "lastName": "Alpsporre"
  },
  {
      "partnerNumberIndividual": "0034336837",
      "employeeId": "198908243994",
      "firstName": "Störtskön",
      "lastName": "Beslutomdödförklaring"
  },
  {
      "partnerNumberIndividual": "0034336979",
      "employeeId": "198908059895",
      "firstName": "Rättsvetenskaplig",
      "lastName": "Magoperation"
  },
  {
      "partnerNumberIndividual": "0034337164",
      "employeeId": "198909213798",
      "firstName": "Tariffmässig",
      "lastName": "Svartstreckadhonungsfågel"
  },
  {
      "partnerNumberIndividual": "0034337194",
      "employeeId": "198906258598",
      "firstName": "Underkuvande",
      "lastName": "Fuling"
  },
  {
      "partnerNumberIndividual": "0034337497",
      "employeeId": "198910134793",
      "firstName": "Snart",
      "lastName": "Läkekonst"
  },
  {
      "partnerNumberIndividual": "0034337662",
      "employeeId": "198910239998",
      "firstName": "Uppvispad",
      "lastName": "Utskiftning"
  },
  {
      "partnerNumberIndividual": "0034338743",
      "employeeId": "198801226187",
      "firstName": "Svensktalande",
      "lastName": "Ovädersnatt"
  },
  {
      "partnerNumberIndividual": "0034338858",
      "employeeId": "198801019186",
      "firstName": "Äppelkindad",
      "lastName": "Kolombiadopping"
  },
  {
      "partnerNumberIndividual": "0034338952",
      "employeeId": "198802126980",
      "firstName": "Skärm",
      "lastName": "Felmeddelande"
  },
  {
      "partnerNumberIndividual": "0034339223",
      "employeeId": "198802064280",
      "firstName": "Monolitisk",
      "lastName": "Nordsjöstubb"
  },
  {
      "partnerNumberIndividual": "0034339241",
      "employeeId": "198802070584",
      "firstName": "Fridlysningsvärd",
      "lastName": "Svetsanordning"
  },
  {
      "partnerNumberIndividual": "0034339266",
      "employeeId": "198803094088",
      "firstName": "Omflyttbar",
      "lastName": "Tilläggsbudget"
  },
  {
      "partnerNumberIndividual": "0034339644",
      "employeeId": "198804113283",
      "firstName": "Pittoresk",
      "lastName": "Oktalsiffra"
  },
  {
      "partnerNumberIndividual": "0034340125",
      "employeeId": "198805212084",
      "firstName": "Ickeskattefinansierad",
      "lastName": "Tangentialturbin"
  },
  {
      "partnerNumberIndividual": "0034340159",
      "employeeId": "198805234088",
      "firstName": "Vrickad",
      "lastName": "Sportlov"
  },
  {
      "partnerNumberIndividual": "0034340182",
      "employeeId": "198805254284",
      "firstName": "Vikariats",
      "lastName": "Katepsin"
  },
  {
      "partnerNumberIndividual": "0034340351",
      "employeeId": "198805076489",
      "firstName": "Naiv",
      "lastName": "Socialrätt"
  },
  {
      "partnerNumberIndividual": "0034340400",
      "employeeId": "198806113786",
      "firstName": "Redobogen",
      "lastName": "Sanitetsinstallation"
  },
  {
      "partnerNumberIndividual": "0034340415",
      "employeeId": "198806127984",
      "firstName": "Asbestinnehållande",
      "lastName": "Kornblixt"
  },
  {
      "partnerNumberIndividual": "0034340723",
      "employeeId": "198807096287",
      "firstName": "Mångordig",
      "lastName": "Tyngdlag"
  },
  {
      "partnerNumberIndividual": "0034340844",
      "employeeId": "198807209880",
      "firstName": "Mittenavoktober",
      "lastName": "Färgskiftning"
  },
  {
      "partnerNumberIndividual": "0034340848",
      "employeeId": "198807212884",
      "firstName": "Deltidsanställd",
      "lastName": "Konturspår"
  },
  {
      "partnerNumberIndividual": "0034340850",
      "employeeId": "198807213783",
      "firstName": "Fylletrött",
      "lastName": "Betongvara"
  },
  {
      "partnerNumberIndividual": "0034340879",
      "employeeId": "198807236685",
      "firstName": "Söder",
      "lastName": "Ankoretliv"
  },
  {
      "partnerNumberIndividual": "0034340905",
      "employeeId": "198807262889",
      "firstName": "Sim",
      "lastName": "Ljushuvadjakamar"
  },
  {
      "partnerNumberIndividual": "0034341233",
      "employeeId": "198808182680",
      "firstName": "Insufficient",
      "lastName": "Extraläxa"
  },
  {
      "partnerNumberIndividual": "0034341307",
      "employeeId": "198808239985",
      "firstName": "Påhittig",
      "lastName": "Hjortpark"
  },
  {
      "partnerNumberIndividual": "0034341570",
      "employeeId": "198809099784",
      "firstName": "Överens",
      "lastName": "Föreläsningssal"
  },
  {
      "partnerNumberIndividual": "0034341601",
      "employeeId": "198809126280",
      "firstName": "Uteliggande",
      "lastName": "Dalöppning"
  },
  {
      "partnerNumberIndividual": "0034341611",
      "employeeId": "198809139887",
      "firstName": "Perfekt",
      "lastName": "Nedsmutsare"
  },
  {
      "partnerNumberIndividual": "0034341924",
      "employeeId": "198810135585",
      "firstName": "Berusande",
      "lastName": "Tidvattensteori"
  },
  {
      "partnerNumberIndividual": "0034342503",
      "employeeId": "198811279887",
      "firstName": "Sölig",
      "lastName": "Byggjobbare"
  },
  {
      "partnerNumberIndividual": "0034343177",
      "employeeId": "198201154625",
      "firstName": "Strup",
      "lastName": "Lyftsele"
  },
  {
      "partnerNumberIndividual": "0034343375",
      "employeeId": "198211136026",
      "firstName": "Fingrad",
      "lastName": "Elektroretinograf"
  },
  {
      "partnerNumberIndividual": "0034343511",
      "employeeId": "198502142550",
      "firstName": "Varefter",
      "lastName": "Flythjälp"
  },
  {
      "partnerNumberIndividual": "0034344098",
      "employeeId": "198601055968",
      "firstName": "Suppletiv",
      "lastName": "Trådekerhjul"
  },
  {
      "partnerNumberIndividual": "0034344507",
      "employeeId": "198702128672",
      "firstName": "Utomrättslig",
      "lastName": "Allvarsman"
  },
  {
      "partnerNumberIndividual": "0034344660",
      "employeeId": "198608030568",
      "firstName": "Metalltäckt",
      "lastName": "Förhörsledare"
  },
  {
      "partnerNumberIndividual": "0034344879",
      "employeeId": "198702042170",
      "firstName": "Mod",
      "lastName": "Risktagning"
  },
  {
      "partnerNumberIndividual": "0034345209",
      "employeeId": "198703029176",
      "firstName": "Spelad",
      "lastName": "Byggnadsvirke"
  },
  {
      "partnerNumberIndividual": "0034345310",
      "employeeId": "198704127979",
      "firstName": "Därförinnan",
      "lastName": "Taiwanvisseltrast"
  },
  {
      "partnerNumberIndividual": "0034345409",
      "employeeId": "198704224073",
      "firstName": "Proforma",
      "lastName": "Samhörighet"
  },
  {
      "partnerNumberIndividual": "0034347018",
      "employeeId": "198709055977",
      "firstName": "Österrikiskpreussisk",
      "lastName": "Ljuvalivet"
  },
  {
      "partnerNumberIndividual": "0034347050",
      "employeeId": "198709077377",
      "firstName": "Ostämd",
      "lastName": "Uppsökare"
  },
  {
      "partnerNumberIndividual": "0034347343",
      "employeeId": "198711133275",
      "firstName": "Fisklik",
      "lastName": "Hoptryckning"
  },
  {
      "partnerNumberIndividual": "0034347391",
      "employeeId": "198711195076",
      "firstName": "Handelspolitisk",
      "lastName": "Trådlöstelefon"
  },
  {
      "partnerNumberIndividual": "0034347413",
      "employeeId": "198711217078",
      "firstName": "Studieintresserad",
      "lastName": "Autokod"
  },
  {
      "partnerNumberIndividual": "0034350383",
      "employeeId": "198705229774",
      "firstName": "Bortkommenterad",
      "lastName": "Sånghöna"
  },
  {
      "partnerNumberIndividual": "0034350389",
      "employeeId": "198902015596",
      "firstName": "Opatriotisk",
      "lastName": "Gny"
  },
  {
      "partnerNumberIndividual": "0034351970",
      "employeeId": "198111185610",
      "firstName": "Sjuspråkig",
      "lastName": "Cognacsessens"
  },
  {
      "partnerNumberIndividual": "0034353004",
      "employeeId": "198703028277",
      "firstName": "Beställnings",
      "lastName": "Pressläktare"
  },
  {
      "partnerNumberIndividual": "0034354489",
      "employeeId": "198804238080",
      "firstName": "Ometodisk",
      "lastName": "Vinnarserie"
  },
  {
      "partnerNumberIndividual": "0034354718",
      "employeeId": "198804126285",
      "firstName": "Handlingsklar",
      "lastName": "Resdatum"
  },
  {
      "partnerNumberIndividual": "0034355479",
      "employeeId": "198810116288",
      "firstName": "Pulserande",
      "lastName": "Bravuraria"
  },
  {
      "partnerNumberIndividual": "0034355504",
      "employeeId": "198911193798",
      "firstName": "Plandels",
      "lastName": "Innehållsindikator"
  },
  {
      "partnerNumberIndividual": "0034355508",
      "employeeId": "198809075685",
      "firstName": "Ädel",
      "lastName": "Toppmatch"
  },
  {
      "partnerNumberIndividual": "0034355879",
      "employeeId": "198811189185",
      "firstName": "Polyteknisk",
      "lastName": "Kariol"
  },
  {
      "partnerNumberIndividual": "0034356284",
      "employeeId": "198909209291",
      "firstName": "Imperatorisk",
      "lastName": "Familjelikhet"
  },
  {
      "partnerNumberIndividual": "0034357611",
      "employeeId": "198003115709",
      "firstName": "Utpyntad",
      "lastName": "Isocrotonsyra"
  },
  {
      "partnerNumberIndividual": "0034358085",
      "employeeId": "198701010871",
      "firstName": "Lykantropisk",
      "lastName": "Öringfiske"
  },
  {
      "partnerNumberIndividual": "0034358216",
      "employeeId": "198709236478",
      "firstName": "Tillväxtförstoppad",
      "lastName": "Splittrad"
  },
  {
      "partnerNumberIndividual": "0034358386",
      "employeeId": "198904084798",
      "firstName": "Somkanförnekas",
      "lastName": "Pannstensbildning"
  },
  {
      "partnerNumberIndividual": "0034359246",
      "employeeId": "198808113081",
      "firstName": "Ouppnåelig",
      "lastName": "Svek"
  },
  {
      "partnerNumberIndividual": "0034359670",
      "employeeId": "198905025691",
      "firstName": "Brännskadad",
      "lastName": "Köpmansgille"
  },
  {
      "partnerNumberIndividual": "0034362614",
      "employeeId": "198803206187",
      "firstName": "Rosig",
      "lastName": "Icketroende"
  },
  {
      "partnerNumberIndividual": "0034364053",
      "employeeId": "198601082467",
      "firstName": "Uppassad",
      "lastName": "Kommunitet"
  },
  {
      "partnerNumberIndividual": "0034365295",
      "employeeId": "198306236434",
      "firstName": "Tillyxad",
      "lastName": "Jordbrukszon"
  },
  {
      "partnerNumberIndividual": "0034365330",
      "employeeId": "198503098256",
      "firstName": "Kostnadsfri",
      "lastName": "Felkalkyl"
  },
  {
      "partnerNumberIndividual": "0034365447",
      "employeeId": "198704128274",
      "firstName": "Hetsig",
      "lastName": "Morgonstjärna"
  },
  {
      "partnerNumberIndividual": "0034365497",
      "employeeId": "198707145879",
      "firstName": "Ihopvikbar",
      "lastName": "Långpassning"
  },
  {
      "partnerNumberIndividual": "0034365502",
      "employeeId": "198707209170",
      "firstName": "Beviljbar",
      "lastName": "Förkänning"
  },
  {
      "partnerNumberIndividual": "0034365559",
      "employeeId": "198710069777",
      "firstName": "Tätbebyggd",
      "lastName": "Beardie"
  },
  {
      "partnerNumberIndividual": "0034365855",
      "employeeId": "198902278996",
      "firstName": "Sekret",
      "lastName": "Ömlåga"
  },
  {
      "partnerNumberIndividual": "0034365876",
      "employeeId": "198903068297",
      "firstName": "Blästrad",
      "lastName": "Djup"
  },
  {
      "partnerNumberIndividual": "0034367224",
      "employeeId": "198906043990",
      "firstName": "Tragikomisk",
      "lastName": "Betongvara"
  },
  {
      "partnerNumberIndividual": "0034369377",
      "employeeId": "198808092889",
      "firstName": "Slottslik",
      "lastName": "Hårdförman"
  },
  {
      "partnerNumberIndividual": "0034370454",
      "employeeId": "198810198583",
      "firstName": "Famlande",
      "lastName": "Skenfot"
  },
  {
      "partnerNumberIndividual": "0034371691",
      "employeeId": "198707220276",
      "firstName": "Antiimperialist",
      "lastName": "Förhandlingspolitik"
  },
  {
      "partnerNumberIndividual": "0034374513",
      "employeeId": "198710162572",
      "firstName": "Tvåhändig",
      "lastName": "Molekylärbiologi"
  },
  {
      "partnerNumberIndividual": "0034377824",
      "employeeId": "198304122032",
      "firstName": "Iglädjerus",
      "lastName": "Vidareanvändning"
  },
  {
      "partnerNumberIndividual": "0034377874",
      "employeeId": "198804016288",
      "firstName": "Virtuos",
      "lastName": "Ilandsättning"
  },
  {
      "partnerNumberIndividual": "0034377877",
      "employeeId": "198807167989",
      "firstName": "Bionomisk",
      "lastName": "Frostskyddsapparat"
  },
  {
      "partnerNumberIndividual": "0034378998",
      "employeeId": "198410242641",
      "firstName": "Opublicerad",
      "lastName": "Eftermiddagsskift"
  },
  {
      "partnerNumberIndividual": "0034379066",
      "employeeId": "198711022973",
      "firstName": "Uppkörd",
      "lastName": "Öglemutter"
  },
  {
      "partnerNumberIndividual": "0034379095",
      "employeeId": "198804272386",
      "firstName": "Tegellagd",
      "lastName": "Aerofon"
  },
  {
      "partnerNumberIndividual": "0034379168",
      "employeeId": "198905072990",
      "firstName": "Förtörnadpå",
      "lastName": "Fundamentalistgrupp"
  },
  {
      "partnerNumberIndividual": "0034379171",
      "employeeId": "198909145693",
      "firstName": "Kostnadspolitisk",
      "lastName": "Innehållsindikator"
  },
  {
      "partnerNumberIndividual": "0034379755",
      "employeeId": "198909077599",
      "firstName": "Plandels",
      "lastName": "Kassasuccé"
  },
  {
      "partnerNumberIndividual": "0034380340",
      "employeeId": "198805248583",
      "firstName": "Basilar",
      "lastName": "Bästaanfallstiden"
  },
  {
      "partnerNumberIndividual": "0034380921",
      "employeeId": "198611039465",
      "firstName": "Insufficient",
      "lastName": "Färgseparation"
  },
  {
      "partnerNumberIndividual": "0034381357",
      "employeeId": "198804270588",
      "firstName": "Tätbebyggd",
      "lastName": "Filmklubb"
  },
  {
      "partnerNumberIndividual": "0034381695",
      "employeeId": "198908132791",
      "firstName": "Situationsanpassad",
      "lastName": "Mussla"
  },
  {
      "partnerNumberIndividual": "0034382134",
      "employeeId": "198011014308",
      "firstName": "Storbystad",
      "lastName": "Malteserkors"
  },
  {
      "partnerNumberIndividual": "0034382246",
      "employeeId": "198910109498",
      "firstName": "Oklippt",
      "lastName": "Frostförsäkring"
  },
  {
      "partnerNumberIndividual": "0034382515",
      "employeeId": "198904062794",
      "firstName": "Flockblommig",
      "lastName": "Lokalguide"
  },
  {
      "partnerNumberIndividual": "0034382949",
      "employeeId": "198911255894",
      "firstName": "Grottlik",
      "lastName": "Tidvattenskraft"
  },
  {
      "partnerNumberIndividual": "0034385618",
      "employeeId": "198509112051",
      "firstName": "Allrakäraste",
      "lastName": "Attackdivision"
  },
  {
      "partnerNumberIndividual": "0034387224",
      "employeeId": "198810046980",
      "firstName": "Utankärlek",
      "lastName": "Automobilindustri"
  },
  {
      "partnerNumberIndividual": "0034387644",
      "employeeId": "198910092892",
      "firstName": "Saltbeständig",
      "lastName": "Vattenbehållare"
  },
  {
      "partnerNumberIndividual": "0034387794",
      "employeeId": "198908018594",
      "firstName": "Frontad",
      "lastName": "Gräsrotsrörelse"
  },
  {
      "partnerNumberIndividual": "0034387937",
      "employeeId": "198711196579",
      "firstName": "Vårdkrävande",
      "lastName": "Fjärrgodstransport"
  },
  {
      "partnerNumberIndividual": "0034388686",
      "employeeId": "198005120400",
      "firstName": "Oljeabsorberande",
      "lastName": "Tangentialturbin"
  },
  {
      "partnerNumberIndividual": "0034389161",
      "employeeId": "198810156987",
      "firstName": "Inlösbar",
      "lastName": "Hörspel"
  },
  {
      "partnerNumberIndividual": "0034389246",
      "employeeId": "198301131531",
      "firstName": "Vissa",
      "lastName": "Gulkronadtyrann"
  },
  {
      "partnerNumberIndividual": "0034389634",
      "employeeId": "198701048277",
      "firstName": "Beståndsbildande",
      "lastName": "Kvartärgeologi"
  },
  {
      "partnerNumberIndividual": "0034390242",
      "employeeId": "198702175970",
      "firstName": "Obehårad",
      "lastName": "Gulkronadmajna"
  },
  {
      "partnerNumberIndividual": "0034391489",
      "employeeId": "198609086262",
      "firstName": "Tjänsteförrättande",
      "lastName": "Algmjöl"
  },
  {
      "partnerNumberIndividual": "0034391531",
      "employeeId": "198910067290",
      "firstName": "Anglobrasiliansk",
      "lastName": "Fjärrgodstransport"
  },
  {
      "partnerNumberIndividual": "0034393139",
      "employeeId": "198910129397",
      "firstName": "Jordbruksmässig",
      "lastName": "Arkivlag"
  },
  {
      "partnerNumberIndividual": "0034394327",
      "employeeId": "198701226378",
      "firstName": "Vattrad",
      "lastName": "Ordanvändning"
  },
  {
      "partnerNumberIndividual": "0034394576",
      "employeeId": "198903019191",
      "firstName": "Proportionell",
      "lastName": "Affärsknep"
  },
  {
      "partnerNumberIndividual": "0034395264",
      "employeeId": "198010223504",
      "firstName": "Retlig",
      "lastName": "Heavyband"
  },
  {
      "partnerNumberIndividual": "0034395496",
      "employeeId": "198911236290",
      "firstName": "Ejavhämtad",
      "lastName": "Offshoreverksamhet"
  },
  {
      "partnerNumberIndividual": "0034395577",
      "employeeId": "198804224486",
      "firstName": "Utomrättslig",
      "lastName": "Betongblandning"
  },
  {
      "partnerNumberIndividual": "0034396229",
      "employeeId": "198708272979",
      "firstName": "Bombmattefällande",
      "lastName": "Ringbrynja"
  },
  {
      "partnerNumberIndividual": "0034396338",
      "employeeId": "198703187073",
      "firstName": "Blåaktig",
      "lastName": "Yrkesbrev"
  },
  {
      "partnerNumberIndividual": "0034398877",
      "employeeId": "198905096197",
      "firstName": "Feberdrabbad",
      "lastName": "Bränslesamlare"
  },
  {
      "partnerNumberIndividual": "0034398893",
      "employeeId": "198902078297",
      "firstName": "Ejavstavad",
      "lastName": "Kalkaneus"
  },
  {
      "partnerNumberIndividual": "0034399108",
      "employeeId": "198508117853",
      "firstName": "Tilltagen",
      "lastName": "Nickel"
  },
  {
      "partnerNumberIndividual": "0034403080",
      "employeeId": "198603276166",
      "firstName": "Numinös",
      "lastName": "Bensoylglycin"
  },
  {
      "partnerNumberIndividual": "0034403223",
      "employeeId": "198805074385",
      "firstName": "Renochskär",
      "lastName": "Cyanfettsyror"
  },
  {
      "partnerNumberIndividual": "0034403792",
      "employeeId": "198903109299",
      "firstName": "Miljöansvarig",
      "lastName": "Carnotit"
  },
  {
      "partnerNumberIndividual": "0034403843",
      "employeeId": "198903158098",
      "firstName": "Mörkhårig",
      "lastName": "Mexikospadnäbb"
  },
  {
      "partnerNumberIndividual": "0034404439",
      "employeeId": "198905206192",
      "firstName": "Anglobrasiliansk",
      "lastName": "Blystearat"
  },
  {
      "partnerNumberIndividual": "0034405301",
      "employeeId": "198810162381",
      "firstName": "Ledande",
      "lastName": "Dragbult"
  },
  {
      "partnerNumberIndividual": "0034406745",
      "employeeId": "198708039170",
      "firstName": "Biofysisk",
      "lastName": "Kosterpiprensare"
  },
  {
      "partnerNumberIndividual": "0034406760",
      "employeeId": "198806133982",
      "firstName": "Dålig",
      "lastName": "Mordhistoria"
  },
  {
      "partnerNumberIndividual": "0034407743",
      "employeeId": "198906217297",
      "firstName": "Vållande",
      "lastName": "Kappress"
  },
  {
      "partnerNumberIndividual": "0034408510",
      "employeeId": "198601074068",
      "firstName": "Rödbrokig",
      "lastName": "Marschformation"
  },
  {
      "partnerNumberIndividual": "0034409805",
      "employeeId": "198206229729",
      "firstName": "Lättsmältande",
      "lastName": "Systemvetenskap"
  },
  {
      "partnerNumberIndividual": "0034410288",
      "employeeId": "198809229985",
      "firstName": "Azoisk",
      "lastName": "Empir"
  },
  {
      "partnerNumberIndividual": "0034410398",
      "employeeId": "198604128465",
      "firstName": "Vidrörd",
      "lastName": "Hexaklorcyklohexan"
  },
  {
      "partnerNumberIndividual": "0034411624",
      "employeeId": "198701116975",
      "firstName": "Omedelbart",
      "lastName": "Platan"
  },
  {
      "partnerNumberIndividual": "0034412272",
      "employeeId": "198604067861",
      "firstName": "Bokföringsskyldig",
      "lastName": "Isobutylacetat"
  },
  {
      "partnerNumberIndividual": "0034412548",
      "employeeId": "198805097287",
      "firstName": "Iglädjerus",
      "lastName": "Vapeninköp"
  },
  {
      "partnerNumberIndividual": "0034415732",
      "employeeId": "198410159845",
      "firstName": "Fyradörrars",
      "lastName": "Överföringavanslag"
  },
  {
      "partnerNumberIndividual": "0034417467",
      "employeeId": "198208021629",
      "firstName": "Visuell",
      "lastName": "Stortungkg"
  },
  {
      "partnerNumberIndividual": "0034417621",
      "employeeId": "198402024940",
      "firstName": "Genomandad",
      "lastName": "Återtaganderätt"
  },
  {
      "partnerNumberIndividual": "0034418244",
      "employeeId": "198910268294",
      "firstName": "Rysk",
      "lastName": "Sidovinst"
  },
  {
      "partnerNumberIndividual": "0034418566",
      "employeeId": "198910265894",
      "firstName": "Mural",
      "lastName": "Enmiljon"
  },
  {
      "partnerNumberIndividual": "0034418673",
      "employeeId": "198804266982",
      "firstName": "Konkurrensduglig",
      "lastName": "Asfaltprimer"
  },
  {
      "partnerNumberIndividual": "0034420493",
      "employeeId": "198707099175",
      "firstName": "Suggererande",
      "lastName": "Kuhlsfladdermus"
  },
  {
      "partnerNumberIndividual": "0034421334",
      "employeeId": "198805032185",
      "firstName": "Bäst",
      "lastName": "Blixtlampa"
  },
  {
      "partnerNumberIndividual": "0034421572",
      "employeeId": "198911075995",
      "firstName": "Samhällsmedicinsk",
      "lastName": "Blodvätska"
  },
  {
      "partnerNumberIndividual": "0034422915",
      "employeeId": "198910112492",
      "firstName": "Jordig",
      "lastName": "Kryptografi"
  },
  {
      "partnerNumberIndividual": "0034424017",
      "employeeId": "198805069880",
      "firstName": "Iglädjerus",
      "lastName": "Frittinträde"
  },
  {
      "partnerNumberIndividual": "0034424913",
      "employeeId": "198902097891",
      "firstName": "Kabbalistisk",
      "lastName": "Smiley"
  },
  {
      "partnerNumberIndividual": "0034424929",
      "employeeId": "198401167245",
      "firstName": "Fastnitad",
      "lastName": "Opiumfält"
  },
  {
      "partnerNumberIndividual": "0034425350",
      "employeeId": "198004259100",
      "firstName": "Inkräktande",
      "lastName": "Modem"
  },
  {
      "partnerNumberIndividual": "0034425659",
      "employeeId": "198803205882",
      "firstName": "Datorinriktad",
      "lastName": "Borrspån"
  },
  {
      "partnerNumberIndividual": "0034426153",
      "employeeId": "198905116094",
      "firstName": "Struntfin",
      "lastName": "Paradisflugsnappare"
  },
  {
      "partnerNumberIndividual": "0034428019",
      "employeeId": "198706230573",
      "firstName": "Kortskaftad",
      "lastName": "Cykelhandtag"
  },
  {
      "partnerNumberIndividual": "0034428862",
      "employeeId": "198205203220",
      "firstName": "Arkadförsedd",
      "lastName": "Snigelcoua"
  },
  {
      "partnerNumberIndividual": "0034428913",
      "employeeId": "198604045263",
      "firstName": "Brunaktig",
      "lastName": "Delbruk"
  },
  {
      "partnerNumberIndividual": "0034433086",
      "employeeId": "198810142482",
      "firstName": "Färdigknuten",
      "lastName": "Kommunstöd"
  },
  {
      "partnerNumberIndividual": "0034436001",
      "employeeId": "198203244622",
      "firstName": "Arkadförsedd",
      "lastName": "Låneavtal"
  },
  {
      "partnerNumberIndividual": "0034436518",
      "employeeId": "198906270593",
      "firstName": "Konstruktiv",
      "lastName": "Väggkarta"
  },
  {
      "partnerNumberIndividual": "0034437326",
      "employeeId": "198306235238",
      "firstName": "Tuvig",
      "lastName": "Oljekastarbricka"
  },
  {
      "partnerNumberIndividual": "0034438093",
      "employeeId": "198801032684",
      "firstName": "Afanitisk",
      "lastName": "Utsago"
  },
  {
      "partnerNumberIndividual": "0034439173",
      "employeeId": "198704030272",
      "firstName": "Urfunktion",
      "lastName": "Medljud"
  },
  {
      "partnerNumberIndividual": "0034439701",
      "employeeId": "198808059185",
      "firstName": "Skotträdd",
      "lastName": "Trekantigtoppsegel"
  },
  {
      "partnerNumberIndividual": "0034439711",
      "employeeId": "198905026293",
      "firstName": "Fnasig",
      "lastName": "Mårdhår"
  },
  {
      "partnerNumberIndividual": "0034440094",
      "employeeId": "198905033794",
      "firstName": "Olycksbenägen",
      "lastName": "Medljud"
  },
  {
      "partnerNumberIndividual": "0034440616",
      "employeeId": "198910017295",
      "firstName": "Avresande",
      "lastName": "Bestämmare"
  },
  {
      "partnerNumberIndividual": "0034441961",
      "employeeId": "198003089201",
      "firstName": "Såpoperalik",
      "lastName": "Vapeninköp"
  },
  {
      "partnerNumberIndividual": "0034443372",
      "employeeId": "198902279291",
      "firstName": "Numerär",
      "lastName": "Läckerriska"
  },
  {
      "partnerNumberIndividual": "0034444393",
      "employeeId": "198408123142",
      "firstName": "Kokett",
      "lastName": "Arkitektkollega"
  },
  {
      "partnerNumberIndividual": "0034444572",
      "employeeId": "198811042681",
      "firstName": "Inkontinent",
      "lastName": "Gnejs"
  },
  {
      "partnerNumberIndividual": "0034445128",
      "employeeId": "198904058594",
      "firstName": "Strukturerad",
      "lastName": "Varmblixt"
  },
  {
      "partnerNumberIndividual": "0034446953",
      "employeeId": "198201090126",
      "firstName": "Adderbar",
      "lastName": "Naturbruk"
  },
  {
      "partnerNumberIndividual": "0034450138",
      "employeeId": "198706244772",
      "firstName": "Utbränd",
      "lastName": "Riktverkan"
  },
  {
      "partnerNumberIndividual": "0034450765",
      "employeeId": "198608069764",
      "firstName": "Inbördeskrigliknande",
      "lastName": "Chokladpudding"
  },
  {
      "partnerNumberIndividual": "0034451815",
      "employeeId": "198806072487",
      "firstName": "Vadderad",
      "lastName": "Nageltrång"
  },
  {
      "partnerNumberIndividual": "0034452104",
      "employeeId": "198608162569",
      "firstName": "Äppelkindad",
      "lastName": "Ondtunga"
  },
  {
      "partnerNumberIndividual": "0034455155",
      "employeeId": "198701117270",
      "firstName": "Flodhästliknande",
      "lastName": "Paparazzo"
  },
  {
      "partnerNumberIndividual": "0034455185",
      "employeeId": "198804057282",
      "firstName": "Dagsfärsk",
      "lastName": "Fundamentalistgrupp"
  },
  {
      "partnerNumberIndividual": "0034457664",
      "employeeId": "198903026394",
      "firstName": "Afferent",
      "lastName": "Växtsamling"
  },
  {
      "partnerNumberIndividual": "0034458040",
      "employeeId": "198806175884",
      "firstName": "Direktörsaktig",
      "lastName": "Fiskedag"
  },
  {
      "partnerNumberIndividual": "0034458186",
      "employeeId": "198702160576",
      "firstName": "Beställnings",
      "lastName": "Antiklor"
  },
  {
      "partnerNumberIndividual": "0034458271",
      "employeeId": "198904216192",
      "firstName": "Nosgrann",
      "lastName": "Grenadjärgarde"
  },
  {
      "partnerNumberIndividual": "0034459221",
      "employeeId": "198508232355",
      "firstName": "Exkluderande",
      "lastName": "Jordbrukszon"
  },
  {
      "partnerNumberIndividual": "0034459496",
      "employeeId": "198901092794",
      "firstName": "Oför",
      "lastName": "Härjare"
  },
  {
      "partnerNumberIndividual": "0034460896",
      "employeeId": "198010270802",
      "firstName": "Tillfälligtvis",
      "lastName": "Orfeusgärdsmyg"
  },
  {
      "partnerNumberIndividual": "0034462465",
      "employeeId": "198704154775",
      "firstName": "Förbluffande",
      "lastName": "Höghastighetsnät"
  },
  {
      "partnerNumberIndividual": "0034463542",
      "employeeId": "198006043502",
      "firstName": "Akter",
      "lastName": "Potage"
  },
  {
      "partnerNumberIndividual": "0034463806",
      "employeeId": "198902040891",
      "firstName": "Förvärkt",
      "lastName": "Våldsgata"
  },
  {
      "partnerNumberIndividual": "0034464995",
      "employeeId": "198204076429",
      "firstName": "Spröd",
      "lastName": "Stopptavla"
  },
  {
      "partnerNumberIndividual": "0034465577",
      "employeeId": "198803269482",
      "firstName": "Kommunalistisk",
      "lastName": "Direktorat"
  },
  {
      "partnerNumberIndividual": "0034465965",
      "employeeId": "198903190596",
      "firstName": "Provocerande",
      "lastName": "Språkdiskriminering"
  },
  {
      "partnerNumberIndividual": "0034466365",
      "employeeId": "198905274893",
      "firstName": "Anglobrasiliansk",
      "lastName": "Åkerböna"
  },
  {
      "partnerNumberIndividual": "0034467505",
      "employeeId": "198608096569",
      "firstName": "Handlingsklar",
      "lastName": "Bearbetaning"
  },
  {
      "partnerNumberIndividual": "0034467525",
      "employeeId": "198803249880",
      "firstName": "Tvungen",
      "lastName": "Smutsgam"
  },
  {
      "partnerNumberIndividual": "0034468158",
      "employeeId": "198408276247",
      "firstName": "Överprissatt",
      "lastName": "Energiflödestäthet"
  },
  {
      "partnerNumberIndividual": "0034469318",
      "employeeId": "198403152047",
      "firstName": "Ohederlig",
      "lastName": "Magnesiumbad"
  },
  {
      "partnerNumberIndividual": "0034471202",
      "employeeId": "198104110310",
      "firstName": "Frontad",
      "lastName": "Charkuteri"
  },
  {
      "partnerNumberIndividual": "0034471908",
      "employeeId": "198710177976",
      "firstName": "Färdigsydd",
      "lastName": "Toppvinkel"
  },
  {
      "partnerNumberIndividual": "0034472019",
      "employeeId": "198808043783",
      "firstName": "Gotländsk",
      "lastName": "Oljekastarbricka"
  },
  {
      "partnerNumberIndividual": "0034473965",
      "employeeId": "198809083788",
      "firstName": "Välskapad",
      "lastName": "Agronomkollega"
  },
  {
      "partnerNumberIndividual": "0034474148",
      "employeeId": "198805012286",
      "firstName": "Förbliven",
      "lastName": "Alpmynta"
  },
  {
      "partnerNumberIndividual": "0034474591",
      "employeeId": "198609222461",
      "firstName": "Från",
      "lastName": "Snigelcoua"
  },
  {
      "partnerNumberIndividual": "0034474839",
      "employeeId": "198307093230",
      "firstName": "Xeromorfisk",
      "lastName": "Byggnadstimmer"
  },
  {
      "partnerNumberIndividual": "0034476164",
      "employeeId": "198810197981",
      "firstName": "Guldgul",
      "lastName": "Giftigtämne"
  },
  {
      "partnerNumberIndividual": "0034476471",
      "employeeId": "198705130279",
      "firstName": "Navelskådande",
      "lastName": "Sossignal"
  },
  {
      "partnerNumberIndividual": "0034476648",
      "employeeId": "198705209875",
      "firstName": "Demonterad",
      "lastName": "Tvådagarstidning"
  },
  {
      "partnerNumberIndividual": "0034476757",
      "employeeId": "198109089915",
      "firstName": "Allmäntbekant",
      "lastName": "Avloppsvatten"
  },
  {
      "partnerNumberIndividual": "0034476773",
      "employeeId": "198705054073",
      "firstName": "Tioårig",
      "lastName": "Förkroppsling"
  },
  {
      "partnerNumberIndividual": "0034477252",
      "employeeId": "198804203084",
      "firstName": "Scenvan",
      "lastName": "Lastningselevator"
  },
  {
      "partnerNumberIndividual": "0034477254",
      "employeeId": "198911208596",
      "firstName": "Industrihistorisk",
      "lastName": "Lokalguide"
  },
  {
      "partnerNumberIndividual": "0034477674",
      "employeeId": "198705102872",
      "firstName": "Zen",
      "lastName": "Paperback"
  },
  {
      "partnerNumberIndividual": "0034477877",
      "employeeId": "198907068996",
      "firstName": "Famlande",
      "lastName": "Ladugårdsbacke"
  },
  {
      "partnerNumberIndividual": "0034478132",
      "employeeId": "198802180284",
      "firstName": "Insufficienskänsla",
      "lastName": "Brandsyn"
  },
  {
      "partnerNumberIndividual": "0034478733",
      "employeeId": "198907123791",
      "firstName": "Utanförbindelse",
      "lastName": "Lastvinkel"
  },
  {
      "partnerNumberIndividual": "0034479752",
      "employeeId": "198910113698",
      "firstName": "Ormrik",
      "lastName": "Investeringsavveckling"
  },
  {
      "partnerNumberIndividual": "0034481361",
      "employeeId": "198206055827",
      "firstName": "Fatisk",
      "lastName": "Ostronodling"
  },
  {
      "partnerNumberIndividual": "0034481385",
      "employeeId": "198903026998",
      "firstName": "Rockklädd",
      "lastName": "Avbetalningslag"
  },
  {
      "partnerNumberIndividual": "0034481808",
      "employeeId": "198011262907",
      "firstName": "Pacifistisk",
      "lastName": "Nummersexton"
  },
  {
      "partnerNumberIndividual": "0034481830",
      "employeeId": "198707102771",
      "firstName": "Retlig",
      "lastName": "Gulkronadtyrann"
  },
  {
      "partnerNumberIndividual": "0034483574",
      "employeeId": "198404212840",
      "firstName": "Piezomagnetisk",
      "lastName": "Resform"
  },
  {
      "partnerNumberIndividual": "0034484164",
      "employeeId": "198810245889",
      "firstName": "Bacillär",
      "lastName": "Tvåtaktsmotor"
  },
  {
      "partnerNumberIndividual": "0034484935",
      "employeeId": "198807165587",
      "firstName": "Biltog",
      "lastName": "Härjare"
  },
  {
      "partnerNumberIndividual": "0034485633",
      "employeeId": "198204027323",
      "firstName": "Konvertibel",
      "lastName": "Pansarsköld"
  },
  {
      "partnerNumberIndividual": "0034486045",
      "employeeId": "198706038372",
      "firstName": "Påfågelsblå",
      "lastName": "Mexikospadnäbb"
  },
  {
      "partnerNumberIndividual": "0034487347",
      "employeeId": "198702153977",
      "firstName": "Glömsk",
      "lastName": "Felkalkyl"
  },
  {
      "partnerNumberIndividual": "0034488606",
      "employeeId": "198807035681",
      "firstName": "Tyngdkrafts",
      "lastName": "Åldringar"
  },
  {
      "partnerNumberIndividual": "0034489253",
      "employeeId": "198901210891",
      "firstName": "Glad",
      "lastName": "Åretruntboende"
  },
  {
      "partnerNumberIndividual": "0034489334",
      "employeeId": "198810253388",
      "firstName": "Iglädjerus",
      "lastName": "Huvudsajt"
  },
  {
      "partnerNumberIndividual": "0034489798",
      "employeeId": "198701179379",
      "firstName": "Opåvisad",
      "lastName": "Beklädnadsförråd"
  },
  {
      "partnerNumberIndividual": "0034490492",
      "employeeId": "198811058083",
      "firstName": "Myeloid",
      "lastName": "Borgerskap"
  },
  {
      "partnerNumberIndividual": "0034490499",
      "employeeId": "198906203396",
      "firstName": "Avgudifierad",
      "lastName": "Kostall"
  },
  {
      "partnerNumberIndividual": "0034490755",
      "employeeId": "198307070931",
      "firstName": "Nedrullad",
      "lastName": "Duplextalkanal"
  },
  {
      "partnerNumberIndividual": "0034490813",
      "employeeId": "198311120433",
      "firstName": "Störtskön",
      "lastName": "Duplextalkanal"
  },
  {
      "partnerNumberIndividual": "0034490915",
      "employeeId": "198207230221",
      "firstName": "Reformvänlig",
      "lastName": "Redigeringsrum"
  },
  {
      "partnerNumberIndividual": "0034491441",
      "employeeId": "198810026180",
      "firstName": "Metalltäckt",
      "lastName": "Borgerskap"
  },
  {
      "partnerNumberIndividual": "0034491696",
      "employeeId": "198602093869",
      "firstName": "Sedd",
      "lastName": "Vitaminbrist"
  },
  {
      "partnerNumberIndividual": "0034493191",
      "employeeId": "198910274292",
      "firstName": "Accelererande",
      "lastName": "Kryptografi"
  },
  {
      "partnerNumberIndividual": "0034494888",
      "employeeId": "198509039452",
      "firstName": "Somnambulistisk",
      "lastName": "Ektypografi"
  },
  {
      "partnerNumberIndividual": "0034497329",
      "employeeId": "198909123997",
      "firstName": "Svåranträffbar",
      "lastName": "Bränslesamlare"
  },
  {
      "partnerNumberIndividual": "0034497378",
      "employeeId": "198508081950",
      "firstName": "Ateistisk",
      "lastName": "Modem"
  },
  {
      "partnerNumberIndividual": "0034497522",
      "employeeId": "198802236987",
      "firstName": "Denaturerad",
      "lastName": "Färgskiftning"
  },
  {
      "partnerNumberIndividual": "0034497668",
      "employeeId": "198905192590",
      "firstName": "Oklippt",
      "lastName": "Koronaurladdning"
  },
  {
      "partnerNumberIndividual": "0034498005",
      "employeeId": "198804238387",
      "firstName": "Översvinnelig",
      "lastName": "Mjölkkvot"
  },
  {
      "partnerNumberIndividual": "0034499658",
      "employeeId": "198811236481",
      "firstName": "Tobaksrökande",
      "lastName": "Investeringsfond"
  },
  {
      "partnerNumberIndividual": "0034500387",
      "employeeId": "198805089482",
      "firstName": "Ljuslila",
      "lastName": "Ordanvändning"
  },
  {
      "partnerNumberIndividual": "0034500404",
      "employeeId": "198906263994",
      "firstName": "Tättsittande",
      "lastName": "Grönaracari"
  },
  {
      "partnerNumberIndividual": "0034500750",
      "employeeId": "198804244385",
      "firstName": "Opåvisad",
      "lastName": "Intvålning"
  },
  {
      "partnerNumberIndividual": "0034500861",
      "employeeId": "198707060276",
      "firstName": "Tillsammantagen",
      "lastName": "Streamadvideo"
  },
  {
      "partnerNumberIndividual": "0034502517",
      "employeeId": "198905142595",
      "firstName": "Krisdrabbad",
      "lastName": "Ridstall"
  },
  {
      "partnerNumberIndividual": "0034502555",
      "employeeId": "198906152791",
      "firstName": "Exkluderande",
      "lastName": "Flasktransportör"
  },
  {
      "partnerNumberIndividual": "0034507152",
      "employeeId": "198801024285",
      "firstName": "Tioårig",
      "lastName": "Potage"
  },
  {
      "partnerNumberIndividual": "0034507403",
      "employeeId": "198703069578",
      "firstName": "Sentblommande",
      "lastName": "Chokladpudding"
  },
  {
      "partnerNumberIndividual": "0034508039",
      "employeeId": "198601102067",
      "firstName": "Likvärdigmed",
      "lastName": "Strilkondensor"
  },
  {
      "partnerNumberIndividual": "0034508268",
      "employeeId": "198908114393",
      "firstName": "Handelspolitisk",
      "lastName": "Allvarsman"
  },
  {
      "partnerNumberIndividual": "0034509918",
      "employeeId": "198904258996",
      "firstName": "Hanseatisk",
      "lastName": "Laplacetransformation"
  },
  {
      "partnerNumberIndividual": "0034510148",
      "employeeId": "198801045983",
      "firstName": "Osteriliserad",
      "lastName": "Femininform"
  },
  {
      "partnerNumberIndividual": "0034511241",
      "employeeId": "198910115198",
      "firstName": "Angloholländsk",
      "lastName": "Färgseparation"
  },
  {
      "partnerNumberIndividual": "0034511607",
      "employeeId": "198803012387",
      "firstName": "Påkopplad",
      "lastName": "Tjänstpersonal"
  },
  {
      "partnerNumberIndividual": "0034512781",
      "employeeId": "198609059467",
      "firstName": "Självcentrerande",
      "lastName": "Direktsumma"
  },
  {
      "partnerNumberIndividual": "0034513079",
      "employeeId": "198607189761",
      "firstName": "Specialkonstruerad",
      "lastName": "Stångjärnshammare"
  },
  {
      "partnerNumberIndividual": "0034513263",
      "employeeId": "198709078573",
      "firstName": "Approximativ",
      "lastName": "Maskinfabrikant"
  },
  {
      "partnerNumberIndividual": "0034513596",
      "employeeId": "198703082779",
      "firstName": "Vulvaliknande",
      "lastName": "Directmail"
  },
  {
      "partnerNumberIndividual": "0034513890",
      "employeeId": "198211150126",
      "firstName": "Påsig",
      "lastName": "Differentialrelä"
  },
  {
      "partnerNumberIndividual": "0034513931",
      "employeeId": "198305196134",
      "firstName": "Månadförmånad",
      "lastName": "Resonansenergi"
  },
  {
      "partnerNumberIndividual": "0034515805",
      "employeeId": "198507110958",
      "firstName": "Farlig",
      "lastName": "Nödochlust"
  },
  {
      "partnerNumberIndividual": "0034516973",
      "employeeId": "198601144267",
      "firstName": "Igenkänningsbar",
      "lastName": "Fullnav"
  },
  {
      "partnerNumberIndividual": "0034519282",
      "employeeId": "198705056177",
      "firstName": "Tillyxad",
      "lastName": "Snövithasselmätare"
  },
  {
      "partnerNumberIndividual": "0034519372",
      "employeeId": "198511072459",
      "firstName": "Levrad",
      "lastName": "Tempocykel"
  },
  {
      "partnerNumberIndividual": "0034520073",
      "employeeId": "198304048237",
      "firstName": "Påsig",
      "lastName": "Etnomusikologi"
  },
  {
      "partnerNumberIndividual": "0034521423",
      "employeeId": "198001091704",
      "firstName": "Överstånden",
      "lastName": "Lastnät"
  },
  {
      "partnerNumberIndividual": "0034521667",
      "employeeId": "198807080588",
      "firstName": "Söder",
      "lastName": "Kommunstöd"
  },
  {
      "partnerNumberIndividual": "0034522155",
      "employeeId": "198905212794",
      "firstName": "Dubbelbottnad",
      "lastName": "Sidovinst"
  },
  {
      "partnerNumberIndividual": "0034523465",
      "employeeId": "198805260885",
      "firstName": "Behandlande",
      "lastName": "Droppeihavet"
  },
  {
      "partnerNumberIndividual": "0034524573",
      "employeeId": "198710253876",
      "firstName": "Hermitesk",
      "lastName": "Digitalsystem"
  },
  {
      "partnerNumberIndividual": "0034525348",
      "employeeId": "198911220898",
      "firstName": "Färgframkallande",
      "lastName": "Pariservitt"
  },
  {
      "partnerNumberIndividual": "0034526396",
      "employeeId": "198507099250",
      "firstName": "Finans",
      "lastName": "Djurläkare"
  },
  {
      "partnerNumberIndividual": "0034526985",
      "employeeId": "198911013293",
      "firstName": "Utslätad",
      "lastName": "Kontrollmanometer"
  },
  {
      "partnerNumberIndividual": "0034532595",
      "employeeId": "198111011410",
      "firstName": "Israelvänlig",
      "lastName": "Vårdutrymme"
  },
  {
      "partnerNumberIndividual": "0034532623",
      "employeeId": "198503139852",
      "firstName": "Pyroteknisk",
      "lastName": "Arnaudbarbett"
  },
  {
      "partnerNumberIndividual": "0034534211",
      "employeeId": "198611131965",
      "firstName": "Musikantisk",
      "lastName": "Handöverfräs"
  },
  {
      "partnerNumberIndividual": "0034534338",
      "employeeId": "198710253272",
      "firstName": "Plandels",
      "lastName": "FNkonvention"
  },
  {
      "partnerNumberIndividual": "0034534792",
      "employeeId": "198801232185",
      "firstName": "Insufficienskänsla",
      "lastName": "Ansiktsvenen"
  },
  {
      "partnerNumberIndividual": "0034535485",
      "employeeId": "198208079221",
      "firstName": "Kardiografisk",
      "lastName": "Lagbud"
  },
  {
      "partnerNumberIndividual": "0034535896",
      "employeeId": "198407266942",
      "firstName": "Ljuslila",
      "lastName": "Justeringavfinansiellöversikt"
  },
  {
      "partnerNumberIndividual": "0034537088",
      "employeeId": "198607242768",
      "firstName": "Flamhärdig",
      "lastName": "Enfrågepolitik"
  },
  {
      "partnerNumberIndividual": "0034537620",
      "employeeId": "198707263375",
      "firstName": "Hemtrevlig",
      "lastName": "Jamaicabäverråtta"
  },
  {
      "partnerNumberIndividual": "0034538387",
      "employeeId": "198501186954",
      "firstName": "Senantik",
      "lastName": "Nyhetsförmedling"
  },
  {
      "partnerNumberIndividual": "0034538565",
      "employeeId": "198302165538",
      "firstName": "Urtjatad",
      "lastName": "Ansiktsvenen"
  },
  {
      "partnerNumberIndividual": "0034542781",
      "employeeId": "198701163977",
      "firstName": "Rörformad",
      "lastName": "Diademyuhina"
  },
  {
      "partnerNumberIndividual": "0034542856",
      "employeeId": "198107156914",
      "firstName": "Tätbebyggd",
      "lastName": "Godistillverkning"
  },
  {
      "partnerNumberIndividual": "0034546251",
      "employeeId": "198705220971",
      "firstName": "Tvågångs",
      "lastName": "Brandsyn"
  },
  {
      "partnerNumberIndividual": "0034549792",
      "employeeId": "198710184279",
      "firstName": "Ametistfärgad",
      "lastName": "Glasning"
  },
  {
      "partnerNumberIndividual": "0034551622",
      "employeeId": "198710080873",
      "firstName": "Atypisk",
      "lastName": "Vattenbehållare"
  },
  {
      "partnerNumberIndividual": "0034551716",
      "employeeId": "198705117375",
      "firstName": "Ädel",
      "lastName": "Bildatlas"
  },
  {
      "partnerNumberIndividual": "0034553162",
      "employeeId": "198011206904",
      "firstName": "Tätbebyggd",
      "lastName": "Sossignal"
  },
  {
      "partnerNumberIndividual": "0034553178",
      "employeeId": "198409225847",
      "firstName": "Kostnadsfri",
      "lastName": "Färgskiftning"
  },
  {
      "partnerNumberIndividual": "0034553214",
      "employeeId": "198204055621",
      "firstName": "Utanförbindelse",
      "lastName": "Blåtjocknäbb"
  },
  {
      "partnerNumberIndividual": "0034555343",
      "employeeId": "198207092522",
      "firstName": "Utankänsel",
      "lastName": "Föräldrar"
  },
  {
      "partnerNumberIndividual": "0034555444",
      "employeeId": "198408139445",
      "firstName": "Immun",
      "lastName": "Gruvkunskap"
  },
  {
      "partnerNumberIndividual": "0034556769",
      "employeeId": "198402072246",
      "firstName": "Laglös",
      "lastName": "Kvartärgeologi"
  },
  {
      "partnerNumberIndividual": "0034556897",
      "employeeId": "198201112722",
      "firstName": "Kippskodd",
      "lastName": "Fjädervilt"
  },
  {
      "partnerNumberIndividual": "0034559058",
      "employeeId": "198404157748",
      "firstName": "Beklagande",
      "lastName": "Hermelinsskinn"
  },
  {
      "partnerNumberIndividual": "0034563795",
      "employeeId": "198208236227",
      "firstName": "Hopkrupen",
      "lastName": "Oljekastarbricka"
  },
  {
      "partnerNumberIndividual": "0034564049",
      "employeeId": "198803232084",
      "firstName": "Endomorf",
      "lastName": "Grönaracari"
  },
  {
      "partnerNumberIndividual": "0034564997",
      "employeeId": "198107068911",
      "firstName": "Fortlevande",
      "lastName": "Avskedsuppvaktning"
  },
  {
      "partnerNumberIndividual": "0034565265",
      "employeeId": "198001247504",
      "firstName": "Mittenavoktober",
      "lastName": "Skirning"
  },
  {
      "partnerNumberIndividual": "0034565494",
      "employeeId": "198903225293",
      "firstName": "Husdjursetisk",
      "lastName": "Spolhjul"
  },
  {
      "partnerNumberIndividual": "0034565983",
      "employeeId": "198910156192",
      "firstName": "Förtörnadpå",
      "lastName": "Handöverfräs"
  },
  {
      "partnerNumberIndividual": "0034567339",
      "employeeId": "198605166365",
      "firstName": "Rusig",
      "lastName": "Studiosus"
  },
  {
      "partnerNumberIndividual": "0034569087",
      "employeeId": "198704086977",
      "firstName": "Zoografisk",
      "lastName": "Energiflödestäthet"
  },
  {
      "partnerNumberIndividual": "0034569318",
      "employeeId": "198708024974",
      "firstName": "Elektiv",
      "lastName": "Avskedsuppvaktning"
  },
  {
      "partnerNumberIndividual": "0034571122",
      "employeeId": "198911124793",
      "firstName": "Strumpförsedd",
      "lastName": "Nedslagenhet"
  },
  {
      "partnerNumberIndividual": "0034572309",
      "employeeId": "198802244189",
      "firstName": "Perfekt",
      "lastName": "Bokstavsträldom"
  },
  {
      "partnerNumberIndividual": "0034573196",
      "employeeId": "198910072696",
      "firstName": "Väldifferentierad",
      "lastName": "Utvecklingshistoria"
  },
  {
      "partnerNumberIndividual": "0034575620",
      "employeeId": "198707119379",
      "firstName": "Kusttillkust",
      "lastName": "Svanhus"
  },
  {
      "partnerNumberIndividual": "0034576272",
      "employeeId": "198911057290",
      "firstName": "Tunnsliten",
      "lastName": "Snöklocka"
  },
  {
      "partnerNumberIndividual": "0034576608",
      "employeeId": "198904167999",
      "firstName": "Varkunnsam",
      "lastName": "Oskaplighet"
  },
  {
      "partnerNumberIndividual": "0034578222",
      "employeeId": "198904085696",
      "firstName": "Samskole",
      "lastName": "Ansiktsgymnastik"
  },
  {
      "partnerNumberIndividual": "0034578817",
      "employeeId": "198001250508",
      "firstName": "Kostnadsfri",
      "lastName": "Mjölkkvot"
  },
  {
      "partnerNumberIndividual": "0034579187",
      "employeeId": "198706162479",
      "firstName": "Hornlik",
      "lastName": "Marmorflis"
  },
  {
      "partnerNumberIndividual": "0034579197",
      "employeeId": "198607112268",
      "firstName": "Helförsäkrad",
      "lastName": "Nyårsgåva"
  },
  {
      "partnerNumberIndividual": "0034579312",
      "employeeId": "198703213275",
      "firstName": "Tilltagen",
      "lastName": "Gruppcentral"
  },
  {
      "partnerNumberIndividual": "0034579557",
      "employeeId": "198207073522",
      "firstName": "Tumultartad",
      "lastName": "Jägaresamlare"
  },
  {
      "partnerNumberIndividual": "0034579908",
      "employeeId": "198803081382",
      "firstName": "Knäpptyst",
      "lastName": "Krigsobligation"
  },
  {
      "partnerNumberIndividual": "0034582382",
      "employeeId": "198211164622",
      "firstName": "Tvågångs",
      "lastName": "Skifferbrytning"
  },
  {
      "partnerNumberIndividual": "0034584157",
      "employeeId": "198906148591",
      "firstName": "Postakut",
      "lastName": "Ditforsling"
  },
  {
      "partnerNumberIndividual": "0034584833",
      "employeeId": "198710179477",
      "firstName": "Herrskapsliknande",
      "lastName": "Svanhus"
  },
  {
      "partnerNumberIndividual": "0034585042",
      "employeeId": "198608088160",
      "firstName": "Omedelbart",
      "lastName": "Skenfot"
  },
  {
      "partnerNumberIndividual": "0034585051",
      "employeeId": "198802079981",
      "firstName": "Uppodlad",
      "lastName": "Modem"
  },
  {
      "partnerNumberIndividual": "0034585776",
      "employeeId": "198802180888",
      "firstName": "Bilmekanisk",
      "lastName": "Observationsbrunn"
  },
  {
      "partnerNumberIndividual": "0034586351",
      "employeeId": "198611195861",
      "firstName": "Pikerad",
      "lastName": "Snövithasselmätare"
  },
  {
      "partnerNumberIndividual": "0034590681",
      "employeeId": "198509246156",
      "firstName": "Berusande",
      "lastName": "Offereld"
  },
  {
      "partnerNumberIndividual": "0034591744",
      "employeeId": "198808199882",
      "firstName": "Genomlysande",
      "lastName": "Mätressregemente"
  },
  {
      "partnerNumberIndividual": "0034592121",
      "employeeId": "198707188077",
      "firstName": "Frankfurtbo",
      "lastName": "Jämkningsgrund"
  },
  {
      "partnerNumberIndividual": "0034593158",
      "employeeId": "198609062461",
      "firstName": "Piprökande",
      "lastName": "Lyssnarbrev"
  },
  {
      "partnerNumberIndividual": "0034593318",
      "employeeId": "198706266171",
      "firstName": "Näraförestående",
      "lastName": "Cognacsessens"
  },
  {
      "partnerNumberIndividual": "0034593481",
      "employeeId": "198902090599",
      "firstName": "Utrörd",
      "lastName": "Marknadsfokuserad"
  },
  {
      "partnerNumberIndividual": "0034594475",
      "employeeId": "198704037871",
      "firstName": "Västerut",
      "lastName": "Vävnad"
  },
  {
      "partnerNumberIndividual": "0034596299",
      "employeeId": "198411059747",
      "firstName": "Transversell",
      "lastName": "Lochiarubra"
  },
  {
      "partnerNumberIndividual": "0034597077",
      "employeeId": "198209138224",
      "firstName": "Som",
      "lastName": "Nedslagenhet"
  },
  {
      "partnerNumberIndividual": "0034598645",
      "employeeId": "198902104796",
      "firstName": "Kostnadspolitisk",
      "lastName": "Försäkringskostnad"
  },
  {
      "partnerNumberIndividual": "0034599145",
      "employeeId": "198903246992",
      "firstName": "Uppodlad",
      "lastName": "Observationsbrunn"
  },
  {
      "partnerNumberIndividual": "0034599149",
      "employeeId": "198907089497",
      "firstName": "Oupptäckt",
      "lastName": "Restvärdesförsäkring"
  },
  {
      "partnerNumberIndividual": "0034599818",
      "employeeId": "198909228291",
      "firstName": "Obeivrad",
      "lastName": "Ekosofi"
  },
  {
      "partnerNumberIndividual": "0034602521",
      "employeeId": "198806016484",
      "firstName": "Ametistliknande",
      "lastName": "Magnesiumstearat"
  },
  {
      "partnerNumberIndividual": "0034602616",
      "employeeId": "198211190221",
      "firstName": "Direktörsaktig",
      "lastName": "Ärtprotein"
  },
  {
      "partnerNumberIndividual": "0034602662",
      "employeeId": "198806265685",
      "firstName": "Spartansk",
      "lastName": "Vinylgummi"
  },
  {
      "partnerNumberIndividual": "0034602683",
      "employeeId": "198611246169",
      "firstName": "Ihopvikbar",
      "lastName": "Färjelinje"
  },
  {
      "partnerNumberIndividual": "0034603717",
      "employeeId": "198403214748",
      "firstName": "Guldfärgad",
      "lastName": "Återbesättning"
  },
  {
      "partnerNumberIndividual": "0034604089",
      "employeeId": "198708246171",
      "firstName": "Vattrad",
      "lastName": "Riktverkan"
  },
  {
      "partnerNumberIndividual": "0034604098",
      "employeeId": "198805103580",
      "firstName": "Blästrad",
      "lastName": "Kariol"
  },
  {
      "partnerNumberIndividual": "0034604817",
      "employeeId": "198801045686",
      "firstName": "Deltidsanställd",
      "lastName": "Öljätte"
  },
  {
      "partnerNumberIndividual": "0034605470",
      "employeeId": "198705055278",
      "firstName": "Postakut",
      "lastName": "Faktureringsbok"
  },
  {
      "partnerNumberIndividual": "0034605475",
      "employeeId": "198710074272",
      "firstName": "Accelererande",
      "lastName": "Widescreenskärm"
  },
  {
      "partnerNumberIndividual": "0034608104",
      "employeeId": "198603240568",
      "firstName": "Utsmyckad",
      "lastName": "Kolombiadopping"
  },
  {
      "partnerNumberIndividual": "0034608559",
      "employeeId": "198804222985",
      "firstName": "Odäckad",
      "lastName": "Stannosulfid"
  },
  {
      "partnerNumberIndividual": "0034608842",
      "employeeId": "198203108728",
      "firstName": "Svårbemästrad",
      "lastName": "Karttekniker"
  },
  {
      "partnerNumberIndividual": "0034609418",
      "employeeId": "198308187536",
      "firstName": "Förbikörande",
      "lastName": "Småstiltatryck"
  },
  {
      "partnerNumberIndividual": "0034609642",
      "employeeId": "198102194217",
      "firstName": "Accelererande",
      "lastName": "FNkonvention"
  },
  {
      "partnerNumberIndividual": "0034611581",
      "employeeId": "198703249170",
      "firstName": "Ejavstavad",
      "lastName": "Kontantköp"
  },
  {
      "partnerNumberIndividual": "0034616767",
      "employeeId": "198506137556",
      "firstName": "Epicen",
      "lastName": "Baljbotten"
  },
  {
      "partnerNumberIndividual": "0034618136",
      "employeeId": "198409182147",
      "firstName": "Heldags",
      "lastName": "Blåringadängelfisk"
  },
  {
      "partnerNumberIndividual": "0034619236",
      "employeeId": "198409017343",
      "firstName": "Djuptrotad",
      "lastName": "Ladugårdsbacke"
  },
  {
      "partnerNumberIndividual": "0034620711",
      "employeeId": "198603080865",
      "firstName": "Flodhästliknande",
      "lastName": "Öljätte"
  },
  {
      "partnerNumberIndividual": "0034621891",
      "employeeId": "198908037891",
      "firstName": "Srilankesisk",
      "lastName": "Justeringavfinansiellöversikt"
  },
  {
      "partnerNumberIndividual": "0034622800",
      "employeeId": "198501159852",
      "firstName": "Såpoperalik",
      "lastName": "Opiumfält"
  },
  {
      "partnerNumberIndividual": "0034622845",
      "employeeId": "198906270296",
      "firstName": "Svåranträffbar",
      "lastName": "Borrplats"
  },
  {
      "partnerNumberIndividual": "0034624207",
      "employeeId": "198408249145",
      "firstName": "Mångfunktionell",
      "lastName": "Jordbruksekonom"
  },
  {
      "partnerNumberIndividual": "0034624976",
      "employeeId": "198702200976",
      "firstName": "Påfågelsblå",
      "lastName": "Malcylinder"
  },
  {
      "partnerNumberIndividual": "0034626251",
      "employeeId": "198911277294",
      "firstName": "Utankänsel",
      "lastName": "Hjärtkontusion"
  },
  {
      "partnerNumberIndividual": "0034629765",
      "employeeId": "198707194075",
      "firstName": "Minnessvag",
      "lastName": "Dahliesort"
  },
  {
      "partnerNumberIndividual": "0034631669",
      "employeeId": "198506212557",
      "firstName": "Kraft",
      "lastName": "Paradisflugsnappare"
  },
  {
      "partnerNumberIndividual": "0034634030",
      "employeeId": "198106084612",
      "firstName": "Profan",
      "lastName": "Fallskärmspacke"
  },
  {
      "partnerNumberIndividual": "0034634772",
      "employeeId": "198110059410",
      "firstName": "Geotermisk",
      "lastName": "Frostskyddsapparat"
  },
  {
      "partnerNumberIndividual": "0034636117",
      "employeeId": "198707258573",
      "firstName": "Direktörsaktig",
      "lastName": "Domning"
  },
  {
      "partnerNumberIndividual": "0034636973",
      "employeeId": "198109249618",
      "firstName": "Numinös",
      "lastName": "Kontantköp"
  },
  {
      "partnerNumberIndividual": "0034637767",
      "employeeId": "198802133283",
      "firstName": "Kardiografisk",
      "lastName": "Vårinflunsa"
  },
  {
      "partnerNumberIndividual": "0034644965",
      "employeeId": "198004079508",
      "firstName": "Spikrak",
      "lastName": "Osfresiologisk"
  },
  {
      "partnerNumberIndividual": "0034645355",
      "employeeId": "198807165280",
      "firstName": "Knäpptyst",
      "lastName": "Kvicksilverväxelriktare"
  },
  {
      "partnerNumberIndividual": "0034646371",
      "employeeId": "198909075197",
      "firstName": "Väderbiten",
      "lastName": "Kaffegrädde"
  },
  {
      "partnerNumberIndividual": "0034647543",
      "employeeId": "198501027851",
      "firstName": "Sydöster",
      "lastName": "Stranguri"
  },
  {
      "partnerNumberIndividual": "0034648733",
      "employeeId": "198705082678",
      "firstName": "Brytbar",
      "lastName": "Penningutbud"
  },
  {
      "partnerNumberIndividual": "0034650126",
      "employeeId": "198902013799",
      "firstName": "Heltmotsatt",
      "lastName": "Bearbetaning"
  },
  {
      "partnerNumberIndividual": "0034650171",
      "employeeId": "198404115548",
      "firstName": "Förkatolsk",
      "lastName": "Empir"
  },
  {
      "partnerNumberIndividual": "0034650740",
      "employeeId": "198907150596",
      "firstName": "Hornlik",
      "lastName": "Societetshus"
  },
  {
      "partnerNumberIndividual": "0034654557",
      "employeeId": "198308279432",
      "firstName": "Folkmordsliknande",
      "lastName": "Resolharts"
  },
  {
      "partnerNumberIndividual": "0034658269",
      "employeeId": "198001129702",
      "firstName": "Meterlång",
      "lastName": "Malcylinder"
  },
  {
      "partnerNumberIndividual": "0034658320",
      "employeeId": "198010162009",
      "firstName": "Självförstörande",
      "lastName": "Beslutomdödförklaring"
  },
  {
      "partnerNumberIndividual": "0034658600",
      "employeeId": "198310222636",
      "firstName": "Kostnadseffektiv",
      "lastName": "Kritsnöre"
  },
  {
      "partnerNumberIndividual": "0034658825",
      "employeeId": "198501242351",
      "firstName": "Storbystad",
      "lastName": "Karttekniker"
  },
  {
      "partnerNumberIndividual": "0034659234",
      "employeeId": "198604072366",
      "firstName": "Kortklippt",
      "lastName": "Rutigtmönster"
  },
  {
      "partnerNumberIndividual": "0034659519",
      "employeeId": "198704039372",
      "firstName": "Linje",
      "lastName": "Nödochlust"
  },
  {
      "partnerNumberIndividual": "0034659865",
      "employeeId": "198504272652",
      "firstName": "Statskontrollerad",
      "lastName": "Bildatlas"
  },
  {
      "partnerNumberIndividual": "0034659881",
      "employeeId": "198804063587",
      "firstName": "Sekret",
      "lastName": "Allmänskog"
  },
  {
      "partnerNumberIndividual": "0034659892",
      "employeeId": "198805172585",
      "firstName": "Profan",
      "lastName": "Oxfordrörelsemedlem"
  },
  {
      "partnerNumberIndividual": "0034659971",
      "employeeId": "198808107984",
      "firstName": "Mittenavoktober",
      "lastName": "Utländskmoderbolag"
  },
  {
      "partnerNumberIndividual": "0034660374",
      "employeeId": "198910230294",
      "firstName": "Sensualistisk",
      "lastName": "Jobbredovisning"
  },
  {
      "partnerNumberIndividual": "0034660905",
      "employeeId": "198702070478",
      "firstName": "Sammanhållen",
      "lastName": "Fenobarbitol"
  },
  {
      "partnerNumberIndividual": "0034661893",
      "employeeId": "198906112696",
      "firstName": "Salutogen",
      "lastName": "Beslutomdödförklaring"
  },
  {
      "partnerNumberIndividual": "0034662570",
      "employeeId": "198504198550",
      "firstName": "Deltid",
      "lastName": "Årsöversikt"
  },
  {
      "partnerNumberIndividual": "0034662774",
      "employeeId": "198708121374",
      "firstName": "Förmånlig",
      "lastName": "Halvapa"
  },
  {
      "partnerNumberIndividual": "0034663454",
      "employeeId": "198306032734",
      "firstName": "Turbinelektrisk",
      "lastName": "Dykdjup"
  },
  {
      "partnerNumberIndividual": "0034663601",
      "employeeId": "198805074088",
      "firstName": "Hanseatisk",
      "lastName": "Betongvara"
  },
  {
      "partnerNumberIndividual": "0034664473",
      "employeeId": "198307085434",
      "firstName": "Tangentbordsstyrd",
      "lastName": "Audigram"
  },
  {
      "partnerNumberIndividual": "0034664637",
      "employeeId": "198711201676",
      "firstName": "Dualistisk",
      "lastName": "Vindsstege"
  },
  {
      "partnerNumberIndividual": "0034665950",
      "employeeId": "198710073977",
      "firstName": "Konstruktiv",
      "lastName": "Förhörsledare"
  },
  {
      "partnerNumberIndividual": "0034666222",
      "employeeId": "198402267846",
      "firstName": "Närsynt",
      "lastName": "Läkekonst"
  },
  {
      "partnerNumberIndividual": "0034666311",
      "employeeId": "198903252396",
      "firstName": "Råkall",
      "lastName": "Nageltrång"
  },
  {
      "partnerNumberIndividual": "0034666767",
      "employeeId": "198511259957",
      "firstName": "Sydsvensk",
      "lastName": "Snöplighet"
  },
  {
      "partnerNumberIndividual": "0034668536",
      "employeeId": "198911187493",
      "firstName": "Pittoresk",
      "lastName": "Spikbleck"
  },
  {
      "partnerNumberIndividual": "0034668798",
      "employeeId": "198008042809",
      "firstName": "Proforma",
      "lastName": "Läckerriska"
  },
  {
      "partnerNumberIndividual": "0034670456",
      "employeeId": "198207273627",
      "firstName": "Dagvill",
      "lastName": "Stortungkg"
  },
  {
      "partnerNumberIndividual": "0034671017",
      "employeeId": "198708115673",
      "firstName": "Redobogen",
      "lastName": "Palaumarkduva"
  },
  {
      "partnerNumberIndividual": "0034671416",
      "employeeId": "198709015575",
      "firstName": "Bekymmersfri",
      "lastName": "Apokryfiskbok"
  },
  {
      "partnerNumberIndividual": "0034671886",
      "employeeId": "198707034974",
      "firstName": "Konstruktiv",
      "lastName": "Levnadsregel"
  },
  {
      "partnerNumberIndividual": "0034672065",
      "employeeId": "198911209495",
      "firstName": "Direktörsaktig",
      "lastName": "Utsago"
  },
  {
      "partnerNumberIndividual": "0034674791",
      "employeeId": "198803049488",
      "firstName": "Sportig",
      "lastName": "Grönaracari"
  },
  {
      "partnerNumberIndividual": "0034675009",
      "employeeId": "198307133937",
      "firstName": "Tyngdkrafts",
      "lastName": "Ledningsmaterialavsilver"
  },
  {
      "partnerNumberIndividual": "0034676838",
      "employeeId": "198809097382",
      "firstName": "Reglementarisk",
      "lastName": "Arnaudbarbett"
  },
  {
      "partnerNumberIndividual": "0034677618",
      "employeeId": "198711085673",
      "firstName": "Sentblommande",
      "lastName": "Miltklimat"
  },
  {
      "partnerNumberIndividual": "0034677701",
      "employeeId": "198711126378",
      "firstName": "Pleuritisk",
      "lastName": "Fariseism"
  },
  {
      "partnerNumberIndividual": "0034677807",
      "employeeId": "198701052774",
      "firstName": "Förbikörande",
      "lastName": "Stridsvagnsduell"
  },
  {
      "partnerNumberIndividual": "0034677829",
      "employeeId": "198903046293",
      "firstName": "Etnisk",
      "lastName": "Moskovit"
  },
  {
      "partnerNumberIndividual": "0034678551",
      "employeeId": "198810135288",
      "firstName": "Frontad",
      "lastName": "Skirning"
  },
  {
      "partnerNumberIndividual": "0034679881",
      "employeeId": "198710233373",
      "firstName": "Urtjatad",
      "lastName": "Plättpanna"
  },
  {
      "partnerNumberIndividual": "0034680652",
      "employeeId": "198201133520",
      "firstName": "Jävelns",
      "lastName": "Cellteknologi"
  },
  {
      "partnerNumberIndividual": "0034680763",
      "employeeId": "198401125946",
      "firstName": "Radiostyrd",
      "lastName": "Varmblixt"
  },
  {
      "partnerNumberIndividual": "0034685379",
      "employeeId": "198609099869",
      "firstName": "Asbestinnehållande",
      "lastName": "Styrspel"
  },
  {
      "partnerNumberIndividual": "0034686696",
      "employeeId": "198903249392",
      "firstName": "Polygenisk",
      "lastName": "Mjölkkvot"
  },
  {
      "partnerNumberIndividual": "0034687637",
      "employeeId": "198903228297",
      "firstName": "Ovis",
      "lastName": "Ytfärg"
  },
  {
      "partnerNumberIndividual": "0034687957",
      "employeeId": "198908134292",
      "firstName": "Utanort",
      "lastName": "Lavulinsyra"
  },
  {
      "partnerNumberIndividual": "0034689761",
      "employeeId": "198202139229",
      "firstName": "Kostnadsfri",
      "lastName": "Lastningselevator"
  },
  {
      "partnerNumberIndividual": "0034689785",
      "employeeId": "198210221324",
      "firstName": "Klinklagd",
      "lastName": "Kemtvättsinrättning"
  },
  {
      "partnerNumberIndividual": "0034691492",
      "employeeId": "198903210493",
      "firstName": "Spondeisk",
      "lastName": "Segelhållare"
  },
  {
      "partnerNumberIndividual": "0034692644",
      "employeeId": "198001091407",
      "firstName": "Hårrörs",
      "lastName": "Orfeusgärdsmyg"
  },
  {
      "partnerNumberIndividual": "0034692888",
      "employeeId": "198603057061",
      "firstName": "Inbördeskrigliknande",
      "lastName": "Tolkprogram"
  },
  {
      "partnerNumberIndividual": "0034692971",
      "employeeId": "198711258379",
      "firstName": "Transitorisk",
      "lastName": "Kariol"
  },
  {
      "partnerNumberIndividual": "0034693445",
      "employeeId": "198909095997",
      "firstName": "Kringvärvd",
      "lastName": "Privatisering"
  },
  {
      "partnerNumberIndividual": "0034694206",
      "employeeId": "198208063225",
      "firstName": "Musikalisk",
      "lastName": "Sidostöttning"
  },
  {
      "partnerNumberIndividual": "0034694465",
      "employeeId": "198604163660",
      "firstName": "Kapitalistisk",
      "lastName": "Fläcktjockfot"
  },
  {
      "partnerNumberIndividual": "0034694973",
      "employeeId": "198010127408",
      "firstName": "Pirrig",
      "lastName": "Tomgångsström"
  },
  {
      "partnerNumberIndividual": "0034695913",
      "employeeId": "198803097081",
      "firstName": "Fullriggad",
      "lastName": "Sändarkrets"
  },
  {
      "partnerNumberIndividual": "0034696205",
      "employeeId": "198910038994",
      "firstName": "Utseende",
      "lastName": "Kornblixt"
  },
  {
      "partnerNumberIndividual": "0034696282",
      "employeeId": "198209074627",
      "firstName": "Hal",
      "lastName": "Mejeributik"
  },
  {
      "partnerNumberIndividual": "0034696531",
      "employeeId": "198404276449",
      "firstName": "Persulfat",
      "lastName": "Silvervinge"
  },
  {
      "partnerNumberIndividual": "0034696970",
      "employeeId": "198806039387",
      "firstName": "Angloholländsk",
      "lastName": "Maltesare"
  },
  {
      "partnerNumberIndividual": "0034698240",
      "employeeId": "198411266144",
      "firstName": "Trendmedveten",
      "lastName": "Natursiden"
  },
  {
      "partnerNumberIndividual": "0034698446",
      "employeeId": "198703027378",
      "firstName": "Frapperande",
      "lastName": "Testikelinflammation"
  },
  {
      "partnerNumberIndividual": "0034699224",
      "employeeId": "198703080971",
      "firstName": "Heteropolär",
      "lastName": "Utsändning"
  },
  {
      "partnerNumberIndividual": "0034699654",
      "employeeId": "198507112459",
      "firstName": "Månadförmånad",
      "lastName": "Jordkällare"
  },
  {
      "partnerNumberIndividual": "0034699673",
      "employeeId": "198711216476",
      "firstName": "Tiggaraktig",
      "lastName": "Vidareanvändning"
  },
  {
      "partnerNumberIndividual": "0034701417",
      "employeeId": "198906059392",
      "firstName": "Bommad",
      "lastName": "Fläkthastighet"
  },
  {
      "partnerNumberIndividual": "0034704299",
      "employeeId": "198906175990",
      "firstName": "Pektin",
      "lastName": "Tennjodid"
  },
  {
      "partnerNumberIndividual": "0034704976",
      "employeeId": "198908202396",
      "firstName": "Bakåtsträvande",
      "lastName": "FemStora"
  },
  {
      "partnerNumberIndividual": "0034704985",
      "employeeId": "198304150934",
      "firstName": "Svårbemästrad",
      "lastName": "Ättekulle"
  },
  {
      "partnerNumberIndividual": "0034706180",
      "employeeId": "198704092678",
      "firstName": "Puckelformig",
      "lastName": "Snigelcoua"
  },
  {
      "partnerNumberIndividual": "0034709102",
      "employeeId": "198808219482",
      "firstName": "Medhjälpande",
      "lastName": "Oskaplighet"
  },
  {
      "partnerNumberIndividual": "0034709424",
      "employeeId": "198708093078",
      "firstName": "Åkbar",
      "lastName": "Öppenvårdsbesök"
  },
  {
      "partnerNumberIndividual": "0034710654",
      "employeeId": "198002083502",
      "firstName": "Rankig",
      "lastName": "Magnetmotstånd"
  },
  {
      "partnerNumberIndividual": "0034710915",
      "employeeId": "198208194624",
      "firstName": "Svensk",
      "lastName": "Bildningsanstalt"
  },
  {
      "partnerNumberIndividual": "0034711604",
      "employeeId": "198806087881",
      "firstName": "Virtuos",
      "lastName": "Sommarförkylning"
  },
  {
      "partnerNumberIndividual": "0034712839",
      "employeeId": "198906086494",
      "firstName": "Strup",
      "lastName": "Maskinfabrikant"
  },
  {
      "partnerNumberIndividual": "0034714631",
      "employeeId": "198710268676",
      "firstName": "Vattrad",
      "lastName": "Strålskyddsrör"
  },
  {
      "partnerNumberIndividual": "0034715183",
      "employeeId": "198608088467",
      "firstName": "Krisdrabbad",
      "lastName": "Därvaro"
  },
  {
      "partnerNumberIndividual": "0034715827",
      "employeeId": "198003183509",
      "firstName": "Flodhästliknande",
      "lastName": "Stannosulfid"
  },
  {
      "partnerNumberIndividual": "0034715894",
      "employeeId": "198204260825",
      "firstName": "Bukstinn",
      "lastName": "Förhandsavgift"
  },
  {
      "partnerNumberIndividual": "0034717260",
      "employeeId": "198411245049",
      "firstName": "Antistatisk",
      "lastName": "Elektroretinograf"
  },
  {
      "partnerNumberIndividual": "0034720256",
      "employeeId": "198208173529",
      "firstName": "Lykantropisk",
      "lastName": "Äktenskapsfrekvens"
  },
  {
      "partnerNumberIndividual": "0034725131",
      "employeeId": "198409019141",
      "firstName": "Kraft",
      "lastName": "Bolagsstämma"
  },
  {
      "partnerNumberIndividual": "0034725799",
      "employeeId": "198808184181",
      "firstName": "Odäckad",
      "lastName": "Strandgata"
  },
  {
      "partnerNumberIndividual": "0034727058",
      "employeeId": "198502149852",
      "firstName": "Heldags",
      "lastName": "Agronomkollega"
  },
  {
      "partnerNumberIndividual": "0034727639",
      "employeeId": "198011241802",
      "firstName": "Igenkänningsbar",
      "lastName": "Totalomkostnad"
  },
  {
      "partnerNumberIndividual": "0034729978",
      "employeeId": "198705166471",
      "firstName": "Kartagisk",
      "lastName": "Flanör"
  },
  {
      "partnerNumberIndividual": "0034730158",
      "employeeId": "198404093547",
      "firstName": "Zetetisk",
      "lastName": "Vinnarserie"
  },
  {
      "partnerNumberIndividual": "0034734071",
      "employeeId": "198506252355",
      "firstName": "Ljuslila",
      "lastName": "Bullerochbång"
  },
  {
      "partnerNumberIndividual": "0034734400",
      "employeeId": "198603207765",
      "firstName": "Aggregerad",
      "lastName": "Rörligpensionsålder"
  },
  {
      "partnerNumberIndividual": "0034740396",
      "employeeId": "198110250415",
      "firstName": "Tariffmässig",
      "lastName": "Kryptografi"
  },
  {
      "partnerNumberIndividual": "0034744980",
      "employeeId": "198202255223",
      "firstName": "Häftade",
      "lastName": "Nåtsåg"
  },
  {
      "partnerNumberIndividual": "0034752082",
      "employeeId": "198206220629",
      "firstName": "Inbillad",
      "lastName": "Nivåfluktuation"
  },
  {
      "partnerNumberIndividual": "0034756600",
      "employeeId": "198708053270",
      "firstName": "Björnaktig",
      "lastName": "Hanplanta"
  },
  {
      "partnerNumberIndividual": "0034756665",
      "employeeId": "198907172590",
      "firstName": "Underkuvande",
      "lastName": "Dahliesort"
  },
  {
      "partnerNumberIndividual": "0034756666",
      "employeeId": "198907032794",
      "firstName": "Gentlemannalik",
      "lastName": "Akademikerbarn"
  },
  {
      "partnerNumberIndividual": "0034760629",
      "employeeId": "198810140981",
      "firstName": "Ugnsrostad",
      "lastName": "Kapacitetsandel"
  },
  {
      "partnerNumberIndividual": "0034761950",
      "employeeId": "198010085507",
      "firstName": "Submolekylär",
      "lastName": "Kontrollmanometer"
  },
  {
      "partnerNumberIndividual": "0034763443",
      "employeeId": "198808107083",
      "firstName": "Bäst",
      "lastName": "Danism"
  },
  {
      "partnerNumberIndividual": "0034765115",
      "employeeId": "198603187561",
      "firstName": "Expanderande",
      "lastName": "Bomullslump"
  },
  {
      "partnerNumberIndividual": "0034765549",
      "employeeId": "198801026983",
      "firstName": "Neuroberäknande",
      "lastName": "Läsesällskap"
  },
  {
      "partnerNumberIndividual": "0034767563",
      "employeeId": "198207044622",
      "firstName": "Miljöansvarig",
      "lastName": "Jordgubbsland"
  },
  {
      "partnerNumberIndividual": "0034768476",
      "employeeId": "198711215577",
      "firstName": "Specialanpassad",
      "lastName": "Dykdjup"
  },
  {
      "partnerNumberIndividual": "0034768875",
      "employeeId": "198602154760",
      "firstName": "Utelämnad",
      "lastName": "Plausibilitet"
  },
  {
      "partnerNumberIndividual": "0034771680",
      "employeeId": "198301243336",
      "firstName": "Beige",
      "lastName": "Gulkronadtyrann"
  },
  {
      "partnerNumberIndividual": "0034771808",
      "employeeId": "198602182167",
      "firstName": "Knarrig",
      "lastName": "Bestrålningstid"
  },
  {
      "partnerNumberIndividual": "0034772763",
      "employeeId": "198108015515",
      "firstName": "Transitorisk",
      "lastName": "Charkuteri"
  },
  {
      "partnerNumberIndividual": "0034773707",
      "employeeId": "198901246499",
      "firstName": "Oljeabsorberande",
      "lastName": "Ljuspolarisation"
  },
  {
      "partnerNumberIndividual": "0034773802",
      "employeeId": "198604043763",
      "firstName": "Benämnbar",
      "lastName": "Ljusstöparverkstad"
  },
  {
      "partnerNumberIndividual": "0034776014",
      "employeeId": "198311204534",
      "firstName": "Esoterisk",
      "lastName": "Folkkyrkopräst"
  },
  {
      "partnerNumberIndividual": "0034777001",
      "employeeId": "198602090865",
      "firstName": "Imperatorisk",
      "lastName": "Aluminiumborkarbid"
  },
  {
      "partnerNumberIndividual": "0034778877",
      "employeeId": "198007116109",
      "firstName": "Utförd",
      "lastName": "Dådlöshet"
  },
  {
      "partnerNumberIndividual": "0034779187",
      "employeeId": "198807207488",
      "firstName": "Eutrof",
      "lastName": "Borrspån"
  },
  {
      "partnerNumberIndividual": "0034779347",
      "employeeId": "198505043250",
      "firstName": "Ejgodkänd",
      "lastName": "Oxfordrörelsemedlem"
  },
  {
      "partnerNumberIndividual": "0034780767",
      "employeeId": "198004013507",
      "firstName": "Helfransk",
      "lastName": "Levnadsregel"
  },
  {
      "partnerNumberIndividual": "0034780893",
      "employeeId": "198403119848",
      "firstName": "Tillfredsställande",
      "lastName": "Öljätte"
  },
  {
      "partnerNumberIndividual": "0034782885",
      "employeeId": "198901052392",
      "firstName": "Huvudsaklig",
      "lastName": "Värmeisolering"
  },
  {
      "partnerNumberIndividual": "0034786936",
      "employeeId": "198306040539",
      "firstName": "Allrabäst",
      "lastName": "Mindreskatfink"
  },
  {
      "partnerNumberIndividual": "0034788708",
      "employeeId": "198908217790",
      "firstName": "Elektrohydraulisk",
      "lastName": "Farsdagen"
  },
  {
      "partnerNumberIndividual": "0034791249",
      "employeeId": "198807172781",
      "firstName": "Jordig",
      "lastName": "Sjukvårdsbiträde"
  },
  {
      "partnerNumberIndividual": "0034792364",
      "employeeId": "198301082734",
      "firstName": "Småfuktig",
      "lastName": "Partistyrelse"
  },
  {
      "partnerNumberIndividual": "0034793088",
      "employeeId": "198206048921",
      "firstName": "Plandels",
      "lastName": "Fältmärke"
  },
  {
      "partnerNumberIndividual": "0034793138",
      "employeeId": "198211178523",
      "firstName": "Gåshudsframkallande",
      "lastName": "Privatisering"
  },
  {
      "partnerNumberIndividual": "0034795788",
      "employeeId": "198610233564",
      "firstName": "Spondeisk",
      "lastName": "Restaurationskomedi"
  },
  {
      "partnerNumberIndividual": "0034801252",
      "employeeId": "198901203995",
      "firstName": "Ormrik",
      "lastName": "Kontantköp"
  },
  {
      "partnerNumberIndividual": "0034802689",
      "employeeId": "198601098166",
      "firstName": "Kardiografisk",
      "lastName": "Menlöshet"
  },
  {
      "partnerNumberIndividual": "0034802901",
      "employeeId": "198709029477",
      "firstName": "Genteknologisk",
      "lastName": "Lustslott"
  },
  {
      "partnerNumberIndividual": "0034802982",
      "employeeId": "198607077065",
      "firstName": "Fingrad",
      "lastName": "Hårdförman"
  },
  {
      "partnerNumberIndividual": "0034803558",
      "employeeId": "198710054076",
      "firstName": "Orientalisk",
      "lastName": "Noronhavireo"
  },
  {
      "partnerNumberIndividual": "0034807797",
      "employeeId": "198607132464",
      "firstName": "Utnött",
      "lastName": "Cognacsessens"
  },
  {
      "partnerNumberIndividual": "0034813516",
      "employeeId": "198210237627",
      "firstName": "Påminnande",
      "lastName": "Engganoglasögonfågel"
  },
  {
      "partnerNumberIndividual": "0034813525",
      "employeeId": "198608094762",
      "firstName": "Partitrogen",
      "lastName": "Godistillverkning"
  },
  {
      "partnerNumberIndividual": "0034815187",
      "employeeId": "198210014620",
      "firstName": "Numerär",
      "lastName": "Oframkomlighet"
  },
  {
      "partnerNumberIndividual": "0034818827",
      "employeeId": "198011249706",
      "firstName": "Fågel",
      "lastName": "Bensoylglycin"
  },
  {
      "partnerNumberIndividual": "0034818966",
      "employeeId": "198206104625",
      "firstName": "Utpyntad",
      "lastName": "Ledarställning"
  },
  {
      "partnerNumberIndividual": "0034819301",
      "employeeId": "198902238594",
      "firstName": "Imperatorisk",
      "lastName": "Domherre"
  },
  {
      "partnerNumberIndividual": "0034821566",
      "employeeId": "198709082476",
      "firstName": "Deskriptiv",
      "lastName": "Kopparsvart"
  },
  {
      "partnerNumberIndividual": "0034821810",
      "employeeId": "198008264908",
      "firstName": "Kusttillkust",
      "lastName": "Stenkastare"
  },
  {
      "partnerNumberIndividual": "0034822205",
      "employeeId": "198806224088",
      "firstName": "Närbesläktad",
      "lastName": "Drossel"
  },
  {
      "partnerNumberIndividual": "0034822597",
      "employeeId": "198104055218",
      "firstName": "Märkesskyddad",
      "lastName": "Marmorflis"
  },
  {
      "partnerNumberIndividual": "0034823742",
      "employeeId": "198206215223",
      "firstName": "Elokvent",
      "lastName": "Offshoreverksamhet"
  },
  {
      "partnerNumberIndividual": "0034824960",
      "employeeId": "198705118571",
      "firstName": "Styckevis",
      "lastName": "Golvplanka"
  },
  {
      "partnerNumberIndividual": "0034826860",
      "employeeId": "198902278392",
      "firstName": "Tadelfri",
      "lastName": "Droppeihavet"
  },
  {
      "partnerNumberIndividual": "0034827596",
      "employeeId": "198109068810",
      "firstName": "Standard",
      "lastName": "Hjärterot"
  },
  {
      "partnerNumberIndividual": "0034829174",
      "employeeId": "198808272481",
      "firstName": "Oförtruten",
      "lastName": "Terum"
  },
  {
      "partnerNumberIndividual": "0034831552",
      "employeeId": "198809029583",
      "firstName": "Utankärlek",
      "lastName": "Kornblixt"
  },
  {
      "partnerNumberIndividual": "0034832446",
      "employeeId": "198701277272",
      "firstName": "Bombmattefällande",
      "lastName": "Uppsökare"
  },
  {
      "partnerNumberIndividual": "0034833252",
      "employeeId": "198804037383",
      "firstName": "Fortlevande",
      "lastName": "Stilkonst"
  },
  {
      "partnerNumberIndividual": "0034833594",
      "employeeId": "198808050986",
      "firstName": "Malolaktisk",
      "lastName": "Trådlöstelefon"
  },
  {
      "partnerNumberIndividual": "0034834369",
      "employeeId": "198801073985",
      "firstName": "Mintgrön",
      "lastName": "Halvpence"
  },
  {
      "partnerNumberIndividual": "0034834876",
      "employeeId": "198009068407",
      "firstName": "Välhängd",
      "lastName": "Tidsaspekt"
  },
  {
      "partnerNumberIndividual": "0034838007",
      "employeeId": "198304212437",
      "firstName": "Feldebiterad",
      "lastName": "Amerikanskpimpernöt"
  },
  {
      "partnerNumberIndividual": "0034841142",
      "employeeId": "198903093899",
      "firstName": "Ugnsrostad",
      "lastName": "Gjutstål"
  },
  {
      "partnerNumberIndividual": "0034844094",
      "employeeId": "198906057891",
      "firstName": "Modellanpassad",
      "lastName": "Natursiden"
  },
  {
      "partnerNumberIndividual": "0034844389",
      "employeeId": "198404095047",
      "firstName": "Hudvänlig",
      "lastName": "Macquarierall"
  },
  {
      "partnerNumberIndividual": "0034845035",
      "employeeId": "198809139580",
      "firstName": "Dualistisk",
      "lastName": "Dubbelverkandeaxiallager"
  },
  {
      "partnerNumberIndividual": "0034851173",
      "employeeId": "198011235507",
      "firstName": "Bulldogslik",
      "lastName": "Jobbredovisning"
  },
  {
      "partnerNumberIndividual": "0034853402",
      "employeeId": "198611222665",
      "firstName": "Posttraumatisk",
      "lastName": "Konservutrustning"
  },
  {
      "partnerNumberIndividual": "0034854824",
      "employeeId": "198207070825",
      "firstName": "Saknad",
      "lastName": "Spolhjul"
  },
  {
      "partnerNumberIndividual": "0034855579",
      "employeeId": "198910203796",
      "firstName": "Gravimetrisk",
      "lastName": "Försäkringskostnad"
  },
  {
      "partnerNumberIndividual": "0034855767",
      "employeeId": "198110168211",
      "firstName": "Föräldra",
      "lastName": "Fiskerikontroll"
  },
  {
      "partnerNumberIndividual": "0034856038",
      "employeeId": "198908156295",
      "firstName": "Hormon",
      "lastName": "Ljusbågeskydd"
  },
  {
      "partnerNumberIndividual": "0034863684",
      "employeeId": "198506163750",
      "firstName": "Etnifierad",
      "lastName": "Åtskildhet"
  },
  {
      "partnerNumberIndividual": "0034863767",
      "employeeId": "198705013970",
      "firstName": "Konstnärlig",
      "lastName": "Kultje"
  },
  {
      "partnerNumberIndividual": "0034864827",
      "employeeId": "198701102470",
      "firstName": "Doxologisk",
      "lastName": "Barfrost"
  },
  {
      "partnerNumberIndividual": "0034866151",
      "employeeId": "198710030571",
      "firstName": "Basilar",
      "lastName": "Hästminne"
  },
  {
      "partnerNumberIndividual": "0034866877",
      "employeeId": "198609105864",
      "firstName": "Blott",
      "lastName": "Korselasticitet"
  },
  {
      "partnerNumberIndividual": "0034869182",
      "employeeId": "198708137073",
      "firstName": "Tillrufsad",
      "lastName": "Storskulden"
  },
  {
      "partnerNumberIndividual": "0034869848",
      "employeeId": "198703262074",
      "firstName": "Esoterisk",
      "lastName": "Dagspress"
  },
  {
      "partnerNumberIndividual": "0034870035",
      "employeeId": "198501012457",
      "firstName": "Esoterisk",
      "lastName": "Lekplatsutrustning"
  },
  {
      "partnerNumberIndividual": "0034870440",
      "employeeId": "198510260253",
      "firstName": "Endräktig",
      "lastName": "Amöbainfektion"
  },
  {
      "partnerNumberIndividual": "0034870453",
      "employeeId": "198904070292",
      "firstName": "Blästrad",
      "lastName": "Offerpris"
  },
  {
      "partnerNumberIndividual": "0034871125",
      "employeeId": "198708092773",
      "firstName": "Kraft",
      "lastName": "Korselasticitet"
  },
  {
      "partnerNumberIndividual": "0034871135",
      "employeeId": "198905068196",
      "firstName": "Intetillgänglig",
      "lastName": "Kritsnöre"
  },
  {
      "partnerNumberIndividual": "0034872602",
      "employeeId": "198805233486",
      "firstName": "Driftsklar",
      "lastName": "Gråbukadtragopan"
  },
  {
      "partnerNumberIndividual": "0034872718",
      "employeeId": "198511019153",
      "firstName": "Expropierad",
      "lastName": "Blomskaft"
  },
  {
      "partnerNumberIndividual": "0034873132",
      "employeeId": "198905159490",
      "firstName": "Tillfredsställande",
      "lastName": "Energiproducerandemineral"
  },
  {
      "partnerNumberIndividual": "0034873307",
      "employeeId": "198108035414",
      "firstName": "Djäkla",
      "lastName": "Tjänstpersonal"
  },
  {
      "partnerNumberIndividual": "0034873632",
      "employeeId": "198605262768",
      "firstName": "Olöslig",
      "lastName": "Emersion"
  },
  {
      "partnerNumberIndividual": "0034873727",
      "employeeId": "198703235872",
      "firstName": "Trädbeskuggad",
      "lastName": "Intvålning"
  },
  {
      "partnerNumberIndividual": "0034873877",
      "employeeId": "198810246481",
      "firstName": "Ganskakort",
      "lastName": "Stridstyrka"
  },
  {
      "partnerNumberIndividual": "0034876217",
      "employeeId": "198206049226",
      "firstName": "Expanderande",
      "lastName": "Australiskhavssula"
  },
  {
      "partnerNumberIndividual": "0034876807",
      "employeeId": "198605097065",
      "firstName": "Lättläst",
      "lastName": "Flygkontrollant"
  },
  {
      "partnerNumberIndividual": "0034879004",
      "employeeId": "198901204894",
      "firstName": "Tillsammantagen",
      "lastName": "Skivproducent"
  },
  {
      "partnerNumberIndividual": "0034879046",
      "employeeId": "198007253506",
      "firstName": "Deltid",
      "lastName": "Älsklingen"
  },
  {
      "partnerNumberIndividual": "0034880426",
      "employeeId": "198911013897",
      "firstName": "Elektronegativ",
      "lastName": "Kassasuccé"
  },
  {
      "partnerNumberIndividual": "0034882750",
      "employeeId": "198108237614",
      "firstName": "Obrytlig",
      "lastName": "Huvudsajt"
  },
  {
      "partnerNumberIndividual": "0034883973",
      "employeeId": "198004097609",
      "firstName": "Ejöverlämnad",
      "lastName": "Svanhus"
  },
  {
      "partnerNumberIndividual": "0034884417",
      "employeeId": "198909277397",
      "firstName": "Flockblommig",
      "lastName": "Amskrock"
  },
  {
      "partnerNumberIndividual": "0034886517",
      "employeeId": "198905096494",
      "firstName": "Spikrak",
      "lastName": "Gråvingadkotinga"
  },
  {
      "partnerNumberIndividual": "0034888075",
      "employeeId": "198809075982",
      "firstName": "Rättsvetenskaplig",
      "lastName": "Etnomusikologi"
  },
  {
      "partnerNumberIndividual": "0034890182",
      "employeeId": "198405132344",
      "firstName": "Tillföljdav",
      "lastName": "Universitetstryckeri"
  },
  {
      "partnerNumberIndividual": "0034890800",
      "employeeId": "198911028994",
      "firstName": "Pågående",
      "lastName": "Menlöshet"
  },
  {
      "partnerNumberIndividual": "0034891725",
      "employeeId": "198804258583",
      "firstName": "Österrikiskpreussisk",
      "lastName": "Stenkastare"
  },
  {
      "partnerNumberIndividual": "0034893165",
      "employeeId": "198702175673",
      "firstName": "Adjektivisk",
      "lastName": "Intvålning"
  },
  {
      "partnerNumberIndividual": "0034895557",
      "employeeId": "198703145774",
      "firstName": "Vidrörd",
      "lastName": "Ljusstöparverkstad"
  },
  {
      "partnerNumberIndividual": "0034900212",
      "employeeId": "198809146189",
      "firstName": "Heterosexistisk",
      "lastName": "Läkarspalt"
  },
  {
      "partnerNumberIndividual": "0034900725",
      "employeeId": "198801101083",
      "firstName": "Tillsist",
      "lastName": "Framtidsrädsla"
  },
  {
      "partnerNumberIndividual": "0034901274",
      "employeeId": "198102032714",
      "firstName": "Afferent",
      "lastName": "Flyttbestyr"
  },
  {
      "partnerNumberIndividual": "0034902326",
      "employeeId": "198507077850",
      "firstName": "Saknad",
      "lastName": "Halvpence"
  },
  {
      "partnerNumberIndividual": "0034904800",
      "employeeId": "198811040289",
      "firstName": "Felinställd",
      "lastName": "Snickare"
  },
  {
      "partnerNumberIndividual": "0034906012",
      "employeeId": "198605188062",
      "firstName": "Genotypisk",
      "lastName": "Lastnät"
  },
  {
      "partnerNumberIndividual": "0034906196",
      "employeeId": "198706232074",
      "firstName": "Minus",
      "lastName": "Styrspel"
  },
  {
      "partnerNumberIndividual": "0034906239",
      "employeeId": "198806230382",
      "firstName": "Tvågångs",
      "lastName": "Effektivitetsrevision"
  },
  {
      "partnerNumberIndividual": "0034906725",
      "employeeId": "198205133625",
      "firstName": "Mestavlägset",
      "lastName": "Gulstrupigbulbyl"
  },
  {
      "partnerNumberIndividual": "0034907045",
      "employeeId": "198401167849",
      "firstName": "Plandels",
      "lastName": "Ärftlighetsgen"
  },
  {
      "partnerNumberIndividual": "0034907714",
      "employeeId": "198210238823",
      "firstName": "Ostämd",
      "lastName": "Rymdteknik"
  },
  {
      "partnerNumberIndividual": "0034910310",
      "employeeId": "198601137360",
      "firstName": "Smidbar",
      "lastName": "Lågfjäll"
  },
  {
      "partnerNumberIndividual": "0034910655",
      "employeeId": "198007033502",
      "firstName": "Halvprivat",
      "lastName": "Hike"
  },
  {
      "partnerNumberIndividual": "0034910660",
      "employeeId": "198106242517",
      "firstName": "Högre",
      "lastName": "Hanplanta"
  },
  {
      "partnerNumberIndividual": "0034911757",
      "employeeId": "198708206373",
      "firstName": "Daggvåt",
      "lastName": "Ljusbågeskydd"
  },
  {
      "partnerNumberIndividual": "0034912166",
      "employeeId": "198205231825",
      "firstName": "Elektrohydraulisk",
      "lastName": "Neurotiker"
  },
  {
      "partnerNumberIndividual": "0034912621",
      "employeeId": "198402072840",
      "firstName": "Mural",
      "lastName": "Samhörighet"
  },
  {
      "partnerNumberIndividual": "0034914010",
      "employeeId": "198404074844",
      "firstName": "Tunnsliten",
      "lastName": "Arglist"
  },
  {
      "partnerNumberIndividual": "0034915638",
      "employeeId": "198701256177",
      "firstName": "Husdjursetisk",
      "lastName": "Fläktkylning"
  },
  {
      "partnerNumberIndividual": "0034915854",
      "employeeId": "198501102852",
      "firstName": "Smidbar",
      "lastName": "Klibbsticka"
  },
  {
      "partnerNumberIndividual": "0034916255",
      "employeeId": "198701255575",
      "firstName": "Utanort",
      "lastName": "Penningmarknadslån"
  },
  {
      "partnerNumberIndividual": "0034916362",
      "employeeId": "198310194637",
      "firstName": "Israelvänlig",
      "lastName": "Icketroende"
  },
  {
      "partnerNumberIndividual": "0034916429",
      "employeeId": "198803046484",
      "firstName": "Puckelformig",
      "lastName": "Laddapparat"
  },
  {
      "partnerNumberIndividual": "0034917512",
      "employeeId": "198311231636",
      "firstName": "Naiv",
      "lastName": "Gruppbildning"
  },
  {
      "partnerNumberIndividual": "0034918852",
      "employeeId": "198702244370",
      "firstName": "Ugnsrostad",
      "lastName": "Nageltrång"
  },
  {
      "partnerNumberIndividual": "0034920920",
      "employeeId": "198408122847",
      "firstName": "Största",
      "lastName": "Fraktionsdestillation"
  },
  {
      "partnerNumberIndividual": "0034921260",
      "employeeId": "198904130898",
      "firstName": "Cirkusaktig",
      "lastName": "Giftigtämne"
  },
  {
      "partnerNumberIndividual": "0034921331",
      "employeeId": "198204029428",
      "firstName": "Fyradörrars",
      "lastName": "Kakmonster"
  },
  {
      "partnerNumberIndividual": "0034929873",
      "employeeId": "198501234259",
      "firstName": "Ganskakort",
      "lastName": "Medhjälpare"
  },
  {
      "partnerNumberIndividual": "0034931377",
      "employeeId": "198004151802",
      "firstName": "Svanslös",
      "lastName": "Sjöborre"
  },
  {
      "partnerNumberIndividual": "0034932835",
      "employeeId": "198702149173",
      "firstName": "Ärtväxt",
      "lastName": "Äkthet"
  },
  {
      "partnerNumberIndividual": "0034933545",
      "employeeId": "198711218274",
      "firstName": "Kartagisk",
      "lastName": "Försnillande"
  },
  {
      "partnerNumberIndividual": "0034934026",
      "employeeId": "198008174800",
      "firstName": "Fnasig",
      "lastName": "Danism"
  },
  {
      "partnerNumberIndividual": "0034935277",
      "employeeId": "198110217315",
      "firstName": "Trafikstyrd",
      "lastName": "Informationssystem"
  },
  {
      "partnerNumberIndividual": "0034935457",
      "employeeId": "198702126270",
      "firstName": "Förminskad",
      "lastName": "Söksträng"
  },
  {
      "partnerNumberIndividual": "0034937522",
      "employeeId": "198103038413",
      "firstName": "Scenvan",
      "lastName": "Maltesare"
  },
  {
      "partnerNumberIndividual": "0034937524",
      "employeeId": "198707235670",
      "firstName": "Datormanipulerad",
      "lastName": "Innaturaskatt"
  },
  {
      "partnerNumberIndividual": "0034940996",
      "employeeId": "198407015943",
      "firstName": "Rosthindrande",
      "lastName": "Rasfördom"
  },
  {
      "partnerNumberIndividual": "0034942718",
      "employeeId": "198107268115",
      "firstName": "Fastnitad",
      "lastName": "Fullnav"
  },
  {
      "partnerNumberIndividual": "0034952291",
      "employeeId": "198605237760",
      "firstName": "Plandels",
      "lastName": "Tempocykel"
  },
  {
      "partnerNumberIndividual": "0034953385",
      "employeeId": "198407140048",
      "firstName": "Sydsvensk",
      "lastName": "Cykelhandtag"
  },
  {
      "partnerNumberIndividual": "0034962222",
      "employeeId": "198311068939",
      "firstName": "Alvlik",
      "lastName": "Hobbyrum"
  },
  {
      "partnerNumberIndividual": "0034962651",
      "employeeId": "198307112535",
      "firstName": "Högre",
      "lastName": "Startpedal"
  },
  {
      "partnerNumberIndividual": "0034967346",
      "employeeId": "198110092213",
      "firstName": "Oljerik",
      "lastName": "Hobbyrum"
  },
  {
      "partnerNumberIndividual": "0034968885",
      "employeeId": "198801080287",
      "firstName": "Tyskvänlig",
      "lastName": "Aneroxi"
  },
  {
      "partnerNumberIndividual": "0034975945",
      "employeeId": "198611085260",
      "firstName": "Navelskådande",
      "lastName": "Byggnadsvirke"
  },
  {
      "partnerNumberIndividual": "0034976597",
      "employeeId": "198810094287",
      "firstName": "Tvåhändig",
      "lastName": "Vapeninköp"
  },
  {
      "partnerNumberIndividual": "0034979441",
      "employeeId": "198802098981",
      "firstName": "Hormon",
      "lastName": "Stilkonst"
  },
  {
      "partnerNumberIndividual": "0034985581",
      "employeeId": "198503168455",
      "firstName": "Invalid",
      "lastName": "Avskedsuppvaktning"
  },
  {
      "partnerNumberIndividual": "0034987545",
      "employeeId": "198206214622",
      "firstName": "Expropierad",
      "lastName": "Tennjodid"
  },
  {
      "partnerNumberIndividual": "0034992248",
      "employeeId": "198902124695",
      "firstName": "Retlig",
      "lastName": "Fruktdiet"
  },
  {
      "partnerNumberIndividual": "0034995870",
      "employeeId": "198207023527",
      "firstName": "Snällmot",
      "lastName": "Grundvattenskydd"
  },
  {
      "partnerNumberIndividual": "0034995956",
      "employeeId": "198306069835",
      "firstName": "Sim",
      "lastName": "Arktisktklima"
  },
  {
      "partnerNumberIndividual": "0034997842",
      "employeeId": "198001181802",
      "firstName": "Hemlös",
      "lastName": "Våldsgata"
  },
  {
      "partnerNumberIndividual": "0034998856",
      "employeeId": "198305246434",
      "firstName": "Hemmaboende",
      "lastName": "Alefnoll"
  },
  {
      "partnerNumberIndividual": "0034998961",
      "employeeId": "198208172927",
      "firstName": "Fortlevande",
      "lastName": "Grundvattenskydd"
  },
  {
      "partnerNumberIndividual": "0034999622",
      "employeeId": "198708163277",
      "firstName": "Heteropolär",
      "lastName": "Sågverksflis"
  },
  {
      "partnerNumberIndividual": "0035000708",
      "employeeId": "198806037282",
      "firstName": "Täthets",
      "lastName": "Morotsfrö"
  },
  {
      "partnerNumberIndividual": "0035000779",
      "employeeId": "198805033084",
      "firstName": "Mångfunktionell",
      "lastName": "Flythjälp"
  },
  {
      "partnerNumberIndividual": "0035002434",
      "employeeId": "198901273295",
      "firstName": "Puckelformig",
      "lastName": "Förstorare"
  },
  {
      "partnerNumberIndividual": "0035002924",
      "employeeId": "198909118294",
      "firstName": "Vördad",
      "lastName": "Presbyter"
  },
  {
      "partnerNumberIndividual": "0035003512",
      "employeeId": "198804050584",
      "firstName": "Västtysk",
      "lastName": "Nymodighetsfobi"
  },
  {
      "partnerNumberIndividual": "0035006099",
      "employeeId": "198703049075",
      "firstName": "Trefokals",
      "lastName": "Enfrågepolitik"
  },
  {
      "partnerNumberIndividual": "0035006185",
      "employeeId": "198407197048",
      "firstName": "Trendmedveten",
      "lastName": "Öglemutter"
  },
  {
      "partnerNumberIndividual": "0035007052",
      "employeeId": "198707034073",
      "firstName": "Välskapad",
      "lastName": "Lyftsele"
  },
  {
      "partnerNumberIndividual": "0035007260",
      "employeeId": "198908244299",
      "firstName": "Tvungen",
      "lastName": "Kopparsvart"
  },
  {
      "partnerNumberIndividual": "0035010109",
      "employeeId": "198202192525",
      "firstName": "Oklangad",
      "lastName": "Rörligpensionsålder"
  },
  {
      "partnerNumberIndividual": "0035012946",
      "employeeId": "198607056267",
      "firstName": "Driftsklar",
      "lastName": "Prästrock"
  },
  {
      "partnerNumberIndividual": "0035014173",
      "employeeId": "198504268759",
      "firstName": "Heterosexistisk",
      "lastName": "Kontrollmanometer"
  },
  {
      "partnerNumberIndividual": "0035018135",
      "employeeId": "198706072074",
      "firstName": "Ejkonvertibel",
      "lastName": "Platan"
  },
  {
      "partnerNumberIndividual": "0035019969",
      "employeeId": "198510068953",
      "firstName": "Horisontutvidgande",
      "lastName": "Likörglas"
  },
  {
      "partnerNumberIndividual": "0035020083",
      "employeeId": "198802036288",
      "firstName": "Snarare",
      "lastName": "Vattenstäkra"
  },
  {
      "partnerNumberIndividual": "0035020986",
      "employeeId": "198602022769",
      "firstName": "Råkall",
      "lastName": "Blomskaft"
  },
  {
      "partnerNumberIndividual": "0035021032",
      "employeeId": "198004168400",
      "firstName": "Hetsig",
      "lastName": "Grenadjärgarde"
  },
  {
      "partnerNumberIndividual": "0035021150",
      "employeeId": "198805032482",
      "firstName": "Risig",
      "lastName": "Lagbud"
  },
  {
      "partnerNumberIndividual": "0035026448",
      "employeeId": "198504233456",
      "firstName": "Häftade",
      "lastName": "Lyra"
  },
  {
      "partnerNumberIndividual": "0035028522",
      "employeeId": "198702182273",
      "firstName": "Fotostat",
      "lastName": "Allaktivist"
  },
  {
      "partnerNumberIndividual": "0035036529",
      "employeeId": "198901142797",
      "firstName": "Genteknologisk",
      "lastName": "Vindsstege"
  },
  {
      "partnerNumberIndividual": "0035038212",
      "employeeId": "198002145004",
      "firstName": "Polygenisk",
      "lastName": "Sommarväder"
  },
  {
      "partnerNumberIndividual": "0035041544",
      "employeeId": "198708183176",
      "firstName": "Termostatstyrd",
      "lastName": "Stortungkg"
  },
  {
      "partnerNumberIndividual": "0035044863",
      "employeeId": "198202081629",
      "firstName": "Underårig",
      "lastName": "Rörligpensionsålder"
  },
  {
      "partnerNumberIndividual": "0035046338",
      "employeeId": "198604023567",
      "firstName": "Proforma",
      "lastName": "Glasögonuggla"
  },
  {
      "partnerNumberIndividual": "0035046558",
      "employeeId": "198811078289",
      "firstName": "Angloholländsk",
      "lastName": "Kaplanturbin"
  },
  {
      "partnerNumberIndividual": "0035047714",
      "employeeId": "198411093746",
      "firstName": "Regelbaserad",
      "lastName": "Presbyter"
  },
  {
      "partnerNumberIndividual": "0035047715",
      "employeeId": "198807249688",
      "firstName": "Kostymerad",
      "lastName": "Fältmärke"
  },
  {
      "partnerNumberIndividual": "0035048316",
      "employeeId": "198807056182",
      "firstName": "Monolitisk",
      "lastName": "Våldsgata"
  },
  {
      "partnerNumberIndividual": "0035048533",
      "employeeId": "198405110944",
      "firstName": "Silver",
      "lastName": "Våtdräkt"
  },
  {
      "partnerNumberIndividual": "0035048870",
      "employeeId": "198001267106",
      "firstName": "Tvungen",
      "lastName": "Kaplanturbin"
  },
  {
      "partnerNumberIndividual": "0035050015",
      "employeeId": "198907118395",
      "firstName": "Företagsbetald",
      "lastName": "Internetbokhandel"
  },
  {
      "partnerNumberIndividual": "0035051554",
      "employeeId": "198406235047",
      "firstName": "Blårutig",
      "lastName": "Självhypnos"
  },
  {
      "partnerNumberIndividual": "0035056261",
      "employeeId": "198805047886",
      "firstName": "Tillväxtförstoppad",
      "lastName": "Öringfiske"
  },
  {
      "partnerNumberIndividual": "0035056963",
      "employeeId": "198605090060",
      "firstName": "Original",
      "lastName": "Grönkungsljus"
  },
  {
      "partnerNumberIndividual": "0035057319",
      "employeeId": "198306213532",
      "firstName": "Grottlik",
      "lastName": "Mässkatalog"
  },
  {
      "partnerNumberIndividual": "0035060398",
      "employeeId": "198906042190",
      "firstName": "Penningorienterad",
      "lastName": "Gruppspråk"
  },
  {
      "partnerNumberIndividual": "0035061373",
      "employeeId": "198802132988",
      "firstName": "Obillig",
      "lastName": "Dans"
  },
  {
      "partnerNumberIndividual": "0035062702",
      "employeeId": "198407174740",
      "firstName": "Pleuritisk",
      "lastName": "Hjortpark"
  },
  {
      "partnerNumberIndividual": "0035062769",
      "employeeId": "198006258407",
      "firstName": "Kommunalistisk",
      "lastName": "Överklassdygd"
  },
  {
      "partnerNumberIndividual": "0035064339",
      "employeeId": "198204228921",
      "firstName": "Ospenderad",
      "lastName": "Jordenssalt"
  },
  {
      "partnerNumberIndividual": "0035066670",
      "employeeId": "198804270281",
      "firstName": "Oälskad",
      "lastName": "Startpedal"
  },
  {
      "partnerNumberIndividual": "0035067658",
      "employeeId": "198805179580",
      "firstName": "Hungersnöddrabbad",
      "lastName": "Industriförorening"
  },
  {
      "partnerNumberIndividual": "0035068379",
      "employeeId": "198911189291",
      "firstName": "Oklippt",
      "lastName": "Restaurationskomedi"
  },
  {
      "partnerNumberIndividual": "0035069563",
      "employeeId": "198205157129",
      "firstName": "Knäckt",
      "lastName": "Paparazzo"
  },
  {
      "partnerNumberIndividual": "0035070813",
      "employeeId": "198210200229",
      "firstName": "Omflyttbar",
      "lastName": "Myrtenol"
  },
  {
      "partnerNumberIndividual": "0035070888",
      "employeeId": "198606100264",
      "firstName": "Zen",
      "lastName": "Fusion"
  },
  {
      "partnerNumberIndividual": "0035072121",
      "employeeId": "198902083990",
      "firstName": "Fridlysningsvärd",
      "lastName": "Moskovit"
  },
  {
      "partnerNumberIndividual": "0035072296",
      "employeeId": "198909032693",
      "firstName": "Slottslik",
      "lastName": "Brass"
  },
  {
      "partnerNumberIndividual": "0035077633",
      "employeeId": "198301133032",
      "firstName": "Handlingsduglig",
      "lastName": "Blåringadängelfisk"
  },
  {
      "partnerNumberIndividual": "0035078531",
      "employeeId": "198609270064",
      "firstName": "Helfransk",
      "lastName": "Svarttaxi"
  },
  {
      "partnerNumberIndividual": "0035079171",
      "employeeId": "198001085706",
      "firstName": "Snurrig",
      "lastName": "Mikrovektor"
  },
  {
      "partnerNumberIndividual": "0035080417",
      "employeeId": "198401097947",
      "firstName": "Långlivad",
      "lastName": "Karminastrild"
  },
  {
      "partnerNumberIndividual": "0035081752",
      "employeeId": "198710157473",
      "firstName": "Statskontrollerad",
      "lastName": "Ödehus"
  },
  {
      "partnerNumberIndividual": "0035086965",
      "employeeId": "198706038976",
      "firstName": "Prestationsorienterad",
      "lastName": "Investeringsavveckling"
  },
  {
      "partnerNumberIndividual": "0035087432",
      "employeeId": "198606163262",
      "firstName": "Säsongskorrigerad",
      "lastName": "Konventionalstraff"
  },
  {
      "partnerNumberIndividual": "0035090886",
      "employeeId": "198807229185",
      "firstName": "Vattenburen",
      "lastName": "Tjänsteman"
  },
  {
      "partnerNumberIndividual": "0035092036",
      "employeeId": "198709189479",
      "firstName": "Konstnärlig",
      "lastName": "Klosterföreståndarinna"
  },
  {
      "partnerNumberIndividual": "0035093620",
      "employeeId": "198903115296",
      "firstName": "Heldags",
      "lastName": "Asbestfiberplatta"
  },
  {
      "partnerNumberIndividual": "0035095791",
      "employeeId": "198803213985",
      "firstName": "Oför",
      "lastName": "Spårdjup"
  },
  {
      "partnerNumberIndividual": "0035095803",
      "employeeId": "198309046137",
      "firstName": "Vikariats",
      "lastName": "Modem"
  },
  {
      "partnerNumberIndividual": "0035102734",
      "employeeId": "198209198822",
      "firstName": "Suggererande",
      "lastName": "Hårrörskärl"
  },
  {
      "partnerNumberIndividual": "0035103419",
      "employeeId": "198606198565",
      "firstName": "Berusande",
      "lastName": "Reduceringsväxel"
  },
  {
      "partnerNumberIndividual": "0035104264",
      "employeeId": "198802146582",
      "firstName": "Samhällsmedicinsk",
      "lastName": "Eftermiddagsskift"
  },
  {
      "partnerNumberIndividual": "0035104888",
      "employeeId": "198805186486",
      "firstName": "Pittoresk",
      "lastName": "Cykelhandtag"
  },
  {
      "partnerNumberIndividual": "0035105744",
      "employeeId": "198907076494",
      "firstName": "Sentimental",
      "lastName": "Lokalguide"
  },
  {
      "partnerNumberIndividual": "0035109937",
      "employeeId": "198311137338",
      "firstName": "Moralistisk",
      "lastName": "Tavetavävare"
  },
  {
      "partnerNumberIndividual": "0035118517",
      "employeeId": "198306172233",
      "firstName": "Motsägelsebar",
      "lastName": "Skirning"
  },
  {
      "partnerNumberIndividual": "0035119261",
      "employeeId": "198108090518",
      "firstName": "Blårutig",
      "lastName": "Widescreenskärm"
  },
  {
      "partnerNumberIndividual": "0035119955",
      "employeeId": "198806252089",
      "firstName": "Hemtrevlig",
      "lastName": "Importintressen"
  },
  {
      "partnerNumberIndividual": "0035121376",
      "employeeId": "198003178400",
      "firstName": "Lödd",
      "lastName": "Allmänskog"
  },
  {
      "partnerNumberIndividual": "0035123912",
      "employeeId": "198709257276",
      "firstName": "Feber",
      "lastName": "Majshack"
  },
  {
      "partnerNumberIndividual": "0035125251",
      "employeeId": "198410193844",
      "firstName": "Tänkbar",
      "lastName": "Kubansktodi"
  },
  {
      "partnerNumberIndividual": "0035125325",
      "employeeId": "198307210438",
      "firstName": "Parhelisk",
      "lastName": "Jordmån"
  },
  {
      "partnerNumberIndividual": "0035127590",
      "employeeId": "198709174075",
      "firstName": "Deskriptiv",
      "lastName": "Startström"
  },
  {
      "partnerNumberIndividual": "0035128228",
      "employeeId": "198402251543",
      "firstName": "Ejavstavad",
      "lastName": "Megaerbjudande"
  },
  {
      "partnerNumberIndividual": "0035128481",
      "employeeId": "198711263775",
      "firstName": "Självförhärligande",
      "lastName": "Bravuraria"
  },
  {
      "partnerNumberIndividual": "0035131209",
      "employeeId": "198206033527",
      "firstName": "Självförstörande",
      "lastName": "Informationssystem"
  },
  {
      "partnerNumberIndividual": "0035132304",
      "employeeId": "198005247302",
      "firstName": "Mångordig",
      "lastName": "Kommunitet"
  },
  {
      "partnerNumberIndividual": "0035133291",
      "employeeId": "198802242985",
      "firstName": "Stressig",
      "lastName": "Västaustraliskskarv"
  },
  {
      "partnerNumberIndividual": "0035135145",
      "employeeId": "198406185648",
      "firstName": "Mellan",
      "lastName": "Getost"
  },
  {
      "partnerNumberIndividual": "0035137198",
      "employeeId": "198506190852",
      "firstName": "Förbliven",
      "lastName": "Vänskapshandling"
  },
  {
      "partnerNumberIndividual": "0035137834",
      "employeeId": "198607235861",
      "firstName": "Färdigutbildad",
      "lastName": "Vårinflunsa"
  },
  {
      "partnerNumberIndividual": "0035137924",
      "employeeId": "198405128441",
      "firstName": "Kostnadseffektiv",
      "lastName": "Svetsomformare"
  },
  {
      "partnerNumberIndividual": "0035138873",
      "employeeId": "198708273274",
      "firstName": "Adderbar",
      "lastName": "Bananglass"
  },
  {
      "partnerNumberIndividual": "0035141601",
      "employeeId": "198607188565",
      "firstName": "Blårutig",
      "lastName": "Energiflödestäthet"
  },
  {
      "partnerNumberIndividual": "0035141815",
      "employeeId": "198905233592",
      "firstName": "Neolitisk",
      "lastName": "Sommarförkylning"
  },
  {
      "partnerNumberIndividual": "0035144456",
      "employeeId": "198701274279",
      "firstName": "Eutrof",
      "lastName": "Fuling"
  },
  {
      "partnerNumberIndividual": "0035145776",
      "employeeId": "198503012653",
      "firstName": "Tidvattens",
      "lastName": "Nonsinelaudeapprobatur"
  },
  {
      "partnerNumberIndividual": "0035149021",
      "employeeId": "198404088448",
      "firstName": "Begynnelse",
      "lastName": "Kvartärgeologi"
  },
  {
      "partnerNumberIndividual": "0035155831",
      "employeeId": "198210153527",
      "firstName": "Herrskapsliknande",
      "lastName": "Medelhansvärlden"
  },
  {
      "partnerNumberIndividual": "0035159024",
      "employeeId": "198804189580",
      "firstName": "Förminskad",
      "lastName": "Halvpence"
  },
  {
      "partnerNumberIndividual": "0035159508",
      "employeeId": "198906132892",
      "firstName": "Små",
      "lastName": "Motocross"
  },
  {
      "partnerNumberIndividual": "0035160092",
      "employeeId": "198801186084",
      "firstName": "Kärlekskrank",
      "lastName": "Megaerbjudande"
  },
  {
      "partnerNumberIndividual": "0035161379",
      "employeeId": "198711062474",
      "firstName": "Hialös",
      "lastName": "Grundvattenskydd"
  },
  {
      "partnerNumberIndividual": "0035163047",
      "employeeId": "198908092995",
      "firstName": "Vulvaliknande",
      "lastName": "Konvolvulus"
  },
  {
      "partnerNumberIndividual": "0035165403",
      "employeeId": "198906242899",
      "firstName": "Fingrad",
      "lastName": "Genrepspublik"
  },
  {
      "partnerNumberIndividual": "0035168674",
      "employeeId": "198906160299",
      "firstName": "Svensk",
      "lastName": "Ytfinhet"
  },
  {
      "partnerNumberIndividual": "0035170111",
      "employeeId": "198802022981",
      "firstName": "Polygenisk",
      "lastName": "Bomullslump"
  },
  {
      "partnerNumberIndividual": "0035171045",
      "employeeId": "198608212562",
      "firstName": "Vissnande",
      "lastName": "Trycklocksburk"
  },
  {
      "partnerNumberIndividual": "0035173799",
      "employeeId": "198210133628",
      "firstName": "Ostämd",
      "lastName": "Stannosulfid"
  },
  {
      "partnerNumberIndividual": "0035174489",
      "employeeId": "198707256478",
      "firstName": "Feberdrabbad",
      "lastName": "Plättpanna"
  },
  {
      "partnerNumberIndividual": "0035174560",
      "employeeId": "198004105105",
      "firstName": "Sträckt",
      "lastName": "Universitetstryckeri"
  },
  {
      "partnerNumberIndividual": "0035175042",
      "employeeId": "198910218596",
      "firstName": "Fullskalig",
      "lastName": "Känsloskala"
  },
  {
      "partnerNumberIndividual": "0035175174",
      "employeeId": "198802243884",
      "firstName": "Ful",
      "lastName": "Lastnät"
  },
  {
      "partnerNumberIndividual": "0035175386",
      "employeeId": "198002124801",
      "firstName": "Närsynt",
      "lastName": "Kaplanturbin"
  },
  {
      "partnerNumberIndividual": "0035175443",
      "employeeId": "198506192056",
      "firstName": "Zoografisk",
      "lastName": "Giftdryck"
  },
  {
      "partnerNumberIndividual": "0035176455",
      "employeeId": "198801162887",
      "firstName": "Omöjlig",
      "lastName": "Sjuplaning"
  },
  {
      "partnerNumberIndividual": "0035178227",
      "employeeId": "198811118986",
      "firstName": "Fnasig",
      "lastName": "Guldgruva"
  },
  {
      "partnerNumberIndividual": "0035179319",
      "employeeId": "198909208699",
      "firstName": "Mördad",
      "lastName": "Avhorning"
  },
  {
      "partnerNumberIndividual": "0035180545",
      "employeeId": "198603083265",
      "firstName": "Nedrullad",
      "lastName": "Bröstlidande"
  },
  {
      "partnerNumberIndividual": "0035183893",
      "employeeId": "198708092476",
      "firstName": "Sträckt",
      "lastName": "Enterostomi"
  },
  {
      "partnerNumberIndividual": "0035186258",
      "employeeId": "198906169993",
      "firstName": "Responsiv",
      "lastName": "Drossel"
  },
  {
      "partnerNumberIndividual": "0035186644",
      "employeeId": "198702264873",
      "firstName": "Häftade",
      "lastName": "Privatisering"
  },
  {
      "partnerNumberIndividual": "0035187721",
      "employeeId": "198710100473",
      "firstName": "Olycksbenägen",
      "lastName": "Svågerpolitik"
  },
  {
      "partnerNumberIndividual": "0035189161",
      "employeeId": "198711105570",
      "firstName": "Syndfri",
      "lastName": "Konventionalstraff"
  },
  {
      "partnerNumberIndividual": "0035189901",
      "employeeId": "198910070591",
      "firstName": "Fnasig",
      "lastName": "Beklädnadsförråd"
  },
  {
      "partnerNumberIndividual": "0035199121",
      "employeeId": "198606114760",
      "firstName": "Närsynt",
      "lastName": "Driftsättning"
  },
  {
      "partnerNumberIndividual": "0035201154",
      "employeeId": "198904279497",
      "firstName": "Tillsist",
      "lastName": "Ryggmärgskompression"
  },
  {
      "partnerNumberIndividual": "0035204805",
      "employeeId": "198810210289",
      "firstName": "Solar",
      "lastName": "Majshack"
  },
  {
      "partnerNumberIndividual": "0035208346",
      "employeeId": "198801072789",
      "firstName": "Tillföljdav",
      "lastName": "Fotbollskänsla"
  },
  {
      "partnerNumberIndividual": "0035213976",
      "employeeId": "198602092663",
      "firstName": "Gulgrön",
      "lastName": "Forbol"
  },
  {
      "partnerNumberIndividual": "0035218233",
      "employeeId": "198104123610",
      "firstName": "Havsliknande",
      "lastName": "Segelhållare"
  },
  {
      "partnerNumberIndividual": "0035219089",
      "employeeId": "198006036001",
      "firstName": "Fastnitad",
      "lastName": "Grenadjärgarde"
  },
  {
      "partnerNumberIndividual": "0035219937",
      "employeeId": "198406076243",
      "firstName": "Arm",
      "lastName": "Industriförorening"
  },
  {
      "partnerNumberIndividual": "0035222772",
      "employeeId": "198704239170",
      "firstName": "Giftasvuxen",
      "lastName": "Omgestaltning"
  },
  {
      "partnerNumberIndividual": "0035223152",
      "employeeId": "198003073502",
      "firstName": "Ödesbestämd",
      "lastName": "Störresultanspett"
  },
  {
      "partnerNumberIndividual": "0035224534",
      "employeeId": "198705276171",
      "firstName": "Preskriberad",
      "lastName": "Akademikerbarn"
  },
  {
      "partnerNumberIndividual": "0035225608",
      "employeeId": "198306013130",
      "firstName": "Främst",
      "lastName": "Flasktransportör"
  },
  {
      "partnerNumberIndividual": "0035225674",
      "employeeId": "198711091077",
      "firstName": "Daggvåt",
      "lastName": "Manligfullmäktigeledamot"
  },
  {
      "partnerNumberIndividual": "0035226069",
      "employeeId": "198106098513",
      "firstName": "Paradoxal",
      "lastName": "Kreditförlustreserv"
  },
  {
      "partnerNumberIndividual": "0035226914",
      "employeeId": "198411134748",
      "firstName": "Samlarlysten",
      "lastName": "Testikelinflammation"
  },
  {
      "partnerNumberIndividual": "0035227467",
      "employeeId": "198705151671",
      "firstName": "Azoisk",
      "lastName": "Nedsmutsare"
  },
  {
      "partnerNumberIndividual": "0035229218",
      "employeeId": "198810246184",
      "firstName": "Srilankesisk",
      "lastName": "Kyrkomusiker"
  },
  {
      "partnerNumberIndividual": "0035229235",
      "employeeId": "198910114894",
      "firstName": "Neolitisk",
      "lastName": "Niltilapia"
  },
  {
      "partnerNumberIndividual": "0035231759",
      "employeeId": "198802085384",
      "firstName": "Tropologisk",
      "lastName": "Påsporten"
  },
  {
      "partnerNumberIndividual": "0035232847",
      "employeeId": "198710234272",
      "firstName": "Flamhärdig",
      "lastName": "Nysrot"
  },
  {
      "partnerNumberIndividual": "0035233060",
      "employeeId": "198510220752",
      "firstName": "Spröd",
      "lastName": "Störrevitstrupigtukan"
  },
  {
      "partnerNumberIndividual": "0035233431",
      "employeeId": "198405202840",
      "firstName": "Pulserande",
      "lastName": "Sågverksflis"
  },
  {
      "partnerNumberIndividual": "0035235134",
      "employeeId": "198211274629",
      "firstName": "Horisontutvidgande",
      "lastName": "Regionaltstöd"
  },
  {
      "partnerNumberIndividual": "0035236363",
      "employeeId": "198703262678",
      "firstName": "Tvungen",
      "lastName": "Giftigtämne"
  },
  {
      "partnerNumberIndividual": "0035237337",
      "employeeId": "198203176220",
      "firstName": "Behandlande",
      "lastName": "Heavyband"
  },
  {
      "partnerNumberIndividual": "0035237449",
      "employeeId": "198002235706",
      "firstName": "Tillföljdav",
      "lastName": "Molekylärbiologi"
  },
  {
      "partnerNumberIndividual": "0035241026",
      "employeeId": "198005260206",
      "firstName": "Brännskadad",
      "lastName": "Realtid"
  },
  {
      "partnerNumberIndividual": "0035241110",
      "employeeId": "198601101465",
      "firstName": "Företagsbetald",
      "lastName": "Återbesättning"
  },
  {
      "partnerNumberIndividual": "0035246826",
      "employeeId": "198808112489",
      "firstName": "Ospenderad",
      "lastName": "Hjortpark"
  },
  {
      "partnerNumberIndividual": "0035247183",
      "employeeId": "198104171510",
      "firstName": "Hängmörad",
      "lastName": "Tursam"
  },
  {
      "partnerNumberIndividual": "0035247938",
      "employeeId": "198502219457",
      "firstName": "Naiv",
      "lastName": "Lustslott"
  },
  {
      "partnerNumberIndividual": "0035248042",
      "employeeId": "198706120279",
      "firstName": "Påminnande",
      "lastName": "Värmeisolering"
  },
  {
      "partnerNumberIndividual": "0035248259",
      "employeeId": "198204234622",
      "firstName": "Ljudlig",
      "lastName": "Tidvattenskraft"
  },
  {
      "partnerNumberIndividual": "0035253030",
      "employeeId": "198502092854",
      "firstName": "Allrakäraste",
      "lastName": "Bestrålningstid"
  },
  {
      "partnerNumberIndividual": "0035254536",
      "employeeId": "198808266186",
      "firstName": "Olöslig",
      "lastName": "Nödochlust"
  },
  {
      "partnerNumberIndividual": "0035255452",
      "employeeId": "198108014310",
      "firstName": "Tätbebyggd",
      "lastName": "Årsöversikt"
  },
  {
      "partnerNumberIndividual": "0035256229",
      "employeeId": "198711197478",
      "firstName": "Informations",
      "lastName": "Scintillationsräknare"
  },
  {
      "partnerNumberIndividual": "0035256467",
      "employeeId": "198710074876",
      "firstName": "Feberdrabbad",
      "lastName": "Frittinträde"
  },
  {
      "partnerNumberIndividual": "0035257269",
      "employeeId": "198703232879",
      "firstName": "Anställd",
      "lastName": "Vantrevnad"
  },
  {
      "partnerNumberIndividual": "0035260620",
      "employeeId": "198007095006",
      "firstName": "Pappaktig",
      "lastName": "Kokainförgiftning"
  },
  {
      "partnerNumberIndividual": "0035266611",
      "employeeId": "198902240996",
      "firstName": "Retlig",
      "lastName": "Moskovit"
  },
  {
      "partnerNumberIndividual": "0035269109",
      "employeeId": "198201043729",
      "firstName": "Generell",
      "lastName": "Utbytestransfusion"
  },
  {
      "partnerNumberIndividual": "0035269151",
      "employeeId": "198807033884",
      "firstName": "Behårad",
      "lastName": "Straffverkställighet"
  },
  {
      "partnerNumberIndividual": "0035269445",
      "employeeId": "198708023778",
      "firstName": "Kippskodd",
      "lastName": "Bokklubbsutgåva"
  },
  {
      "partnerNumberIndividual": "0035269465",
      "employeeId": "198804134081",
      "firstName": "Omusikalisk",
      "lastName": "Toppvinkel"
  },
  {
      "partnerNumberIndividual": "0035272292",
      "employeeId": "198209253627",
      "firstName": "Fridlysningsvärd",
      "lastName": "Totalomkostnad"
  },
  {
      "partnerNumberIndividual": "0035272913",
      "employeeId": "198901245897",
      "firstName": "Studieintresserad",
      "lastName": "Växelkurssystem"
  },
  {
      "partnerNumberIndividual": "0035276206",
      "employeeId": "198310029833",
      "firstName": "Minnes",
      "lastName": "Elektroniskhandel"
  },
  {
      "partnerNumberIndividual": "0035277147",
      "employeeId": "198710122774",
      "firstName": "Kommunalistisk",
      "lastName": "Raffinadkoppar"
  },
  {
      "partnerNumberIndividual": "0035279083",
      "employeeId": "198401235042",
      "firstName": "Suggererande",
      "lastName": "Beslutomdödförklaring"
  },
  {
      "partnerNumberIndividual": "0035279115",
      "employeeId": "198507059759",
      "firstName": "Ädel",
      "lastName": "Överklassdygd"
  },
  {
      "partnerNumberIndividual": "0035281893",
      "employeeId": "198908155693",
      "firstName": "Invalid",
      "lastName": "Jamaicabäverråtta"
  },
  {
      "partnerNumberIndividual": "0035285021",
      "employeeId": "198209199127",
      "firstName": "Abelsk",
      "lastName": "Repulsor"
  },
  {
      "partnerNumberIndividual": "0035286499",
      "employeeId": "198304052437",
      "firstName": "Allrabäst",
      "lastName": "Fettfärg"
  },
  {
      "partnerNumberIndividual": "0035289493",
      "employeeId": "198005247609",
      "firstName": "Omflyttbar",
      "lastName": "FemStora"
  },
  {
      "partnerNumberIndividual": "0035290887",
      "employeeId": "198011146308",
      "firstName": "Expanderande",
      "lastName": "Hagelkorn"
  },
  {
      "partnerNumberIndividual": "0035291296",
      "employeeId": "198003157602",
      "firstName": "Endoplasmatisk",
      "lastName": "Politisksociologi"
  },
  {
      "partnerNumberIndividual": "0035291940",
      "employeeId": "198008065701",
      "firstName": "Ifrågasättande",
      "lastName": "Vinylgummi"
  },
  {
      "partnerNumberIndividual": "0035293255",
      "employeeId": "198607020669",
      "firstName": "Säsongskorrigerad",
      "lastName": "Isobutylacetat"
  },
  {
      "partnerNumberIndividual": "0035294755",
      "employeeId": "198807080885",
      "firstName": "Hängmörad",
      "lastName": "Icketroende"
  },
  {
      "partnerNumberIndividual": "0035302411",
      "employeeId": "198408055948",
      "firstName": "Nyfunnen",
      "lastName": "Referensmaterial"
  },
  {
      "partnerNumberIndividual": "0035310564",
      "employeeId": "198907027992",
      "firstName": "Syndfri",
      "lastName": "Konstruktionsstandard"
  },
  {
      "partnerNumberIndividual": "0035314294",
      "employeeId": "198005052900",
      "firstName": "Sjusiffrig",
      "lastName": "Framtidsrädsla"
  },
  {
      "partnerNumberIndividual": "0035314564",
      "employeeId": "198007094108",
      "firstName": "Heterosexistisk",
      "lastName": "Gjutstål"
  },
  {
      "partnerNumberIndividual": "0035317673",
      "employeeId": "198008154901",
      "firstName": "Fullskalig",
      "lastName": "Yrkesgrupp"
  },
  {
      "partnerNumberIndividual": "0035320100",
      "employeeId": "198409127647",
      "firstName": "Heltmotsatt",
      "lastName": "Frostförsäkring"
  },
  {
      "partnerNumberIndividual": "0035330014",
      "employeeId": "198904098996",
      "firstName": "Israelvänlig",
      "lastName": "Nedrekontrollgräns"
  },
  {
      "partnerNumberIndividual": "0035334353",
      "employeeId": "198905080795",
      "firstName": "Passé",
      "lastName": "Strålskyddsrör"
  },
  {
      "partnerNumberIndividual": "0035337178",
      "employeeId": "198802126089",
      "firstName": "Bokstavlig",
      "lastName": "Konventdeltagare"
  },
  {
      "partnerNumberIndividual": "0035340067",
      "employeeId": "198005115004",
      "firstName": "Endoplasmatisk",
      "lastName": "Avhämtning"
  },
  {
      "partnerNumberIndividual": "0035340449",
      "employeeId": "198904041699",
      "firstName": "Kippskodd",
      "lastName": "Medbringarpinne"
  },
  {
      "partnerNumberIndividual": "0035342850",
      "employeeId": "198710032072",
      "firstName": "Ifrågasättande",
      "lastName": "Västligtangara"
  },
  {
      "partnerNumberIndividual": "0035347192",
      "employeeId": "198402115946",
      "firstName": "Heteropolär",
      "lastName": "Tennjodid"
  },
  {
      "partnerNumberIndividual": "0035349026",
      "employeeId": "198406095540",
      "firstName": "Reparerbar",
      "lastName": "Spolhjul"
  },
  {
      "partnerNumberIndividual": "0035349970",
      "employeeId": "198502039558",
      "firstName": "Skrafferad",
      "lastName": "Obemärkthet"
  },
  {
      "partnerNumberIndividual": "0035350895",
      "employeeId": "198903115593",
      "firstName": "Hemmaboende",
      "lastName": "Farsdagen"
  },
  {
      "partnerNumberIndividual": "0035351034",
      "employeeId": "198611111462",
      "firstName": "Hal",
      "lastName": "Alpmynta"
  },
  {
      "partnerNumberIndividual": "0035353348",
      "employeeId": "198506253858",
      "firstName": "Kortskaftad",
      "lastName": "Strandväg"
  },
  {
      "partnerNumberIndividual": "0035358425",
      "employeeId": "198005068302",
      "firstName": "Blårutig",
      "lastName": "Trasskola"
  },
  {
      "partnerNumberIndividual": "0035361786",
      "employeeId": "198803102782",
      "firstName": "Tillyxad",
      "lastName": "Liechtensteinare"
  },
  {
      "partnerNumberIndividual": "0035362778",
      "employeeId": "198908245791",
      "firstName": "Sexfotad",
      "lastName": "Tvåtaktsmotor"
  },
  {
      "partnerNumberIndividual": "0035363070",
      "employeeId": "198907165099",
      "firstName": "Musikalisk",
      "lastName": "Karminastrild"
  },
  {
      "partnerNumberIndividual": "0035365858",
      "employeeId": "198405279749",
      "firstName": "Fnasig",
      "lastName": "Vinylgummi"
  },
  {
      "partnerNumberIndividual": "0035366110",
      "employeeId": "198605014763",
      "firstName": "Tunnklädd",
      "lastName": "Lavulinsyra"
  },
  {
      "partnerNumberIndividual": "0035367039",
      "employeeId": "198007094702",
      "firstName": "Levnadstrött",
      "lastName": "Manskram"
  },
  {
      "partnerNumberIndividual": "0035367972",
      "employeeId": "198205161022",
      "firstName": "Gassig",
      "lastName": "Amöbainfektion"
  },
  {
      "partnerNumberIndividual": "0035368924",
      "employeeId": "198902152993",
      "firstName": "Pappaktig",
      "lastName": "Våldsgata"
  },
  {
      "partnerNumberIndividual": "0035369838",
      "employeeId": "198706052175",
      "firstName": "Sociologiskt",
      "lastName": "Återtaganderätt"
  },
  {
      "partnerNumberIndividual": "0035371483",
      "employeeId": "198705119470",
      "firstName": "Gladiatorklädd",
      "lastName": "Kostall"
  },
  {
      "partnerNumberIndividual": "0035377370",
      "employeeId": "198304159737",
      "firstName": "Rovfågelsliknande",
      "lastName": "Växtsamling"
  },
  {
      "partnerNumberIndividual": "0035377996",
      "employeeId": "198411267340",
      "firstName": "Skum",
      "lastName": "Vinägrettsås"
  },
  {
      "partnerNumberIndividual": "0035379432",
      "employeeId": "198409196949",
      "firstName": "Zen",
      "lastName": "Sånghöna"
  },
  {
      "partnerNumberIndividual": "0035379437",
      "employeeId": "198411067849",
      "firstName": "Statskontrollerad",
      "lastName": "Stångstål"
  },
  {
      "partnerNumberIndividual": "0035379604",
      "employeeId": "198909144498",
      "firstName": "Akvmarinfärgad",
      "lastName": "Omao"
  },
  {
      "partnerNumberIndividual": "0035383185",
      "employeeId": "198709085172",
      "firstName": "Polygenisk",
      "lastName": "Gulbentflugsnappare"
  },
  {
      "partnerNumberIndividual": "0035384145",
      "employeeId": "198411155545",
      "firstName": "Azoisk",
      "lastName": "Snabblåsmutter"
  },
  {
      "partnerNumberIndividual": "0035388308",
      "employeeId": "198801179485",
      "firstName": "Härleddav",
      "lastName": "Bästaanfallstiden"
  },
  {
      "partnerNumberIndividual": "0035388477",
      "employeeId": "198411107645",
      "firstName": "Meterlång",
      "lastName": "Flanör"
  },
  {
      "partnerNumberIndividual": "0035388949",
      "employeeId": "198509245851",
      "firstName": "Värmealstrande",
      "lastName": "Vitfläckigpygmérall"
  },
  {
      "partnerNumberIndividual": "0035389810",
      "employeeId": "198506162851",
      "firstName": "Urkomisk",
      "lastName": "Föreläsningssal"
  },
  {
      "partnerNumberIndividual": "0035394763",
      "employeeId": "198404094149",
      "firstName": "Leklysten",
      "lastName": "Restaurationskomedi"
  },
  {
      "partnerNumberIndividual": "0035397255",
      "employeeId": "198401256444",
      "firstName": "Anglobrasiliansk",
      "lastName": "Regionaltstöd"
  },
  {
      "partnerNumberIndividual": "0035399495",
      "employeeId": "198407092744",
      "firstName": "Underkuvande",
      "lastName": "Äxing"
  },
  {
      "partnerNumberIndividual": "0035403482",
      "employeeId": "198202089226",
      "firstName": "Osystematisk",
      "lastName": "Världsrekord"
  },
  {
      "partnerNumberIndividual": "0035404656",
      "employeeId": "198704204778",
      "firstName": "Inkräktande",
      "lastName": "Myrtenol"
  },
  {
      "partnerNumberIndividual": "0035408734",
      "employeeId": "198410102845",
      "firstName": "Snurrig",
      "lastName": "Tetracyaneten"
  },
  {
      "partnerNumberIndividual": "0035414221",
      "employeeId": "198905157999",
      "firstName": "Främst",
      "lastName": "Amerikanskpimpernöt"
  },
  {
      "partnerNumberIndividual": "0035415400",
      "employeeId": "198404205943",
      "firstName": "Fågel",
      "lastName": "Fläktkylning"
  },
  {
      "partnerNumberIndividual": "0035415758",
      "employeeId": "198301146331",
      "firstName": "Elektronegativ",
      "lastName": "Eftermiddagsskift"
  },
  {
      "partnerNumberIndividual": "0035417468",
      "employeeId": "198511086053",
      "firstName": "Såpoperalik",
      "lastName": "Vinägrettsås"
  },
  {
      "partnerNumberIndividual": "0035418419",
      "employeeId": "198607278069",
      "firstName": "Urtjatad",
      "lastName": "Diademyuhina"
  },
  {
      "partnerNumberIndividual": "0035419012",
      "employeeId": "198210209626",
      "firstName": "Självförhärligande",
      "lastName": "Kreditförlustreserv"
  },
  {
      "partnerNumberIndividual": "0035419892",
      "employeeId": "198006238201",
      "firstName": "Bifalls",
      "lastName": "Laternamagica"
  },
  {
      "partnerNumberIndividual": "0035422006",
      "employeeId": "198308036238",
      "firstName": "Vadderad",
      "lastName": "Champagnetillverkare"
  },
  {
      "partnerNumberIndividual": "0035425072",
      "employeeId": "198710199970",
      "firstName": "Himmelsvid",
      "lastName": "Energiproducerandemineral"
  },
  {
      "partnerNumberIndividual": "0035425951",
      "employeeId": "198606121963",
      "firstName": "Direktörsaktig",
      "lastName": "Politisksociologi"
  },
  {
      "partnerNumberIndividual": "0035426047",
      "employeeId": "198910163396",
      "firstName": "Exakt",
      "lastName": "Fenobarbitol"
  },
  {
      "partnerNumberIndividual": "0035428165",
      "employeeId": "198907040292",
      "firstName": "Endomorf",
      "lastName": "Tidskorridor"
  },
  {
      "partnerNumberIndividual": "0035429164",
      "employeeId": "198806259688",
      "firstName": "Hanseatisk",
      "lastName": "Snigelcoua"
  },
  {
      "partnerNumberIndividual": "0035435337",
      "employeeId": "198804195884",
      "firstName": "Termostatreglerad",
      "lastName": "Plantavstånd"
  },
  {
      "partnerNumberIndividual": "0035435967",
      "employeeId": "198006127602",
      "firstName": "Framröstad",
      "lastName": "Vantrevnad"
  },
  {
      "partnerNumberIndividual": "0035435989",
      "employeeId": "198211122729",
      "firstName": "Sköplig",
      "lastName": "Äxing"
  },
  {
      "partnerNumberIndividual": "0035439985",
      "employeeId": "198210098722",
      "firstName": "Kostnadseffektiv",
      "lastName": "Snövithasselmätare"
  },
  {
      "partnerNumberIndividual": "0035440806",
      "employeeId": "198309086539",
      "firstName": "Territorial",
      "lastName": "Elektroniskhandel"
  },
  {
      "partnerNumberIndividual": "0035442677",
      "employeeId": "198005199107",
      "firstName": "Företagsbetald",
      "lastName": "Ättekulle"
  },
  {
      "partnerNumberIndividual": "0035445116",
      "employeeId": "198603228860",
      "firstName": "Asturisk",
      "lastName": "Härjare"
  },
  {
      "partnerNumberIndividual": "0035445744",
      "employeeId": "198008243506",
      "firstName": "Halvlång",
      "lastName": "Mässkatalog"
  },
  {
      "partnerNumberIndividual": "0035450354",
      "employeeId": "198701060579",
      "firstName": "Bukig",
      "lastName": "Valbarhet"
  },
  {
      "partnerNumberIndividual": "0035450432",
      "employeeId": "198404095641",
      "firstName": "Behäftadmedfel",
      "lastName": "Batterilåda"
  },
  {
      "partnerNumberIndividual": "0035454978",
      "employeeId": "198811090888",
      "firstName": "Accentfri",
      "lastName": "Svartkronadsiska"
  },
  {
      "partnerNumberIndividual": "0035457432",
      "employeeId": "198601228060",
      "firstName": "Välhängd",
      "lastName": "Läkartjänst"
  },
  {
      "partnerNumberIndividual": "0035459593",
      "employeeId": "198604183569",
      "firstName": "Avresande",
      "lastName": "Mätarlarv"
  },
  {
      "partnerNumberIndividual": "0035460745",
      "employeeId": "198103160118",
      "firstName": "Känd",
      "lastName": "Lavulinsyra"
  },
  {
      "partnerNumberIndividual": "0035461753",
      "employeeId": "198804218181",
      "firstName": "Interkontinental",
      "lastName": "Störrevitstrupigtukan"
  },
  {
      "partnerNumberIndividual": "0035469976",
      "employeeId": "198601076766",
      "firstName": "Kortsvansad",
      "lastName": "Resform"
  },
  {
      "partnerNumberIndividual": "0035470297",
      "employeeId": "198805206987",
      "firstName": "Visuell",
      "lastName": "Megaerbjudande"
  },
  {
      "partnerNumberIndividual": "0035472620",
      "employeeId": "198701234778",
      "firstName": "Monolitisk",
      "lastName": "Ångstrykjärn"
  },
  {
      "partnerNumberIndividual": "0035473428",
      "employeeId": "198408212648",
      "firstName": "Deriverbar",
      "lastName": "Tyrolerdräkt"
  },
  {
      "partnerNumberIndividual": "0035475685",
      "employeeId": "198104082014",
      "firstName": "Fatisk",
      "lastName": "Flasktransportör"
  },
  {
      "partnerNumberIndividual": "0035477111",
      "employeeId": "198103112515",
      "firstName": "Femtonhundratals",
      "lastName": "Reservationsdatum"
  },
  {
      "partnerNumberIndividual": "0035478145",
      "employeeId": "198303015138",
      "firstName": "Demokratiserbar",
      "lastName": "Byggnadstimmer"
  },
  {
      "partnerNumberIndividual": "0035480797",
      "employeeId": "198808272788",
      "firstName": "Knarrig",
      "lastName": "Läkarspalt"
  },
  {
      "partnerNumberIndividual": "0035483144",
      "employeeId": "198704252678",
      "firstName": "Utpyntad",
      "lastName": "Glansmedel"
  },
  {
      "partnerNumberIndividual": "0035483425",
      "employeeId": "198902147894",
      "firstName": "Husdjursetisk",
      "lastName": "Avbärgning"
  },
  {
      "partnerNumberIndividual": "0035483803",
      "employeeId": "198505151459",
      "firstName": "Mörkhårig",
      "lastName": "Kriminalteknisktlaboratorium"
  },
  {
      "partnerNumberIndividual": "0035486205",
      "employeeId": "198011234005",
      "firstName": "Preskriberad",
      "lastName": "Tandfyllningsmaterial"
  },
  {
      "partnerNumberIndividual": "0035495911",
      "employeeId": "198704091472",
      "firstName": "Deskriptiv",
      "lastName": "Politisksociologi"
  },
  {
      "partnerNumberIndividual": "0035503592",
      "employeeId": "198709056579",
      "firstName": "Anankastisk",
      "lastName": "Ladugårdsbacke"
  },
  {
      "partnerNumberIndividual": "0035504161",
      "employeeId": "198006057106",
      "firstName": "Omflyttbar",
      "lastName": "Ciselerhammare"
  },
  {
      "partnerNumberIndividual": "0035509994",
      "employeeId": "198608163765",
      "firstName": "Ansvarsmedveten",
      "lastName": "Färjelinje"
  },
  {
      "partnerNumberIndividual": "0035511145",
      "employeeId": "198602108063",
      "firstName": "Själfull",
      "lastName": "Hattmakare"
  },
  {
      "partnerNumberIndividual": "0035511860",
      "employeeId": "198008057609",
      "firstName": "Pressad",
      "lastName": "Soppa"
  },
  {
      "partnerNumberIndividual": "0035513168",
      "employeeId": "198803274888",
      "firstName": "Utnött",
      "lastName": "Dykdjup"
  },
  {
      "partnerNumberIndividual": "0035519681",
      "employeeId": "198605056368",
      "firstName": "Snart",
      "lastName": "Jordkällare"
  },
  {
      "partnerNumberIndividual": "0035523027",
      "employeeId": "198502218855",
      "firstName": "Tätting",
      "lastName": "Acetofenon"
  },
  {
      "partnerNumberIndividual": "0035523033",
      "employeeId": "198705061870",
      "firstName": "Bokstavlig",
      "lastName": "Överklassdygd"
  },
  {
      "partnerNumberIndividual": "0035528367",
      "employeeId": "198702015374",
      "firstName": "Gotländsk",
      "lastName": "Återbesättning"
  },
  {
      "partnerNumberIndividual": "0035534815",
      "employeeId": "198101169913",
      "firstName": "Nedsmord",
      "lastName": "Klosterföreståndarinna"
  },
  {
      "partnerNumberIndividual": "0035540746",
      "employeeId": "198609090165",
      "firstName": "Försumlig",
      "lastName": "Nickel"
  },
  {
      "partnerNumberIndividual": "0035546318",
      "employeeId": "198101270216",
      "firstName": "Spelad",
      "lastName": "Bearbetaning"
  },
  {
      "partnerNumberIndividual": "0035547639",
      "employeeId": "198603236368",
      "firstName": "Risig",
      "lastName": "Offshoreverksamhet"
  },
  {
      "partnerNumberIndividual": "0035558809",
      "employeeId": "198009211809",
      "firstName": "Ocensurerad",
      "lastName": "Jetstråle"
  },
  {
      "partnerNumberIndividual": "0035559845",
      "employeeId": "198306192736",
      "firstName": "Irreal",
      "lastName": "Ragu"
  },
  {
      "partnerNumberIndividual": "0035561750",
      "employeeId": "198004195502",
      "firstName": "Utelämnad",
      "lastName": "Charkuteri"
  },
  {
      "partnerNumberIndividual": "0035562916",
      "employeeId": "198801177984",
      "firstName": "Spartansk",
      "lastName": "Affärsknep"
  },
  {
      "partnerNumberIndividual": "0035569025",
      "employeeId": "198702065973",
      "firstName": "Avgudadyrkande",
      "lastName": "Susande"
  },
  {
      "partnerNumberIndividual": "0035569036",
      "employeeId": "198808136587",
      "firstName": "Hållfast",
      "lastName": "Kommunstöd"
  },
  {
      "partnerNumberIndividual": "0035569432",
      "employeeId": "198211069425",
      "firstName": "Havsliknande",
      "lastName": "Nyårsgåva"
  },
  {
      "partnerNumberIndividual": "0035569458",
      "employeeId": "198604204365",
      "firstName": "Ejavstavad",
      "lastName": "Mindreskatfink"
  },
  {
      "partnerNumberIndividual": "0035578500",
      "employeeId": "198005094803",
      "firstName": "Tänkbar",
      "lastName": "Försäkringskostnad"
  },
  {
      "partnerNumberIndividual": "0035586953",
      "employeeId": "198311190337",
      "firstName": "Keff",
      "lastName": "Alpmynta"
  },
  {
      "partnerNumberIndividual": "0035589106",
      "employeeId": "198805096081",
      "firstName": "Utanort",
      "lastName": "Hoptryckning"
  },
  {
      "partnerNumberIndividual": "0035594193",
      "employeeId": "198303079332",
      "firstName": "Avtäckt",
      "lastName": "Ömlåga"
  },
  {
      "partnerNumberIndividual": "0035594303",
      "employeeId": "198609168268",
      "firstName": "Redobogen",
      "lastName": "Älsklingen"
  },
  {
      "partnerNumberIndividual": "0035597794",
      "employeeId": "198609239069",
      "firstName": "Gott",
      "lastName": "Chancroid"
  },
  {
      "partnerNumberIndividual": "0035599706",
      "employeeId": "198107072210",
      "firstName": "Direktörsaktig",
      "lastName": "Oxfordrörelsemedlem"
  },
  {
      "partnerNumberIndividual": "0035603239",
      "employeeId": "198009233803",
      "firstName": "Kymig",
      "lastName": "Förhörsledare"
  },
  {
      "partnerNumberIndividual": "0035609036",
      "employeeId": "198001251407",
      "firstName": "Horisontutvidgande",
      "lastName": "Bestämmare"
  },
  {
      "partnerNumberIndividual": "0035609150",
      "employeeId": "198601053567",
      "firstName": "Gravimetrisk",
      "lastName": "Platå"
  },
  {
      "partnerNumberIndividual": "0035612477",
      "employeeId": "198508163352",
      "firstName": "Rörelsemässig",
      "lastName": "Fotbollshysteri"
  },
  {
      "partnerNumberIndividual": "0035619173",
      "employeeId": "198202233527",
      "firstName": "Mod",
      "lastName": "Datorstab"
  },
  {
      "partnerNumberIndividual": "0035621202",
      "employeeId": "198410165545",
      "firstName": "Antikrigs",
      "lastName": "Utskiftning"
  },
  {
      "partnerNumberIndividual": "0035621571",
      "employeeId": "198201223628",
      "firstName": "Handelspolitisk",
      "lastName": "Gulkronadtyrann"
  },
  {
      "partnerNumberIndividual": "0035628319",
      "employeeId": "198808160983",
      "firstName": "Urfunktion",
      "lastName": "Gruvhammare"
  },
  {
      "partnerNumberIndividual": "0035635357",
      "employeeId": "198605013567",
      "firstName": "Mångstavig",
      "lastName": "Vuxenmobbning"
  },
  {
      "partnerNumberIndividual": "0035635410",
      "employeeId": "198709271079",
      "firstName": "Våtvärmande",
      "lastName": "Barfrost"
  },
  {
      "partnerNumberIndividual": "0035635451",
      "employeeId": "198906200996",
      "firstName": "Genteknologisk",
      "lastName": "Mätarlarv"
  },
  {
      "partnerNumberIndividual": "0035644190",
      "employeeId": "198609091361",
      "firstName": "Återlagrad",
      "lastName": "Älsklingen"
  },
  {
      "partnerNumberIndividual": "0035650419",
      "employeeId": "198711099872",
      "firstName": "Standard",
      "lastName": "Kundkommunikatör"
  },
  {
      "partnerNumberIndividual": "0035650639",
      "employeeId": "198607130666",
      "firstName": "Informations",
      "lastName": "TimmenT"
  },
  {
      "partnerNumberIndividual": "0035659567",
      "employeeId": "198103267418",
      "firstName": "Radiostyrd",
      "lastName": "Widescreenskärm"
  },
  {
      "partnerNumberIndividual": "0035662330",
      "employeeId": "198901094899",
      "firstName": "Brännskadad",
      "lastName": "Nedslagenhet"
  },
  {
      "partnerNumberIndividual": "0035662384",
      "employeeId": "198401118743",
      "firstName": "Oljeabsorberande",
      "lastName": "Ansiktsgymnastik"
  },
  {
      "partnerNumberIndividual": "0035665213",
      "employeeId": "198907172293",
      "firstName": "Superheterodyn",
      "lastName": "Gruvkunskap"
  },
  {
      "partnerNumberIndividual": "0035665689",
      "employeeId": "198609264067",
      "firstName": "Genteknologisk",
      "lastName": "Rasfördom"
  },
  {
      "partnerNumberIndividual": "0035669630",
      "employeeId": "198806155985",
      "firstName": "Tiohörnig",
      "lastName": "Guldnissöga"
  },
  {
      "partnerNumberIndividual": "0035670913",
      "employeeId": "198004082809",
      "firstName": "Onyttig",
      "lastName": "Directmail"
  },
  {
      "partnerNumberIndividual": "0035679754",
      "employeeId": "198906238095",
      "firstName": "Homopolymerisk",
      "lastName": "Levnadsregel"
  },
  {
      "partnerNumberIndividual": "0035680093",
      "employeeId": "198907192499",
      "firstName": "Främst",
      "lastName": "Lyssnarbrev"
  },
  {
      "partnerNumberIndividual": "0035684824",
      "employeeId": "198802022080",
      "firstName": "Förbluffande",
      "lastName": "Skinka"
  },
  {
      "partnerNumberIndividual": "0035686943",
      "employeeId": "198907118098",
      "firstName": "Husdjursetisk",
      "lastName": "Elektroretinograf"
  },
  {
      "partnerNumberIndividual": "0035691149",
      "employeeId": "198608275262",
      "firstName": "Levrad",
      "lastName": "Nyckelord"
  },
  {
      "partnerNumberIndividual": "0035692445",
      "employeeId": "198404233945",
      "firstName": "Bombmattefällande",
      "lastName": "Betongblandning"
  },
  {
      "partnerNumberIndividual": "0035692625",
      "employeeId": "198805262683",
      "firstName": "Vikariats",
      "lastName": "Platå"
  },
  {
      "partnerNumberIndividual": "0035698399",
      "employeeId": "198208056021",
      "firstName": "Oklippt",
      "lastName": "Cyanidlutning"
  },
  {
      "partnerNumberIndividual": "0035699286",
      "employeeId": "198409273748",
      "firstName": "Khaki",
      "lastName": "Tolkprogram"
  },
  {
      "partnerNumberIndividual": "0035699361",
      "employeeId": "198603012769",
      "firstName": "Utomrättslig",
      "lastName": "Nerslagning"
  },
  {
      "partnerNumberIndividual": "0035700347",
      "employeeId": "198106130415",
      "firstName": "Dagsfärsk",
      "lastName": "Biljettbokning"
  },
  {
      "partnerNumberIndividual": "0035706370",
      "employeeId": "198401111441",
      "firstName": "Välputsad",
      "lastName": "Fissionsbränsle"
  },
  {
      "partnerNumberIndividual": "0035707947",
      "employeeId": "198705040171",
      "firstName": "Bäst",
      "lastName": "Mätressregemente"
  },
  {
      "partnerNumberIndividual": "0035708915",
      "employeeId": "198002103706",
      "firstName": "Farlig",
      "lastName": "Dragbult"
  },
  {
      "partnerNumberIndividual": "0035710558",
      "employeeId": "198901092190",
      "firstName": "Ljudlig",
      "lastName": "Växelryttare"
  },
  {
      "partnerNumberIndividual": "0035713349",
      "employeeId": "198205149027",
      "firstName": "Krabbätande",
      "lastName": "Manchongsida"
  },
  {
      "partnerNumberIndividual": "0035713853",
      "employeeId": "198703172570",
      "firstName": "Förvärkt",
      "lastName": "Kariol"
  },
  {
      "partnerNumberIndividual": "0035716479",
      "employeeId": "198009010805",
      "firstName": "Termostatstyrd",
      "lastName": "Segmentering"
  },
  {
      "partnerNumberIndividual": "0035722032",
      "employeeId": "198404032941",
      "firstName": "Guldfärgad",
      "lastName": "Elektroretinograf"
  },
  {
      "partnerNumberIndividual": "0035722199",
      "employeeId": "198408165044",
      "firstName": "Tölpig",
      "lastName": "Anslutningsslang"
  },
  {
      "partnerNumberIndividual": "0035726408",
      "employeeId": "198211027829",
      "firstName": "Tvungen",
      "lastName": "Fraktionsdestillation"
  },
  {
      "partnerNumberIndividual": "0035727403",
      "employeeId": "198906272391",
      "firstName": "Asocial",
      "lastName": "Avdragsregel"
  },
  {
      "partnerNumberIndividual": "0035741439",
      "employeeId": "198201058826",
      "firstName": "Neuroberäknande",
      "lastName": "Dvärgmalkoha"
  },
  {
      "partnerNumberIndividual": "0035742180",
      "employeeId": "198902236192",
      "firstName": "Omeddelsam",
      "lastName": "Hagelkorn"
  },
  {
      "partnerNumberIndividual": "0035746162",
      "employeeId": "198104098614",
      "firstName": "Djäkla",
      "lastName": "Bestrålningstid"
  },
  {
      "partnerNumberIndividual": "0035747584",
      "employeeId": "198608211960",
      "firstName": "Nattblå",
      "lastName": "Streamadvideo"
  },
  {
      "partnerNumberIndividual": "0035747714",
      "employeeId": "198206056122",
      "firstName": "Senromersk",
      "lastName": "Jordmån"
  },
  {
      "partnerNumberIndividual": "0035750306",
      "employeeId": "198607193961",
      "firstName": "Epokgörande",
      "lastName": "Referensmaterial"
  },
  {
      "partnerNumberIndividual": "0035754075",
      "employeeId": "198510165650",
      "firstName": "Uppkopplad",
      "lastName": "Hoptryckning"
  },
  {
      "partnerNumberIndividual": "0035757312",
      "employeeId": "198910064891",
      "firstName": "Retlig",
      "lastName": "Bröstlidande"
  },
  {
      "partnerNumberIndividual": "0035761171",
      "employeeId": "198502266755",
      "firstName": "Oljerik",
      "lastName": "Decimalmått"
  },
  {
      "partnerNumberIndividual": "0035767975",
      "employeeId": "198903052291",
      "firstName": "Interparlamentarisk",
      "lastName": "Blodvätska"
  },
  {
      "partnerNumberIndividual": "0035770180",
      "employeeId": "198303014834",
      "firstName": "Kommunalistisk",
      "lastName": "Ridstall"
  },
  {
      "partnerNumberIndividual": "0035772100",
      "employeeId": "198406032840",
      "firstName": "Dubbelbestruken",
      "lastName": "Avdragsregel"
  },
  {
      "partnerNumberIndividual": "0035776169",
      "employeeId": "198809262788",
      "firstName": "Utomrättslig",
      "lastName": "Valbarhet"
  },
  {
      "partnerNumberIndividual": "0035782544",
      "employeeId": "198805191882",
      "firstName": "Tunnsliten",
      "lastName": "Känsloskala"
  },
  {
      "partnerNumberIndividual": "0035784054",
      "employeeId": "198602210166",
      "firstName": "Mångfunktionell",
      "lastName": "Medvetandeström"
  },
  {
      "partnerNumberIndividual": "0035789426",
      "employeeId": "198002167602",
      "firstName": "Spacey",
      "lastName": "Anslutningsslang"
  },
  {
      "partnerNumberIndividual": "0035791208",
      "employeeId": "198904154393",
      "firstName": "Ihopvikbar",
      "lastName": "Godistillverkning"
  },
  {
      "partnerNumberIndividual": "0035791614",
      "employeeId": "198005094209",
      "firstName": "Inbillad",
      "lastName": "Regissör"
  },
  {
      "partnerNumberIndividual": "0035791638",
      "employeeId": "198807118586",
      "firstName": "Stillstående",
      "lastName": "Inköpsagent"
  },
  {
      "partnerNumberIndividual": "0035792710",
      "employeeId": "198910253197",
      "firstName": "Gott",
      "lastName": "Mätarlarv"
  },
  {
      "partnerNumberIndividual": "0035793698",
      "employeeId": "198510207551",
      "firstName": "Elbesparande",
      "lastName": "Snickare"
  },
  {
      "partnerNumberIndividual": "0035794784",
      "employeeId": "198404096243",
      "firstName": "Impressionist",
      "lastName": "Våtdräkt"
  },
  {
      "partnerNumberIndividual": "0035796336",
      "employeeId": "198911033796",
      "firstName": "Rörelsemässig",
      "lastName": "Svek"
  },
  {
      "partnerNumberIndividual": "0035797001",
      "employeeId": "198711083272",
      "firstName": "Tillväxtförstoppad",
      "lastName": "Arkivdepå"
  },
  {
      "partnerNumberIndividual": "0035797830",
      "employeeId": "198305264833",
      "firstName": "Trefokals",
      "lastName": "Medbringarpinne"
  },
  {
      "partnerNumberIndividual": "0035798738",
      "employeeId": "198809188686",
      "firstName": "Självförstörande",
      "lastName": "Skivproducent"
  },
  {
      "partnerNumberIndividual": "0035800116",
      "employeeId": "198805012880",
      "firstName": "Postsilurisk",
      "lastName": "Dvärgmalkoha"
  },
  {
      "partnerNumberIndividual": "0035810662",
      "employeeId": "198605098568",
      "firstName": "Tadelfri",
      "lastName": "Prästrock"
  },
  {
      "partnerNumberIndividual": "0035814481",
      "employeeId": "198104049518",
      "firstName": "Snällmot",
      "lastName": "Konstruktionsstandard"
  },
  {
      "partnerNumberIndividual": "0035816252",
      "employeeId": "198008243803",
      "firstName": "Framröstad",
      "lastName": "Allaktivist"
  },
  {
      "partnerNumberIndividual": "0035819250",
      "employeeId": "198901252794",
      "firstName": "Behandlande",
      "lastName": "Tamgås"
  },
  {
      "partnerNumberIndividual": "0035821563",
      "employeeId": "198001108607",
      "firstName": "Radiärsymmetrisk",
      "lastName": "Halogenpuck"
  },
  {
      "partnerNumberIndividual": "0035831119",
      "employeeId": "198401125045",
      "firstName": "Sagolik",
      "lastName": "Avloppsslam"
  },
  {
      "partnerNumberIndividual": "0035837321",
      "employeeId": "198004036706",
      "firstName": "Uzbekistansk",
      "lastName": "Ljushuvadjakamar"
  },
  {
      "partnerNumberIndividual": "0035840900",
      "employeeId": "198201106427",
      "firstName": "Ambivalent",
      "lastName": "Himlenrunthörnet"
  },
  {
      "partnerNumberIndividual": "0035856284",
      "employeeId": "198908180691",
      "firstName": "Etnisk",
      "lastName": "Köksinredning"
  },
  {
      "partnerNumberIndividual": "0035865975",
      "employeeId": "198909192992",
      "firstName": "Halvautonom",
      "lastName": "Läkemedelskontroll"
  },
  {
      "partnerNumberIndividual": "0035866917",
      "employeeId": "198411039848",
      "firstName": "Malolaktisk",
      "lastName": "Fridlysning"
  },
  {
      "partnerNumberIndividual": "0035890767",
      "employeeId": "198004041508",
      "firstName": "Anankastisk",
      "lastName": "Äxing"
  },
  {
      "partnerNumberIndividual": "0035899104",
      "employeeId": "198906271799",
      "firstName": "Knarrande",
      "lastName": "Jackfält"
  },
  {
      "partnerNumberIndividual": "0035903955",
      "employeeId": "198511064050",
      "firstName": "Skum",
      "lastName": "Vårdutrymme"
  },
  {
      "partnerNumberIndividual": "0035905773",
      "employeeId": "198802029986",
      "firstName": "Atypisk",
      "lastName": "Stålverksarbetare"
  },
  {
      "partnerNumberIndividual": "0035926889",
      "employeeId": "198801253884",
      "firstName": "Kortvågig",
      "lastName": "Innehållsindikator"
  },
  {
      "partnerNumberIndividual": "0035933668",
      "employeeId": "198303110939",
      "firstName": "Genteknologisk",
      "lastName": "Sandblästerskydd"
  },
  {
      "partnerNumberIndividual": "0035935733",
      "employeeId": "198206124821",
      "firstName": "Tunnklädd",
      "lastName": "Spikbleck"
  },
  {
      "partnerNumberIndividual": "0035935758",
      "employeeId": "198602177068",
      "firstName": "Fortlevande",
      "lastName": "Australiskhavssula"
  },
  {
      "partnerNumberIndividual": "0035938977",
      "employeeId": "198810142789",
      "firstName": "Tidvattens",
      "lastName": "Azur"
  },
  {
      "partnerNumberIndividual": "0035943521",
      "employeeId": "198908039699",
      "firstName": "Vardagslik",
      "lastName": "Förstärkare"
  },
  {
      "partnerNumberIndividual": "0035948765",
      "employeeId": "198810094881",
      "firstName": "Demonterad",
      "lastName": "Stapeldiagram"
  },
  {
      "partnerNumberIndividual": "0035956386",
      "employeeId": "200301024303",
      "firstName": "Otillrådlig",
      "lastName": "Ljuvalivet"
  },
  {
      "partnerNumberIndividual": "0035957530",
      "employeeId": "198202144625",
      "firstName": "Midströms",
      "lastName": "Plättpanna"
  },
  {
      "partnerNumberIndividual": "0035957885",
      "employeeId": "198306055636",
      "firstName": "Respektive",
      "lastName": "Kariol"
  },
  {
      "partnerNumberIndividual": "0035958512",
      "employeeId": "198208270523",
      "firstName": "Pacifistisk",
      "lastName": "Tillhandahållnatjänster"
  },
  {
      "partnerNumberIndividual": "0035961686",
      "employeeId": "198506273757",
      "firstName": "Hialös",
      "lastName": "Dagspris"
  },
  {
      "partnerNumberIndividual": "0035961692",
      "employeeId": "198601130068",
      "firstName": "Anemometrisk",
      "lastName": "Överste"
  },
  {
      "partnerNumberIndividual": "0035977469",
      "employeeId": "198005226504",
      "firstName": "Rusig",
      "lastName": "Växelkurssystem"
  },
  {
      "partnerNumberIndividual": "0035983344",
      "employeeId": "198704219271",
      "firstName": "Påsig",
      "lastName": "Politisksociologi"
  },
  {
      "partnerNumberIndividual": "0035987727",
      "employeeId": "198810269681",
      "firstName": "Solar",
      "lastName": "Cyanfettsyror"
  },
  {
      "partnerNumberIndividual": "0035988041",
      "employeeId": "198204117124",
      "firstName": "Tight",
      "lastName": "Repulsor"
  },
  {
      "partnerNumberIndividual": "0035988293",
      "employeeId": "198706064873",
      "firstName": "Färdigsydd",
      "lastName": "Manskram"
  },
  {
      "partnerNumberIndividual": "0035993425",
      "employeeId": "198402025541",
      "firstName": "Elektronegativ",
      "lastName": "Paparazzo"
  },
  {
      "partnerNumberIndividual": "0035993473",
      "employeeId": "198701163670",
      "firstName": "Bisynkron",
      "lastName": "Charkuteri"
  },
  {
      "partnerNumberIndividual": "0035994695",
      "employeeId": "198007122701",
      "firstName": "Pappaktig",
      "lastName": "Biljettbokning"
  },
  {
      "partnerNumberIndividual": "0035995813",
      "employeeId": "198209267221",
      "firstName": "Huvudsaklig",
      "lastName": "Tangentialturbin"
  },
  ]
